
import   React      , 
       { useState   ,
	     useEffect  } from "react";
		 
import   classNames   from "classnames";

import   styles       from "./Icon.module.scss";

import { lucideIcons }                 from "./lucideRegistry";
import type { LucideIcon }             from "lucide-react";
 

// Voir https://picsvg.com/   et   https://www.flaticon.com/


export const svgIcons: Record<string, JSX.Element> = {

cloud: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="431.000000pt" height="309.000000pt" viewBox="0 0 431.000000 309.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,309.000000) scale(0.050000,-0.050000)">
<path d="M3950 5990 c-368 -81 -730 -311 -961 -611 -86 -113 -249 -405 -249
-448 0 -13 -101 -21 -275 -22 -666 -2 -1134 -433 -1196 -1101 l-14 -143 -94
-11 c-969 -115 -1358 -1381 -625 -2034 329 -293 371 -300 1842 -300 l1222 0 0
219 0 219 -96 -11 c-524 -62 -927 528 -698 1023 83 178 1026 1121 1204 1203
175 81 427 82 600 1 183 -86 1124 -1026 1215 -1214 220 -458 -121 -1006 -630
-1009 l-155 -1 0 -215 0 -215 1216 0 c1344 0 1322 -2 1583 129 598 302 818
1077 469 1654 -178 293 -600 557 -892 557 -53 0 -56 4 -56 95 -3 653 -518
1151 -1195 1156 l-266 1 -68 144 c-341 711 -1126 1101 -1881 934z"/>
<path d="M4150 3689 c-89 -46 -1006 -966 -1053 -1057 -121 -232 45 -537 308
-567 132 -14 222 25 364 157 69 65 132 118 139 118 6 0 12 -428 12 -951 0
-812 4 -961 31 -1024 137 -328 601 -328 738 0 27 63 31 212 31 1027 l0 954
110 -104 c185 -175 338 -219 500 -144 210 97 300 319 211 517 -59 130 -996
1056 -1096 1084 -107 30 -225 26 -295 -10z"/>
</g>
</svg>

),

cloud0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="588.000000pt" height="448.000000pt" viewBox="0 0 588.000000 448.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,448.000000) scale(0.050000,-0.050000)">
<path d="M4118 8821 c-838 -153 -1543 -730 -1721 -1406 l-25 -95 -164 0 c-749
0 -1532 -439 -1893 -1062 -490 -846 -166 -1958 721 -2477 142 -83 182 -116
172 -140 -172 -395 -162 -922 27 -1351 428 -972 1733 -1486 2820 -1112 151 52
177 56 191 30 117 -208 497 -550 770 -692 910 -474 2111 -302 2789 399 l76 78
114 -56 c1774 -865 3857 790 3074 2442 l-70 148 97 102 c1041 1083 367 2798
-1226 3116 l-140 28 -14 162 c-126 1510 -2238 2322 -3538 1361 l-58 -44 -55
51 c-458 422 -1278 640 -1947 518z m742 -291 c423 -65 741 -212 1040 -480 181
-162 231 -167 387 -37 198 165 595 328 916 375 1202 179 2278 -643 2232 -1705
-7 -143 25 -166 282 -209 1471 -241 2075 -1685 1122 -2682 -197 -206 -209
-238 -132 -352 490 -723 166 -1755 -691 -2201 -613 -319 -1329 -317 -1963 6
-237 121 -240 120 -440 -97 -839 -910 -2462 -782 -3131 248 -131 201 -162 212
-356 127 -1526 -664 -3252 685 -2625 2052 96 208 79 272 -97 347 -613 265
-1025 850 -1024 1456 2 936 832 1641 1934 1642 278 0 310 17 336 186 92 587
677 1137 1372 1292 320 71 537 79 838 32z"/>
</g>
</svg>

),

chain: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="348.000000pt" height="897.000000pt" viewBox="0 0 348.000000 897.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,897.000000) scale(0.100000,-0.100000)">
<path d="M1005 8874 c-99 -14 -256 -59 -329 -96 -127 -64 -187 -108 -302 -223
-136 -136 -200 -229 -256 -377 -77 -201 -73 -123 -73 -1348 0 -1018 1 -1100
18 -1171 44 -190 138 -372 257 -501 113 -123 207 -195 331 -255 190 -93 331
-123 581 -123 116 0 128 -2 138 -19 6 -12 10 -123 10 -289 0 -228 -2 -271 -15
-282 -10 -8 -64 -14 -163 -16 -174 -5 -259 -16 -367 -49 -231 -70 -431 -208
-576 -397 -32 -42 -59 -81 -59 -86 0 -5 -8 -20 -19 -33 -31 -40 -87 -179 -117
-289 l-29 -105 -3 -1030 c-2 -728 0 -1056 8 -1120 24 -194 74 -327 186 -498
61 -92 207 -237 308 -306 97 -66 246 -138 312 -151 27 -5 65 -14 84 -20 65
-20 392 -29 945 -26 521 3 555 4 645 24 228 52 386 140 553 307 138 139 214
259 271 429 60 181 60 165 63 1294 4 920 2 1042 -12 1120 -22 116 -74 272
-115 342 -5 8 -18 32 -29 52 -118 218 -368 412 -632 492 -117 35 -198 46 -377
51 -96 3 -159 9 -168 16 -19 16 -21 561 -2 576 7 6 99 13 203 17 114 3 216 12
255 21 163 39 339 121 450 210 103 83 226 220 269 300 12 22 25 47 30 55 23
37 82 193 103 270 l22 85 4 1055 c3 1164 4 1140 -60 1333 -117 351 -431 641
-802 739 -79 21 -99 22 -796 24 -393 1 -728 0 -745 -2z m1395 -683 c76 -22
142 -61 202 -122 64 -63 102 -134 118 -219 13 -70 13 -1930 0 -2022 -14 -97
-49 -167 -117 -235 -67 -67 -127 -100 -217 -119 -80 -17 -286 -18 -309 -1 -14
10 -17 44 -19 267 l-3 255 -28 57 c-32 65 -110 141 -177 172 -65 30 -196 29
-263 -1 -61 -28 -152 -119 -180 -180 -21 -45 -22 -65 -25 -303 -2 -172 -7
-259 -15 -269 -9 -11 -41 -12 -157 -9 -119 4 -156 9 -205 28 -113 43 -202 128
-252 241 l-28 64 -3 999 c-2 653 1 1018 8 1055 34 185 196 333 383 350 39 3
335 6 657 5 437 -1 596 -4 630 -13z m-1032 -4714 c6 -7 12 -110 14 -267 l3
-255 29 -58 c39 -78 128 -159 202 -182 68 -21 181 -17 236 9 20 10 66 47 103
84 97 98 105 129 105 426 0 167 3 235 12 244 20 20 270 16 349 -6 116 -32 209
-113 267 -232 l37 -75 -3 -1020 c-2 -1107 0 -1064 -57 -1175 -30 -59 -128
-153 -185 -178 -107 -48 -85 -46 -725 -50 -648 -3 -696 -1 -793 43 -112 51
-216 183 -242 308 -7 37 -10 356 -8 1047 4 1120 -2 1045 80 1162 69 98 170
160 289 178 92 13 275 12 287 -3z"/>
</g>
</svg>

),

publicPersonnalInfos: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="580.000000pt" height="458.000000pt" viewBox="0 0 580.000000 458.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,458.000000) scale(0.050000,-0.050000)">
<path d="M5050 9092 c-597 -138 -979 -554 -1123 -1222 l-17 -80 -344 -10
c-308 -9 -349 -14 -400 -52 -88 -65 -146 -165 -146 -250 l0 -77 -1246 -5
-1247 -6 -117 -60 c-145 -74 -276 -227 -319 -373 -55 -186 -46 -6315 10 -6464
51 -139 165 -268 302 -344 l107 -59 4840 0 4840 0 86 46 c132 71 237 176 298
301 l56 113 0 3191 0 3192 -60 117 c-74 145 -227 276 -373 319 -89 26 -281 31
-1311 31 l-1206 0 0 77 c0 86 -58 185 -146 251 -51 38 -92 43 -400 52 l-343
10 -14 60 c-8 33 -29 122 -47 197 -167 719 -958 1211 -1680 1045z m690 -259
c392 -137 705 -492 788 -893 33 -162 34 -160 -106 -160 l-116 0 -23 106 c-218
973 -1602 1006 -1852 44 -39 -150 -39 -150 -159 -150 -134 0 -132 -3 -99 156
147 706 890 1132 1567 897z m-96 -478 c208 -95 377 -298 408 -491 l13 -83
-715 0 -715 0 11 71 c70 426 591 690 998 503z m1785 -826 c48 -48 46 -739 -2
-792 -49 -54 -4091 -58 -4150 -4 -52 47 -56 745 -6 796 48 48 4110 48 4158 0z
m-4409 -599 c11 -264 24 -301 134 -384 l73 -56 2125 0 c2115 0 2125 0 2180 41
122 91 137 132 148 395 l10 244 1170 6 c1310 6 1298 7 1430 -125 138 -138 130
65 130 -3313 0 -3258 3 -3157 -103 -3286 -138 -167 368 -151 -4947 -151 -5175
-1 -4829 -10 -4964 130 -133 138 -126 -41 -126 3307 0 3377 -8 3175 130 3313
128 128 99 125 1410 122 l1190 -3 10 -240z"/>
<path d="M2790 5847 c-880 -188 -1423 -1256 -1030 -2027 22 -43 40 -82 40 -86
0 -5 -53 -41 -119 -82 -542 -334 -700 -741 -701 -1803 0 -706 4 -729 119 -729
96 0 97 10 106 750 13 996 104 1250 561 1571 l140 99 142 -148 c579 -599 1473
-607 2067 -18 l165 163 118 -79 c469 -313 567 -578 578 -1557 4 -397 16 -725
26 -745 25 -46 124 -47 168 -3 50 50 34 1437 -19 1616 -110 377 -331 677 -654
888 -87 57 -110 82 -96 104 145 229 180 827 66 1132 -262 710 -961 1107 -1677
954z m556 -219 c973 -215 1307 -1439 581 -2128 -691 -656 -1840 -289 -2037
650 -183 875 598 1668 1456 1478z"/>
<path d="M5683 4828 c-62 -44 -53 -147 17 -182 39 -20 473 -25 2000 -25 2126
0 2045 -5 2056 113 13 133 132 126 -2056 126 -1772 0 -1976 -3 -2017 -32z"/>
<path d="M5664 3856 c-40 -40 -29 -131 20 -165 68 -47 3964 -47 4032 0 49 34
60 125 20 165 -35 35 -4037 35 -4072 0z"/>
<path d="M5700 2914 c-70 -35 -79 -138 -17 -182 41 -29 245 -32 2017 -32 2171
0 2060 -6 2060 120 0 126 110 120 -2049 120 -1535 -1 -1972 -6 -2011 -26z"/>
<path d="M5700 1954 c-70 -35 -79 -138 -17 -182 70 -49 3964 -49 4034 0 62 44
53 147 -17 182 -73 37 -3927 37 -4000 0z"/>
</g>
</svg>
),


privatePersonnalInfos: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="580.000000pt" height="458.000000pt" viewBox="0 0 580.000000 458.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,458.000000) scale(0.050000,-0.050000)">
<path d="M5050 9092 c-597 -138 -979 -554 -1123 -1222 l-17 -80 -344 -10
c-308 -9 -349 -14 -400 -52 -88 -65 -146 -165 -146 -250 l0 -77 -1246 -5
-1247 -6 -117 -60 c-145 -74 -276 -227 -319 -373 -55 -186 -46 -6315 10 -6464
51 -139 165 -268 302 -344 l107 -59 4840 0 4840 0 86 46 c132 71 237 176 298
301 l56 113 5 2605 6 2605 -111 0 -110 0 0 -2545 c0 -2704 2 -2635 -103 -2763
-138 -167 368 -151 -4947 -151 -5175 -1 -4829 -10 -4964 130 -133 138 -126
-41 -126 3307 0 3378 -8 3175 130 3313 132 132 120 131 1430 125 l1170 -6 10
-240 c11 -264 24 -301 134 -384 l73 -56 2125 0 c2115 0 2125 0 2180 41 122 91
137 132 148 395 l10 244 835 5 835 5 0 110 0 110 -840 0 -840 0 0 77 c0 86
-58 185 -146 251 -51 38 -92 43 -400 52 l-343 10 -14 60 c-8 33 -29 122 -47
197 -167 719 -958 1211 -1680 1045z m690 -259 c392 -137 705 -492 788 -893 33
-162 34 -160 -106 -160 l-116 0 -23 106 c-218 973 -1602 1006 -1852 44 -39
-150 -39 -150 -159 -150 -134 0 -132 -3 -99 156 147 706 890 1132 1567 897z
m-96 -478 c208 -95 377 -298 408 -491 l13 -83 -715 0 -715 0 11 71 c70 426
591 690 998 503z m1785 -826 c48 -48 46 -739 -2 -792 -49 -54 -4091 -58 -4150
-4 -52 47 -56 745 -6 796 48 48 4110 48 4158 0z"/>
<path d="M10198 8600 c-356 -61 -538 -325 -538 -780 l0 -259 -70 -30 c-147
-61 -150 -77 -150 -841 0 -944 -115 -848 1027 -849 l858 -1 77 78 78 77 0 688
c0 771 -3 787 -148 848 l-67 28 -9 275 c-18 608 -394 880 -1058 766z m637
-285 c152 -100 194 -204 202 -500 l7 -255 -582 0 -582 0 0 251 c0 321 50 429
250 537 111 59 600 37 705 -33z m-162 -1242 c103 -112 98 -250 -13 -355 l-80
-76 0 -170 c0 -148 -5 -173 -39 -191 -114 -62 -161 -2 -161 206 0 160 -2 165
-58 198 -110 66 -150 214 -87 331 90 166 312 195 438 57z"/>
<path d="M2790 5847 c-880 -188 -1423 -1256 -1030 -2027 22 -43 40 -82 40 -86
0 -5 -53 -41 -119 -82 -542 -334 -700 -741 -701 -1803 0 -706 4 -729 119 -729
96 0 97 10 106 750 13 996 104 1250 561 1571 l140 99 142 -148 c579 -599 1473
-607 2067 -18 l165 163 118 -79 c469 -313 567 -578 578 -1557 4 -397 16 -725
26 -745 25 -46 124 -47 168 -3 50 50 34 1437 -19 1616 -110 377 -331 677 -654
888 -87 57 -110 82 -96 104 145 229 180 827 66 1132 -262 710 -961 1107 -1677
954z m556 -219 c973 -215 1307 -1439 581 -2128 -691 -656 -1840 -289 -2037
650 -183 875 598 1668 1456 1478z"/>
<path d="M5683 4828 c-62 -44 -53 -147 17 -182 39 -20 473 -25 2000 -25 2126
0 2045 -5 2056 113 13 133 132 126 -2056 126 -1772 0 -1976 -3 -2017 -32z"/>
<path d="M5664 3856 c-40 -40 -29 -131 20 -165 68 -47 3964 -47 4032 0 49 34
60 125 20 165 -35 35 -4037 35 -4072 0z"/>
<path d="M5700 2914 c-70 -35 -79 -138 -17 -182 41 -29 245 -32 2017 -32 2171
0 2060 -6 2060 120 0 126 110 120 -2049 120 -1535 -1 -1972 -6 -2011 -26z"/>
<path d="M5700 1954 c-70 -35 -79 -138 -17 -182 70 -49 3964 -49 4034 0 62 44
53 147 -17 182 -73 37 -3927 37 -4000 0z"/>
</g>
</svg>
),


localisation: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="234.000000pt" height="368.000000pt" viewBox="0 0 234.000000 368.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,368.000000) scale(0.050000,-0.050000)">
<path d="M2030 7239 c-1210 -188 -2037 -1300 -1868 -2512 74 -537 342 -1005
1167 -2037 572 -716 700 -894 912 -1267 l106 -187 61 114 c180 332 437 691
972 1360 847 1059 1097 1512 1163 2103 156 1413 -1118 2643 -2513 2426z m496
-941 c1176 -180 1480 -1710 463 -2334 -726 -446 -1710 -6 -1878 840 -132 662
311 1349 949 1474 61 12 128 25 150 29 77 16 174 13 316 -9z"/>
<path d="M1374 1220 c-831 -155 -1190 -462 -873 -748 718 -649 3800 -486 3799
201 0 243 -496 502 -1067 557 l-123 12 132 -47 c695 -245 171 -620 -872 -624
-1035 -3 -1621 367 -960 606 250 91 246 95 -36 43z"/>
</g>
</svg>


),

idCard: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="480.000000pt" height="327.000000pt" viewBox="0 0 480.000000 327.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,327.000000) scale(0.050000,-0.050000)">
<path d="M810 6427 c-43 -10 -61 -17 -231 -94 -197 -89 -370 -310 -426 -543
-36 -146 -40 -4863 -5 -5090 17 -105 51 -183 75 -168 9 5 12 -2 7 -16 -30 -78
263 -322 471 -392 l132 -44 3982 0 3981 0 117 43 c64 24 131 56 149 70 17 15
38 27 46 27 87 0 298 282 366 489 l46 140 0 2420 c-1 2355 -2 2424 -40 2547
-41 132 -132 304 -160 304 -9 0 -43 25 -74 55 -122 117 -211 185 -243 186 -18
0 -69 18 -113 39 -75 36 -7918 62 -8080 27z m7945 -326 c149 -28 270 -118 365
-271 l50 -80 0 -2480 0 -2480 -48 -80 c-55 -91 -119 -157 -221 -230 l-71 -50
-4023 0 c-3803 0 -4025 2 -4061 35 -22 19 -48 35 -59 35 -27 0 -153 137 -204
223 l-43 72 5 2488 5 2487 60 88 c81 120 189 203 304 234 119 31 7774 41 7941
9z"/>
<path d="M2380 5378 c-122 -15 -273 -66 -322 -110 -17 -15 -39 -28 -50 -28
-36 -1 -243 -232 -293 -330 -362 -698 243 -1495 1001 -1320 85 20 168 47 184
60 17 14 49 31 73 38 24 8 92 60 152 118 663 637 170 1678 -745 1572z m280
-319 c671 -165 551 -1177 -140 -1178 -562 -1 -810 696 -378 1063 84 71 326
163 388 147 11 -3 70 -17 130 -32z"/>
<path d="M5384 4586 c-56 -69 -55 -111 1 -175 l45 -51 1538 -1 c1089 -1 1545
6 1560 21 34 34 28 218 -8 240 -18 12 -631 20 -1561 20 l-1532 0 -43 -54z"/>
<path d="M5381 3767 c-53 -67 -52 -112 4 -176 l45 -52 1539 0 c1059 0 1545 7
1560 22 33 33 26 217 -9 239 -18 12 -632 20 -1564 20 l-1533 0 -42 -53z"/>
<path d="M1471 3217 c-43 -10 -94 -31 -112 -48 -17 -16 -41 -29 -52 -29 -33 0
-139 -127 -195 -232 l-52 -98 0 -646 c0 -676 6 -724 86 -724 25 0 97 -18 159
-40 63 -22 137 -40 164 -40 28 0 84 -13 126 -29 74 -28 222 -48 701 -94 192
-19 294 -19 460 0 118 14 303 34 412 44 108 11 234 32 280 47 45 15 125 33
177 41 52 7 99 22 105 32 7 10 57 24 112 31 143 19 142 13 134 758 -6 628 -7
642 -53 725 -78 142 -246 276 -377 302 -138 28 -1957 28 -2075 0z m2048 -321
c146 -85 161 -147 161 -685 l0 -468 -66 -40 c-36 -23 -146 -55 -245 -73 -98
-17 -219 -39 -269 -49 -121 -25 -1066 -24 -1180 0 -49 11 -165 33 -257 49 -92
16 -195 45 -230 65 l-63 37 -5 493 c-6 550 -4 563 136 666 l67 49 937 0 c931
0 938 0 1014 -44z"/>
<path d="M5389 2951 c-62 -62 -62 -113 -1 -185 l49 -56 1530 0 c1230 0 1536 5
1557 26 29 29 36 211 9 237 -9 10 -709 19 -1555 22 l-1539 6 -50 -50z"/>
<path d="M5673 2180 c-332 -13 -423 -93 -275 -242 l59 -58 771 0 771 0 64 56
c75 68 71 184 -9 227 -47 26 -898 37 -1381 17z"/>
</g>
</svg>

),


tv2:(

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="180.000000pt" height="133.000000pt" viewBox="0 0 180.000000 133.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,133.000000) scale(0.050000,-0.050000)">
<path d="M220 2574 c-66 -31 -88 -53 -127 -129 -50 -95 -50 -2148 -1 -2251 68
-142 -30 -134 1708 -134 1738 0 1640 -8 1708 134 36 76 50 2138 14 2230 -28
72 -86 127 -160 153 -97 33 -3070 30 -3142 -3z m3179 -127 c40 -52 41 -70 41
-1131 l0 -1078 -53 -49 -53 -49 -1534 0 c-1522 0 -1535 0 -1587 41 l-53 42 0
1092 0 1092 43 47 44 46 1555 0 1555 0 42 -53z"/>
<path d="M320 1510 l0 -810 1480 0 1480 0 -5 805 -5 805 -1475 5 -1475 5 0
-810z m2830 717 c26 -10 30 -106 30 -719 l0 -708 -1380 0 -1380 0 0 708 c0
548 6 711 25 719 35 14 2668 15 2705 0z"/>
<path d="M913 1985 c-12 -38 -18 -130 -15 -199 3 -70 56 -106 153 -106 l89 0
1 -315 c0 -387 -1 -385 196 -385 183 0 183 -1 183 386 l0 308 125 12 c150 13
117 53 233 -278 53 -153 111 -312 129 -353 l31 -75 151 0 c164 0 189 17 230
153 9 31 59 174 110 317 151 419 154 429 147 496 l-6 64 -152 6 c-180 7 -173
13 -248 -221 -56 -176 -77 -205 -100 -140 -6 19 -36 107 -66 195 l-54 160
-564 5 c-524 5 -564 3 -573 -30z m767 -124 l0 -79 -125 -6 -125 -6 -5 -356 -6
-356 -84 6 -85 6 -5 354 -6 354 -124 6 c-113 5 -126 10 -132 52 -14 102 -9
104 356 104 l341 0 0 -79z m291 64 c19 -13 166 -448 200 -591 20 -81 29 -63
140 283 l101 313 84 6 c106 8 107 1 6 -286 -42 -121 -102 -292 -132 -380 -31
-88 -64 -171 -75 -185 -31 -40 -188 -32 -205 10 -8 19 -44 121 -81 225 -37
105 -99 279 -138 387 -39 108 -66 205 -60 215 14 22 130 23 160 3z"/>
<path d="M1745 487 c-14 -6 -25 -31 -25 -56 0 -89 101 -120 148 -46 41 65 -43
135 -123 102z"/>
<path d="M371 333 c-86 -62 -17 -73 469 -73 481 0 532 8 479 71 -34 41 -892
43 -948 2z"/>
<path d="M2285 347 c-14 -6 -25 -28 -25 -49 0 -54 953 -60 974 -6 6 18 -1 40
-16 50 -29 18 -889 23 -933 5z"/>
</g>
</svg>

),

tv1: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="184.000000pt" height="162.000000pt" viewBox="0 0 184.000000 162.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,162.000000) scale(0.050000,-0.050000)">
<path d="M1214 3147 c-33 -33 1 -77 266 -345 154 -155 280 -291 280 -302 0
-11 -287 -21 -725 -24 -1018 -8 -918 127 -911 -1230 6 -994 6 -996 51 -1059
95 -134 19 -128 1700 -122 l1518 5 69 47 c120 83 118 59 118 1160 l0 1009 -53
69 c-92 121 -116 125 -825 125 -352 0 -644 7 -650 16 -5 9 116 142 269 295
269 269 315 336 247 362 -23 9 -124 -79 -349 -304 l-317 -317 -311 309 c-302
299 -347 336 -377 306z m2180 -806 c84 -56 86 -84 86 -1088 l0 -966 -56 -53
-56 -54 -1527 5 -1527 5 -42 56 c-41 56 -42 77 -48 970 -7 1107 -7 1108 153
1141 147 29 2970 15 3017 -16z"/>
<path d="M1150 2208 c-620 -67 -809 -281 -810 -912 0 -775 227 -962 1170 -965
978 -2 1216 212 1184 1059 -20 502 -149 673 -592 783 -111 27 -789 52 -952 35z
m908 -140 c434 -97 522 -228 522 -778 -1 -644 -140 -792 -798 -851 -986 -88
-1343 134 -1341 835 1 519 105 685 489 785 235 62 870 66 1128 9z"/>
<path d="M2930 1352 c-123 -123 -67 -319 98 -346 142 -23 234 54 236 197 2
172 -214 268 -334 149z m191 -73 c74 -39 31 -176 -56 -178 -30 -1 -105 70
-105 99 0 65 98 113 161 79z"/>
<path d="M2924 887 c-74 -37 -164 -174 -164 -251 0 -247 300 -402 488 -254
283 223 0 664 -324 505z m212 -88 c195 -69 144 -359 -64 -359 -101 0 -141 27
-180 120 -62 153 83 295 244 239z"/>
</g>
</svg>

),

devices: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="162.000000pt" height="132.000000pt" viewBox="0 0 162.000000 132.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,132.000000) scale(0.050000,-0.050000)">
<path d="M418 2522 l-58 -59 0 -721 c0 -709 1 -722 40 -722 39 0 40 13 40 630
l0 630 1180 0 1180 0 0 -630 c0 -617 1 -630 40 -630 47 0 64 1366 18 1467 -42
92 -57 93 -1250 93 l-1131 0 -59 -58z m2338 -53 c25 -18 44 -52 44 -80 l0 -49
-1175 5 c-1280 5 -1257 3 -1146 114 56 56 2197 65 2277 10z"/>
<path d="M1145 1989 c-60 -42 -85 -147 -85 -361 l0 -183 -92 -10 c-162 -18
-197 -74 -205 -325 l-7 -210 -348 0 -348 0 0 -119 c0 -96 9 -129 47 -173 l46
-54 302 -2 302 -2 6 -195 c10 -285 32 -304 364 -308 277 -4 328 10 373 108
l30 64 424 1 c511 0 527 6 542 212 l8 118 293 5 c357 7 383 22 383 226 l0 119
-340 0 -340 0 0 481 c0 510 -10 571 -99 618 -68 37 -1203 28 -1256 -10z m1224
-80 c17 -18 31 -63 31 -100 l0 -69 -620 0 -620 0 0 63 c0 136 3 137 622 137
478 0 560 -4 587 -31z m31 -769 l0 -541 -435 6 -435 5 -10 360 c-13 455 -21
470 -263 470 l-97 0 0 120 0 120 620 0 620 0 0 -540z m-1004 189 c120 -85 65
-109 -246 -109 -312 0 -340 11 -257 103 45 50 433 55 503 6z m44 -559 l0 -390
-290 0 -290 0 0 390 0 390 290 0 290 0 0 -390z m-678 41 c5 -4 5 -47 2 -95
l-7 -86 -283 4 c-242 4 -287 10 -309 39 -27 37 -33 112 -12 134 15 14 595 19
609 4z m2338 -59 c0 -37 -13 -78 -29 -91 -31 -26 -47 -27 -356 -24 l-215 3 0
90 0 90 300 0 300 0 0 -68z m-704 -299 c10 -155 16 -153 -458 -153 l-418 0 0
117 c0 149 -46 135 444 134 l426 -1 6 -97z m-960 -189 c11 -114 -13 -124 -284
-124 -274 0 -292 8 -292 125 l0 76 285 -5 285 -6 6 -66z"/>
<path d="M1668 1842 c-29 -30 9 -42 126 -42 102 0 128 6 111 23 -22 22 -218
37 -237 19z"/>
<path d="M1719 459 c-16 -31 -16 -49 2 -70 36 -44 114 -36 129 12 28 86 -88
137 -131 58z"/>
<path d="M1107 250 c-7 -18 -3 -42 9 -54 30 -30 88 -3 80 39 -9 46 -73 57 -89
15z"/>
</g>
</svg>

),

growth: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="273.000000pt" height="311.000000pt" viewBox="0 0 273.000000 311.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,311.000000) scale(0.050000,-0.050000)">
<path d="M4000 6164 c0 -11 60 -73 133 -137 l133 -117 317 -7 c174 -4 316 -13
316 -20 -2 -18 -1694 -1502 -1727 -1515 -15 -6 -193 165 -424 409 -219 230
-409 423 -423 430 -20 9 -1212 -1032 -2173 -1900 l-119 -107 190 0 189 0 935
830 c513 457 938 830 944 830 6 0 200 -193 432 -430 232 -236 430 -430 440
-430 10 0 105 79 212 176 107 97 537 481 955 853 l760 676 6 -289 5 -288 120
-119 119 -118 0 622 0 622 -565 13 c-311 8 -612 19 -670 25 -66 7 -105 4 -105
-9z"/>
<path d="M4620 2120 l0 -2080 390 0 390 0 0 2080 0 2080 -390 0 -390 0 0
-2080z"/>
<path d="M1554 3607 c-8 -7 -14 -813 -14 -1790 l0 -1777 400 0 400 0 -5 1785
-5 1785 -381 5 c-210 3 -388 0 -395 -8z"/>
<path d="M3600 1690 l0 -1650 390 0 390 0 0 1650 0 1650 -390 0 -390 0 0
-1650z"/>
<path d="M2580 1340 l0 -1300 390 0 390 0 0 1300 0 1300 -390 0 -390 0 0
-1300z"/>
<path d="M520 740 l0 -700 400 0 400 0 0 700 0 700 -400 0 -400 0 0 -700z"/>
</g>
</svg>
), 

storage: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="436.000000pt" height="416.000000pt" viewBox="0 0 436.000000 416.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,416.000000) scale(0.050000,-0.050000)">
<path d="M3640 8238 c-1897 -114 -3398 -733 -3572 -1473 -44 -187 -40 -4955 4
-5106 486 -1662 6587 -1961 8141 -400 308 309 291 125 283 3041 l-6 2471 -64
130 c-431 874 -2565 1470 -4786 1337z m1040 -419 c1704 -82 3121 -547 3360
-1104 343 -796 -1957 -1520 -4372 -1377 -2030 120 -3475 759 -3157 1397 278
558 1798 1041 3439 1091 99 3 212 7 250 10 39 2 255 -6 480 -17z m-4007 -2166
c1710 -1027 5683 -1018 7228 17 182 121 192 118 173 -59 -26 -258 -236 -461
-701 -681 -2131 -1005 -6826 -510 -6909 729 l-9 129 47 -30 c27 -17 103 -64
171 -105z m297 -1093 c1142 -545 3145 -745 4910 -488 817 118 1512 346 2004
655 190 119 196 119 196 15 -1 -500 -786 -922 -2145 -1151 -2486 -421 -5473
209 -5475 1153 l0 113 175 -110 c96 -60 247 -144 335 -187z m-320 -752 c1605
-1046 5721 -1040 7268 11 148 100 171 93 154 -53 -63 -540 -1009 -975 -2532
-1164 -2442 -304 -5078 325 -5080 1213 0 128 -17 128 190 -7z m30 -948 c1681
-1039 5722 -1021 7236 32 167 116 172 115 158 -41 -33 -347 -429 -653 -1153
-892 -2378 -784 -6366 -233 -6456 892 -13 157 -23 156 215 9z m-68 -893 c548
-370 1409 -624 2578 -760 381 -45 1667 -51 2040 -11 1236 134 2141 391 2687
762 151 103 172 94 156 -61 -94 -898 -2924 -1496 -5334 -1127 -1408 216 -2278
665 -2279 1175 0 63 3 115 7 115 4 0 70 -42 145 -93z"/>
<path d="M3770 7547 c-1378 -68 -2679 -458 -2760 -829 -30 -137 104 -210 185
-101 162 220 998 465 1955 573 1586 180 3664 -90 4171 -542 147 -132 204 -124
215 32 37 494 -1963 955 -3766 867z"/>
</g>
</svg>

),

pinOnMap: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="318.000000pt" height="290.000000pt" viewBox="0 0 318.000000 290.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,290.000000) scale(0.050000,-0.050000)">
<path d="M2628 5631 c-765 -174 -1184 -1059 -833 -1761 112 -225 411 -693 690
-1080 l58 -80 -106 -13 c-59 -7 -336 -24 -616 -37 l-509 -24 -641 -300 c-720
-336 -688 -317 -652 -385 25 -46 2195 -1892 2244 -1908 12 -5 41 15 64 42 24
27 219 156 433 286 215 130 427 261 473 292 l83 56 807 6 807 7 656 193 c705
208 694 205 694 243 0 27 -2262 1898 -2307 1908 -15 3 -115 -26 -224 -65 -108
-38 -199 -67 -203 -64 -3 4 86 146 199 316 386 582 466 758 488 1079 60 838
-746 1485 -1605 1289z m606 -538 c498 -254 499 -924 1 -1172 -555 -278 -1150
342 -857 892 164 307 553 435 856 280z m1092 -2422 c185 -151 333 -278 330
-281 -41 -33 -1176 -349 -1286 -358 -126 -10 -178 -16 -350 -41 -27 -4 -242
-35 -476 -68 l-426 -60 -606 -278 -606 -278 -393 331 -393 331 115 52 c63 29
331 155 595 280 551 260 472 243 1268 278 287 13 477 13 491 2 12 -10 94 -122
181 -249 88 -127 170 -231 182 -231 22 -1 167 197 169 230 1 11 32 60 69 109
37 50 119 164 182 255 82 119 124 163 147 155 18 -5 122 20 232 57 109 37 208
62 219 54 11 -8 171 -138 356 -290z m1131 -929 c366 -301 662 -549 659 -552
-3 -3 -234 -70 -513 -150 l-507 -144 -958 465 c-527 256 -953 471 -947 477 11
11 63 17 234 27 41 2 75 11 75 20 0 8 22 15 50 15 50 0 1090 309 1155 343 19
10 35 32 35 49 0 43 -19 57 717 -550z m-1612 -415 c536 -261 975 -481 975
-491 0 -18 -326 -26 -1068 -26 -381 0 -500 -6 -507 -25 -5 -14 -16 -25 -24
-25 -9 0 -230 -131 -490 -290 -260 -159 -478 -290 -483 -290 -7 0 -1049 873
-1193 999 -9 8 243 132 560 276 602 275 567 264 915 294 33 2 76 12 96 20 19
9 62 10 96 4 37 -8 55 -5 48 7 -47 76 205 -30 1075 -453z"/>
<path d="M2360 2229 c-264 -166 -494 -197 -813 -112 -281 74 -490 53 -757 -78
-138 -68 -172 -105 -133 -144 16 -16 71 1 204 65 240 113 389 126 673 58 352
-84 557 -57 851 110 104 59 145 93 145 122 0 60 -49 54 -170 -21z"/>
<path d="M1830 1220 c-127 -26 -310 -114 -310 -150 0 -53 46 -53 181 3 223 92
341 81 527 -49 324 -226 521 -226 959 1 160 83 196 120 156 160 -18 18 -58 5
-160 -51 -427 -230 -622 -237 -897 -29 -156 118 -282 149 -456 115z"/>
</g>
</svg>

),


internet: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="561.000000pt" height="560.000000pt" viewBox="0 0 561.000000 560.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,560.000000) scale(0.050000,-0.050000)">
<path d="M5080 11110 c-830 -102 -1524 -316 -2145 -662 -2366 -1319 -3448
-4106 -2576 -6634 916 -2657 3689 -4223 6411 -3621 3538 782 5385 4677 3755
7916 -662 1317 -2007 2429 -3400 2811 -690 189 -1464 261 -2045 190z m887
-690 c744 -48 1632 -339 2191 -719 l113 -76 74 -308 c93 -387 194 -1078 195
-1332 0 -14 -47 -47 -105 -74 -58 -26 -132 -65 -165 -86 l-59 -38 -361 174
c-612 296 -1158 469 -1871 592 -415 71 -1421 82 -1837 19 l-228 -34 -137 144
c-75 79 -137 161 -137 182 0 118 529 1172 667 1329 89 102 157 126 533 185
420 67 616 74 1127 42z m-2187 -355 c0 -8 -87 -199 -193 -425 -106 -225 -218
-477 -248 -560 l-54 -150 -108 -22 c-236 -48 -413 -170 -521 -361 -68 -121
-13 -107 -598 -158 -485 -43 -464 -53 -307 150 455 595 1038 1069 1734 1413
259 128 295 141 295 113z m5202 -1011 c875 -884 1346 -1912 1449 -3164 16
-186 25 -190 -175 70 -207 269 -493 592 -726 820 l-214 210 25 103 c74 310
-90 675 -357 795 -102 46 -101 45 -125 361 -25 331 -53 552 -101 788 -61 303
-59 303 224 17z m-3307 -815 c615 -53 1439 -295 2058 -605 l262 -132 9 -206
c13 -296 121 -497 325 -607 91 -49 92 -81 1 -438 -102 -400 -93 -389 -329
-418 -103 -12 -93 -21 -474 410 -745 841 -1766 1502 -2892 1870 -186 61 -331
119 -322 128 39 39 900 37 1362 -2z m-3565 -267 c-222 -106 -506 -270 -784
-453 -254 -167 -250 -169 -147 64 169 378 159 364 271 383 329 56 596 91 710
91 l130 1 -180 -86z m2167 -112 c1266 -358 2358 -1063 3198 -2067 l131 -157
-62 -123 c-147 -289 -123 -597 60 -787 74 -77 78 -64 -120 -360 -385 -575
-890 -1108 -1442 -1524 -321 -242 -351 -258 -407 -223 -251 161 -426 194 -676
129 l-144 -37 -80 89 c-962 1085 -1493 2638 -1448 4240 13 491 14 493 111 510
133 22 304 133 411 267 119 148 103 146 468 43z m-1547 -72 c30 -39 99 -98
153 -132 l98 -60 -15 -153 c-171 -1668 365 -3446 1442 -4783 105 -130 151
-203 145 -230 -4 -22 -18 -80 -30 -130 -12 -49 -29 -143 -37 -208 -19 -138 16
-119 -477 -262 -333 -96 -630 -158 -949 -199 l-210 -26 -144 109 c-970 734
-1613 1754 -1871 2971 l-64 305 1 620 c1 654 30 932 118 1117 83 175 851 692
1477 995 335 162 296 154 363 66z m6642 -1333 c413 -424 705 -794 947 -1199
l104 -174 -51 -276 c-161 -872 -454 -1532 -978 -2202 -190 -243 -176 -251
-232 126 -93 625 -219 1094 -441 1640 l-115 283 49 59 c213 255 210 665 -6
905 -110 122 -119 50 112 908 12 41 31 75 45 76 13 0 83 27 154 59 72 32 135
59 142 59 7 1 128 -118 270 -264z m-996 -2145 c274 -652 502 -1659 504 -2223
0 -190 -1372 -1047 -1677 -1047 -123 0 -717 299 -1141 574 l-227 148 16 124
c10 68 18 184 18 256 l1 133 170 116 c639 437 1300 1116 1764 1815 l183 275
161 -5 161 -6 67 -160z m-3674 -2717 c254 -194 533 -233 785 -110 l90 43 246
-160 c281 -181 582 -360 722 -428 128 -62 124 -67 -100 -106 -995 -172 -1976
-39 -2943 401 -82 37 -145 71 -140 76 4 4 134 36 288 70 286 63 757 198 875
249 88 39 78 40 177 -35z"/>
</g>
</svg>

),


verified: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="263.000000pt" height="347.000000pt" viewBox="0 0 263.000000 347.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,347.000000) scale(0.050000,-0.050000)">
<path d="M2480 6838 c-38 -23 -134 -104 -213 -180 -164 -158 -161 -158 -397
-78 -366 124 -541 23 -620 -354 -27 -132 -97 -177 -316 -202 -397 -45 -458
-132 -407 -588 l18 -155 -61 -55 c-33 -31 -124 -96 -203 -146 -246 -154 -283
-289 -142 -520 44 -72 99 -168 124 -214 l44 -83 -50 -97 c-27 -53 -79 -144
-116 -202 -150 -235 -105 -378 178 -559 231 -147 234 -153 203 -404 -46 -379
32 -472 428 -511 197 -20 239 -46 289 -185 23 -63 56 -153 73 -201 85 -230
220 -281 498 -186 297 101 289 103 467 -66 307 -291 382 -293 663 -22 190 183
198 185 414 113 427 -144 471 -118 655 384 42 114 91 141 291 162 388 42 465
136 420 518 -28 240 -20 260 134 355 362 224 409 343 241 608 -174 276 -177
302 -54 485 219 324 195 449 -125 657 -227 148 -229 152 -196 406 48 372 -42
474 -448 511 -76 7 -155 22 -177 33 -38 21 -134 203 -135 254 0 15 -24 76 -52
137 -95 200 -227 232 -535 127 -238 -81 -235 -82 -410 88 -228 220 -337 258
-483 170z m337 -286 c245 -236 307 -252 596 -152 283 98 311 84 393 -192 77
-261 221 -368 493 -368 219 0 272 -62 241 -276 -49 -337 -16 -412 262 -594
237 -156 242 -172 108 -379 -195 -303 -194 -358 17 -700 118 -191 121 -185
-201 -393 -205 -132 -231 -226 -175 -618 21 -148 -17 -177 -272 -208 -326 -40
-385 -90 -489 -408 -78 -239 -91 -245 -361 -155 -321 106 -363 96 -602 -138
-204 -199 -227 -198 -441 31 -170 182 -277 208 -521 125 -325 -110 -331 -108
-424 160 -106 305 -150 340 -476 383 -291 38 -287 32 -256 380 24 271 -18 339
-329 537 -170 109 -172 129 -31 363 170 280 168 351 -12 630 -144 223 -140
237 127 407 236 151 268 209 245 462 -31 342 -24 360 149 381 427 52 497 97
575 369 82 285 110 299 394 201 289 -100 351 -84 596 152 97 94 169 148 197
148 28 0 100 -54 197 -148z"/>
<path d="M2330 6072 c-1490 -244 -2067 -2083 -984 -3134 1120 -1088 3015 -348
3108 1213 69 1164 -976 2110 -2124 1921z m700 -212 c1073 -274 1579 -1519
1001 -2462 -728 -1190 -2506 -998 -2973 321 -434 1225 708 2464 1972 2141z"/>
<path d="M2870 4660 c-286 -286 -525 -520 -532 -520 -7 0 -92 81 -189 180 -97
99 -182 180 -189 180 -22 0 -401 -386 -395 -403 4 -14 757 -777 766 -777 10 0
1469 1466 1469 1476 0 17 -378 384 -396 384 -8 0 -248 -234 -534 -520z"/>
<path d="M771 2166 c-330 -673 -618 -1799 -494 -1923 76 -76 112 -62 313 127
178 167 602 486 619 466 3 -3 20 -34 38 -69 67 -132 365 -549 480 -672 119
-128 204 -63 244 185 62 386 178 762 349 1132 l75 162 -67 53 c-36 29 -69 53
-74 53 -71 0 -454 -1113 -454 -1319 0 -91 -150 93 -352 430 -147 248 -152 254
-214 254 -77 0 -461 -262 -691 -470 -110 -101 -111 -99 -63 137 110 540 262
993 480 1427 121 242 121 221 3 221 l-97 0 -95 -194z"/>
<path d="M4180 2351 c0 -7 49 -110 110 -231 219 -437 394 -969 480 -1459 32
-185 30 -188 -75 -89 -159 150 -518 414 -622 458 -86 36 -146 3 -204 -112 -79
-156 -386 -598 -415 -598 -5 0 -16 43 -23 95 -47 330 -331 1140 -443 1263 -3
4 -37 -19 -73 -50 l-67 -58 85 -180 c163 -348 347 -988 347 -1207 0 -76 61
-143 129 -143 80 0 331 303 535 645 45 75 87 139 95 144 28 18 453 -306 659
-502 130 -124 182 -145 252 -99 140 92 -101 1109 -438 1852 l-122 270 -105 6
c-58 3 -105 1 -105 -5z"/>
</g>
</svg>

),


subscribers:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="226.000000pt" height="208.000000pt" viewBox="0 0 226.000000 208.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,208.000000) scale(0.050000,-0.050000)">
<path d="M980 4088 c-331 -89 -480 -298 -480 -674 0 -168 -3 -181 -51 -219
-104 -81 -101 -252 5 -409 28 -41 64 -120 80 -175 196 -671 1067 -832 1466
-271 88 124 6 115 -118 -13 -438 -450 -1110 -265 -1283 353 -14 50 -42 108
-61 130 -99 112 -109 302 -18 336 l60 23 0 208 c0 456 182 635 668 658 405 19
632 -60 764 -267 88 -137 159 -127 88 12 -145 284 -670 429 -1120 308z"/>
<path d="M2780 3980 c-467 -80 -660 -304 -660 -765 l0 -198 -70 -66 c-103 -97
-95 -286 20 -441 24 -33 60 -109 79 -170 299 -925 1478 -944 1774 -28 25 76
64 165 88 198 116 159 125 352 21 442 l-72 62 0 212 c0 581 -463 877 -1180
754z m520 -81 c415 -67 565 -244 576 -685 l8 -276 53 -20 c118 -46 115 -237
-8 -378 -24 -27 -54 -94 -67 -147 -216 -890 -1428 -890 -1644 0 -13 53 -39
115 -58 137 -130 149 -137 342 -15 388 l55 21 0 237 c0 273 27 379 129 497
173 202 559 292 971 226z"/>
<path d="M564 1969 c-387 -190 -483 -326 -527 -740 -36 -343 21 -453 283 -544
313 -109 1193 -179 1177 -93 -7 35 -35 39 -357 51 -789 29 -1032 136 -1027
454 6 464 109 626 517 815 138 64 209 108 205 126 -9 52 -44 43 -271 -69z"/>
<path d="M1833 2067 c-31 -31 -5 -53 138 -119 83 -39 196 -97 251 -129 98 -58
138 -62 138 -12 0 57 -488 298 -527 260z"/>
<path d="M2190 1602 c-473 -232 -590 -428 -590 -989 l0 -220 86 -83 c401 -384
2392 -366 2735 25 106 120 77 633 -50 883 -81 159 -589 502 -745 502 -97 0 -6
-79 209 -183 453 -217 564 -394 565 -900 l0 -214 -81 -69 c-191 -164 -528
-224 -1259 -224 -777 0 -1125 61 -1303 231 l-77 73 0 198 c1 513 109 686 568
909 182 88 247 129 239 150 -17 44 -38 38 -297 -89z"/>
</g>
</svg>

),


clock: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="199.000000pt" height="199.000000pt" viewBox="0 0 199.000000 199.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,199.000000) scale(0.050000,-0.050000)">
<path d="M1613 3909 c-2291 -455 -1976 -3850 357 -3858 1888 -6 2688 2348
1190 3498 -424 325 -1022 464 -1547 360z m737 -162 c1134 -212 1768 -1524
1240 -2567 -674 -1333 -2596 -1307 -3230 44 -630 1346 516 2799 1990 2523z"/>
<path d="M1944 3616 c-65 -65 -2 -158 77 -115 62 33 38 139 -31 139 -12 0 -33
-11 -46 -24z"/>
<path d="M1139 3388 c-35 -42 0 -98 61 -98 61 0 96 56 61 98 -14 18 -42 32
-61 32 -19 0 -47 -14 -61 -32z"/>
<path d="M2708 3393 c-24 -63 0 -103 62 -103 53 0 60 7 60 60 0 68 -99 103
-122 43z"/>
<path d="M1944 3216 c-17 -17 -24 -159 -24 -510 l0 -486 68 0 69 0 2 470 c2
527 -19 622 -115 526z"/>
<path d="M573 2827 c-30 -31 -12 -105 29 -118 56 -18 107 33 89 89 -13 41 -87
59 -118 29z"/>
<path d="M3293 2827 c-7 -8 -13 -34 -13 -59 0 -58 72 -84 114 -42 42 42 16
114 -42 114 -25 0 -51 -6 -59 -13z"/>
<path d="M1869 2111 c-104 -104 -32 -291 112 -291 79 0 179 95 179 170 0 138
-193 218 -291 121z"/>
<path d="M362 2032 c-41 -50 -8 -115 55 -108 44 5 53 16 53 66 0 69 -65 94
-108 42z"/>
<path d="M3499 2029 c-36 -43 -1 -99 63 -99 40 0 48 10 48 60 0 70 -66 94
-111 39z"/>
<path d="M2175 1879 l-33 -58 144 -84 c79 -45 228 -132 331 -191 183 -108 232
-118 256 -55 20 51 33 42 -584 399 l-80 47 -34 -58z"/>
<path d="M585 1267 c-33 -14 -32 -96 2 -125 61 -50 143 48 92 109 -24 30 -49
34 -94 16z"/>
<path d="M3305 1267 c-37 -15 -30 -102 9 -124 74 -41 142 53 82 113 -25 25
-49 28 -91 11z"/>
<path d="M1139 668 c-35 -42 0 -98 61 -98 61 0 96 56 61 98 -14 18 -42 32 -61
32 -19 0 -47 -14 -61 -32z"/>
<path d="M2708 673 c-24 -63 0 -103 62 -103 53 0 60 7 60 60 0 68 -99 103
-122 43z"/>
<path d="M1954 477 c-48 -27 -44 -111 7 -127 49 -16 99 21 99 72 0 49 -61 80
-106 55z"/>
</g>
</svg>

),


user :(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="397.000000pt" height="495.000000pt" viewBox="0 0 397.000000 495.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,495.000000) scale(0.050000,-0.050000)">
<path d="M3530 9788 c-2075 -366 -2859 -2912 -1348 -4378 1620 -1572 4338
-420 4340 1840 2 1591 -1438 2812 -2992 2538z"/>
<path d="M3522 4420 c-1714 -144 -3061 -1020 -3377 -2198 -69 -256 -83 -1440
-19 -1602 92 -233 265 -403 489 -478 171 -58 6473 -67 6666 -10 231 69 432
263 513 495 64 182 50 1337 -19 1593 -376 1398 -2251 2368 -4253 2200z"/>
</g>
</svg>

),

playSymbol : (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="200.000000pt" height="231.000000pt" viewBox="0 0 200.000000 231.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,231.000000) scale(0.050000,-0.050000)">
<path d="M467 4538 c-118 -34 -251 -143 -315 -258 l-62 -110 -5 -1819 c-7
-2067 -16 -1942 155 -2113 144 -144 353 -194 537 -129 92 32 2883 1787 2966
1865 222 207 232 581 22 805 -93 98 -2785 1680 -2985 1754 -80 29 -222 32
-313 5z"/>
</g>
</svg>

),


timeDuration : (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="432.000000pt" height="475.000000pt" viewBox="0 0 432.000000 475.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,475.000000) scale(0.050000,-0.050000)">
<path d="M3420 9050 l0 -390 290 0 290 0 0 -429 0 -429 -65 -11 c-36 -5 -137
-20 -225 -32 -604 -81 -1320 -396 -1808 -793 l-109 -89 -296 296 c-343 343
-329 307 -185 448 259 254 209 549 -99 575 -154 12 -171 -1 -686 -519 -532
-536 -574 -615 -427 -802 139 -177 335 -149 558 79 l107 110 298 -297 c339
-338 321 -303 219 -424 -567 -679 -893 -1736 -822 -2666 233 -3062 3728 -4653
6177 -2811 1718 1291 2040 3831 695 5481 l-96 117 297 297 c163 164 306 298
316 299 11 0 80 -60 154 -133 232 -230 520 -184 567 91 24 146 -26 213 -533
715 -508 504 -531 519 -695 470 -260 -78 -281 -332 -48 -567 l135 -136 -307
-308 -308 -308 -107 88 c-549 447 -1193 709 -2012 818 l-95 12 0 429 0 429
300 0 300 0 0 390 0 390 -890 0 -890 0 0 -390z m713 -2229 c3 -358 53 -454
216 -413 117 29 131 72 131 395 0 341 -14 320 191 295 334 -42 654 -129 934
-255 l135 -61 -142 -244 c-157 -270 -175 -346 -98 -428 116 -123 224 -70 371
183 63 109 130 222 149 253 l34 57 158 -120 c199 -150 430 -375 587 -573 190
-239 198 -206 -89 -370 -265 -151 -290 -176 -290 -287 0 -79 90 -173 166 -173
23 0 153 63 288 140 135 77 254 140 264 140 75 0 287 -716 332 -1125 l13 -115
-297 0 c-376 0 -465 -51 -406 -231 35 -106 111 -129 430 -129 l274 0 -11 -75
c-6 -41 -17 -124 -24 -185 -30 -254 -153 -670 -262 -887 -47 -91 -51 -95 -93
-68 -456 293 -674 322 -674 90 0 -100 37 -137 294 -284 130 -75 240 -139 244
-143 57 -50 -797 -908 -903 -908 -7 0 -76 113 -155 250 -79 138 -160 259 -180
270 -104 56 -257 -17 -262 -124 -5 -83 4 -103 136 -331 71 -123 126 -234 122
-247 -23 -70 -589 -254 -946 -308 -323 -48 -290 -79 -290 271 0 347 -22 399
-170 399 -144 0 -170 -56 -172 -369 -3 -306 -3 -303 -22 -321 -70 -71 -1179
229 -1212 328 -4 13 52 125 124 250 179 307 169 472 -28 472 -103 0 -131 -29
-280 -290 -79 -137 -148 -250 -155 -250 -132 0 -965 869 -884 922 16 10 126
73 244 140 287 162 348 267 226 389 -91 91 -186 60 -605 -194 l-64 -39 -49 97
c-122 240 -248 701 -281 1029 l-12 113 300 7 c349 7 410 36 406 190 -4 144
-58 166 -409 166 l-300 0 13 115 c46 412 256 1125 332 1125 10 0 130 -64 267
-142 309 -176 451 -161 451 46 0 97 -28 124 -289 275 -288 166 -280 132 -91
370 161 202 386 422 584 572 l162 122 34 -57 c19 -31 86 -144 149 -253 147
-253 255 -306 371 -183 75 80 58 155 -98 426 l-141 246 131 59 c323 145 950
299 1098 270 12 -3 21 -118 23 -290z"/>
<path d="M4189 5931 c-29 -29 -49 -73 -49 -105 0 -31 -1 -351 -2 -712 -1 -590
-4 -660 -34 -685 -19 -16 -73 -62 -120 -103 -356 -302 -140 -886 327 -886 172
0 339 93 429 239 l49 81 627 0 c751 0 764 3 764 193 0 49 -15 83 -53 118 l-53
49 -644 0 -645 0 -25 60 c-27 66 -155 189 -231 224 l-49 22 0 728 0 728 -49
49 c-67 67 -175 67 -242 0z"/>
</g>
</svg>

),

timeDuration1 : (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="286.000000pt" height="338.000000pt" viewBox="0 0 286.000000 338.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,338.000000) scale(0.050000,-0.050000)">
<path d="M2184 6667 c-131 -65 -154 -126 -154 -407 0 -326 53 -406 290 -434
l100 -12 0 -103 0 -104 -135 -25 c-1745 -318 -2716 -2350 -1893 -3963 1117
-2189 4319 -1943 5105 394 516 1533 -495 3283 -2062 3569 l-135 25 0 106 c0
103 2 107 55 107 103 0 197 39 266 111 l69 71 0 254 c0 287 -23 348 -158 412
-102 48 -1249 47 -1348 -1z m1272 -211 c44 -44 32 -370 -15 -395 -52 -28
-1110 -28 -1162 0 -47 25 -59 351 -15 395 34 34 1158 34 1192 0z m-376 -726
l0 -90 -220 0 -220 0 0 90 0 90 220 0 220 0 0 -90z m350 -367 c1999 -501 2659
-2921 1182 -4338 -1005 -966 -2616 -930 -3584 79 -1434 1495 -600 3974 1445
4295 200 32 773 10 957 -36z"/>
<path d="M2800 5084 l-50 -40 -6 -1047 c-3 -576 0 -1077 6 -1114 17 -93 1541
-1623 1616 -1623 60 0 208 153 347 360 818 1214 275 2871 -1103 3365 -310 111
-731 163 -810 99z m552 -254 c1369 -347 1975 -1976 1160 -3118 -153 -215 -65
-269 -853 519 l-699 699 0 943 c0 519 5 958 12 975 18 47 149 41 380 -18z"/>
</g>
</svg>

),

timeDuration0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="294.000000pt" height="348.000000pt" viewBox="0 0 294.000000 348.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,348.000000) scale(0.100000,-0.100000)">
<path d="M1142 3434 c-21 -15 -22 -21 -22 -174 0 -200 -9 -190 178 -190 l133
0 -3 -87 -3 -88 -100 -12 c-238 -30 -462 -109 -636 -227 l-52 -35 -21 27 c-12
15 -36 46 -54 68 l-32 42 75 56 c55 41 75 63 75 79 0 14 -38 73 -91 142 -94
125 -104 135 -130 135 -9 0 -100 -63 -202 -141 -162 -121 -187 -144 -187 -167
1 -40 177 -266 211 -270 17 -2 45 12 91 48 37 27 69 50 72 50 3 0 28 -30 56
-67 l52 -68 -55 -50 c-135 -122 -269 -312 -341 -484 -213 -505 -124 -1076 233
-1488 246 -285 583 -456 971 -493 322 -31 679 65 945 255 142 101 170 140 127
178 -29 26 -43 21 -118 -39 -394 -316 -934 -381 -1402 -168 -188 86 -412 275
-530 446 -152 222 -232 481 -232 748 0 154 20 283 66 419 134 400 436 702 837
836 246 82 535 89 790 19 389 -107 742 -429 877 -803 126 -345 115 -692 -30
-1015 l-23 -50 -11 34 c-6 19 -23 41 -38 49 -24 14 -28 14 -47 -3 -25 -23 -26
-34 -5 -161 11 -64 24 -107 35 -119 18 -19 20 -19 139 4 102 19 124 26 136 46
33 50 -8 90 -78 75 -23 -6 -44 -8 -46 -6 -2 1 10 29 26 61 16 33 44 99 61 148
188 532 38 1128 -380 1516 l-59 55 51 65 c28 36 55 66 59 68 5 2 39 -19 75
-47 68 -53 90 -60 117 -38 8 6 55 65 103 130 77 102 87 121 79 142 -14 35
-368 297 -396 293 -21 -3 -93 -89 -184 -220 -37 -52 -28 -76 51 -133 36 -27
65 -50 65 -53 0 -7 -101 -142 -107 -142 -2 0 -23 13 -46 28 -170 116 -396 196
-632 225 l-100 12 -3 88 -3 87 136 0 c182 0 175 -8 175 190 0 137 -2 152 -20
170 -19 19 -33 20 -338 20 -271 0 -321 -2 -340 -16z m588 -174 l0 -80 -252 2
-253 3 -3 64 c-2 35 -1 70 2 77 4 11 54 14 256 14 l250 0 0 -80z m913 -312
l117 -89 -45 -59 c-25 -33 -49 -61 -54 -64 -4 -3 -62 36 -127 86 -66 50 -121
93 -122 94 -2 1 17 32 43 68 29 41 51 63 58 59 7 -4 65 -47 130 -95z m-2140
26 c27 -36 47 -67 45 -68 -1 -2 -59 -45 -127 -96 l-124 -94 -23 30 c-14 16
-37 47 -51 68 l-28 39 23 15 c13 9 69 50 125 93 56 43 104 78 107 78 3 0 27
-29 53 -65z"/>
<path d="M1339 2590 c-415 -49 -785 -343 -929 -739 -55 -150 -65 -211 -64
-391 0 -135 4 -181 22 -253 130 -521 581 -877 1112 -877 530 0 982 356 1112
875 29 120 32 381 5 493 -142 589 -667 961 -1258 892z m396 -130 c119 -32 213
-74 312 -140 212 -140 371 -360 436 -602 19 -72 22 -107 21 -263 0 -164 -3
-187 -27 -265 -109 -356 -366 -615 -710 -714 -144 -42 -280 -53 -414 -33 -427
62 -744 333 -870 747 -24 78 -27 101 -27 265 -1 210 14 284 88 441 55 116 115
201 208 293 154 153 343 251 567 292 85 15 328 3 416 -21z"/>
<path d="M1448 2419 c-15 -8 -18 -25 -18 -95 0 -80 1 -85 25 -96 19 -8 31 -8
50 0 24 11 25 16 25 96 0 74 -3 87 -19 96 -24 12 -41 12 -63 -1z"/>
<path d="M990 2290 c-27 -27 -25 -42 13 -111 33 -61 57 -77 96 -64 35 11 35
47 2 113 -41 82 -73 100 -111 62z"/>
<path d="M1907 2299 c-27 -16 -80 -127 -73 -155 7 -25 42 -40 73 -30 19 6 83
114 83 140 0 19 -35 56 -52 56 -7 0 -21 -5 -31 -11z"/>
<path d="M1452 2144 c-22 -15 -22 -18 -22 -264 l0 -249 -29 -16 c-70 -36 -107
-131 -82 -208 7 -20 29 -51 50 -70 71 -64 170 -59 235 13 20 22 36 45 36 50 0
6 62 10 166 10 95 0 174 4 185 10 27 15 25 64 -3 84 -18 13 -54 16 -183 16
l-161 0 -18 30 c-10 17 -35 42 -57 57 l-39 26 0 248 c0 245 0 248 -22 263 -12
9 -25 16 -28 16 -3 0 -16 -7 -28 -16z m66 -630 c45 -31 19 -114 -36 -114 -36
0 -62 27 -62 66 0 34 28 64 60 64 9 0 26 -7 38 -16z"/>
<path d="M2250 1972 c-45 -21 -112 -67 -121 -84 -8 -15 -6 -25 6 -44 22 -33
58 -31 125 9 45 27 56 38 58 64 2 23 -3 35 -20 47 -25 17 -26 18 -48 8z"/>
<path d="M651 1956 c-26 -32 -9 -68 49 -103 82 -49 130 -42 130 19 0 22 -10
34 -55 63 -58 37 -105 45 -124 21z"/>
<path d="M531 1506 c-7 -8 -11 -30 -9 -48 3 -33 4 -33 63 -38 92 -8 125 -1
137 26 8 18 7 29 -6 49 -15 23 -22 25 -95 25 -56 0 -82 -4 -90 -14z"/>
<path d="M2244 1495 c-13 -20 -14 -31 -6 -49 12 -27 45 -34 137 -26 59 5 60 5
63 38 5 53 -10 62 -99 62 -73 0 -80 -2 -95 -25z"/>
<path d="M710 1090 c-62 -39 -70 -47 -70 -74 0 -25 28 -56 51 -56 27 0 137 72
143 94 3 11 -1 31 -10 43 -20 31 -58 29 -114 -7z"/>
<path d="M2141 1106 c-25 -30 -9 -69 44 -104 28 -18 60 -35 73 -38 41 -11 79
46 54 82 -14 20 -113 74 -136 74 -13 0 -29 -6 -35 -14z"/>
<path d="M1033 807 c-10 -13 -29 -47 -42 -75 -23 -49 -23 -52 -7 -77 19 -29
56 -33 78 -7 26 28 68 109 68 130 0 24 -31 52 -58 52 -11 0 -29 -10 -39 -23z"/>
<path d="M1847 812 c-10 -10 -17 -26 -17 -36 0 -19 43 -101 68 -128 22 -26 59
-22 78 7 16 25 16 28 -7 77 -45 97 -84 122 -122 80z"/>
<path d="M1452 704 c-19 -13 -22 -24 -22 -93 0 -84 8 -101 50 -101 42 0 50 17
50 101 0 69 -3 80 -22 93 -12 9 -25 16 -28 16 -3 0 -16 -7 -28 -16z"/>
</g>
</svg>

),

playNow: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="600.000000pt" height="704.000000pt" viewBox="0 0 600.000000 704.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,704.000000) scale(0.050000,-0.050000)">
<path d="M3234 13989 c-3019 -470 -4202 -4071 -2105 -6406 648 -722 1900
-1210 2883 -1124 130 11 243 14 251 6 11 -12 719 -1164 921 -1500 47 -78 47
-78 -107 -15 -863 350 -1841 89 -2167 -579 -188 -384 -73 -657 380 -906 121
-66 364 -200 540 -296 482 -265 678 -408 1253 -913 1963 -1724 2081 -1826
2237 -1926 557 -356 1149 -339 1813 54 2026 1199 2038 1207 2207 1376 579 579
738 1679 361 2510 -54 119 -983 1758 -1282 2260 -409 687 -793 958 -1400 985
-392 17 -451 -1 -1844 -574 -316 -130 -368 -139 -455 -88 -43 26 -358 467
-428 600 -6 13 45 85 115 160 204 221 241 267 381 473 765 1129 875 2620 282
3844 -698 1443 -2293 2299 -3836 2059z m835 -570 c2604 -298 3747 -3358 1998
-5351 l-102 -117 -415 629 c-228 346 -419 639 -423 651 -5 12 139 113 320 225
483 299 617 481 588 803 -26 281 -142 412 -604 685 -187 111 -480 285 -651
386 -170 101 -512 304 -760 450 -247 146 -571 338 -720 426 -406 241 -460 263
-650 263 -268 -1 -470 -130 -582 -374 l-58 -125 0 -1760 0 -1760 52 -112 c178
-379 572 -466 999 -220 l137 79 78 -124 c213 -339 627 -1018 638 -1047 34 -87
-739 7 -1108 136 -1997 694 -2823 3135 -1654 4888 623 934 1819 1495 2917
1369z m-1343 -1532 c35 -17 280 -160 544 -316 583 -346 1611 -953 1945 -1149
376 -220 375 -225 -98 -519 l-326 -203 -47 60 c-62 80 -270 225 -394 277 -764
315 -1517 -215 -1462 -1030 7 -108 15 -228 18 -266 7 -108 -263 -261 -335
-190 -40 41 -48 3219 -8 3295 43 81 71 88 163 41z m1413 -2369 c195 -86 258
-174 1695 -2368 523 -799 616 -881 996 -879 l180 0 840 338 c1042 420 1166
439 1553 238 304 -159 263 -98 1503 -2288 462 -818 543 -1181 393 -1776 -134
-532 -187 -579 -1554 -1390 -1261 -748 -1244 -740 -1565 -741 -452 -1 -268
-136 -2556 1873 -899 790 -909 797 -1682 1220 -659 360 -613 314 -470 473 379
422 858 439 1744 63 439 -186 454 -191 559 -162 220 59 328 311 228 531 -54
118 -847 1423 -1920 3160 -293 473 -559 913 -592 979 -241 473 172 937 648
729z"/>
</g>
</svg>

),

playNow0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="348.000000pt" height="353.000000pt" viewBox="0 0 348.000000 353.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,353.000000) scale(0.050000,-0.050000)">
<path d="M2537 6977 c-609 -39 -1214 -316 -1656 -757 -1412 -1410 -834 -3792
1069 -4408 413 -133 1204 -164 1241 -48 25 77 -16 86 -367 80 -2464 -46 -3538
3033 -1574 4511 1710 1287 4187 -105 3985 -2238 -34 -358 -35 -347 35 -347 78
0 110 153 113 550 14 1560 -1271 2760 -2846 2657z"/>
<path d="M2044 5776 c-42 -42 -34 -2843 8 -2878 37 -30 235 59 257 116 19 50
-30 91 -93 78 l-56 -11 0 1260 0 1260 45 -23 c25 -13 329 -187 675 -387 347
-200 817 -471 1045 -602 228 -131 415 -243 415 -249 -1 -5 -174 -109 -385
-231 -329 -189 -386 -228 -391 -272 -14 -122 62 -87 886 397 204 120 391 -11
-1782 1242 -590 340 -586 338 -624 300z"/>
<path d="M2670 3822 c-188 -87 -276 -293 -201 -473 16 -39 147 -230 290 -425
143 -195 481 -653 750 -1019 270 -366 483 -665 475 -665 -9 0 -150 45 -314
100 -444 149 -617 124 -727 -104 -135 -279 -14 -456 424 -617 156 -57 511
-188 789 -292 782 -290 978 -305 1394 -106 172 82 968 740 1106 914 265 334
276 824 27 1176 -318 449 -857 1118 -933 1157 -180 94 -399 22 -493 -162 l-52
-104 -46 49 c-198 211 -568 139 -648 -126 -13 -44 -14 -44 -67 -6 -196 140
-484 63 -587 -157 -26 -55 -51 -100 -57 -100 -5 0 -171 206 -367 458 -434 557
-521 614 -763 502z m266 -137 c42 -23 226 -240 526 -625 254 -324 478 -593
497 -596 79 -13 91 50 31 167 -105 208 6 413 224 413 113 0 173 -39 305 -196
167 -198 311 -190 173 9 -110 159 -38 353 140 376 112 15 175 -21 343 -202
190 -203 292 -203 202 0 -90 204 91 405 290 322 91 -38 931 -1128 997 -1293
98 -249 63 -576 -85 -790 -120 -173 -891 -827 -1087 -922 -262 -126 -605 -143
-872 -42 -71 27 -404 150 -740 273 -880 323 -921 354 -807 594 78 165 170 163
702 -15 233 -78 438 -137 455 -131 81 31 27 110 -1363 1987 -307 414 -320 444
-256 568 64 123 203 168 325 103z"/>
</g>
</svg>
),

listAdd: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="292.000000pt" height="292.000000pt" viewBox="0 0 292.000000 292.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,292.000000) scale(0.100000,-0.100000)">
<path d="M78 2884 c-30 -16 -58 -61 -58 -94 0 -53 57 -110 110 -110 53 0 110
57 110 110 0 34 -28 78 -60 95 -36 19 -67 19 -102 -1z"/>
<path d="M518 2884 c-30 -16 -58 -61 -58 -94 0 -12 7 -34 15 -50 33 -63 -25
-60 1085 -60 1110 0 1052 -3 1085 60 19 37 19 63 0 100 -33 63 25 60 -1087 60
-877 -1 -1017 -3 -1040 -16z"/>
<path d="M78 2224 c-30 -16 -58 -61 -58 -94 0 -53 57 -110 110 -110 53 0 110
57 110 110 0 34 -28 78 -60 95 -36 19 -67 19 -102 -1z"/>
<path d="M518 2224 c-30 -16 -58 -61 -58 -94 0 -12 7 -34 15 -50 33 -63 -25
-60 1085 -60 1110 0 1052 -3 1085 60 19 37 19 63 0 100 -33 63 25 60 -1087 60
-877 -1 -1017 -3 -1040 -16z"/>
<path d="M78 1564 c-30 -16 -58 -61 -58 -94 0 -53 57 -110 110 -110 53 0 110
57 110 110 0 34 -28 78 -60 95 -36 19 -67 19 -102 -1z"/>
<path d="M518 1564 c-30 -16 -58 -61 -58 -94 0 -12 7 -34 15 -50 33 -63 -25
-60 1085 -60 1110 0 1052 -3 1085 60 19 37 19 63 0 100 -33 63 25 60 -1087 60
-877 -1 -1017 -3 -1040 -16z"/>
<path d="M2278 1124 c-51 -27 -58 -56 -58 -249 l0 -175 -175 0 c-195 0 -222
-7 -250 -60 -19 -37 -19 -63 0 -100 28 -53 55 -60 250 -60 l175 0 0 -175 c0
-195 7 -222 60 -250 37 -19 63 -19 100 0 53 28 60 55 60 250 l0 175 175 0
c195 0 222 7 250 60 19 37 19 63 0 100 -28 53 -55 60 -250 60 l-175 0 0 175
c0 195 -7 222 -60 250 -36 19 -67 19 -102 -1z"/>
<path d="M78 904 c-30 -16 -58 -61 -58 -94 0 -34 28 -78 60 -95 16 -8 38 -15
50 -15 53 0 110 57 110 110 0 34 -28 78 -60 95 -36 19 -67 19 -102 -1z"/>
<path d="M518 904 c-30 -16 -58 -61 -58 -94 0 -34 28 -78 60 -95 25 -13 98
-15 490 -15 392 0 465 2 490 15 32 17 60 61 60 95 0 34 -28 78 -60 95 -43 22
-941 22 -982 -1z"/>
</g>
</svg>
),

calendarAdd: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="358.000000pt" height="357.000000pt" viewBox="0 0 358.000000 357.000000"
 fill="currentColor"
 stroke="currentColor"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,357.000000) scale(0.050000,-0.050000)">
<path d="M1293 7059 c-52 -41 -53 -46 -53 -290 l0 -249 -227 0 c-482 0 -734
-124 -888 -439 l-55 -111 0 -1950 0 -1950 55 -111 c198 -404 339 -442 1584
-435 l915 6 38 47 c52 64 48 135 -11 194 l-49 49 -948 0 -947 0 -108 55 c-71
36 -130 85 -169 142 l-60 86 -5 1469 -6 1468 2641 0 2640 0 0 -249 c0 -244 1
-249 53 -290 74 -58 188 -40 216 35 37 95 11 1382 -29 1490 -129 343 -344 471
-823 489 l-294 10 -6 249 c-8 273 -32 326 -150 326 -115 0 -147 -74 -147 -339
l0 -241 -1470 0 -1470 0 0 245 c-1 259 -5 276 -74 312 -62 33 -93 29 -153 -18z
m-53 -1089 c0 -280 21 -330 140 -330 119 0 140 50 140 330 l0 250 1470 0 1470
0 0 -237 c0 -278 28 -343 148 -343 119 0 141 49 149 332 l6 248 244 0 c497 0
614 -113 629 -605 l9 -275 -2644 0 -2644 0 7 298 c10 478 119 582 610 582
l266 0 0 -250z"/>
<path d="M4978 3860 c-1295 -160 -2058 -1522 -1508 -2694 706 -1505 2865
-1451 3489 88 537 1326 -569 2780 -1981 2606z m633 -338 c1411 -400 1622
-2311 329 -2980 -1082 -561 -2349 209 -2349 1428 0 1060 1012 1838 2020 1552z"/>
<path d="M5127 2977 c-76 -37 -87 -101 -87 -488 l0 -369 -382 0 -381 0 -61
-61 c-48 -48 -58 -71 -47 -115 27 -116 58 -124 482 -124 l387 0 6 -402 c7
-442 18 -478 149 -478 129 0 147 59 147 489 l0 391 391 0 c430 0 489 18 489
147 0 131 -36 142 -478 149 l-402 6 0 387 c0 456 -43 552 -213 468z"/>
</g>
</svg>

),



  bookUser : (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="415.000000pt" height="497.000000pt" viewBox="0 0 415.000000 497.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,497.000000) scale(0.100000,-0.100000)">
<path d="M695 4931 c-194 -57 -334 -191 -406 -391 -21 -59 -23 -86 -27 -276
l-4 -212 209 -4 c199 -4 211 -5 264 -30 79 -36 133 -89 171 -166 29 -58 33
-76 33 -147 0 -102 -33 -178 -106 -247 -84 -79 -129 -90 -366 -96 l-203 -4 0
-264 0 -264 208 0 207 0 62 -29 c213 -101 268 -364 112 -535 -29 -32 -72 -65
-106 -82 -57 -28 -61 -28 -270 -32 l-213 -4 0 -264 0 -264 193 0 c218 0 263
-8 340 -63 214 -152 186 -474 -52 -586 -54 -25 -63 -26 -269 -29 l-214 -3 4
-217 c4 -187 8 -225 25 -272 63 -171 159 -282 308 -355 141 -70 39 -66 1621
-62 l1429 2 60 22 c192 68 336 216 394 407 21 68 21 69 21 2025 0 2168 5 2006
-66 2142 -74 140 -203 249 -350 294 l-80 25 -1435 -1 c-1334 0 -1438 -2 -1494
-18z m1750 -1205 c131 -35 240 -107 321 -211 60 -78 81 -120 105 -212 36 -143
17 -293 -54 -428 -46 -88 -156 -192 -248 -236 -99 -48 -155 -61 -271 -60 -304
1 -549 229 -575 536 -23 277 161 535 436 611 62 17 224 17 286 0z m320 -1379
c175 -62 304 -173 378 -328 59 -122 68 -169 74 -377 l6 -172 -914 2 -914 3 -3
110 c-8 275 46 445 188 595 91 95 224 167 353 189 29 5 210 9 402 7 l350 -1
80 -28z"/>
<path d="M131 3873 c-132 -66 -129 -269 5 -334 40 -19 58 -20 286 -17 239 3
245 4 279 27 58 40 83 87 83 156 0 69 -23 116 -76 155 -33 25 -35 25 -288 28
-223 2 -259 0 -289 -15z"/>
<path d="M155 2669 c-59 -17 -125 -109 -125 -173 0 -49 24 -103 61 -138 55
-52 107 -61 352 -56 174 3 207 6 241 22 78 39 122 141 96 222 -17 51 -75 112
-118 124 -45 12 -465 12 -507 -1z"/>
<path d="M171 1460 c-131 -32 -182 -196 -93 -302 52 -62 82 -68 332 -68 197 0
230 3 265 19 111 50 146 182 75 280 -53 73 -66 76 -320 78 -124 1 -240 -2
-259 -7z"/>
</g>
</svg>

  ),

  gear: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="358.000000pt" height="358.000000pt" viewBox="0 0 358.000000 358.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,358.000000) scale(0.100000,-0.100000)">
<path d="M1544 3546 c-17 -8 -34 -21 -37 -29 -3 -8 -20 -102 -37 -208 -17
-107 -34 -211 -38 -232 -7 -38 -9 -39 -93 -72 -47 -18 -105 -43 -128 -54 l-42
-22 -196 141 c-152 108 -204 140 -228 140 -27 0 -53 -23 -203 -173 -129 -131
-172 -179 -172 -198 0 -15 38 -79 98 -164 54 -77 117 -168 141 -201 l42 -62
-34 -68 c-19 -38 -43 -95 -53 -126 -9 -32 -25 -60 -33 -62 -9 -3 -115 -22
-236 -42 -121 -20 -228 -40 -237 -45 -33 -17 -40 -76 -36 -301 3 -202 4 -219
23 -237 15 -16 66 -28 220 -55 110 -20 218 -39 239 -43 38 -8 40 -11 61 -73
12 -36 36 -93 54 -128 l32 -63 -141 -196 c-108 -152 -140 -204 -140 -228 0
-27 23 -54 175 -204 164 -163 176 -173 204 -168 17 4 113 64 213 135 101 71
188 131 194 135 7 4 45 -8 85 -27 41 -18 98 -41 126 -52 29 -10 55 -25 58 -33
2 -9 21 -115 41 -236 20 -121 40 -228 45 -237 17 -33 76 -40 301 -36 202 3
219 4 237 23 15 15 28 62 51 195 18 96 37 204 44 240 l12 65 69 26 c39 14 93
38 122 52 29 15 56 27 61 27 4 0 98 -63 208 -140 122 -85 208 -140 223 -140
19 0 68 43 198 172 149 148 173 177 173 203 0 23 -32 75 -136 220 -75 104
-138 195 -141 201 -2 7 7 34 20 60 13 27 35 78 47 114 13 36 28 70 34 77 6 7
103 28 216 47 273 47 266 45 287 68 16 18 18 45 21 237 4 224 -3 283 -36 300
-14 8 -277 54 -434 76 -56 8 -58 11 -88 95 -12 36 -33 86 -46 112 -13 26 -24
51 -24 56 0 5 63 98 140 208 87 124 140 208 140 223 0 19 -44 69 -172 198
-148 149 -177 173 -203 173 -23 0 -75 -32 -220 -136 -104 -75 -195 -138 -201
-141 -7 -2 -38 9 -70 25 -33 16 -87 40 -122 52 -34 13 -64 26 -66 29 -3 3 -23
112 -46 241 -32 183 -45 239 -61 255 -18 19 -34 20 -247 22 -175 2 -234 0
-258 -11z m413 -276 c49 -285 58 -323 72 -340 9 -10 54 -30 101 -44 47 -15
130 -50 185 -78 83 -42 104 -49 125 -41 14 5 104 67 201 136 96 70 180 127
185 127 5 0 54 -45 108 -99 l99 -99 -74 -106 c-41 -59 -100 -143 -132 -188
-32 -45 -60 -92 -63 -103 -3 -13 14 -60 46 -126 28 -57 62 -141 76 -187 17
-56 32 -87 47 -96 12 -8 110 -28 217 -45 107 -18 207 -34 223 -37 l28 -6 -3
-146 -3 -147 -220 -38 c-121 -22 -230 -45 -242 -53 -15 -9 -30 -40 -47 -96
-14 -46 -48 -130 -77 -188 -42 -87 -50 -109 -42 -130 5 -14 67 -104 136 -201
70 -97 127 -180 127 -185 0 -5 -45 -54 -99 -108 l-99 -99 -179 126 c-99 69
-192 131 -206 138 -25 11 -37 8 -130 -39 -56 -28 -140 -63 -186 -78 -46 -15
-92 -35 -101 -44 -9 -9 -22 -50 -30 -96 -7 -43 -25 -144 -39 -224 l-27 -145
-146 -3 -146 -3 -6 28 c-3 16 -19 111 -36 213 -17 102 -35 197 -41 212 -11 28
-22 33 -134 69 -38 12 -112 43 -164 69 -75 39 -99 46 -121 40 -15 -4 -88 -50
-161 -102 -74 -52 -156 -109 -183 -127 l-48 -33 -99 98 c-54 54 -99 103 -99
109 0 5 59 91 130 190 87 122 129 189 130 207 0 15 -20 67 -45 115 -25 48 -57
126 -72 173 -14 47 -35 95 -47 107 -17 17 -60 28 -241 60 l-220 38 -3 147 -3
146 28 6 c16 3 114 19 218 36 121 20 199 37 214 48 16 12 33 46 52 107 16 50
50 130 74 178 25 49 45 100 45 115 0 18 -43 89 -132 215 l-131 189 99 99 c54
54 103 99 107 99 5 0 92 -58 192 -130 122 -86 192 -130 209 -130 15 0 66 20
114 44 48 24 119 53 157 66 109 35 125 42 134 59 5 9 23 104 40 211 17 107 34
207 37 223 l6 28 146 -3 147 -3 22 -125z"/>
<path d="M1625 2381 c-100 -29 -184 -79 -265 -161 -125 -124 -180 -256 -180
-430 0 -174 55 -305 180 -431 122 -124 255 -179 430 -179 174 0 305 55 431
180 124 122 179 255 179 430 0 175 -55 308 -179 430 -84 84 -176 138 -277 164
-83 21 -240 20 -319 -3z m327 -160 c133 -51 237 -165 279 -303 68 -224 -57
-475 -279 -558 -233 -89 -500 32 -593 268 -33 83 -33 243 -1 324 52 130 156
228 290 275 87 31 216 28 304 -6z"/>
</g>
</svg>
  
  ),
 


  youtubeIcon:(
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="560.000000pt" height="418.000000pt" viewBox="0 0 560.000000 418.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,418.000000) scale(0.100000,-0.100000)">
<path d="M2275 4129 c-708 -22 -1420 -97 -1640 -172 -216 -74 -371 -210 -449
-393 -13 -34 -34 -114 -45 -180 -27 -164 -68 -553 -81 -768 -13 -227 -13 -818
0 -1046 21 -365 86 -814 136 -939 71 -179 237 -331 445 -406 170 -61 636 -117
1339 -162 408 -25 1268 -22 1715 6 614 38 1078 96 1250 154 196 67 340 184
422 344 49 95 63 154 102 438 90 658 106 1079 58 1566 -41 416 -105 833 -147
955 -42 121 -132 239 -243 318 -122 86 -228 126 -424 161 -568 101 -1571 152
-2438 124z m-149 -1158 c5 -5 209 -124 454 -264 245 -140 537 -307 650 -372
113 -65 253 -146 312 -179 60 -34 108 -63 108 -66 0 -3 -48 -32 -108 -66 -59
-33 -262 -150 -452 -259 -190 -109 -482 -277 -650 -373 -168 -95 -309 -178
-315 -183 -35 -34 -35 -33 -35 881 0 914 0 915 36 881z"/>
</g>
</svg>
  
  ),



  imageFile: (
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="519.000000pt" height="415.000000pt" viewBox="0 0 519.000000 415.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,415.000000) scale(0.100000,-0.100000)">
<path d="M220 4121 c-69 -21 -130 -73 -166 -141 -18 -34 -19 -102 -22 -1870
-1 -1273 1 -1851 8 -1887 13 -61 70 -132 134 -166 l41 -22 2354 -3 c1599 -1
2366 1 2392 8 53 15 118 67 154 125 l30 48 0 1866 c0 1801 -1 1867 -19 1901
-26 49 -74 98 -121 123 l-40 22 -2360 2 c-1298 1 -2371 -2 -2385 -6z m4725
-135 c19 -8 44 -30 55 -48 20 -33 20 -46 20 -1520 0 -819 -3 -1488 -8 -1488
-4 0 -109 93 -233 208 -124 114 -348 320 -498 457 -149 138 -299 267 -334 288
-169 103 -385 110 -564 19 -65 -34 -80 -47 -443 -392 -14 -14 -162 -155 -329
-315 -166 -159 -306 -291 -310 -293 -5 -1 -144 121 -309 271 -318 290 -373
329 -498 362 -68 18 -201 20 -276 4 -29 -6 -85 -27 -124 -46 -73 -36 -129 -83
-643 -528 -134 -116 -254 -218 -267 -228 l-24 -19 0 1594 c0 1580 0 1593 20
1626 40 66 -143 61 2408 62 1999 0 2327 -2 2357 -14z"/>
<path d="M1557 3246 c-113 -47 -175 -106 -225 -214 -23 -49 -26 -71 -27 -152
0 -86 3 -101 32 -162 146 -309 570 -308 717 1 28 60 31 75 31 161 -1 86 -4
102 -32 160 -41 85 -111 155 -193 194 -55 26 -79 31 -155 34 -77 2 -99 -1
-148 -22z"/>
</g>
</svg>

  ),


  videoCamera: (
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="452.000000pt" height="293.000000pt" viewBox="0 0 452.000000 293.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,293.000000) scale(0.100000,-0.100000)">
<path d="M439 2889 c-83 -5 -106 -10 -170 -41 -124 -60 -210 -163 -244 -293
-23 -89 -23 -2101 0 -2190 41 -157 166 -282 325 -325 71 -20 2592 -14 2658 5
104 31 216 126 267 225 43 85 47 116 54 402 l6 276 554 -298 c304 -165 564
-306 577 -315 l24 -15 0 1139 0 1140 -80 -46 c-44 -25 -303 -165 -577 -313
l-498 -268 -6 276 c-7 286 -11 317 -54 402 -52 100 -166 196 -270 225 -42 12
-252 15 -1260 17 -665 2 -1253 0 -1306 -3z"/>
</g>
</svg>

  
  ),


  videoPlaylist: (
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="596.000000pt" height="537.000000pt" viewBox="0 0 596.000000 537.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
	 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,537.000000) scale(0.100000,-0.100000)">
<path d="M1391 5318 c-61 -23 -120 -77 -153 -140 -16 -32 -24 -67 -28 -133
l-5 -90 -180 -5 c-200 -6 -245 -18 -313 -83 -65 -62 -85 -110 -91 -216 l-6
-96 -190 -5 c-156 -4 -196 -8 -226 -23 -59 -29 -112 -81 -139 -133 l-25 -49 0
-2060 0 -2060 27 -46 c34 -57 87 -105 145 -130 44 -19 114 -19 2771 -19 2659
0 2728 1 2769 19 61 28 127 94 154 154 l24 52 0 2035 0 2035 -28 57 c-16 32
-48 75 -73 97 -70 62 -111 71 -311 71 l-173 0 0 63 c0 116 -44 216 -122 273
-69 53 -92 57 -284 62 l-181 4 -6 84 c-8 135 -59 217 -170 276 l-42 23 -1545
2 c-1540 2 -1545 2 -1599 -19z m3130 -207 c26 -27 29 -36 29 -95 l0 -66 -1575
0 -1575 0 0 56 c0 60 11 90 44 116 20 16 116 18 1534 18 l1514 0 29 -29z m564
-373 c38 -17 55 -58 55 -128 l0 -60 -2162 2 -2163 3 0 68 c0 65 2 70 33 98
l32 29 2090 0 c1598 0 2095 -3 2115 -12z m616 -416 l29 -32 0 -2000 0 -2000
-29 -32 -29 -33 -2696 0 -2696 0 -27 28 -28 27 -3 1996 c-2 2207 -7 2040 61
2069 27 12 443 14 2710 12 l2679 -2 29 -33z"/>
<path d="M2326 3385 c-57 -20 -87 -46 -113 -95 l-23 -43 0 -956 c0 -912 1
-958 19 -997 37 -82 145 -130 226 -102 51 18 1560 921 1598 957 78 72 85 187
17 264 -16 19 -89 70 -162 114 -309 186 -1405 841 -1423 850 -37 20 -99 23
-139 8z"/>
</g>
</svg>

  ),


  groupOfPeople: (
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="375.000000pt" height="346.000000pt" viewBox="0 0 375.000000 346.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,346.000000) scale(0.100000,-0.100000)">
<path d="M1369 3397 c-147 -50 -270 -180 -309 -326 -17 -63 -14 -191 5 -258
58 -202 235 -334 450 -337 270 -2 475 202 475 474 0 172 -89 325 -240 412
-107 62 -260 76 -381 35z"/>
<path d="M2883 2965 c-112 -31 -185 -80 -249 -167 -45 -62 -84 -164 -84 -223
0 -27 6 -37 36 -55 84 -52 183 -207 205 -322 11 -57 12 -57 63 -75 75 -26 204
-23 281 7 117 45 192 115 247 229 43 90 50 208 19 310 -26 85 -95 182 -164
228 -105 71 -248 98 -354 68z"/>
<path d="M680 2526 c-128 -28 -240 -117 -301 -241 -33 -67 -34 -74 -34 -185 0
-109 2 -119 32 -183 107 -225 373 -319 588 -209 35 17 43 27 53 70 23 87 70
171 132 236 68 71 73 92 44 201 -41 158 -177 284 -339 314 -72 13 -104 13
-175 -3z"/>
<path d="M2170 2526 c-82 -17 -146 -53 -210 -115 -69 -68 -120 -167 -127 -250
l-5 -57 42 -29 c89 -62 165 -181 196 -307 16 -66 18 -68 63 -85 32 -13 74 -18
141 -18 89 0 100 2 172 37 126 60 210 158 242 283 30 112 14 241 -41 335 -61
104 -179 187 -298 209 -72 13 -104 13 -175 -3z"/>
<path d="M1223 2433 c-13 -2 -23 -6 -23 -9 0 -2 13 -28 30 -57 32 -57 60 -152
60 -205 0 -29 3 -33 18 -27 144 63 295 70 422 20 13 -4 18 8 27 62 7 37 28 99
47 137 19 39 32 73 30 76 -7 6 -581 9 -611 3z"/>
<path d="M1467 2080 c-71 -12 -170 -63 -227 -116 -99 -92 -153 -252 -130 -384
45 -259 293 -420 545 -354 211 54 353 273 317 486 -33 192 -178 337 -368 368
-66 11 -69 11 -137 0z"/>
<path d="M2800 2042 c0 -82 -55 -216 -122 -295 -22 -27 -39 -50 -37 -51 2 -2
26 -11 53 -22 171 -64 318 -221 381 -405 24 -71 29 -105 33 -218 l4 -134 85 7
c170 14 392 65 483 111 l50 25 0 258 c0 286 -7 335 -62 449 -44 91 -150 198
-238 241 -113 55 -160 62 -407 62 l-223 0 0 -28z"/>
<path d="M455 1616 c-148 -37 -278 -137 -355 -272 -59 -102 -70 -176 -70 -470
l0 -263 82 -25 c161 -49 339 -84 509 -101 l66 -6 6 128 c9 185 45 293 140 419
68 89 196 184 290 214 20 6 37 14 37 17 0 3 -16 24 -36 46 -51 60 -92 150
-112 245 l-17 82 -245 -1 c-160 0 -262 -5 -295 -13z"/>
<path d="M2072 1563 c-17 -101 -48 -174 -104 -243 -27 -34 -48 -63 -46 -64 2
-1 25 -11 51 -20 27 -10 82 -41 123 -68 190 -127 294 -332 294 -580 l0 -108
38 0 c148 0 426 62 545 122 l37 18 0 255 c0 279 -6 324 -55 430 -62 135 -174
240 -314 294 -63 24 -77 25 -311 29 l-246 3 -12 -68z"/>
<path d="M1226 1164 c-195 -48 -361 -210 -411 -399 -12 -46 -15 -119 -15 -332
l0 -273 28 -11 c93 -36 338 -89 507 -109 134 -17 402 -14 528 5 145 22 287 58
364 94 l63 30 0 238 c0 283 -8 341 -60 451 -65 136 -173 235 -318 291 -65 25
-74 25 -347 28 -219 2 -293 -1 -339 -13z"/>
</g>
</svg>

  ),

  radioSignal: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="520.000000pt" height="401.000000pt" viewBox="0 0 520.000000 401.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,401.000000) scale(0.100000,-0.100000)">
<path d="M1200 3977 c-92 -35 -304 -192 -454 -337 -317 -305 -545 -705 -640
-1125 -50 -221 -69 -513 -47 -720 69 -639 395 -1219 897 -1593 212 -158 297
-193 389 -157 114 43 167 170 116 280 -22 47 -45 70 -126 121 -428 269 -727
698 -831 1194 -127 605 68 1247 512 1682 112 110 172 158 306 247 128 84 152
119 153 217 0 50 -5 68 -28 102 -54 83 -162 121 -247 89z"/>
<path d="M3877 3980 c-121 -36 -179 -191 -115 -302 21 -34 48 -59 110 -98 462
-294 755 -732 854 -1275 21 -114 29 -370 15 -485 -72 -586 -370 -1062 -862
-1378 -36 -23 -75 -52 -87 -65 -49 -52 -67 -153 -38 -221 19 -46 79 -101 125
-114 80 -24 127 -12 241 61 480 308 824 780 970 1331 207 785 -22 1615 -601
2184 -121 119 -206 187 -344 279 -136 91 -188 107 -268 83z"/>
<path d="M1930 3266 c-185 -77 -304 -158 -451 -305 -203 -204 -312 -408 -375
-701 -26 -119 -26 -381 0 -500 28 -129 63 -236 112 -335 83 -171 175 -293 319
-423 102 -92 192 -152 325 -216 166 -79 256 -75 338 18 43 49 57 107 43 172
-18 79 -58 118 -176 174 -131 61 -208 114 -294 201 -127 128 -214 286 -252
462 -27 120 -23 322 9 438 41 152 128 303 242 418 87 87 164 140 295 201 118
56 158 95 176 174 14 65 0 123 -43 172 -67 76 -163 94 -268 50z"/>
<path d="M3080 3268 c-62 -32 -102 -92 -108 -162 -9 -108 44 -182 163 -228
168 -66 354 -227 448 -386 149 -253 175 -532 77 -805 -85 -234 -282 -441 -512
-538 -96 -41 -131 -69 -158 -124 -48 -99 -8 -220 90 -273 88 -47 221 -12 410
106 597 376 811 1121 504 1749 -140 286 -402 534 -686 649 -101 41 -164 44
-228 12z"/>
<path d="M2407 2396 c-116 -48 -183 -112 -234 -222 -25 -53 -28 -70 -28 -164
0 -97 2 -110 32 -172 41 -88 113 -160 201 -201 62 -30 75 -32 172 -32 97 0
110 2 172 32 88 41 160 113 201 201 30 62 32 75 32 172 0 97 -2 110 -32 172
-41 88 -113 160 -201 201 -58 27 -80 32 -162 35 -83 2 -103 -1 -153 -22z"/>
</g>
</svg>

  ),


  radioSignal2: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="519.000000pt" height="421.000000pt" viewBox="0 0 519.000000 421.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,421.000000) scale(0.050000,-0.050000)">
<path d="M1650 8332 c-152 -66 -655 -680 -910 -1110 -1109 -1874 -832 -4200
691 -5800 262 -275 478 -297 599 -61 78 149 44 242 -178 489 -1559 1735 -1575
4089 -42 5813 241 271 248 283 249 399 2 213 -214 355 -409 270z"/>
<path d="M8460 8325 c-234 -118 -221 -316 39 -605 1582 -1759 1589 -4109 19
-5860 -233 -260 -266 -348 -188 -499 124 -241 338 -215 611 74 1803 1905 1801
4786 -4 6694 -219 232 -321 274 -477 196z"/>
<path d="M2548 7422 c-176 -80 -596 -642 -795 -1063 -633 -1339 -413 -2901
566 -4012 233 -265 385 -310 551 -164 161 141 139 301 -73 533 -1063 1160
-1067 2978 -9 4117 206 222 238 365 116 510 -97 115 -217 142 -356 79z"/>
<path d="M7569 7432 c-242 -105 -241 -336 3 -599 1060 -1141 1053 -2952 -15
-4124 -205 -225 -226 -387 -67 -526 166 -146 318 -101 551 164 1228 1395 1229
3467 3 4865 -205 234 -321 287 -475 220z"/>
<path d="M3490 6529 c-394 -136 -811 -1041 -809 -1757 2 -844 565 -1861 968
-1750 258 72 299 313 94 553 -350 408 -451 680 -451 1205 0 524 101 797 450
1204 120 141 150 216 129 326 -31 168 -217 275 -381 219z"/>
<path d="M6691 6529 c-238 -82 -276 -311 -87 -524 639 -722 644 -1692 13
-2430 -166 -195 -179 -363 -36 -483 159 -134 294 -107 489 97 820 858 813
2340 -17 3202 -142 148 -233 183 -362 138z"/>
<path d="M4904 5921 c-1053 -286 -1095 -1773 -59 -2108 33 -11 35 -113 35
-1757 l1 -1746 44 -78 c115 -200 395 -200 510 0 l44 78 1 1746 c0 1644 2 1746
35 1757 793 257 1020 1280 410 1850 -271 254 -668 354 -1021 258z"/>
</g>
</svg>
),

  clapboard:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="380.000000pt" height="362.000000pt" viewBox="0 0 380.000000 362.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,362.000000) scale(0.100000,-0.100000)">
<path d="M1849 3340 c-1238 -191 -1672 -262 -1692 -275 -47 -30 -72 -83 -72
-150 1 -33 4 -73 8 -88 7 -27 10 -28 51 -22 93 14 189 -43 222 -133 10 -26 18
-48 19 -49 1 -2 26 1 56 6 80 14 139 23 1554 240 1700 262 1758 271 1763 276
6 5 -35 276 -49 327 -20 74 -90 129 -161 127 -18 -1 -783 -117 -1699 -259z
m1586 4 c99 -104 144 -158 136 -163 -7 -4 -65 -16 -129 -26 l-117 -17 -147
153 c-81 85 -148 157 -148 160 0 3 57 15 128 26 70 12 127 21 128 22 0 1 67
-69 149 -155z m-743 -51 c52 -54 120 -126 151 -159 l57 -61 -117 -17 c-65 -10
-125 -20 -134 -22 -10 -3 -34 16 -64 48 -27 29 -93 99 -148 156 -54 57 -97
106 -94 109 5 4 203 39 239 42 9 0 59 -43 110 -96z m-634 -162 c78 -82 142
-153 142 -158 0 -5 -57 -17 -127 -27 l-128 -19 -147 154 c-81 85 -148 157
-148 160 0 6 185 36 235 38 26 1 48 -18 173 -148z m-685 -110 c81 -85 145
-156 144 -158 -2 -1 -62 -12 -132 -23 l-129 -19 -122 127 c-67 71 -134 142
-148 159 l-27 32 48 7 c26 3 82 12 123 19 41 7 80 12 86 11 5 0 76 -70 157
-155z m-689 -106 c82 -86 147 -157 145 -159 -2 -2 -62 -12 -132 -23 l-129 -19
-148 155 c-82 86 -146 158 -144 161 5 4 203 37 240 39 14 1 66 -47 168 -154z"/>
<path d="M97 2738 c-71 -42 -98 -144 -54 -209 49 -74 129 -98 203 -63 100 48
112 201 21 266 -45 32 -122 35 -170 6z"/>
<path d="M365 2529 c-23 -72 -136 -138 -216 -125 l-39 6 2 -1144 c3 -1144 3
-1145 24 -1173 11 -15 38 -38 60 -50 l39 -23 1722 3 1722 2 28 21 c15 11 38
36 51 54 l22 33 0 1208 0 1209 -1704 0 -1705 0 -6 -21z m455 -55 c0 -3 -54
-84 -121 -180 l-121 -174 -130 0 c-117 0 -130 2 -124 17 4 9 57 90 119 179
l112 163 133 1 c72 0 132 -3 132 -6z m694 -6 c-4 -7 -59 -88 -123 -180 l-115
-168 -134 0 c-73 0 -132 4 -130 8 2 5 57 86 122 180 l120 172 134 0 c104 0
132 -3 126 -12z m630 -100 c-43 -62 -99 -142 -124 -178 l-46 -65 -132 -3 c-73
-1 -132 0 -132 4 0 3 54 84 121 180 l120 174 135 0 136 0 -78 -112z m766 105
c0 -5 -54 -84 -118 -178 l-118 -170 -133 -3 c-119 -2 -133 -1 -127 14 3 8 57
89 119 179 l112 164 133 1 c72 0 132 -3 132 -7z m700 1 c0 -3 -24 -39 -52 -79
-29 -41 -84 -119 -122 -175 l-70 -100 -133 0 c-105 0 -133 3 -127 13 4 6 51
75 104 152 54 77 105 152 115 168 l17 27 134 0 c74 0 134 -3 134 -6z m68
-1408 c2 -784 0 -892 -13 -913 l-15 -23 -1700 0 c-1531 0 -1700 2 -1714 16
-14 14 -16 111 -16 915 l0 899 1728 -2 1727 -3 3 -889z"/>
<path d="M1643 1466 l-28 -24 -3 -383 c-2 -277 1 -391 9 -412 15 -36 62 -61
103 -54 17 3 155 77 306 164 151 88 295 170 318 184 45 24 72 62 72 99 0 48
-29 77 -142 143 -62 36 -207 119 -322 186 -232 134 -260 142 -313 97z"/>
</g>
</svg>

  ),
  

  antenna: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="303.000000pt" height="458.000000pt" viewBox="0 0 303.000000 458.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,458.000000) scale(0.100000,-0.100000)">
<path d="M543 4514 c-183 -137 -379 -429 -447 -666 -133 -465 -20 -943 309
-1307 91 -101 115 -121 157 -128 25 -4 38 0 52 16 28 31 15 60 -70 142 -252
246 -384 549 -384 884 0 346 160 707 407 920 111 95 128 128 85 163 -26 21
-58 14 -109 -24z"/>
<path d="M2347 4532 c-32 -35 -20 -56 90 -158 198 -184 310 -373 374 -634 20
-82 23 -120 23 -285 0 -173 -2 -200 -26 -295 -60 -237 -163 -418 -328 -580
-90 -87 -99 -106 -69 -143 35 -45 58 -36 161 66 191 188 313 413 369 680 29
134 31 370 5 501 -53 272 -182 525 -366 719 -125 132 -195 171 -233 129z"/>
<path d="M774 4282 c-127 -93 -281 -307 -343 -478 -137 -375 -35 -813 252
-1081 60 -57 92 -66 120 -35 30 33 20 58 -54 134 -162 166 -243 350 -256 582
-10 177 38 366 133 532 33 57 76 108 153 184 59 58 110 114 114 124 5 11 1 28
-8 42 -21 33 -63 31 -111 -4z"/>
<path d="M2145 4280 c-26 -29 -6 -67 77 -148 209 -202 325 -525 288 -804 -27
-204 -96 -346 -250 -512 -73 -79 -82 -102 -52 -129 46 -42 110 -1 213 135 71
93 127 201 162 313 38 121 49 195 48 334 -1 274 -104 523 -300 724 -104 108
-148 129 -186 87z"/>
<path d="M989 4032 c-84 -54 -188 -186 -234 -300 -108 -267 -51 -569 147 -778
50 -53 73 -63 112 -48 9 4 21 15 27 25 13 25 0 48 -68 124 -127 140 -178 338
-138 528 29 140 102 250 238 363 42 35 49 70 19 97 -26 24 -52 21 -103 -11z"/>
<path d="M1926 4039 c-14 -11 -26 -27 -26 -35 0 -9 38 -53 84 -98 69 -68 91
-99 130 -177 121 -245 95 -477 -74 -673 -64 -75 -75 -110 -42 -139 35 -31 66
-21 121 39 101 110 163 250 183 412 25 210 -53 437 -211 605 -41 44 -105 87
-129 87 -5 0 -21 -9 -36 -21z"/>
<path d="M1449 3766 c-2 -3 -16 -6 -29 -8 -14 -2 -35 -9 -47 -16 -13 -7 -23
-10 -23 -7 0 3 -10 -3 -22 -15 -12 -11 -26 -20 -30 -20 -8 0 -33 -25 -66 -65
-5 -6 -20 -39 -34 -73 -19 -49 -25 -77 -22 -125 3 -70 7 -93 17 -103 4 -4 7
-15 7 -24 0 -9 11 -30 25 -46 14 -16 25 -32 25 -36 0 -8 49 -55 89 -86 19 -15
22 -22 13 -38 -21 -40 -33 -71 -37 -89 -2 -11 -4 -20 -5 -20 -1 0 -3 -11 -6
-25 -2 -14 -7 -32 -11 -40 -3 -8 -5 -21 -4 -27 1 -7 -3 -13 -8 -13 -6 0 -8 -6
-5 -14 3 -8 1 -17 -5 -20 -6 -4 -8 -13 -4 -21 3 -8 0 -15 -7 -15 -6 0 -9 -4
-6 -9 4 -5 1 -22 -6 -38 -6 -15 -12 -30 -12 -33 -1 -3 -5 -11 -9 -17 -5 -7 -6
-13 -3 -13 3 0 -7 -36 -23 -80 -16 -44 -27 -80 -24 -80 3 0 0 -7 -7 -15 -7 -8
-9 -15 -5 -15 4 0 3 -6 -3 -12 -6 -7 -10 -16 -10 -21 -1 -19 -15 -73 -22 -82
-5 -5 -9 -13 -9 -17 -1 -5 -1 -9 -2 -10 0 -2 -2 -14 -4 -28 -2 -14 -9 -38 -16
-55 -7 -16 -13 -33 -14 -37 -2 -5 -3 -9 -5 -10 -1 -2 -4 -16 -6 -31 -3 -15
-10 -40 -16 -55 -6 -15 -12 -31 -13 -37 -9 -39 -49 -162 -56 -170 -4 -5 -8
-13 -8 -17 -1 -5 -1 -9 -2 -10 0 -2 -2 -14 -4 -28 -2 -14 -9 -38 -16 -55 -7
-16 -13 -33 -14 -37 -2 -5 -4 -11 -5 -15 -1 -5 -2 -11 -1 -15 0 -4 -4 -20 -10
-35 -6 -15 -10 -30 -11 -33 0 -3 -4 -11 -10 -17 -6 -7 -7 -13 -3 -13 4 0 2 -7
-5 -15 -7 -8 -10 -15 -7 -15 3 0 -3 -26 -14 -57 -11 -32 -22 -65 -24 -73 -2
-8 -4 -15 -5 -15 -1 0 -3 -7 -5 -15 -8 -41 -38 -136 -46 -146 -5 -6 -6 -13 -4
-16 3 -3 0 -18 -6 -34 -7 -16 -13 -32 -14 -36 -2 -5 -4 -10 -5 -13 -3 -6 -3
-6 -14 -55 -5 -19 -11 -39 -15 -45 -3 -5 -6 -13 -7 -17 -1 -5 -3 -10 -4 -13
-1 -3 -4 -9 -5 -15 -1 -5 -4 -12 -5 -15 -1 -3 -4 -9 -5 -15 -1 -5 -3 -11 -5
-12 -1 -2 -3 -11 -5 -20 -2 -9 -11 -41 -20 -70 -18 -58 -22 -69 -24 -80 -11
-46 -35 -116 -43 -126 -6 -6 -7 -12 -3 -12 4 0 2 -6 -4 -13 -6 -8 -8 -17 -5
-20 3 -3 2 -12 -2 -19 -5 -7 -9 -16 -10 -20 -1 -5 -2 -9 -4 -10 -1 -2 -3 -10
-5 -19 -3 -17 -83 -266 -92 -289 -3 -8 -7 -18 -8 -22 -2 -5 -4 -10 -5 -13 -1
-3 -4 -9 -5 -15 -1 -5 -4 -13 -5 -17 -1 -5 -2 -11 -1 -15 0 -4 -4 -20 -11 -35
-6 -15 -12 -31 -13 -35 -2 -5 -3 -9 -5 -10 -2 -4 -10 -38 -14 -65 -5 -34 24
-68 57 -68 24 1 32 8 49 45 12 25 22 47 23 50 1 3 10 32 19 65 10 33 23 66 28
73 6 6 7 12 3 12 -4 0 -2 6 4 13 6 8 8 16 6 19 -3 3 0 18 6 34 7 16 13 34 14
39 1 6 3 13 5 18 1 4 3 13 4 20 1 9 184 13 870 15 l868 2 -6 -24 c-3 -14 -1
-28 4 -31 6 -4 10 -12 9 -18 -1 -7 3 -25 10 -41 6 -16 13 -38 16 -50 2 -11 4
-21 5 -21 1 0 3 -8 6 -17 6 -25 9 -37 23 -88 28 -98 63 -134 105 -106 13 8 26
23 28 34 3 11 -12 70 -33 133 -21 62 -36 115 -34 117 3 3 0 11 -6 19 -6 7 -8
13 -4 13 4 0 3 6 -3 13 -6 7 -13 26 -16 42 -2 17 -5 31 -6 33 -2 1 -4 7 -5 12
-1 6 -3 11 -5 13 -1 1 -3 9 -5 17 -2 8 -17 53 -33 100 -16 47 -30 90 -32 95
-1 6 -6 20 -11 33 -5 12 -8 26 -8 30 1 4 0 10 -1 15 -1 4 -4 12 -5 17 -1 6 -4
12 -5 15 -1 3 -3 8 -5 13 -1 4 -7 20 -13 35 -7 15 -11 31 -11 35 1 4 0 10 -1
15 -1 4 -4 12 -5 17 -1 6 -4 12 -5 15 -1 3 -3 8 -5 13 -1 4 -4 14 -8 22 -8 22
-48 149 -51 163 -2 7 -6 19 -9 27 -7 20 -28 88 -31 103 -2 7 -8 25 -15 40 -6
16 -9 33 -5 38 3 5 0 9 -6 9 -7 0 -10 7 -7 15 4 8 2 17 -4 20 -5 4 -7 10 -4
15 3 5 1 11 -4 14 -7 5 -22 51 -37 119 -1 4 -3 9 -4 12 -1 3 -4 10 -5 15 -1 6
-4 12 -5 15 -1 3 -3 8 -4 13 -1 4 -5 13 -9 20 -5 6 -6 12 -2 12 3 0 -1 13 -10
30 -8 16 -16 41 -17 55 -1 14 -6 25 -11 25 -4 0 -7 6 -6 13 1 6 -3 25 -9 40
-7 16 -10 33 -6 38 3 5 0 9 -6 9 -6 0 -10 6 -9 13 1 6 -3 25 -9 40 -7 15 -11
31 -11 35 1 4 0 10 -1 15 -1 4 -4 12 -5 17 -1 6 -4 12 -5 15 -1 3 -4 10 -5 15
-1 6 -3 11 -5 13 -1 1 -3 9 -5 17 -2 8 -15 48 -29 87 -13 40 -22 73 -19 73 3
0 0 7 -7 15 -7 8 -9 15 -5 15 4 0 3 6 -3 13 -6 7 -13 26 -16 42 -2 17 -5 31
-6 33 -2 1 -4 7 -5 12 -1 6 -4 12 -5 15 -1 3 -3 8 -5 13 -1 4 -7 20 -13 35 -7
16 -10 33 -6 38 3 5 0 9 -6 9 -7 0 -10 6 -7 14 3 8 3 17 -1 21 -4 4 -7 10 -8
13 0 4 -3 14 -7 22 -9 25 -39 120 -41 133 -1 7 -5 18 -9 25 -5 6 -6 12 -2 12
3 0 -1 13 -9 28 -8 16 -17 42 -20 58 -2 16 -5 29 -6 29 -1 0 -3 8 -6 18 -2 9
-6 25 -8 35 -3 9 -5 19 -7 22 -1 3 -3 10 -4 15 -1 6 -7 23 -14 39 -6 16 -9 31
-6 34 2 3 0 11 -6 19 -6 7 -8 13 -4 13 4 0 2 6 -4 14 -6 8 -11 18 -10 22 1 5
0 12 -1 17 -1 4 -3 10 -5 15 -1 4 -7 20 -13 35 -17 41 -15 53 12 71 35 22 78
67 95 96 54 94 59 113 56 190 -1 41 -9 92 -16 113 -16 42 -107 156 -126 156
-7 1 -13 6 -13 12 0 5 -4 8 -9 5 -5 -4 -11 -2 -13 4 -2 6 -13 12 -24 14 -12 3
-39 9 -60 15 -39 11 -117 15 -125 7z m128 -121 c100 -42 161 -134 149 -228
-15 -134 -137 -225 -265 -199 -99 21 -169 98 -178 199 -9 96 39 176 132 219
58 28 111 30 162 9z m-27 -545 c8 -5 11 -10 6 -10 -5 0 -3 -7 4 -15 7 -8 9
-15 5 -15 -4 0 -2 -7 5 -15 9 -11 8 -20 -9 -44 -12 -16 -21 -32 -21 -36 0 -3
-7 -14 -16 -23 -16 -15 -19 -14 -45 17 -36 44 -43 73 -25 116 13 30 20 35 48
35 18 0 40 -5 48 -10z m-130 -237 c21 -18 27 -43 10 -43 -5 0 -10 -4 -10 -10
0 -5 -19 -35 -41 -67 -27 -37 -39 -49 -35 -33 4 14 8 32 10 40 11 45 38 130
42 130 2 0 13 -8 24 -17z m210 -23 c4 -14 13 -44 20 -66 19 -65 7 -73 -29 -21
-34 50 -44 78 -34 103 8 22 35 13 43 -16z m-100 -131 c8 -11 23 -30 33 -41 9
-12 17 -25 17 -29 0 -4 7 -15 16 -24 22 -22 114 -163 114 -175 0 -6 5 -10 10
-10 6 0 10 -6 10 -14 0 -8 6 -17 13 -19 9 -4 9 -7 -1 -14 -35 -25 -113 -95
-169 -151 -72 -73 -69 -73 -154 10 -30 29 -78 74 -107 99 -37 33 -51 51 -46
63 3 9 10 16 15 16 5 0 9 7 9 15 0 8 5 15 10 15 6 0 10 5 10 10 0 6 9 20 20
32 11 12 20 28 20 35 0 7 5 13 10 13 6 0 10 6 10 13 0 7 11 24 25 39 14 15 25
30 25 33 0 4 6 12 13 19 6 8 19 24 27 36 20 29 40 50 49 50 3 0 13 -9 21 -21z
m-193 -536 l84 -81 -72 -76 c-40 -42 -77 -76 -82 -76 -6 0 -31 -20 -56 -45
-25 -25 -67 -64 -92 -88 -25 -23 -51 -51 -57 -62 -6 -11 -14 -17 -17 -13 -4 4
-3 13 1 20 5 7 10 22 11 33 2 11 6 27 10 35 3 8 7 18 7 22 1 3 4 9 8 13 4 4 4
13 1 21 -3 8 0 14 7 14 6 0 8 5 5 10 -4 6 -1 17 5 25 7 8 9 15 6 15 -4 0 -4 6
1 13 4 6 8 17 9 24 2 13 23 80 31 103 4 8 7 18 8 23 2 4 3 8 5 10 1 1 3 10 5
19 2 9 10 39 19 65 9 26 16 52 15 57 -1 16 24 24 39 13 9 -7 53 -49 99 -94z
m476 71 c5 -16 11 -36 14 -44 4 -8 7 -18 8 -22 2 -5 4 -10 5 -13 1 -3 4 -9 5
-15 1 -5 4 -12 5 -15 1 -3 3 -8 5 -12 1 -5 5 -15 8 -23 13 -30 37 -101 36
-108 -1 -4 0 -10 1 -14 1 -5 3 -11 5 -15 1 -5 7 -21 14 -37 6 -16 9 -31 6 -34
-2 -3 0 -11 6 -19 6 -7 8 -13 4 -13 -4 0 -2 -7 5 -15 7 -8 9 -15 5 -15 -4 0
-2 -7 5 -15 7 -8 10 -15 7 -15 -3 0 1 -16 9 -36 8 -20 13 -38 10 -41 -3 -3
-73 62 -155 143 -165 164 -220 214 -233 214 -18 0 -6 20 40 60 26 24 71 65
101 92 30 27 58 47 64 45 6 -2 15 -16 20 -33z m-286 -246 c9 -7 56 -51 103
-98 47 -47 130 -125 183 -174 54 -49 94 -93 89 -98 -4 -4 -187 -7 -405 -6
l-396 3 122 125 c136 139 265 260 279 260 5 0 16 -6 25 -12z m420 -493 c-2 -5
-35 -28 -73 -52 -38 -23 -74 -46 -80 -51 -36 -31 -114 -83 -114 -75 0 4 -5 0
-11 -10 -6 -9 -14 -15 -20 -12 -5 4 -9 1 -9 -4 0 -6 -7 -11 -15 -11 -8 0 -15
-3 -15 -7 0 -5 -17 -19 -38 -33 -20 -14 -41 -30 -45 -37 -12 -20 -29 -15 -64
17 -18 17 -35 30 -38 30 -10 0 -100 63 -103 72 -2 4 -10 8 -18 8 -8 0 -14 5
-14 10 0 6 -4 10 -10 10 -11 0 -113 71 -118 82 -2 5 -10 8 -18 8 -8 0 -14 5
-14 10 0 6 -7 10 -15 10 -8 0 -15 4 -15 9 0 5 -9 11 -21 14 -12 3 -18 10 -15
16 8 13 887 10 883 -4z m-967 -75 c0 -5 5 -10 11 -10 15 0 169 -101 169 -111
0 -5 5 -9 10 -9 10 0 19 -6 53 -36 7 -5 20 -13 30 -17 9 -3 17 -11 17 -17 0
-5 6 -10 14 -10 7 0 25 -11 40 -25 15 -14 31 -25 37 -25 5 0 9 -4 9 -10 0 -5
7 -10 15 -10 22 0 18 -21 -5 -27 -11 -3 -20 -9 -20 -14 0 -5 -7 -9 -15 -9 -8
0 -15 -4 -15 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -15
-10 -8 0 -15 -4 -15 -9 0 -9 -105 -81 -119 -81 -5 0 -11 -3 -13 -7 -5 -12 -75
-63 -86 -63 -6 0 -12 -4 -14 -9 -4 -11 -215 -161 -227 -161 -5 0 -12 -7 -15
-16 -3 -8 -10 -12 -16 -9 -5 3 -10 1 -10 -4 0 -6 -7 -11 -15 -11 -8 0 -15 -5
-15 -11 0 -5 -4 -8 -9 -5 -11 7 -3 66 10 82 5 6 6 13 4 16 -3 3 0 18 6 34 7
16 13 32 13 36 1 3 4 9 8 13 4 4 4 13 1 21 -3 8 0 14 6 14 6 0 8 7 5 15 -4 8
-1 15 5 15 6 0 10 3 9 8 -3 13 14 77 24 90 6 6 7 12 3 12 -4 0 -2 7 5 15 7 8
10 15 7 15 -3 0 6 33 19 73 14 39 27 79 29 87 2 8 4 16 5 18 2 1 4 7 5 12 1 6
4 13 5 18 1 4 2 10 1 14 0 4 4 20 11 35 6 15 11 31 10 35 -1 4 3 20 10 35 10
26 13 33 17 48 2 10 31 5 31 -5z m1140 -162 c30 -95 55 -176 56 -180 1 -5 3
-10 4 -13 1 -3 3 -8 5 -12 1 -5 7 -21 13 -36 7 -15 11 -31 10 -35 -1 -4 4 -20
11 -37 7 -16 14 -41 16 -55 2 -14 4 -26 6 -27 1 -2 2 -6 4 -10 1 -5 5 -15 8
-23 4 -8 8 -27 11 -42 3 -15 7 -31 10 -36 3 -5 7 -19 10 -33 3 -13 9 -39 15
-56 11 -38 1 -43 -29 -13 -11 11 -24 20 -29 20 -4 0 -20 11 -35 25 -15 14 -31
25 -37 25 -5 0 -9 5 -9 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -7 10 -15
10 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -9 0 -18 7 -21 15 -4 8 -10 12 -15 9
-5 -3 -12 2 -15 10 -3 9 -10 13 -15 10 -5 -3 -12 2 -15 10 -3 9 -12 16 -20 16
-8 0 -14 5 -14 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -6 10 -13 10 -7 0
-24 11 -39 25 -15 14 -31 25 -35 25 -5 0 -20 11 -35 25 -15 14 -32 25 -37 25
-6 0 -14 8 -20 18 -5 9 -11 15 -13 12 -5 -7 -138 101 -138 112 0 4 6 8 13 8 7
0 18 9 25 20 7 11 16 20 22 20 5 0 21 11 36 25 14 13 39 30 55 37 16 7 29 16
29 20 0 5 7 8 15 8 8 0 15 5 15 10 0 6 5 10 10 10 6 0 21 9 33 20 12 12 32 23
44 26 13 4 23 10 23 15 0 5 5 9 10 9 6 0 32 16 58 35 26 19 52 35 57 35 6 0
35 -78 65 -172z m-582 -218 c12 -11 26 -20 32 -20 6 0 13 -7 16 -15 4 -8 10
-15 16 -15 5 0 16 -6 23 -12 20 -18 33 -28 90 -68 28 -19 52 -38 53 -42 2 -4
8 -8 13 -8 9 0 16 -5 52 -35 7 -6 28 -21 47 -32 31 -19 47 -32 107 -83 7 -5
17 -10 23 -10 5 0 10 -4 10 -10 0 -5 5 -10 10 -10 6 0 16 -5 23 -10 44 -37 61
-50 66 -50 3 0 19 -11 35 -25 l29 -25 -691 0 c-381 0 -692 2 -692 4 0 2 20 17
45 33 25 15 45 31 45 36 0 4 7 7 15 7 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 4
15 9 0 5 24 23 53 40 47 27 66 40 114 81 7 5 17 10 23 10 5 0 10 5 10 10 0 6
7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 4 15 8 0 4 29 25 65 47 36
22 65 43 65 48 0 4 7 7 15 7 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 5 15 10 0
6 7 10 15 10 8 0 15 5 15 10 0 6 7 10 15 10 8 0 15 3 15 8 0 6 34 27 51 31 3
0 15 -8 27 -19z"/>
</g>
</svg>

  ),


  envelope: (
<svg version             = "1.0"  
     xmlns               = "http://www.w3.org/2000/svg"
     width               = "311.000000pt" 
	 height              = "202.000000pt" 
	 viewBox             = "0 0 311.000000 202.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
     preserveAspectRatio = "xMidYMid meet">
<g transform="translate(0.000000,202.000000) scale(0.066667,-0.066667)">
<path d="M121 2981 c-105 -54 -98 50 -102 -1445 -5 -1479 -9 -1416 89 -1476
72 -43 4364 -48 4438 -4 93 54 89 -8 89 1459 0 1483 5 1413 -97 1461 -67 32
-4355 37 -4417 5z m2273 -131 c1777 0 2091 -3 2091 -21 0 -11 -10 -25 -22 -29
-25 -10 -746 -456 -1547 -957 -635 -397 -585 -374 -671 -315 -78 53 -1911
1197 -2011 1255 -82 47 -66 94 27 75 23 -4 984 -8 2133 -8z m-2109 -270 c76
-51 1116 -701 1332 -832 52 -32 92 -63 90 -68 -3 -6 -200 -165 -439 -353 -240
-188 -586 -462 -769 -609 l-334 -267 0 1103 c0 878 4 1101 19 1092 10 -6 56
-36 101 -66z m4204 -1031 c-2 -600 -4 -1094 -4 -1097 0 -2 -52 39 -116 92 -64
53 -410 328 -769 610 -679 534 -676 532 -638 546 31 12 1229 750 1390 856 69
46 129 83 133 83 4 1 6 -490 4 -1090z m-2404 -101 c123 -79 233 -143 243 -143
11 0 111 58 222 129 111 71 214 135 228 143 21 11 113 -56 465 -336 242 -192
623 -493 847 -669 281 -221 405 -328 402 -345 -3 -13 -5 -30 -6 -36 0 -6 -971
-9 -2157 -7 l-2156 4 0 40 c0 34 40 72 285 262 156 123 332 260 390 306 57 46
181 143 275 217 94 74 296 234 449 356 154 121 281 221 284 221 3 0 106 -64
229 -142z"/>
</g>
</svg>


),	
	
  copy: (
<svg version             = "1.0" 
     xmlns               = "http://www.w3.org/2000/svg"
     width               = "306.000000pt" 
	 height              = "358.000000pt" 
	 viewBox             = "0 0 306.000000 358.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
     preserveAspectRatio = "xMidYMid meet">
<g transform="translate(0.000000,358.000000) scale(0.100000,-0.100000)">
<path d="M940 3554 c-109 -29 -189 -98 -239 -203 -23 -49 -26 -71 -29 -182
l-4 -127 -181 -4 c-157 -4 -190 -8 -239 -27 -113 -44 -205 -157 -228 -282 -7
-37 -10 -456 -8 -1240 l3 -1184 23 -57 c43 -106 143 -194 254 -224 76 -20
1748 -21 1823 0 115 30 198 99 248 205 27 57 31 76 35 186 l5 122 182 5 c176
4 183 5 246 35 79 36 148 104 186 181 l28 57 3 1210 c2 848 -1 1226 -9 1263
-24 118 -139 234 -265 267 -86 22 -1750 21 -1834 -1z m1816 -109 c61 -18 116
-62 152 -123 l27 -47 3 -1194 c3 -1315 5 -1257 -59 -1334 -17 -21 -53 -49 -80
-62 l-48 -25 -891 0 c-733 0 -896 2 -924 14 -51 21 -107 76 -132 131 l-24 50
0 1194 c0 902 3 1204 12 1234 18 61 92 135 158 157 52 18 98 19 906 20 720 0
858 -2 900 -15z m-2086 -1565 c0 -1020 0 -1040 20 -1094 39 -103 109 -174 218
-221 45 -19 72 -20 716 -23 l668 -3 -4 -112 c-4 -96 -8 -119 -31 -163 -26 -51
-74 -96 -132 -124 -46 -23 -1734 -28 -1810 -6 -74 22 -128 65 -159 127 l-26
53 0 1208 c0 1343 -5 1245 68 1322 66 68 93 76 295 76 l177 0 0 -1040z"/>
</g>
</svg>

),	
	
  calendar: (
    <svg xmlns               = "http://www.w3.org/2000/svg"
         width               = "900.000000pt"
         height              = "900.000000pt"
         preserveAspectRatio = "xMidYMid meet"
         fill                = "currentColor" 
         stroke              = "currentColor" 
         viewBox             = "0 0 900.000000 900.000000" >
      <g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
        <path d="M1425 8774 c-67 -25 -133 -101 -150 -174 -12 -50 -11 -1208 0 -1247 14 -47 79 -120 127 -143 33 -16 62 -20 135 -20 89 0 97 2 142 31 27 18 62 53 80 80 l31 48 0 638 0 638 -38 54 c-52 75 -112 105 -212 108 -46 1 -90 -4 -115 -13z"/>
        <path d="M5755 8780 c-3 -5 -16 -10 -29 -10 -28 0 -101 -61 -122 -102 -43 -83 -44 -98 -44 -693 0 -424 3 -581 13 -611 15 -51 81 -128 133 -154 55 -28 208 -28 263 0 43 22 83 64 112 121 19 38 19 59 17 668 l-3 629 -22 24 c-13 14 -23 29 -23 34 0 17 -42 50 -97 78 -41 21 -67 26 -122 26 -38 0 -73 -4 -76 -10z"/>
        <path d="M680 7710 c-8 -5 -32 -10 -52 -10 -20 0 -39 -4 -42 -9 -3 -4 -19 -11 -35 -14 -43 -9 -136 -73 -205 -143 -61 -61 -124 -171 -140 -243 -15 -68 -14 -5024 1 -5071 27 -86 59 -139 151 -252 44 -53 180 -132 262 -151 56 -13 3299 -26 3318 -13 17 12 18 506 0 524 -9 9 -377 12 -1594 12 l-1583 0 -15 22 c-14 20 -16 214 -16 1868 0 1015 4 1851 8 1858 7 10 604 12 2953 10 l2944 -3 3 -519 c1 -363 6 -523 13 -533 16 -18 512 -19 525 0 11 14 1 2163 -10 2222 -4 22 -28 82 -53 133 -37 75 -59 105 -118 160 -75 70 -170 124 -253 144 -76 17 -353 22 -363 6 -5 -7 -9 -82 -9 -165 0 -206 -19 -280 -101 -401 -25 -37 -68 -84 -95 -105 -55 -43 -158 -97 -185 -97 -10 0 -21 -4 -24 -10 -3 -6 -51 -10 -108 -10 -116 0 -228 25 -289 66 -21 13 -41 24 -46 24 -9 0 -112 103 -112 112 0 3 -16 29 -35 58 -19 28 -39 69 -45 90 -6 22 -15 42 -20 45 -6 4 -10 84 -10 195 0 177 -1 190 -19 200 -13 7 -534 10 -1614 10 l-1595 0 -6 -22 c-3 -13 -6 -97 -6 -188 0 -168 -7 -203 -52 -306 -24 -56 -98 -140 -169 -194 -148 -112 -416 -121 -584 -21 -43 26 -155 130 -155 144 0 5 -11 23 -25 41 -52 68 -67 136 -72 331 -4 143 -8 184 -21 198 -13 15 -34 17 -151 17 -75 0 -143 -5 -151 -10z"/>
        <path d="M1271 5556 c-8 -9 -10 -159 -9 -537 l3 -524 535 0 535 0 3 515 c1 283 0 525 -3 538 l-5 22 -524 0 c-430 0 -526 -2 -535 -14z"/> 
        <path d="M2892 5562 c-10 -7 -12 -121 -10 -538 l3 -529 530 0 530 0 0 535 0 535 -520 2 c-286 2 -526 -1 -533 -5z"/>
        <path d="M4497 5563 c-4 -3 -7 -246 -7 -540 l0 -533 538 2 537 3 3 522 c2 464 0 523 -14 537 -14 14 -75 16 -533 16 -285 0 -521 -3 -524 -7z"/>
        <path d="M6395 4478 c-16 -5 -66 -14 -110 -18 -105 -11 -273 -52 -327 -81 -10 -5 -26 -9 -36 -9 -10 0 -27 -7 -38 -15 -10 -8 -26 -15 -36 -15 -25 0 -223 -97 -310 -152 -43 -26 -81 -48 -85 -48 -5 0 -22 -13 -38 -29 -17 -15 -42 -34 -55 -41 -13 -7 -41 -29 -62 -48 -21 -19 -50 -43 -66 -52 -32 -21 -232 -223 -232 -236 0 -5 -21 -31 -45 -57 -25 -27 -45 -52 -45 -57 0 -4 -16 -25 -35 -46 -19 -22 -35 -42 -35 -47 0 -4 -22 -42 -48 -85 -55 -87 -152 -285 -152 -310 0 -10 -7 -26 -15 -36 -8 -11 -15 -28 -15 -38 0 -10 -4 -26 -9 -36 -10 -18 -54 -165 -66 -217 -4 -16 -10 -66 -15 -110 -4 -44 -13 -96 -19 -115 -14 -46 -14 -432 0 -485 6 -22 15 -76 19 -120 5 -44 13 -100 20 -125 21 -87 82 -270 91 -276 5 -3 9 -15 9 -26 0 -25 112 -258 145 -302 12 -17 32 -49 43 -72 20 -38 35 -59 134 -183 94 -117 324 -334 444 -420 96 -68 396 -231 425 -231 8 0 43 -11 79 -23 118 -43 134 -48 200 -68 115 -35 266 -53 480 -57 310 -6 482 18 735 103 135 45 342 141 435 201 25 16 53 33 62 39 44 26 126 86 153 112 17 15 42 35 55 44 46 30 132 113 202 194 38 44 75 87 82 95 23 26 136 179 136 184 0 3 14 25 30 50 46 67 155 291 183 376 69 205 83 259 116 461 13 81 15 482 2 558 -11 63 -47 247 -60 303 -4 21 -13 43 -18 50 -6 7 -13 24 -16 38 -28 131 -166 416 -278 574 -86 120 -303 350 -420 444 -124 99 -145 114 -183 134 -23 11 -55 31 -72 43 -43 33 -278 145 -303 145 -11 0 -22 4 -25 9 -6 9 -189 70 -276 91 -25 7 -81 15 -125 20 -44 4 -98 13 -120 19 -51 13 -449 13 -490 -1z m439 -537 c3 -5 34 -12 68 -16 35 -4 77 -11 93 -15 17 -5 57 -17 90 -26 33 -8 68 -20 77 -25 10 -5 25 -9 34 -9 14 0 153 -66 254 -122 94 -51 214 -144 312 -241 102 -101 208 -224 208 -242 0 -4 13 -24 28 -44 27 -36 145 -268 155 -306 5 -21 24 -75 38 -110 4 -11 10 -33 13 -50 3 -16 13 -73 22 -125 13 -67 18 -148 18 -275 1 -174 -4 -218 -43 -390 -5 -22 -12 -56 -16 -75 -5 -19 -14 -44 -22 -55 -7 -11 -13 -26 -13 -34 0 -17 -123 -263 -155 -311 -14 -19 -35 -50 -47 -69 -92 -135 -303 -336 -420 -400 -20 -12 -39 -25 -42 -30 -8 -13 -269 -141 -287 -141 -8 0 -23 -6 -34 -13 -11 -8 -36 -17 -55 -22 -19 -4 -53 -11 -75 -16 -164 -37 -218 -43 -390 -43 -131 0 -206 4 -275 17 -52 10 -108 20 -125 23 -16 3 -39 9 -50 13 -35 14 -89 33 -110 38 -11 3 -76 33 -145 67 -125 61 -215 117 -300 185 -76 61 -261 253 -292 304 -17 26 -33 47 -38 47 -4 0 -22 28 -40 63 -107 208 -140 276 -140 291 0 9 -4 24 -9 34 -5 9 -17 44 -25 77 -9 33 -21 74 -26 90 -4 17 -11 58 -15 93 -4 34 -11 65 -16 68 -12 7 -12 371 1 394 5 10 12 44 16 76 3 33 10 68 15 79 5 11 13 38 18 60 24 102 53 181 107 286 99 195 169 290 322 440 169 166 200 188 387 284 137 71 206 98 320 127 22 5 49 13 60 18 11 5 46 11 79 14 32 4 66 11 75 16 21 12 388 13 395 1z"/>
        <path d="M6294 3406 c-89 -30 -132 -68 -170 -154 l-24 -53 0 -586 c0 -634 -1 -620 55 -703 23 -34 48 -53 97 -78 l67 -33 594 1 c628 0 604 -2 684 44 56 32 88 77 110 156 20 73 16 121 -16 186 -36 74 -71 107 -141 133 -52 20 -74 21 -476 21 l-422 0 -6 23 c-3 12 -6 210 -6 440 l0 418 -24 47 c-29 56 -65 92 -123 121 -54 27 -145 35 -199 17z"/>
        <path d="M1265 3938 c-3 -7 -4 -247 -3 -533 l3 -520 525 -3 c485 -2 526 -1 538 15 17 24 18 1023 0 1041 -18 18 -1057 17 -1063 0z"/>
        <path d="M2893 3943 c-18 -7 -19 -1033 -1 -1051 9 -9 140 -12 530 -12 l518 0 5 23 c3 12 4 252 3 532 l-3 510 -520 2 c-286 1 -526 -1 -532 -4z"/>
      </g>
    </svg>
  ),


  calendar1: (
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="478.000000pt" height="498.000000pt" viewBox="0 0 478.000000 498.000000"
     fill                = "currentColor" 
     stroke              = "currentColor" 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,498.000000) scale(0.100000,-0.100000)">
<path d="M997 4940 c-45 -13 -95 -57 -119 -103 -18 -35 -22 -63 -26 -169 l-4
-128 -327 0 c-294 0 -330 -2 -366 -19 -59 -26 -101 -80 -114 -143 -8 -37 -10
-657 -9 -2123 l3 -2070 25 -45 c16 -28 43 -55 74 -75 l49 -30 2206 0 2206 0
45 25 c28 16 55 43 75 74 l30 49 0 2096 c0 1699 -2 2103 -13 2133 -17 46 -79
103 -129 117 -23 7 -162 11 -354 11 l-317 0 -4 128 c-3 112 -7 132 -28 172
-14 24 -44 58 -68 75 -43 30 -45 30 -194 33 -176 4 -216 -6 -272 -68 -46 -51
-56 -92 -56 -227 l0 -113 -920 0 -920 0 0 113 c0 133 -10 175 -53 224 -54 62
-92 73 -252 72 -77 0 -153 -5 -168 -9z m265 -201 c2 -2 2 -140 0 -306 l-3
-303 -99 0 -100 0 0 304 c0 234 3 306 13 310 14 6 185 2 189 -5z m2458 -299
l0 -310 -100 0 -100 0 0 304 0 305 23 4 c12 2 57 5 100 6 l77 1 0 -310z
m-2870 -215 c0 -134 10 -174 58 -227 56 -62 79 -68 255 -68 142 0 157 2 198
23 29 16 54 40 74 72 29 46 30 54 33 182 l4 133 918 0 918 0 4 -133 c3 -128 4
-136 33 -182 20 -32 45 -56 74 -72 41 -21 56 -23 197 -23 84 0 165 5 181 11
15 5 45 27 66 47 50 49 67 108 67 241 l0 106 305 2 305 2 0 -359 0 -360 -2150
0 -2150 0 0 359 0 360 305 -2 305 -2 0 -110z m3163 -815 l527 0 0 -1585 0
-1585 -2150 0 -2150 0 0 1585 0 1585 583 2 c320 2 1050 2 1622 1 572 -2 1277
-3 1568 -3z"/>
<path d="M1308 3002 l-458 -2 0 -1175 0 -1175 1540 0 1540 0 0 1175 0 1175
-527 0 c-291 1 -778 2 -1083 3 -305 1 -761 1 -1012 -1z m262 -457 l0 -255
-255 0 -255 0 0 255 0 255 255 0 255 0 0 -255z m720 0 l0 -255 -255 0 -255 0
0 255 0 255 255 0 255 0 0 -255z m716 209 c-3 -26 -6 -141 -6 -255 l0 -209
-255 0 -255 0 0 255 0 255 261 0 262 0 -7 -46z m714 -209 l0 -255 -255 0 -255
0 0 255 0 255 255 0 255 0 0 -255z m-2150 -720 l0 -255 -255 0 -255 0 0 255 0
255 255 0 255 0 0 -255z m720 0 l0 -255 -254 0 -253 0 -5 174 c-3 95 -3 210 0
255 l5 81 253 0 254 0 0 -255z m712 130 c2 -68 2 -183 0 -255 l-4 -130 -254 0
-254 0 0 255 0 255 254 0 254 0 4 -125z m718 -130 l0 -255 -255 0 -255 0 0
255 0 255 255 0 255 0 0 -255z m-2150 -715 l0 -260 -255 0 -255 0 0 260 0 260
255 0 255 0 0 -260z m715 0 l0 -255 -252 -3 -253 -2 0 260 0 260 253 -2 252
-3 0 -255z m715 0 l0 -260 -252 2 -253 3 -3 245 c-1 134 0 250 3 257 3 10 62
13 255 13 l250 0 0 -260z m720 0 l0 -260 -255 0 -255 0 0 260 0 260 255 0 255
0 0 -260z"/>
</g>
</svg>
  ),


  eye: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="300.000000pt" height="145.000000pt" viewBox="0 0 300.000000 145.000000"
 preserveAspectRatio="xMidYMid meet"
      fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
    >
<g transform="translate(0.000000,145.000000) scale(0.100000,-0.100000)">
<path d="M1215 1384 c-334 -59 -652 -203 -922 -416 -93 -73 -253 -227 -253
-243 0 -15 157 -167 245 -237 275 -219 597 -364 934 -422 125 -21 434 -22 557
-1 102 18 277 65 379 102 110 40 296 136 380 194 42 30 84 59 93 64 37 22 162
129 246 209 l89 85 -38 47 c-53 65 -231 215 -359 303 -225 154 -510 268 -790
316 -115 20 -448 19 -561 -1z m470 -108 c107 -38 214 -120 285 -217 56 -77 70
-110 95 -221 15 -65 16 -90 6 -160 -23 -179 -24 -182 -102 -289 -70 -95 -178
-177 -284 -215 -74 -26 -265 -31 -341 -9 -126 36 -238 118 -321 233 -73 100
-103 196 -103 327 0 131 30 227 103 327 80 111 183 189 307 230 73 24 280 21
355 -6z"/>
<path d="M1390 1111 c-104 -23 -210 -116 -255 -226 -25 -60 -29 -83 -29 -160
0 -77 4 -100 29 -160 34 -83 104 -159 186 -201 50 -26 62 -28 174 -29 131 0
170 12 250 75 199 158 199 472 0 630 -71 56 -120 73 -224 76 -53 2 -112 -1
-131 -5z"/>
</g>
</svg>  
  ),

  slashedEye: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="227.000000pt" viewBox="0 0 300.000000 227.000000"
 preserveAspectRatio="xMidYMid meet"
      fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
    >  
<g transform="translate(0.000000,227.000000) scale(0.100000,-0.100000)">
<path d="M1415 1198 l-1026 -1031 63 -64 c34 -34 67 -63 73 -63 5 0 473 463
1040 1030 l1030 1030 -65 65 c-35 36 -70 65 -76 65 -7 0 -474 -464 -1039
-1032z"/>
<path d="M1313 1810 c-84 -9 -255 -45 -314 -65 -23 -8 -50 -15 -61 -15 -11 0
-34 -6 -51 -14 -18 -8 -77 -33 -132 -56 -126 -53 -205 -96 -325 -178 -196
-134 -390 -307 -390 -347 0 -59 365 -350 583 -465 l67 -35 132 132 132 132
-19 78 c-38 163 -13 350 62 461 82 122 195 209 328 253 99 33 244 33 334 0
l64 -23 55 56 c31 30 54 57 52 60 -3 2 -61 11 -128 20 -129 17 -266 19 -389 6z"/>
<path d="M2165 1496 c-88 -87 -134 -139 -129 -147 16 -27 33 -139 33 -219 0
-140 -29 -232 -103 -329 -94 -122 -213 -201 -356 -237 -81 -21 -201 -15 -285
14 l-60 21 -52 -51 c-29 -28 -50 -54 -48 -58 10 -16 201 -35 345 -34 159 1
267 15 416 55 44 12 97 25 119 29 55 12 279 109 365 159 40 22 74 41 77 41 7
0 125 87 217 160 102 81 246 219 246 235 0 35 -365 343 -473 400 -12 6 -56 30
-99 54 l-76 42 -137 -135z"/>
<path d="M1333 1500 c-35 -16 -86 -51 -115 -77 -84 -78 -136 -221 -121 -330
l6 -45 233 233 c129 129 234 237 234 241 0 5 -39 8 -87 8 -77 0 -96 -4 -150
-30z"/>
<path d="M1647 982 c-125 -125 -227 -230 -227 -235 0 -4 39 -7 86 -7 76 0 94
4 153 32 131 62 215 187 228 338 10 123 11 123 -240 -128z"/>
</g>
</svg>	
  ),
  
  trashCan0: (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="331.000000pt" viewBox="0 0 300.000000 331.000000"
 preserveAspectRatio="xMidYMid meet"
      fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait 
 >

<g transform="translate(0.000000,331.000000) scale(0.100000,-0.100000)">
<path d="M895 3060 c-17 -11 -41 -38 -54 -60 l-22 -40 -227 0 c-203 0 -230 -2
-255 -18 -56 -37 -56 -40 -57 -270 0 -182 2 -218 17 -242 19 -33 48 -51 98
-59 l35 -6 0 -880 c0 -975 -2 -945 65 -1054 60 -100 156 -167 276 -196 95 -22
1257 -22 1343 0 144 38 250 129 308 266 l23 54 3 906 3 906 40 6 c50 7 95 47
109 96 5 20 10 114 10 209 0 195 -8 229 -64 263 -28 17 -54 19 -251 19 -121 0
-224 4 -230 8 -5 4 -17 21 -26 37 -10 17 -32 40 -49 53 l-33 22 -516 0 c-495
0 -517 -1 -546 -20z m1055 -170 l30 -60 245 0 245 0 0 -165 0 -165 -1030 0
-1030 0 0 165 0 165 244 0 245 0 33 60 33 60 477 0 478 0 30 -60z m368 -1437
l-3 -868 -23 -50 c-28 -60 -71 -107 -132 -143 l-45 -27 -658 -3 -658 -3 -60
27 c-67 30 -121 84 -153 153 -21 46 -21 51 -24 914 l-3 867 881 0 881 0 -3
-867z"/>
<path d="M1015 1760 l-80 -80 170 -170 170 -170 -170 -170 c-93 -93 -167 -171
-165 -174 3 -3 40 -41 82 -85 l77 -79 171 171 170 171 173 -172 172 -172 66
67 c36 38 71 76 79 86 12 16 -4 35 -155 187 l-168 170 164 165 c90 91 165 169
167 173 2 8 -102 120 -141 151 -17 13 -33 0 -187 -154 l-169 -169 -167 167
c-92 92 -170 167 -173 167 -4 0 -42 -36 -86 -80z"/>
</g>
</svg>
    ),

  trashCan: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="1131.000000pt" viewBox="0 0 900.000000 1131.000000"
 preserveAspectRatio="xMidYMid meet"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
>
<g transform="translate(0.000000,1131.000000) scale(0.100000,-0.100000)">
<path d="M3545 11231 c-99 -13 -120 -34 -249 -241 -157 -251 -321 -516 -441
-710 -59 -96 -117 -185 -128 -197 l-20 -23 -862 0 c-880 0 -964 -3 -1096 -40
-81 -22 -219 -86 -286 -131 -146 -100 -302 -296 -360 -454 -51 -138 -55 -168
-60 -475 -4 -199 -2 -308 6 -336 6 -23 29 -62 51 -87 63 -71 92 -77 365 -77
169 0 236 -3 248 -12 14 -11 18 -47 27 -213 5 -110 16 -324 25 -475 8 -151 21
-405 30 -565 42 -790 66 -1234 80 -1480 8 -148 22 -400 30 -560 16 -305 32
-598 65 -1210 11 -203 24 -455 30 -560 6 -104 15 -271 20 -370 6 -99 17 -306
25 -460 16 -298 36 -681 60 -1120 8 -148 19 -360 24 -470 6 -110 13 -227 16
-260 3 -33 10 -157 15 -275 6 -118 16 -231 22 -250 17 -53 63 -106 116 -132
l47 -23 3150 0 3150 0 46 27 c52 31 91 77 107 128 7 19 16 129 22 245 5 116
12 244 15 285 3 41 10 161 16 265 5 105 16 314 24 465 15 274 32 584 60 1115
8 154 21 406 30 560 8 154 20 366 25 470 5 105 12 226 15 270 3 44 14 251 25
460 11 209 25 463 30 565 6 102 22 394 35 650 26 488 48 893 65 1195 5 99 17
311 25 470 8 160 22 409 30 555 8 146 19 360 25 475 6 116 16 215 21 220 6 6
114 12 262 15 247 5 254 6 302 31 35 18 59 39 80 74 l30 49 0 320 c-1 298 -2
326 -22 391 -109 359 -348 600 -693 699 -112 32 -225 36 -1085 36 l-862 0 -20
23 c-11 12 -87 130 -169 262 -81 132 -200 323 -263 425 -62 102 -139 226 -169
275 -67 110 -93 139 -151 168 l-46 22 -930 1 c-511 1 -952 -1 -980 -5z m1741
-449 c12 -8 60 -81 196 -302 53 -85 128 -207 167 -270 39 -63 70 -122 69 -130
-3 -13 -148 -15 -1226 -18 -1094 -2 -1223 0 -1229 13 -6 17 7 39 214 370 68
110 130 209 136 220 30 50 72 111 81 117 6 4 364 8 796 8 432 0 790 -4 796 -8z
m2785 -1176 c202 -43 368 -202 414 -397 16 -71 20 -265 5 -289 -8 -13 -464
-15 -4000 -15 -3536 0 -3992 2 -4000 15 -13 21 -12 208 1 272 43 204 208 368
414 413 93 20 7071 21 7166 1z m-272 -1155 c12 -7 12 -39 2 -202 -22 -378 -32
-556 -41 -749 -5 -107 -14 -271 -19 -365 -6 -93 -18 -298 -26 -455 -8 -157
-22 -406 -30 -555 -8 -148 -22 -398 -30 -555 -8 -157 -22 -400 -30 -540 -8
-140 -17 -309 -20 -375 -3 -66 -10 -194 -15 -285 -23 -397 -41 -716 -55 -995
-8 -165 -20 -374 -26 -465 -6 -91 -14 -253 -19 -360 -8 -183 -15 -299 -40
-730 -6 -96 -15 -263 -20 -370 -20 -413 -49 -915 -56 -953 l-6 -27 -2878 0
-2878 0 -6 27 c-7 37 -39 598 -56 973 -5 118 -12 235 -15 260 -3 25 -9 142
-15 260 -5 118 -14 289 -20 380 -5 91 -17 291 -25 445 -16 303 -37 685 -60
1110 -8 149 -22 396 -30 550 -8 154 -22 399 -30 545 -8 146 -22 393 -30 550
-29 538 -69 1267 -85 1555 -6 99 -15 268 -20 375 -10 206 -22 444 -41 754 -10
157 -9 190 2 197 18 12 6600 11 6618 0z"/>
<path d="M2484 7144 c-23 -8 -58 -31 -79 -51 -70 -68 -75 -104 -59 -390 19
-351 33 -603 49 -933 9 -162 24 -464 35 -670 11 -206 25 -463 30 -570 6 -107
17 -321 25 -475 8 -154 26 -500 40 -770 31 -608 52 -999 66 -1265 6 -113 15
-223 21 -245 21 -83 122 -155 219 -155 47 0 134 44 164 84 45 60 50 102 37
353 -7 125 -19 354 -27 508 -37 699 -46 862 -56 1040 -5 105 -14 280 -19 390
-5 110 -14 281 -19 380 -6 99 -18 315 -26 480 -8 165 -22 422 -30 570 -8 149
-21 407 -30 575 -9 168 -20 375 -25 460 -5 85 -12 229 -16 320 -7 202 -20 257
-75 310 -41 39 -112 71 -158 69 -14 0 -45 -7 -67 -15z"/>
<path d="M4419 7144 c-58 -17 -121 -79 -137 -132 -9 -30 -12 -674 -12 -2633
l0 -2593 21 -43 c78 -162 307 -162 390 0 19 37 20 85 20 2644 l0 2606 -22 44
c-24 50 -67 86 -128 108 -52 18 -72 18 -132 -1z"/>
<path d="M6345 7143 c-65 -27 -94 -52 -120 -103 -23 -45 -26 -68 -40 -322 -8
-150 -20 -358 -26 -463 -5 -104 -14 -278 -19 -385 -5 -107 -14 -283 -20 -390
-22 -394 -39 -728 -45 -840 -3 -63 -10 -194 -15 -290 -5 -96 -17 -307 -25
-467 -8 -161 -22 -425 -30 -585 -8 -161 -20 -374 -26 -473 -5 -99 -14 -268
-19 -375 -5 -107 -14 -290 -21 -406 -6 -117 -9 -227 -5 -246 9 -52 60 -121
106 -147 24 -13 65 -25 98 -28 78 -7 154 32 196 100 38 62 32 -17 96 1247 11
217 24 476 30 575 6 99 15 270 20 380 11 214 31 593 55 1060 8 160 19 380 25
490 5 110 14 279 20 375 5 96 17 312 25 480 9 168 20 372 24 453 9 166 2 224
-34 279 -51 77 -168 116 -250 81z"/>
</g>
</svg>

 ),


  trashCan2: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="100.000000pt" height="100.000000pt" viewBox="0 0 100.000000 100.000000"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)">
<path d="M388 974 c-192 -46 -336 -202 -370 -401 -48 -286 190 -563 482 -563
312 0 553 306 475 603 -69 264 -329 424 -587 361z m264 -42 c223 -79 352 -319
293 -547 -22 -82 -58 -144 -124 -210 -161 -161 -409 -179 -592 -43 -140 104
-209 273 -181 439 18 103 55 173 131 250 101 100 205 142 341 135 41 -2 101
-13 132 -24z"/>
<path d="M403 821 c-28 -40 -28 -40 -94 -41 -76 0 -99 -16 -99 -68 0 -25 4
-32 20 -32 14 0 20 -7 20 -22 0 -18 28 -504 30 -515 1 -9 410 -1 415 7 5 7 34
441 35 518 0 6 9 12 20 12 16 0 20 7 20 34 0 48 -28 66 -106 66 -59 0 -61 1
-85 38 -23 35 -27 37 -86 40 l-63 3 -27 -40z m141 -7 c28 -28 17 -34 -59 -34
l-75 0 16 25 c13 20 24 25 59 25 26 0 50 -6 59 -16z m194 -86 c3 -17 -14 -18
-247 -18 -203 0 -251 3 -251 13 0 8 3 17 7 21 4 3 115 5 247 4 220 -3 241 -5
244 -20z m-42 -130 c-3 -46 -8 -137 -11 -203 -3 -66 -8 -144 -11 -172 l-5 -53
-180 0 c-177 0 -179 0 -183 23 -4 19 -27 424 -26 470 0 16 17 17 211 17 l211
0 -6 -82z"/>
<path d="M356 592 c-8 -14 13 -335 23 -345 18 -18 20 13 10 173 -9 152 -17
197 -33 172z"/>
<path d="M476 574 c-8 -20 -8 -298 0 -318 17 -45 24 1 24 159 0 158 -7 204
-24 159z"/>
<path d="M596 538 c-11 -100 -11 -283 -1 -288 12 -6 21 78 26 229 3 73 0 106
-8 108 -7 3 -13 -15 -17 -49z"/>
</g>
</svg>
 ),




  topArrow0: (
 
 <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="876.000000pt" viewBox="0 0 900.000000 876.000000"
 preserveAspectRatio="xMidYMid meet"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait 
	  >
<g transform="translate(0.000000,876.000000) scale(0.100000,-0.100000)">
<path d="M4282 8495 c-17 -13 -49 -16 -158 -14 -88 1 -140 -3 -147 -10 -7 -7
-53 -11 -118 -11 -84 0 -109 -3 -119 -15 -9 -11 -25 -14 -54 -12 -23 3 -53 -1
-68 -9 -15 -8 -42 -14 -60 -14 -18 -1 -44 -7 -58 -15 -14 -7 -37 -11 -51 -8
-16 3 -30 -1 -38 -11 -8 -9 -29 -16 -48 -16 -21 0 -36 -6 -39 -15 -4 -9 -19
-15 -39 -15 -18 0 -38 -7 -45 -15 -7 -9 -29 -15 -52 -15 -22 0 -46 -7 -54 -15
-9 -8 -26 -15 -40 -15 -13 0 -41 -9 -61 -20 -21 -11 -50 -20 -65 -20 -15 0
-29 -4 -32 -8 -9 -15 -132 -72 -154 -72 -11 0 -25 -7 -32 -15 -7 -8 -20 -15
-30 -15 -10 0 -23 -7 -30 -15 -7 -8 -21 -15 -31 -15 -10 0 -21 -4 -24 -10 -3
-5 -27 -19 -53 -30 -25 -11 -54 -27 -63 -36 -9 -8 -48 -30 -87 -49 -39 -20
-74 -40 -77 -45 -3 -6 -14 -10 -24 -10 -9 0 -30 -13 -46 -30 -15 -16 -57 -44
-92 -61 -36 -18 -67 -38 -70 -46 -3 -7 -13 -13 -22 -13 -9 0 -37 -21 -61 -46
-25 -25 -61 -54 -80 -64 -19 -10 -48 -32 -64 -49 -17 -17 -35 -31 -41 -31 -6
0 -46 -36 -90 -80 -44 -44 -87 -80 -96 -80 -17 0 -239 -221 -239 -238 0 -6
-33 -45 -72 -87 -40 -43 -80 -89 -89 -104 -9 -14 -35 -44 -58 -66 -22 -21 -41
-46 -41 -55 0 -9 -16 -31 -35 -50 -19 -19 -35 -39 -35 -46 0 -6 -7 -17 -15
-24 -8 -7 -15 -20 -15 -29 0 -9 -20 -37 -45 -61 -25 -24 -45 -52 -45 -62 0 -9
-6 -21 -13 -25 -14 -8 -39 -52 -77 -135 -12 -27 -26 -48 -31 -48 -5 0 -23 -28
-39 -62 -17 -35 -35 -70 -40 -78 -27 -46 -58 -123 -54 -134 3 -7 -2 -19 -11
-26 -8 -7 -15 -18 -15 -25 0 -13 -56 -124 -71 -139 -5 -6 -9 -16 -9 -24 0 -7
-7 -20 -15 -28 -8 -9 -15 -28 -15 -43 0 -16 -7 -34 -16 -42 -10 -8 -14 -22
-10 -39 2 -15 -2 -39 -10 -54 -8 -16 -14 -36 -14 -45 0 -9 -11 -38 -25 -66
-13 -27 -25 -64 -25 -82 0 -17 -5 -35 -10 -38 -6 -3 -10 -16 -10 -28 0 -12 -7
-35 -15 -51 -8 -15 -15 -43 -15 -61 0 -18 -7 -38 -15 -45 -11 -9 -15 -34 -15
-94 -1 -55 -5 -87 -15 -100 -10 -14 -15 -44 -15 -96 0 -48 -5 -83 -14 -95 -9
-14 -13 -44 -11 -98 1 -50 -3 -86 -11 -103 -21 -41 -20 -591 1 -630 11 -21 15
-54 13 -122 -1 -60 2 -96 10 -104 7 -7 12 -40 12 -78 0 -43 5 -73 15 -86 10
-13 14 -45 15 -100 0 -60 4 -85 15 -94 10 -8 15 -30 15 -65 0 -35 5 -57 15
-65 8 -7 15 -25 15 -41 0 -15 4 -31 10 -34 5 -3 10 -22 10 -41 0 -19 10 -59
23 -87 37 -81 51 -129 48 -165 -1 -21 4 -34 14 -38 8 -3 15 -17 15 -29 0 -13
25 -72 55 -131 30 -60 55 -115 55 -124 0 -21 134 -287 158 -314 10 -12 35 -55
55 -97 20 -42 43 -82 52 -89 8 -7 15 -19 15 -27 0 -9 18 -33 39 -55 22 -21 50
-60 62 -86 12 -26 44 -70 71 -99 26 -28 48 -58 48 -66 0 -7 14 -24 31 -36 17
-13 37 -37 44 -54 8 -18 45 -63 84 -102 39 -38 71 -75 71 -82 0 -18 192 -213
210 -213 8 0 56 -40 105 -90 49 -49 95 -90 102 -90 13 0 76 -51 172 -137 32
-29 65 -53 74 -53 9 0 19 -5 22 -10 4 -6 25 -23 48 -37 23 -14 46 -32 50 -39
4 -8 16 -14 26 -14 9 0 30 -14 46 -30 16 -17 36 -30 46 -30 9 0 22 -7 29 -15
7 -8 16 -15 21 -15 16 0 176 -80 188 -94 15 -18 86 -56 105 -56 8 0 16 -7 20
-15 3 -8 14 -15 24 -15 11 0 25 -7 32 -15 7 -8 23 -15 36 -15 13 0 56 -15 96
-34 40 -18 92 -39 116 -46 23 -7 47 -19 53 -27 6 -7 26 -13 44 -13 18 0 38 -7
45 -15 7 -8 29 -15 49 -15 21 0 46 -7 57 -15 10 -8 31 -15 45 -15 15 0 32 -7
39 -15 7 -8 24 -15 39 -15 15 0 31 -4 36 -9 6 -5 28 -11 50 -14 73 -10 143
-25 164 -36 11 -6 40 -11 65 -11 25 0 48 -4 51 -10 3 -6 50 -10 106 -10 79 0
101 -3 105 -15 5 -13 35 -15 178 -15 134 -1 175 -4 190 -15 29 -22 358 -22
376 0 10 12 41 15 157 15 115 0 147 3 159 15 12 11 41 15 124 15 62 0 111 4
115 10 3 6 26 10 51 10 25 0 54 5 65 10 11 6 36 13 57 16 40 5 96 21 124 35
10 5 31 9 48 9 18 0 33 6 36 15 4 10 20 15 48 15 22 0 50 7 60 15 11 8 36 15
57 15 20 0 42 7 49 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 23 15 37 15 13 0
40 8 61 19 20 10 51 22 68 25 18 4 40 16 50 27 9 10 29 19 44 19 15 0 33 7 40
15 7 8 28 15 47 15 21 0 36 6 39 15 4 8 12 15 20 15 19 0 90 38 105 56 12 14
171 94 188 94 4 0 20 14 36 30 16 17 36 30 45 30 9 0 29 13 45 30 16 16 37 30
47 30 10 0 21 7 24 15 3 8 16 17 27 21 12 4 37 20 55 35 18 16 38 29 45 29 7
0 35 23 62 50 27 28 54 50 60 50 6 0 35 25 65 56 30 30 71 64 90 74 42 22 416
397 424 425 3 11 35 49 71 84 36 36 65 69 65 74 0 6 21 33 48 62 26 28 56 66
67 85 11 19 25 43 32 54 6 11 23 32 37 47 14 15 26 34 26 42 0 7 9 22 19 31
11 10 29 39 41 64 12 26 30 56 40 67 9 11 41 68 70 128 29 59 57 110 61 113 5
3 9 14 9 25 0 10 4 19 10 19 12 0 41 55 34 63 -4 3 1 16 10 29 9 12 16 32 16
44 0 20 52 128 71 149 5 5 9 15 9 23 0 7 7 20 15 28 8 9 15 28 15 43 0 16 6
34 14 40 13 11 19 34 33 126 3 22 12 50 21 63 8 12 12 25 9 29 -4 3 0 18 8 34
8 15 15 42 15 59 0 16 4 38 9 48 22 44 35 92 38 144 3 32 11 62 19 69 9 7 14
31 14 63 0 29 7 59 15 70 10 13 15 43 15 83 0 35 6 72 12 83 10 15 10 22 1 31
-9 9 -9 17 -1 33 18 33 19 928 1 962 -8 16 -13 60 -13 113 0 61 -4 93 -15 107
-8 11 -15 41 -15 70 0 33 -5 56 -15 64 -9 7 -15 30 -15 54 0 22 -7 50 -15 60
-8 11 -15 30 -15 42 0 13 -4 26 -10 29 -5 3 -10 23 -10 43 0 20 -7 50 -15 66
-9 16 -13 31 -11 34 3 2 -1 17 -9 33 -8 15 -15 44 -15 63 0 19 -4 38 -10 41
-5 3 -10 19 -10 34 0 16 -7 34 -15 41 -8 7 -15 28 -15 47 0 21 -6 36 -15 39
-8 4 -15 13 -15 21 0 14 -54 119 -71 137 -5 6 -9 24 -9 42 0 17 -6 37 -14 43
-7 6 -13 23 -13 37 0 14 -10 35 -22 48 -11 12 -21 30 -21 39 0 10 -7 20 -15
23 -8 4 -15 14 -15 24 0 10 -7 23 -15 30 -8 7 -15 19 -15 26 0 8 -11 32 -25
54 -14 22 -25 44 -25 49 0 5 -10 22 -23 38 -13 15 -35 53 -50 85 -15 31 -34
59 -42 62 -8 3 -15 14 -15 24 0 10 -13 31 -30 47 -16 16 -30 35 -30 43 0 8
-16 30 -35 49 -19 19 -35 39 -35 45 0 6 -13 26 -30 45 -16 18 -30 39 -30 46 0
7 -34 46 -75 87 -41 41 -75 79 -75 85 0 15 -403 417 -427 426 -10 4 -47 37
-83 74 -36 37 -81 75 -100 85 -19 10 -48 32 -64 49 -17 17 -38 31 -48 31 -10
0 -18 4 -18 9 0 5 -40 34 -90 66 -49 32 -90 61 -90 66 0 5 -8 9 -18 9 -11 0
-32 11 -48 26 -16 14 -62 41 -102 61 -40 20 -75 40 -78 44 -3 5 -13 9 -23 9
-10 0 -26 9 -36 20 -10 11 -24 20 -30 20 -7 0 -18 7 -25 15 -7 8 -20 15 -30
15 -10 0 -23 7 -30 15 -7 8 -27 15 -46 15 -18 0 -35 4 -38 9 -11 16 -125 71
-149 71 -14 0 -30 6 -36 13 -6 8 -30 19 -53 26 -24 8 -52 17 -63 22 -11 4 -30
11 -42 14 -13 4 -23 11 -23 16 0 5 -20 9 -44 9 -26 0 -48 6 -56 15 -7 8 -27
15 -45 15 -20 0 -35 6 -39 15 -4 10 -19 15 -48 15 -24 0 -54 7 -66 16 -13 9
-26 14 -29 10 -3 -3 -18 1 -34 9 -15 8 -42 15 -59 15 -17 0 -43 6 -58 14 -16
8 -43 12 -68 9 -29 -3 -44 0 -53 11 -11 13 -35 16 -120 16 -65 0 -111 4 -118
11 -7 7 -59 11 -147 10 -109 -2 -141 1 -158 14 -33 22 -383 22 -416 0z m213
-305 c4 -6 88 -10 219 -10 178 0 216 -3 226 -15 9 -11 32 -15 79 -15 44 0 74
-5 87 -15 11 -8 41 -15 70 -15 33 0 56 -5 64 -15 7 -9 29 -15 54 -15 23 0 47
-5 54 -12 6 -6 26 -11 44 -10 18 0 42 -5 53 -12 20 -13 37 -17 160 -34 33 -4
79 -18 102 -30 23 -12 53 -22 66 -22 14 0 30 -7 37 -15 7 -8 20 -15 30 -15 10
0 23 -7 30 -15 7 -8 20 -15 30 -15 10 0 23 -7 30 -15 7 -8 23 -15 36 -15 12 0
26 -4 29 -10 3 -5 14 -10 24 -10 10 0 24 -7 31 -15 7 -8 23 -15 37 -15 28 0
94 -32 112 -54 8 -9 22 -16 33 -16 10 0 21 -7 24 -15 4 -8 14 -15 24 -15 10 0
25 -7 34 -15 8 -8 19 -15 25 -15 6 0 29 -11 51 -25 22 -14 45 -25 51 -25 6 0
27 -13 46 -30 18 -16 40 -30 47 -30 7 0 21 -9 31 -20 10 -11 24 -20 30 -20 7
0 18 -7 25 -15 7 -8 20 -15 29 -15 9 0 37 -21 61 -46 25 -25 61 -54 82 -65 20
-10 45 -30 56 -44 11 -14 27 -25 36 -25 8 0 50 -36 93 -80 42 -44 84 -80 93
-80 18 0 104 -86 113 -113 4 -9 15 -20 24 -24 24 -8 103 -84 103 -99 0 -6 30
-42 66 -80 37 -38 77 -85 89 -104 12 -19 37 -48 54 -65 17 -16 31 -36 31 -44
0 -7 14 -29 30 -48 17 -18 30 -39 30 -46 0 -7 13 -24 30 -37 16 -14 29 -32 30
-41 0 -8 12 -26 26 -40 14 -13 32 -37 40 -54 8 -16 27 -48 44 -70 16 -22 29
-47 30 -56 0 -9 7 -22 15 -29 8 -7 15 -18 15 -24 0 -6 16 -42 35 -80 19 -39
35 -75 35 -80 0 -6 14 -24 30 -40 17 -16 30 -39 30 -50 0 -12 11 -41 25 -65
14 -23 25 -53 25 -65 0 -12 7 -31 15 -42 8 -10 15 -28 15 -39 0 -12 9 -38 19
-59 11 -21 23 -51 26 -68 4 -16 18 -48 31 -71 13 -23 24 -58 24 -78 0 -20 6
-42 14 -48 8 -7 16 -37 19 -69 3 -52 16 -100 38 -144 5 -10 9 -36 9 -58 0 -22
7 -57 15 -77 8 -19 15 -55 15 -79 0 -23 5 -46 10 -49 6 -3 10 -44 10 -89 0
-62 4 -87 15 -96 22 -18 23 -791 1 -809 -10 -8 -16 -40 -20 -94 -6 -112 -19
-198 -34 -224 -7 -12 -12 -37 -12 -57 0 -19 -4 -38 -10 -41 -5 -3 -10 -30 -10
-59 0 -35 -5 -58 -15 -66 -10 -8 -15 -30 -15 -62 0 -34 -4 -50 -15 -54 -10 -4
-15 -20 -15 -44 0 -20 -11 -57 -24 -82 -13 -25 -27 -60 -31 -78 -4 -18 -16
-47 -26 -64 -10 -17 -19 -43 -19 -57 0 -15 -7 -32 -15 -39 -8 -7 -15 -23 -15
-37 0 -20 -28 -82 -70 -153 -5 -8 -11 -22 -14 -30 -3 -8 -10 -22 -15 -30 -5
-8 -26 -51 -47 -95 -20 -44 -41 -87 -45 -95 -5 -8 -16 -31 -24 -50 -9 -19 -29
-52 -45 -72 -17 -20 -30 -41 -30 -47 0 -6 -13 -24 -30 -41 -17 -17 -30 -37
-30 -46 0 -21 -42 -84 -84 -123 -20 -19 -36 -42 -36 -51 0 -9 -21 -34 -46 -55
-25 -22 -54 -55 -64 -75 -10 -19 -44 -60 -74 -90 -31 -30 -56 -61 -56 -69 0
-20 -188 -209 -230 -231 -19 -10 -66 -50 -105 -89 -38 -39 -75 -71 -82 -71 -6
0 -33 -18 -58 -40 -25 -22 -49 -40 -53 -40 -4 0 -33 -25 -64 -55 -31 -30 -60
-55 -65 -55 -15 0 -80 -36 -98 -54 -9 -9 -22 -16 -29 -16 -7 0 -21 -9 -31 -20
-10 -11 -69 -45 -131 -75 -63 -31 -114 -60 -114 -64 0 -8 -110 -65 -147 -76
-13 -3 -23 -11 -23 -16 0 -5 -13 -9 -28 -9 -16 0 -37 -7 -48 -15 -10 -8 -31
-15 -45 -15 -15 0 -32 -7 -39 -15 -7 -8 -19 -15 -27 -15 -8 0 -21 -7 -29 -15
-9 -8 -24 -15 -35 -15 -10 0 -19 -4 -19 -10 0 -5 -10 -10 -23 -10 -13 0 -46
-11 -73 -25 -30 -15 -66 -25 -92 -25 -24 0 -57 -7 -74 -16 -16 -9 -41 -13 -53
-10 -14 4 -29 0 -39 -9 -8 -8 -32 -15 -53 -15 -21 0 -47 -7 -57 -15 -11 -8
-36 -15 -57 -15 -20 0 -42 -7 -49 -15 -8 -10 -31 -15 -69 -15 -33 -1 -64 -7
-75 -15 -13 -10 -43 -15 -82 -15 -35 0 -66 -5 -69 -10 -4 -6 -78 -10 -189 -10
-145 0 -186 -3 -202 -15 -26 -20 -137 -20 -154 0 -10 12 -45 15 -196 15 -111
0 -185 4 -189 10 -3 5 -30 10 -59 10 -30 0 -60 6 -72 15 -11 8 -42 14 -75 15
-38 0 -61 5 -69 15 -7 8 -29 15 -49 15 -21 0 -46 7 -57 15 -10 8 -38 15 -61
15 -23 0 -43 5 -45 12 -3 8 -22 11 -52 9 -30 -1 -57 4 -72 13 -13 9 -38 16
-56 16 -18 0 -55 11 -82 25 -27 14 -60 25 -73 25 -13 0 -23 5 -23 10 0 6 -9
10 -19 10 -11 0 -26 7 -35 15 -8 8 -24 15 -36 15 -12 0 -45 13 -75 30 -30 16
-65 30 -79 30 -15 0 -26 4 -26 9 0 5 -10 13 -22 16 -65 20 -349 170 -379 201
-18 19 -38 34 -45 34 -7 0 -20 7 -29 16 -18 18 -83 54 -98 54 -5 0 -30 20 -55
45 -25 25 -50 45 -57 45 -6 0 -26 16 -45 35 -19 19 -41 35 -50 35 -8 0 -42 27
-75 61 -33 33 -73 67 -90 76 -40 20 -365 344 -365 363 0 9 -22 38 -50 65 -27
27 -50 54 -50 60 0 5 -20 32 -45 58 -25 27 -45 54 -45 61 0 7 -12 23 -26 37
-14 13 -34 40 -44 60 -10 19 -26 41 -34 48 -9 8 -16 21 -16 30 0 9 -14 29 -30
45 -17 16 -30 34 -30 39 0 5 -11 22 -25 39 -14 16 -25 40 -25 53 0 12 -7 29
-17 36 -9 8 -33 50 -55 94 -21 43 -43 84 -48 89 -6 6 -10 18 -10 27 0 9 -7 22
-15 29 -8 7 -15 20 -15 30 0 10 -7 23 -15 30 -8 7 -15 20 -15 30 0 16 -19 65
-39 100 -25 44 -61 132 -57 139 3 5 -1 17 -9 27 -8 10 -15 35 -15 55 0 19 -7
44 -15 55 -8 10 -15 38 -15 60 0 28 -5 44 -15 48 -9 3 -15 18 -15 39 0 19 -6
40 -14 46 -13 11 -20 36 -32 126 -4 22 -13 48 -21 57 -11 12 -14 30 -11 56 4
23 0 48 -8 63 -8 15 -13 57 -14 110 0 54 -5 90 -13 97 -9 10 -13 118 -15 453
-2 380 -1 445 13 471 10 21 15 60 15 117 1 59 5 92 15 105 8 11 12 29 9 43 -4
13 -1 30 6 38 7 8 16 43 21 78 13 96 20 125 35 138 9 7 14 31 14 61 0 34 4 50
15 54 8 4 15 18 15 33 0 15 7 36 15 47 8 10 15 38 15 61 0 23 5 43 10 45 6 2
13 18 15 36 2 18 13 49 24 70 10 20 22 44 25 52 3 8 10 22 14 30 24 41 32 61
32 77 1 10 12 36 25 58 14 22 27 46 30 53 3 6 7 18 10 25 3 6 9 19 14 27 5 8
24 44 41 80 18 36 41 74 51 86 11 11 19 32 19 47 0 14 5 29 10 32 6 4 25 30
44 58 18 29 45 63 60 76 14 14 26 31 26 38 0 18 42 83 69 107 11 11 21 26 21
34 0 8 20 35 45 60 25 25 45 50 45 55 0 6 23 34 50 63 28 29 50 59 50 66 0 18
332 348 351 348 8 0 50 36 93 80 44 44 85 80 91 80 6 0 24 14 40 30 16 17 35
30 42 30 8 0 36 20 62 45 26 25 55 45 63 45 9 0 21 7 28 15 7 8 18 15 25 15 6
0 20 9 30 20 10 11 24 20 31 20 7 0 29 14 47 30 19 17 42 30 50 30 9 0 21 9
27 20 6 11 22 23 35 26 13 3 29 12 36 20 6 8 18 14 26 14 8 0 21 7 29 15 9 8
24 15 33 15 10 0 24 7 31 15 7 8 17 15 22 15 4 0 40 16 79 35 39 19 80 35 90
35 11 0 37 11 59 25 22 14 50 25 64 25 13 0 29 7 36 15 7 8 20 15 30 15 10 0
23 7 30 15 7 8 23 15 37 15 13 0 46 11 73 25 27 14 66 25 86 25 38 0 82 12
140 37 18 7 51 12 73 11 23 -1 47 4 53 10 7 7 31 12 54 12 25 0 47 6 54 15 7
9 29 15 55 15 26 0 48 6 55 15 9 11 32 15 80 15 48 0 71 4 80 15 10 12 48 15
226 15 131 0 215 4 219 10 3 6 12 10 20 10 8 0 17 -4 20 -10z"/>
<path d="M4370 6455 c-7 -8 -19 -15 -27 -15 -7 0 -396 -382 -864 -850 -927
-926 -906 -902 -916 -1025 -4 -51 -1 -67 21 -108 14 -26 26 -54 26 -60 0 -16
92 -107 107 -107 6 0 31 -11 54 -25 52 -29 138 -35 159 -10 7 8 25 15 41 15
17 0 37 9 46 20 10 11 24 20 33 20 8 0 332 317 720 705 388 388 712 705 720
705 8 0 334 -319 725 -710 578 -578 718 -713 757 -730 26 -11 50 -25 53 -30 3
-6 36 -10 72 -10 51 0 77 6 117 26 28 14 58 30 66 34 8 4 22 22 32 41 9 19 30
47 47 63 22 21 31 39 31 61 0 18 7 46 16 64 15 30 15 34 0 50 -9 10 -16 33
-16 51 0 21 -13 53 -37 89 -43 66 -1598 1625 -1659 1663 -21 14 -45 33 -53 42
-7 9 -21 16 -31 16 -10 0 -23 7 -30 15 -9 11 -35 15 -105 15 -70 0 -96 -4
-105 -15z"/>
<path d="M4404 4833 c-7 -7 -25 -13 -41 -13 -24 0 -157 -130 -896 -867 -549
-550 -870 -877 -873 -893 -3 -14 -13 -40 -21 -59 -17 -38 -13 -145 6 -164 6
-6 11 -21 11 -32 0 -30 111 -145 139 -145 11 0 21 -4 21 -10 0 -5 10 -10 23
-10 12 0 35 -7 51 -15 36 -19 90 -19 106 0 7 8 25 15 39 15 16 0 37 10 51 25
13 14 29 25 36 25 18 0 283 266 294 295 5 14 18 25 28 25 20 0 108 91 132 136
9 16 31 36 49 45 38 18 146 128 156 158 3 11 15 23 26 26 31 10 127 104 131
128 2 12 12 23 22 25 21 4 86 71 86 88 0 13 47 58 79 74 38 19 101 83 101 102
0 10 14 24 33 32 39 17 112 91 126 129 6 15 17 27 26 27 8 0 43 27 77 60 33
33 64 60 68 60 4 0 329 -321 722 -713 620 -618 722 -717 777 -745 69 -35 122
-41 167 -17 16 8 39 15 51 15 12 0 30 11 41 25 11 14 29 25 40 25 20 0 102
114 102 142 0 8 7 30 17 48 14 28 14 40 4 74 -7 23 -15 52 -18 66 -3 14 -17
38 -29 53 -13 16 -24 34 -24 40 0 19 -1663 1677 -1681 1677 -9 0 -22 7 -29 15
-7 8 -21 15 -30 15 -10 0 -20 5 -22 11 -5 16 -158 17 -174 2z"/>
</g>
</svg>
 ),
 
  topArrow: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="900.000000pt" viewBox="0 0 900.000000 900.000000"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
<path d="M4276 8945 c-4 -12 -32 -15 -163 -15 -123 -1 -162 -4 -177 -15 -15
-11 -49 -15 -132 -15 -84 0 -114 -3 -123 -14 -7 -8 -38 -16 -74 -19 -93 -8
-166 -22 -179 -35 -7 -7 -31 -12 -54 -12 -25 0 -47 -6 -54 -15 -7 -8 -27 -15
-45 -15 -18 0 -38 -6 -44 -14 -6 -8 -26 -16 -44 -20 -143 -25 -161 -30 -265
-78 -35 -17 -69 -27 -77 -24 -8 3 -17 1 -20 -4 -8 -12 -148 -80 -165 -80 -18
0 -98 -39 -106 -51 -3 -5 -13 -9 -23 -9 -10 0 -24 -7 -31 -15 -7 -8 -20 -15
-30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -9 -1 -27 -14 -41 -30
-14 -17 -34 -30 -47 -30 -13 0 -23 -4 -23 -10 0 -5 -12 -13 -26 -16 -40 -10
-135 -63 -169 -93 -39 -36 -81 -61 -99 -61 -9 0 -29 -13 -46 -30 -17 -16 -38
-30 -47 -30 -9 0 -42 -27 -75 -60 -32 -33 -64 -60 -71 -60 -7 0 -34 -20 -60
-45 -27 -25 -54 -45 -60 -45 -7 0 -48 -36 -92 -80 -44 -44 -86 -80 -95 -80
-20 0 -260 -240 -260 -260 0 -9 -36 -51 -80 -95 -44 -44 -80 -85 -80 -92 0 -7
-27 -41 -60 -75 -33 -33 -60 -67 -60 -75 0 -7 -20 -33 -45 -56 -26 -26 -45
-53 -45 -65 0 -12 -4 -22 -9 -22 -5 0 -13 -10 -16 -22 -4 -13 -20 -36 -35 -53
-50 -55 -150 -222 -150 -251 0 -7 -14 -27 -30 -44 -17 -17 -30 -40 -30 -51 0
-11 -7 -22 -15 -25 -8 -4 -15 -14 -15 -24 0 -10 -7 -23 -15 -30 -8 -7 -15 -20
-15 -30 0 -10 -7 -23 -15 -30 -8 -7 -15 -20 -15 -30 0 -10 -7 -23 -15 -30 -8
-7 -15 -22 -15 -34 0 -11 -32 -84 -70 -161 -38 -77 -70 -153 -70 -168 0 -16
-6 -43 -13 -60 -29 -67 -40 -103 -44 -142 -3 -22 -9 -44 -14 -49 -5 -6 -9 -24
-9 -42 0 -17 -7 -37 -15 -44 -9 -7 -15 -29 -15 -54 0 -23 -7 -51 -15 -62 -8
-10 -15 -30 -15 -44 0 -14 -7 -34 -15 -44 -8 -11 -15 -37 -15 -57 0 -21 -4
-41 -10 -44 -5 -3 -10 -35 -10 -71 0 -48 -4 -66 -15 -70 -12 -5 -15 -27 -15
-108 0 -75 -4 -107 -15 -122 -22 -28 -21 -1109 1 -1139 9 -12 14 -45 14 -91 0
-55 4 -73 15 -78 11 -4 15 -22 15 -70 0 -36 4 -68 10 -71 5 -3 10 -30 10 -59
0 -30 6 -60 15 -72 8 -10 15 -30 15 -44 0 -14 7 -34 15 -44 8 -11 15 -39 15
-62 0 -25 6 -47 15 -54 8 -7 15 -27 15 -46 0 -18 4 -36 10 -39 5 -3 10 -22 10
-41 0 -30 10 -55 49 -124 28 -51 41 -80 41 -97 0 -10 25 -67 55 -128 30 -60
55 -116 55 -124 0 -18 39 -99 51 -107 5 -3 9 -13 9 -23 0 -10 7 -24 15 -31 8
-7 15 -20 15 -30 0 -10 7 -23 15 -30 8 -7 15 -20 15 -30 0 -10 7 -20 15 -24 8
-3 15 -14 15 -25 0 -11 14 -34 30 -51 16 -17 30 -37 30 -44 0 -29 100 -196
150 -251 15 -16 31 -40 35 -52 3 -13 11 -23 16 -23 5 0 9 -10 9 -22 0 -13 23
-44 60 -80 33 -32 60 -64 60 -71 0 -7 20 -34 45 -60 25 -27 45 -54 45 -60 0
-7 36 -48 80 -92 44 -44 80 -86 80 -95 0 -20 210 -230 230 -230 9 0 58 -43
110 -95 52 -52 100 -95 107 -95 7 0 33 -20 60 -45 26 -25 53 -45 60 -45 7 0
39 -27 71 -60 33 -33 66 -60 75 -60 9 0 30 -14 47 -30 17 -17 35 -30 40 -30 5
0 38 -20 74 -45 78 -53 163 -100 200 -109 14 -3 26 -11 26 -16 0 -6 11 -10 25
-10 14 0 28 -7 31 -15 4 -8 14 -15 23 -15 10 0 30 -14 46 -30 16 -17 36 -30
46 -30 9 0 22 -7 29 -15 7 -8 21 -15 31 -15 10 0 20 -4 23 -9 8 -12 88 -51
106 -51 17 0 157 -68 165 -80 3 -5 13 -6 21 -3 9 3 43 -8 77 -24 98 -48 119
-54 264 -79 18 -4 38 -12 44 -20 6 -8 26 -14 44 -14 18 0 38 -7 45 -15 7 -9
29 -15 54 -15 23 0 47 -5 54 -12 13 -13 86 -27 179 -35 36 -3 67 -11 74 -19 8
-10 37 -14 108 -14 70 0 103 -4 117 -15 15 -11 58 -14 207 -15 157 0 189 -2
193 -15 9 -22 329 -22 338 0 4 13 36 15 193 15 149 1 192 4 207 15 14 11 47
15 117 15 71 0 100 4 108 14 7 8 38 16 74 19 93 8 166 22 179 35 7 7 31 12 54
12 25 0 47 6 54 15 7 8 27 15 45 15 18 0 38 6 44 14 6 8 26 16 44 20 145 25
166 31 264 79 34 16 68 27 77 24 8 -3 18 -2 21 3 8 12 148 80 165 80 18 0 98
39 106 51 3 5 13 9 23 9 10 0 24 7 31 15 7 8 20 15 29 15 10 0 30 13 46 30 16
16 36 30 46 30 9 0 19 7 23 15 3 8 17 15 31 15 14 0 25 4 25 10 0 5 12 13 26
16 37 9 122 56 200 109 36 25 69 45 74 45 5 0 23 13 40 30 17 16 38 30 47 30
9 0 42 27 75 60 32 33 64 60 71 60 7 0 34 20 60 45 27 25 53 45 60 45 7 0 55
43 107 95 52 52 102 95 110 95 20 0 230 211 230 230 0 9 36 51 80 95 44 44 80
85 80 92 0 6 20 33 45 60 25 26 45 53 45 60 0 7 27 39 60 71 37 36 60 67 60
80 0 12 4 22 9 22 5 0 13 10 16 23 4 12 20 36 35 52 50 55 150 222 150 251 0
7 14 27 30 44 17 17 30 40 30 51 0 11 7 22 15 25 8 4 15 14 15 24 0 10 7 23
15 30 8 7 15 20 15 30 0 10 7 23 15 30 8 7 15 21 15 31 0 10 4 20 9 23 12 8
51 88 51 106 0 18 59 140 78 163 8 9 12 17 7 17 -4 0 0 11 9 25 9 13 16 35 16
48 0 13 7 32 15 43 8 10 15 33 15 51 0 18 6 47 14 65 8 18 20 52 27 76 7 23
18 47 26 53 7 7 13 32 13 59 0 30 6 52 15 60 8 7 15 27 15 45 0 18 6 38 14 44
15 13 23 71 32 229 4 68 9 95 20 99 10 4 14 24 14 77 0 48 5 79 15 92 10 14
14 48 15 130 0 87 3 114 15 124 23 19 23 671 0 690 -11 9 -15 36 -15 109 -1
68 -5 102 -15 115 -11 14 -15 46 -15 107 0 69 -3 88 -15 93 -13 5 -15 22 -14
92 1 52 -3 90 -10 97 -6 6 -11 30 -11 53 0 25 -6 47 -15 54 -8 7 -15 27 -15
45 0 18 -7 38 -15 45 -9 8 -15 30 -15 60 0 27 -6 52 -13 59 -8 6 -19 30 -26
53 -7 24 -19 58 -27 76 -8 18 -14 47 -14 65 0 18 -7 41 -15 51 -8 11 -15 30
-15 43 0 13 -7 35 -16 48 -9 14 -13 25 -9 25 5 0 1 8 -7 18 -23 27 -108 207
-108 229 0 11 -7 26 -15 33 -8 7 -15 20 -15 30 0 10 -7 23 -15 30 -8 7 -15 20
-15 30 0 10 -7 23 -15 30 -8 7 -15 20 -15 30 0 10 -7 20 -15 24 -8 3 -15 14
-15 25 0 11 -13 34 -30 51 -16 17 -30 37 -30 44 0 29 -100 196 -150 251 -15
17 -31 40 -35 53 -3 12 -11 22 -16 22 -5 0 -9 10 -9 22 0 12 -19 39 -45 65
-25 23 -45 49 -45 56 0 8 -27 42 -60 75 -33 34 -60 68 -60 75 0 7 -36 48 -80
92 -44 44 -80 86 -80 95 0 20 -240 260 -260 260 -9 0 -51 36 -95 80 -44 44
-85 80 -92 80 -6 0 -33 20 -60 45 -26 25 -53 45 -60 45 -7 0 -39 27 -71 60
-33 33 -66 60 -75 60 -9 0 -30 14 -47 30 -17 17 -37 30 -46 30 -18 0 -60 25
-99 61 -34 30 -129 83 -169 93 -14 3 -26 11 -26 16 0 6 -10 10 -23 10 -13 0
-33 13 -47 30 -14 16 -32 29 -41 30 -9 0 -22 7 -29 15 -7 8 -20 15 -30 15 -10
0 -23 7 -30 15 -7 8 -21 15 -31 15 -10 0 -20 4 -23 9 -8 12 -88 51 -106 51
-17 0 -157 68 -165 80 -3 5 -12 7 -20 4 -8 -3 -42 7 -77 24 -104 48 -122 53
-265 78 -18 4 -38 12 -44 20 -6 8 -26 14 -44 14 -18 0 -38 7 -45 15 -7 9 -29
15 -54 15 -23 0 -47 5 -54 12 -13 13 -86 27 -179 35 -36 3 -67 11 -74 19 -9
11 -39 14 -123 14 -83 0 -117 4 -132 15 -15 11 -54 14 -177 15 -131 0 -159 3
-163 15 -5 13 -38 15 -214 15 -176 0 -209 -2 -214 -15z m490 -345 c178 0 224
-3 240 -15 12 -9 44 -14 90 -15 51 0 75 -4 84 -15 8 -10 30 -15 62 -15 34 0
50 -4 54 -15 4 -10 21 -15 54 -15 30 0 52 -6 60 -15 8 -10 31 -15 70 -15 39 0
62 -5 70 -15 7 -8 27 -15 45 -15 20 0 35 -6 39 -15 4 -11 22 -15 69 -15 45 0
68 -5 77 -15 7 -8 21 -15 31 -15 10 0 21 -4 24 -10 3 -5 16 -10 28 -10 12 0
47 -13 77 -30 30 -16 65 -29 77 -30 12 0 43 -11 69 -25 26 -14 54 -25 64 -25
17 0 308 -144 324 -160 6 -6 17 -10 26 -10 9 0 30 -13 46 -30 16 -16 36 -30
45 -30 8 0 28 -13 44 -30 16 -16 36 -30 45 -30 9 0 29 -13 45 -30 16 -16 34
-30 40 -30 21 0 84 -37 115 -69 17 -17 37 -31 45 -31 7 0 34 -20 61 -45 26
-25 53 -45 61 -45 7 0 52 -38 99 -85 47 -47 91 -85 97 -85 15 0 367 -351 367
-366 0 -7 27 -40 60 -74 33 -34 58 -66 55 -70 -2 -4 16 -29 40 -55 25 -26 45
-53 45 -61 0 -7 15 -28 33 -46 18 -18 45 -58 59 -88 15 -30 43 -71 62 -89 20
-19 36 -42 36 -51 0 -9 14 -29 30 -45 20 -19 30 -39 30 -58 0 -17 10 -40 25
-55 27 -30 175 -317 175 -341 0 -8 25 -66 55 -128 30 -63 55 -122 55 -132 0
-9 5 -22 11 -28 6 -6 11 -32 11 -58 -1 -32 3 -48 13 -52 10 -3 15 -19 15 -44
0 -26 5 -42 15 -45 10 -4 15 -21 15 -54 0 -30 6 -52 15 -60 8 -7 15 -25 15
-39 0 -15 7 -36 15 -47 8 -11 14 -42 15 -75 0 -38 5 -61 15 -69 9 -8 15 -30
15 -60 0 -33 5 -50 15 -54 12 -4 15 -26 15 -108 1 -75 5 -108 15 -122 23 -30
22 -957 0 -976 -12 -10 -15 -36 -15 -117 0 -83 -3 -105 -15 -109 -11 -5 -15
-22 -15 -69 0 -43 -5 -66 -15 -75 -9 -7 -15 -30 -15 -54 0 -22 -7 -50 -15 -60
-8 -11 -15 -32 -15 -47 0 -14 -7 -32 -15 -39 -8 -7 -15 -27 -15 -45 0 -21 -6
-35 -16 -39 -13 -5 -16 -16 -12 -57 4 -42 2 -51 -14 -60 -15 -8 -17 -17 -12
-45 4 -23 1 -42 -10 -59 -9 -13 -16 -35 -16 -47 0 -13 -11 -43 -25 -67 -14
-23 -25 -49 -25 -56 0 -7 -7 -18 -15 -25 -8 -7 -15 -20 -15 -30 0 -10 -7 -23
-15 -30 -8 -7 -15 -27 -15 -45 0 -18 -7 -38 -15 -45 -8 -7 -15 -21 -15 -31 0
-10 -4 -20 -8 -23 -5 -3 -32 -52 -60 -110 -29 -57 -63 -115 -77 -128 -17 -15
-25 -34 -25 -58 -1 -26 -8 -41 -30 -60 -17 -13 -30 -32 -30 -43 0 -10 -13 -30
-30 -44 -16 -13 -30 -33 -30 -42 0 -10 -11 -28 -25 -41 -14 -13 -25 -29 -25
-36 0 -7 -18 -32 -40 -56 -22 -24 -40 -48 -40 -55 0 -6 -18 -30 -40 -53 -22
-23 -40 -49 -40 -57 0 -9 -27 -42 -60 -75 -33 -32 -60 -64 -60 -72 0 -17 -379
-396 -397 -396 -7 0 -46 -34 -85 -75 -40 -42 -80 -75 -90 -75 -11 0 -31 -14
-46 -31 -14 -18 -40 -38 -57 -45 -16 -7 -43 -26 -60 -42 -31 -29 -88 -62 -111
-62 -7 0 -24 -13 -37 -30 -14 -16 -34 -30 -45 -30 -10 0 -37 -20 -60 -45 -23
-26 -50 -45 -62 -45 -11 0 -23 -7 -26 -15 -4 -8 -17 -15 -29 -15 -13 0 -26 -4
-30 -10 -3 -5 -53 -33 -111 -61 -58 -29 -107 -56 -110 -61 -3 -4 -13 -8 -23
-8 -10 0 -24 -7 -31 -15 -7 -8 -24 -15 -39 -15 -26 0 -88 -27 -116 -50 -8 -6
-19 -9 -25 -5 -6 4 -38 -7 -70 -24 -32 -17 -67 -31 -79 -31 -11 0 -45 -13 -75
-29 -42 -23 -63 -29 -89 -24 -28 4 -37 1 -46 -14 -9 -17 -18 -19 -60 -15 -36
3 -58 0 -75 -12 -14 -9 -43 -16 -64 -16 -23 0 -45 -6 -52 -15 -8 -9 -30 -15
-60 -15 -33 0 -50 -5 -54 -15 -4 -11 -22 -15 -69 -15 -45 0 -68 -5 -77 -15 -8
-10 -31 -15 -69 -15 -33 -1 -64 -7 -75 -15 -16 -12 -59 -15 -217 -15 -162 0
-199 -3 -209 -15 -17 -21 -133 -21 -150 0 -10 12 -47 15 -209 15 -158 0 -201
3 -217 15 -11 8 -42 14 -75 15 -38 0 -61 5 -69 15 -9 10 -32 15 -77 15 -47 0
-65 4 -69 15 -4 10 -21 15 -54 15 -30 0 -52 6 -60 15 -7 9 -29 15 -52 15 -21
0 -50 7 -64 16 -17 12 -39 15 -75 12 -42 -4 -51 -2 -60 15 -9 15 -18 18 -46
14 -26 -5 -47 1 -89 24 -30 16 -64 29 -75 29 -12 0 -47 14 -79 31 -32 17 -64
28 -70 24 -6 -4 -17 -1 -25 5 -28 23 -90 50 -116 50 -15 0 -32 7 -39 15 -7 8
-21 15 -31 15 -10 0 -20 4 -23 8 -3 5 -52 32 -110 61 -58 28 -108 56 -111 61
-4 6 -17 10 -30 10 -12 0 -25 7 -29 15 -3 8 -15 15 -26 15 -12 0 -39 19 -62
45 -23 25 -50 45 -60 45 -11 0 -31 14 -45 30 -13 17 -30 30 -37 30 -23 0 -80
33 -111 62 -16 16 -44 35 -60 42 -17 7 -43 27 -57 45 -15 17 -35 31 -46 31
-10 0 -50 33 -90 75 -39 41 -78 75 -85 75 -18 0 -397 379 -397 396 0 8 -27 40
-60 72 -33 33 -60 66 -60 75 0 8 -18 34 -40 57 -22 23 -40 47 -40 53 0 7 -18
31 -40 55 -22 24 -40 49 -40 56 0 7 -11 23 -25 36 -14 13 -25 31 -25 41 0 9
-13 29 -30 42 -16 14 -30 34 -30 44 0 11 -13 30 -30 43 -22 19 -29 34 -30 60
0 23 -8 43 -24 57 -13 13 -48 70 -77 129 -29 58 -56 107 -61 110 -4 3 -8 13
-8 23 0 10 -7 24 -15 31 -8 7 -15 27 -15 45 0 18 -7 38 -15 45 -8 7 -15 20
-15 30 0 10 -7 23 -15 30 -8 7 -15 17 -15 22 0 15 -61 138 -72 144 -4 3 -8 21
-8 40 0 19 -4 34 -10 34 -5 0 -10 9 -10 19 0 11 -8 27 -17 37 -13 13 -17 31
-16 66 2 38 -2 50 -17 58 -15 8 -18 17 -13 45 4 23 0 43 -11 59 -10 16 -16 46
-16 79 0 36 -5 59 -15 67 -9 8 -15 30 -15 60 0 33 -5 50 -15 54 -11 4 -15 22
-15 69 0 45 -5 68 -15 77 -11 9 -15 34 -15 94 0 57 -5 88 -15 102 -22 29 -22
839 0 868 10 14 15 45 15 102 0 60 4 85 15 94 10 9 15 32 15 77 0 47 4 65 15
69 11 5 15 22 15 69 0 43 5 66 15 75 8 7 15 24 15 39 0 14 7 35 15 45 9 12 15
42 15 77 0 41 4 58 15 63 11 4 15 21 15 60 0 39 4 55 15 60 8 3 15 14 15 25 0
11 4 23 10 26 5 3 10 16 10 28 0 12 14 49 30 81 17 32 30 69 30 80 0 12 5 27
10 32 6 6 12 25 15 44 2 18 9 38 14 43 6 6 11 20 11 32 0 28 144 313 175 347
15 15 25 38 25 55 0 19 10 39 30 58 16 16 30 36 30 45 0 9 16 32 36 51 19 18
47 59 62 89 14 30 41 70 59 88 18 18 33 39 33 47 0 7 18 32 40 55 22 23 40 48
40 55 0 7 27 41 60 75 33 34 60 67 60 74 0 15 352 366 367 366 6 0 50 38 97
85 47 47 92 85 99 85 8 0 35 20 61 45 27 25 54 45 61 45 8 0 28 14 45 31 31
32 94 69 115 69 6 0 24 14 40 30 16 17 36 30 45 30 9 0 29 14 45 30 16 17 36
30 44 30 9 0 29 14 45 30 16 17 37 30 46 30 9 0 20 4 26 10 16 16 307 160 324
160 10 0 38 11 64 25 26 14 57 25 69 25 12 1 47 14 77 30 30 17 65 30 77 30
12 0 25 5 28 10 3 6 14 10 24 10 10 0 24 7 31 15 9 10 32 15 77 15 47 0 65 4
69 15 4 9 19 15 39 15 18 0 38 7 45 15 8 10 31 15 70 15 39 0 62 5 70 15 8 9
30 15 60 15 33 0 50 5 54 15 4 11 20 15 54 15 32 0 54 5 62 15 9 11 33 15 84
15 46 1 78 6 90 15 16 12 62 15 241 15 169 0 226 3 239 13 16 11 25 11 55 1
25 -9 103 -13 257 -14z"/>
<path d="M4335 6070 c-21 -22 -46 -40 -54 -40 -21 0 -1781 -1760 -1781 -1781
0 -8 -11 -26 -25 -39 -18 -17 -25 -34 -25 -63 0 -21 -8 -52 -17 -68 -16 -27
-16 -31 0 -58 9 -16 17 -44 17 -63 0 -26 9 -43 40 -73 22 -21 40 -46 40 -55 0
-23 25 -44 104 -85 57 -29 78 -35 132 -35 48 0 66 4 70 15 4 8 17 15 30 15 14
0 27 7 30 15 4 8 14 15 24 15 9 0 357 339 787 770 424 424 776 770 783 770 6
0 352 -340 768 -755 415 -415 761 -755 767 -755 6 0 25 -13 41 -30 20 -20 39
-30 60 -30 17 0 37 -7 44 -15 23 -28 101 -19 177 21 88 45 136 93 179 177 46
92 47 162 3 256 -29 61 -100 134 -948 984 -504 504 -923 917 -932 917 -9 0
-22 7 -29 15 -10 12 -38 15 -129 15 l-117 0 -39 -40z"/>
</g>
</svg>
 ),

  topArrow2: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="74.000000pt" height="74.000000pt" viewBox="0 0 74.000000 74.000000"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,74.000000) scale(0.100000,-0.100000)">
<path d="M294 720 c-193 -41 -323 -250 -269 -436 54 -188 222 -297 408 -264
151 28 258 135 287 288 48 243 -181 464 -426 412z m162 -35 c161 -48 264 -203
237 -360 -21 -120 -76 -196 -181 -247 -58 -29 -77 -33 -142 -33 -128 1 -229
62 -288 174 -135 252 102 547 374 466z"/>
<path d="M276 520 c-66 -67 -76 -83 -66 -95 19 -23 30 -19 77 27 l43 42 0
-173 c0 -178 6 -211 40 -211 34 0 40 33 40 211 l0 173 43 -42 c47 -46 58 -50
77 -27 10 12 0 28 -66 95 -42 44 -85 80 -94 80 -9 0 -52 -36 -94 -80z"/>
</g>
</svg>
 ),

  bottomArrow0: (
 <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="876.000000pt" viewBox="0 0 900.000000 876.000000"
 preserveAspectRatio="xMidYMid meet"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait  
 >
<g transform="translate(0.000000,876.000000) scale(0.100000,-0.100000)">
<path d="M4267 8473 c-19 -8 -79 -13 -167 -13 -107 0 -140 -3 -149 -14 -9 -11
-33 -14 -99 -12 -53 2 -103 -2 -127 -10 -22 -8 -59 -14 -82 -14 -23 0 -45 -4
-48 -10 -3 -5 -23 -10 -43 -10 -20 0 -50 -7 -66 -15 -15 -8 -36 -15 -46 -15
-10 0 -23 -7 -30 -15 -7 -8 -27 -15 -45 -15 -18 0 -38 -7 -45 -15 -7 -9 -30
-15 -54 -15 -22 0 -50 -7 -60 -15 -11 -8 -34 -15 -50 -15 -17 0 -53 -11 -81
-24 -27 -14 -53 -22 -57 -20 -3 2 -28 -7 -54 -21 -26 -14 -55 -25 -64 -25 -10
0 -34 -13 -55 -30 -21 -16 -49 -30 -62 -30 -13 0 -31 -7 -39 -15 -9 -8 -28
-15 -43 -15 -16 0 -34 -7 -41 -15 -7 -8 -19 -15 -26 -15 -16 0 -89 -44 -99
-60 -3 -5 -12 -10 -19 -10 -7 0 -46 -18 -86 -40 -40 -22 -78 -40 -85 -40 -6 0
-24 -13 -38 -30 -15 -16 -36 -30 -46 -30 -11 0 -21 -4 -23 -9 -4 -13 -107 -81
-122 -81 -7 0 -23 -13 -36 -30 -14 -16 -32 -29 -40 -30 -9 0 -38 -22 -65 -50
-27 -27 -56 -50 -65 -50 -9 0 -40 -25 -70 -56 -30 -31 -68 -65 -85 -75 -39
-25 -425 -409 -425 -423 0 -7 -29 -41 -65 -76 -36 -35 -65 -70 -65 -77 0 -7
-22 -36 -50 -65 -27 -29 -50 -58 -50 -64 0 -6 -13 -24 -30 -40 -16 -16 -30
-36 -30 -45 0 -8 -13 -28 -30 -44 -16 -16 -30 -37 -30 -46 0 -10 -6 -22 -13
-26 -16 -10 -57 -80 -57 -97 0 -7 -9 -21 -21 -31 -11 -11 -38 -56 -61 -102
-22 -46 -44 -86 -49 -89 -5 -3 -9 -12 -9 -20 0 -9 -16 -39 -35 -68 -19 -29
-35 -62 -35 -74 0 -11 -4 -23 -9 -26 -4 -3 -11 -21 -14 -40 -3 -18 -17 -52
-31 -75 -14 -22 -26 -47 -26 -55 0 -7 -7 -19 -15 -26 -8 -7 -15 -20 -15 -30 0
-10 -7 -20 -15 -24 -9 -3 -15 -18 -15 -36 0 -17 -4 -38 -9 -48 -14 -28 -31
-87 -31 -108 0 -20 -26 -106 -41 -136 -5 -10 -9 -30 -9 -45 0 -16 -7 -41 -15
-57 -8 -15 -15 -38 -15 -51 0 -12 -7 -28 -15 -35 -10 -8 -15 -31 -15 -70 0
-39 -5 -62 -15 -70 -10 -8 -15 -30 -15 -64 0 -29 -5 -57 -12 -64 -6 -6 -12
-40 -13 -74 -1 -35 -7 -73 -14 -85 -9 -18 -9 -27 1 -43 10 -15 10 -22 0 -32
-9 -9 -12 -124 -12 -479 0 -401 2 -471 15 -495 12 -22 14 -45 9 -97 -5 -53 -3
-73 10 -92 10 -15 16 -46 16 -78 0 -36 5 -59 15 -67 9 -7 15 -29 15 -55 0 -26
6 -48 15 -55 8 -7 15 -25 15 -40 0 -15 7 -33 15 -40 9 -8 14 -27 13 -51 -1
-22 4 -45 10 -51 7 -7 12 -24 12 -39 0 -15 7 -32 16 -40 9 -8 14 -22 11 -38
-4 -21 7 -68 34 -136 4 -11 10 -33 14 -48 3 -16 17 -46 30 -68 14 -21 25 -45
25 -53 0 -7 7 -19 15 -26 8 -7 15 -20 15 -30 0 -10 7 -20 15 -24 9 -3 15 -18
15 -40 0 -19 5 -38 10 -41 6 -3 10 -17 10 -30 0 -13 11 -37 25 -53 14 -17 25
-35 25 -41 0 -6 10 -28 23 -49 13 -20 34 -58 46 -84 13 -27 27 -50 32 -54 5
-3 9 -12 9 -20 0 -8 13 -32 29 -52 17 -20 33 -49 36 -63 4 -14 20 -41 36 -58
16 -18 29 -38 29 -45 0 -7 11 -23 25 -36 14 -13 25 -29 25 -36 0 -7 18 -29 40
-50 22 -21 40 -46 40 -55 0 -9 7 -22 16 -30 8 -7 24 -29 34 -48 10 -20 50 -67
89 -104 39 -38 73 -77 76 -87 7 -21 397 -412 420 -420 8 -3 48 -38 89 -78 41
-39 80 -72 88 -72 8 0 32 -18 53 -40 21 -22 45 -40 51 -40 7 0 26 -11 42 -25
17 -14 34 -25 39 -25 5 0 20 -11 33 -25 13 -14 28 -25 35 -25 6 0 26 -13 45
-30 19 -16 42 -29 51 -30 9 0 19 -6 22 -14 3 -7 57 -39 121 -71 63 -31 120
-63 126 -70 14 -17 152 -85 172 -85 8 0 45 -16 81 -35 36 -19 74 -35 85 -35
10 0 40 -11 66 -25 26 -14 55 -25 64 -25 9 0 26 -7 36 -15 11 -8 27 -15 37
-15 9 0 19 -7 23 -15 4 -10 19 -15 48 -15 24 0 54 -7 66 -16 13 -9 26 -14 29
-10 3 3 18 -1 34 -9 15 -8 42 -15 59 -15 17 0 44 -7 59 -15 16 -8 31 -12 34
-9 3 4 16 -1 29 -10 12 -9 41 -16 63 -16 23 0 46 -5 53 -12 6 -6 33 -11 60 -9
34 1 53 -3 62 -14 10 -12 35 -15 120 -15 83 0 110 -3 120 -15 10 -12 41 -15
159 -15 112 -1 150 -4 165 -15 29 -22 353 -22 382 0 15 11 52 14 162 15 114 0
147 3 158 15 12 11 40 15 120 15 81 0 109 4 121 15 9 10 31 15 62 14 26 -1 56
3 68 9 12 7 37 12 56 12 19 0 40 7 47 15 7 9 25 15 39 13 27 -2 102 16 135 34
10 5 32 12 49 14 17 2 35 8 41 14 5 5 27 10 47 10 20 0 42 7 49 15 7 8 27 15
46 15 18 0 36 5 39 10 7 11 73 43 91 45 12 0 26 6 112 49 30 14 64 26 77 26
13 0 27 5 30 10 3 6 15 10 26 10 11 0 22 7 25 15 4 8 14 15 24 15 11 0 22 4
25 10 3 5 28 19 55 31 26 11 58 32 71 45 12 13 28 24 34 24 6 0 42 16 81 35
38 19 74 35 79 35 6 0 31 20 55 45 24 25 52 45 61 45 9 0 22 7 29 15 7 8 18
15 25 15 6 0 20 9 30 20 10 11 25 20 34 20 9 0 41 25 71 55 30 30 59 55 65 55
6 0 29 18 50 40 21 22 46 40 54 40 8 0 52 36 97 80 45 44 87 80 94 80 17 0
230 212 230 229 0 8 36 52 80 97 44 45 80 88 80 96 0 9 23 36 50 62 28 26 50
51 50 56 0 6 16 27 35 49 19 21 44 59 55 83 11 25 38 64 60 86 22 22 40 46 40
53 0 7 9 22 19 33 22 24 81 134 81 152 0 6 9 19 21 29 11 11 38 55 60 100 22
44 44 87 48 95 13 23 27 60 42 108 7 23 18 47 26 53 7 6 13 17 13 24 0 13 56
124 71 140 5 5 9 23 9 41 0 19 6 34 15 38 10 4 15 19 15 48 0 24 7 54 16 66 9
13 13 26 10 29 -3 3 1 19 9 34 8 16 22 42 30 57 8 16 12 37 9 48 -3 11 2 33
10 49 9 17 16 39 16 50 0 11 7 28 14 38 7 9 11 28 8 42 -2 14 3 36 12 50 11
17 16 47 16 98 0 49 5 80 15 93 10 13 14 45 15 100 0 60 4 85 15 94 11 9 15
35 15 104 0 57 4 96 12 104 18 18 20 582 2 618 -9 17 -14 61 -14 123 0 70 -4
103 -15 117 -9 12 -14 43 -15 85 0 47 -4 70 -15 79 -11 9 -15 34 -15 95 0 65
-3 84 -15 89 -12 4 -15 19 -14 61 1 31 -3 61 -9 67 -7 7 -12 24 -12 39 0 15
-7 32 -16 40 -10 8 -14 22 -10 40 3 18 -3 44 -19 76 -14 26 -25 55 -25 63 0 8
-7 28 -15 44 -8 15 -15 42 -15 60 0 17 -7 40 -15 50 -8 11 -15 32 -15 47 0 14
-7 32 -15 39 -8 7 -15 19 -15 28 0 8 -6 23 -13 31 -15 18 -67 133 -67 149 0
13 -45 109 -80 170 -6 9 -13 24 -16 32 -3 8 -10 22 -15 30 -5 8 -13 25 -18 37
-6 11 -15 24 -21 28 -6 4 -29 44 -50 89 -21 45 -48 90 -59 100 -12 11 -21 25
-21 31 0 7 -20 35 -45 63 -25 27 -45 55 -45 61 0 19 -45 84 -84 120 -20 19
-36 41 -36 49 0 8 -20 35 -45 60 -25 25 -45 50 -45 56 0 7 -34 45 -75 86 -41
41 -75 81 -75 90 0 20 -191 210 -210 210 -9 0 -58 43 -110 95 -52 52 -101 95
-108 95 -7 0 -25 13 -40 29 -15 16 -40 36 -57 44 -16 8 -50 36 -75 61 -24 25
-52 46 -61 46 -9 0 -22 7 -30 16 -16 19 -113 84 -126 84 -5 0 -18 9 -28 19 -9
11 -55 39 -101 62 -46 22 -87 45 -90 50 -3 5 -12 9 -20 9 -8 0 -46 20 -84 45
-38 25 -76 45 -84 45 -8 0 -21 6 -28 13 -22 20 -78 47 -97 47 -10 0 -38 11
-62 25 -24 14 -51 27 -59 31 -8 3 -23 10 -32 15 -10 5 -25 9 -33 9 -9 0 -38
11 -65 25 -27 14 -60 25 -72 25 -13 0 -31 7 -42 15 -11 8 -30 12 -45 9 -18 -4
-32 0 -40 10 -8 9 -28 16 -46 16 -18 0 -38 7 -45 15 -7 8 -24 15 -39 15 -14 0
-35 7 -45 15 -11 8 -36 15 -57 15 -20 0 -42 6 -48 14 -7 9 -29 14 -53 14 -22
0 -45 5 -51 11 -6 6 -34 11 -62 11 -27 0 -58 7 -68 14 -12 10 -41 12 -98 9
-62 -3 -87 0 -105 12 -19 12 -57 15 -187 15 -90 0 -167 4 -173 10 -15 15 -341
17 -377 3z m283 -308 c10 -12 45 -15 197 -15 151 0 187 -3 199 -15 10 -10 35
-15 73 -15 40 0 63 -5 71 -15 8 -10 30 -15 65 -15 32 0 57 -5 64 -14 6 -7 22
-11 35 -9 13 3 39 -2 57 -10 33 -15 54 -19 169 -35 30 -4 65 -13 77 -20 12 -7
35 -12 51 -12 16 0 50 -11 76 -25 26 -14 56 -25 67 -25 11 0 27 -7 35 -15 9
-8 24 -15 34 -15 10 0 20 -7 24 -15 3 -9 18 -15 35 -15 16 0 49 -11 72 -25 24
-14 51 -25 60 -25 10 0 44 -14 78 -30 33 -17 71 -35 83 -40 13 -6 30 -14 38
-19 8 -5 22 -12 30 -15 8 -3 23 -10 33 -16 41 -24 54 -31 98 -50 26 -12 61
-37 80 -56 18 -19 40 -34 49 -34 9 0 25 -9 36 -21 10 -11 41 -31 69 -44 28
-14 66 -40 85 -60 18 -19 40 -35 46 -35 7 0 28 -16 47 -35 19 -19 40 -35 48
-35 8 0 41 -27 74 -61 33 -33 76 -69 95 -79 43 -23 370 -351 370 -371 0 -8 20
-35 45 -59 25 -24 45 -50 45 -56 0 -7 20 -34 45 -61 25 -26 45 -53 45 -59 0
-5 16 -25 35 -44 19 -19 35 -40 35 -47 0 -7 14 -28 30 -46 17 -19 30 -39 30
-44 0 -6 9 -18 20 -28 11 -10 22 -27 26 -39 4 -11 20 -36 35 -54 16 -18 29
-42 29 -53 0 -11 11 -35 24 -52 20 -27 43 -72 70 -137 3 -8 24 -46 45 -85 22
-38 40 -82 40 -96 1 -15 8 -29 16 -33 8 -3 15 -16 15 -30 0 -14 4 -27 9 -31
15 -9 61 -115 61 -140 0 -12 7 -28 15 -35 9 -8 15 -26 13 -46 -1 -19 3 -39 10
-46 7 -7 12 -34 12 -60 0 -34 5 -50 15 -54 8 -4 15 -18 15 -33 0 -15 7 -36 15
-47 8 -10 15 -31 15 -45 0 -15 7 -32 15 -39 9 -8 15 -29 15 -56 0 -23 5 -46
10 -49 6 -3 10 -30 10 -59 0 -36 5 -58 16 -67 12 -10 15 -31 13 -106 -2 -62 1
-97 9 -105 16 -16 17 -874 1 -915 -6 -15 -10 -60 -10 -98 1 -44 -4 -84 -14
-107 -8 -21 -15 -51 -15 -67 0 -16 -4 -33 -10 -36 -5 -3 -10 -30 -10 -59 0
-30 -6 -60 -15 -72 -8 -10 -15 -31 -15 -45 0 -15 -7 -32 -15 -39 -9 -7 -15
-30 -15 -54 0 -22 -7 -50 -15 -60 -8 -11 -15 -28 -15 -38 0 -10 -4 -26 -9 -36
-6 -9 -13 -38 -16 -64 -3 -26 -10 -50 -16 -53 -5 -4 -9 -15 -9 -26 0 -18 -8
-37 -32 -79 -4 -8 -11 -22 -14 -30 -3 -8 -17 -36 -30 -61 -13 -26 -24 -56 -24
-67 0 -11 -7 -25 -15 -32 -8 -7 -15 -20 -15 -30 0 -10 -7 -23 -15 -30 -8 -7
-15 -18 -15 -24 0 -7 -16 -41 -35 -76 -19 -36 -35 -72 -35 -81 0 -8 -11 -26
-25 -39 -14 -13 -25 -34 -25 -46 0 -13 -13 -39 -30 -57 -16 -19 -30 -40 -30
-45 0 -6 -16 -27 -35 -47 -20 -19 -44 -55 -55 -79 -10 -25 -35 -62 -54 -84
-20 -22 -36 -45 -36 -52 0 -7 -18 -30 -40 -51 -22 -21 -40 -43 -40 -49 0 -5
-25 -37 -55 -70 -30 -33 -55 -66 -55 -73 0 -16 -312 -327 -329 -327 -7 0 -52
-38 -101 -85 -49 -47 -95 -85 -103 -85 -7 0 -28 -16 -46 -35 -17 -19 -37 -35
-44 -35 -6 0 -32 -18 -56 -40 -25 -22 -69 -51 -98 -65 -29 -13 -53 -29 -53
-34 0 -6 -8 -11 -18 -11 -10 0 -29 -12 -43 -26 -13 -14 -37 -32 -54 -40 -16
-8 -48 -27 -70 -44 -22 -16 -47 -29 -56 -30 -9 0 -22 -7 -29 -15 -7 -8 -18
-15 -24 -15 -6 0 -42 -16 -80 -35 -39 -19 -76 -35 -83 -35 -8 0 -16 -7 -19
-15 -4 -9 -19 -15 -39 -15 -19 0 -37 -5 -40 -10 -9 -14 -90 -50 -113 -50 -11
0 -25 -7 -32 -15 -7 -8 -21 -15 -31 -15 -10 0 -21 -4 -24 -10 -3 -5 -15 -10
-27 -10 -11 0 -43 -11 -71 -25 -30 -16 -64 -25 -86 -24 -20 2 -46 -3 -58 -9
-12 -7 -33 -12 -46 -12 -14 0 -30 -7 -37 -15 -8 -10 -31 -15 -64 -15 -29 0
-59 -7 -70 -15 -11 -8 -39 -15 -62 -15 -27 0 -44 -5 -47 -14 -3 -8 -26 -16
-54 -20 -26 -3 -83 -9 -126 -14 -43 -5 -83 -14 -89 -20 -8 -8 -74 -12 -215
-12 -133 0 -211 -4 -228 -12 -19 -9 -28 -9 -37 0 -8 8 -75 12 -223 12 -169 1
-214 4 -229 15 -13 10 -43 15 -82 15 -35 0 -66 5 -69 10 -3 6 -30 10 -59 10
-30 0 -60 6 -72 15 -10 8 -36 15 -57 15 -21 0 -45 7 -53 15 -9 9 -34 15 -58
15 -27 0 -48 6 -56 15 -7 9 -29 15 -51 15 -21 0 -41 5 -44 10 -3 6 -27 10 -53
10 -29 0 -68 10 -100 25 -30 14 -64 25 -77 25 -12 0 -28 7 -35 15 -7 8 -19 15
-26 15 -8 0 -32 11 -54 25 -22 14 -50 25 -64 25 -13 0 -29 7 -36 15 -7 8 -20
15 -30 15 -10 0 -23 7 -30 15 -7 8 -23 15 -37 15 -25 0 -97 33 -107 49 -3 5
-53 32 -111 61 -58 29 -108 56 -111 61 -3 5 -12 9 -21 9 -8 0 -31 13 -50 30
-18 16 -40 30 -47 30 -8 0 -19 7 -26 15 -7 9 -36 27 -64 40 -28 13 -67 41 -86
61 -19 20 -57 51 -85 70 -97 66 -121 86 -190 154 -39 39 -76 70 -83 70 -18 0
-93 71 -103 97 -5 13 -19 27 -32 32 -25 10 -107 95 -107 112 0 6 -35 48 -77
94 -111 121 -153 171 -153 183 0 6 -13 27 -30 45 -16 19 -30 41 -30 49 0 8
-16 29 -35 48 -19 19 -35 39 -35 45 0 7 -13 25 -30 41 -16 16 -30 36 -30 45 0
9 -9 24 -20 34 -17 16 -48 73 -84 155 -3 8 -22 44 -41 80 -19 36 -35 70 -35
75 -1 6 -14 21 -30 35 -18 15 -30 34 -30 49 0 13 -11 48 -25 78 -14 29 -24 57
-21 62 3 4 -1 17 -9 27 -8 10 -15 28 -15 39 0 11 -11 40 -25 64 -14 23 -25 56
-25 72 0 17 -6 32 -15 35 -8 4 -15 16 -15 29 0 12 -7 28 -15 35 -8 7 -15 27
-15 45 0 18 -7 46 -15 61 -8 16 -15 48 -15 72 0 23 -4 50 -9 60 -19 37 -40
118 -39 147 0 17 -4 40 -11 52 -6 12 -11 44 -11 71 0 33 -5 54 -16 63 -12 10
-15 30 -13 93 2 55 0 81 -9 84 -17 5 -17 803 -1 819 7 7 11 41 10 82 -1 47 4
81 14 101 8 16 15 47 15 70 0 23 7 54 14 69 8 15 12 38 9 50 -3 11 1 28 8 37
12 15 20 57 35 186 3 26 12 52 20 59 8 6 14 27 14 46 0 19 13 57 30 88 17 30
30 63 30 75 0 12 7 28 15 36 8 9 15 24 15 34 0 10 5 22 10 25 6 3 10 17 10 30
0 13 5 27 10 30 6 3 10 21 10 40 0 19 4 36 9 39 4 3 25 38 45 78 20 40 40 80
45 88 5 8 12 22 15 30 3 8 10 22 15 30 11 17 77 157 86 180 3 8 13 27 23 41 9
14 34 51 54 81 20 31 41 59 47 62 6 4 11 16 11 27 0 10 4 19 10 19 5 0 12 11
16 24 3 13 25 43 50 67 24 24 44 49 44 57 0 8 21 35 46 61 26 25 57 62 69 81
13 19 46 59 74 89 28 29 51 58 51 65 0 17 221 233 246 240 11 4 53 40 93 81
40 41 80 75 89 75 9 0 23 9 30 20 7 11 36 36 65 54 28 19 68 50 86 70 19 20
42 36 52 36 9 0 22 7 29 15 7 8 17 15 22 15 5 0 22 9 36 21 54 41 99 68 200
119 56 29 112 63 125 76 12 13 27 24 33 24 5 0 41 16 80 35 38 19 77 35 87 35
11 0 31 6 45 14 15 8 46 20 70 27 23 7 47 18 53 26 6 7 19 13 29 13 10 0 23 7
30 15 7 8 23 15 37 15 13 0 44 11 69 25 28 16 61 25 87 25 23 0 55 7 71 15 15
8 43 15 62 15 18 0 36 5 39 10 3 6 24 10 46 10 22 0 51 7 64 16 14 9 36 14 50
12 14 -3 33 1 42 8 10 7 41 14 68 14 28 0 59 7 69 15 13 10 43 15 87 15 47 0
70 4 79 15 10 12 46 15 200 15 158 0 189 2 194 15 4 11 22 15 69 15 45 0 68
-5 77 -15z"/>
<path d="M2804 6065 c-10 -8 -31 -15 -45 -15 -15 0 -37 -12 -54 -30 -16 -16
-36 -30 -45 -30 -20 0 -89 -101 -97 -142 -3 -16 -10 -31 -14 -34 -12 -7 -11
-101 1 -109 6 -3 10 -18 10 -32 0 -14 13 -41 30 -60 17 -18 30 -39 30 -46 0
-7 371 -382 823 -834 923 -920 877 -880 1020 -884 42 -1 82 3 89 9 7 5 25 12
40 14 21 2 234 209 903 877 744 743 875 878 875 902 0 15 5 31 10 34 13 8 13
129 1 153 -6 9 -12 29 -15 43 -6 30 -109 139 -130 139 -7 0 -19 7 -26 15 -7 8
-24 15 -39 15 -14 0 -35 7 -45 15 -26 19 -80 19 -96 0 -7 -8 -25 -15 -39 -15
-16 0 -37 -10 -51 -25 -13 -14 -30 -25 -38 -25 -19 0 -278 -255 -298 -292 -8
-16 -20 -28 -27 -28 -18 0 -124 -111 -132 -138 -3 -12 -23 -31 -43 -41 -45
-23 -157 -137 -167 -168 -3 -13 -14 -23 -23 -23 -22 0 -132 -110 -132 -132 0
-9 -11 -19 -24 -22 -26 -6 -71 -54 -98 -105 -9 -17 -30 -36 -45 -43 -34 -14
-123 -97 -123 -115 0 -7 -12 -19 -28 -27 -36 -19 -132 -121 -132 -140 0 -9 -8
-16 -18 -16 -10 0 -44 -27 -77 -60 -33 -33 -64 -60 -70 -60 -5 0 -332 322
-725 715 -393 393 -723 715 -731 715 -9 0 -22 7 -29 15 -7 8 -20 15 -30 15
-10 0 -20 7 -24 15 -7 20 -95 20 -122 0z"/>
<path d="M2785 4440 c-3 -5 -17 -10 -31 -10 -14 0 -27 -7 -30 -15 -4 -8 -14
-15 -23 -15 -19 0 -61 -40 -61 -58 0 -6 -17 -27 -37 -47 -31 -30 -37 -43 -38
-82 -1 -26 -7 -49 -14 -51 -15 -5 -13 -43 4 -66 8 -11 12 -30 9 -45 -4 -20 1
-36 20 -58 14 -17 26 -35 26 -39 0 -13 1643 -1654 1656 -1654 6 0 19 -9 29
-20 55 -60 216 -82 301 -41 25 13 341 322 887 868 733 734 851 856 877 908 39
79 41 149 4 231 -26 58 -107 154 -130 154 -7 0 -32 11 -55 25 -52 29 -138 35
-159 10 -7 -9 -18 -14 -24 -12 -14 5 -66 -20 -66 -32 0 -5 -13 -13 -28 -19
-16 -5 -324 -305 -729 -711 -386 -385 -705 -701 -709 -701 -5 0 -330 321 -724
713 -393 393 -727 721 -742 730 -15 10 -34 17 -41 17 -8 0 -20 7 -27 15 -14
17 -135 22 -145 5z"/>
</g>
</svg>
  ),

  bottomArrow: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="900.000000pt" viewBox="0 0 900.000000 900.000000"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
<path d="M4336 8945 c-4 -13 -36 -15 -193 -15 -149 -1 -192 -4 -207 -15 -14
-11 -47 -15 -117 -15 -71 0 -100 -4 -108 -14 -7 -8 -38 -16 -74 -19 -93 -8
-166 -22 -179 -35 -7 -7 -31 -12 -54 -12 -25 0 -47 -6 -54 -15 -7 -8 -27 -15
-45 -15 -18 0 -38 -6 -44 -14 -6 -8 -26 -16 -44 -20 -145 -25 -166 -31 -264
-79 -34 -16 -68 -27 -77 -24 -8 3 -18 2 -21 -3 -8 -12 -148 -80 -165 -80 -18
0 -98 -39 -106 -51 -3 -5 -13 -9 -23 -9 -10 0 -24 -7 -31 -15 -7 -8 -20 -15
-29 -15 -10 0 -30 -13 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -19 -7 -23 -15
-3 -8 -17 -15 -31 -15 -14 0 -25 -4 -25 -10 0 -5 -12 -13 -26 -16 -37 -9 -122
-56 -200 -109 -36 -25 -69 -45 -74 -45 -5 0 -23 -13 -40 -30 -17 -16 -38 -30
-47 -30 -9 0 -42 -27 -75 -60 -32 -33 -64 -60 -71 -60 -7 0 -34 -20 -60 -45
-27 -25 -53 -45 -60 -45 -7 0 -55 -43 -107 -95 -52 -52 -102 -95 -110 -95 -20
0 -230 -211 -230 -230 0 -9 -36 -51 -80 -95 -44 -44 -80 -85 -80 -92 0 -6 -20
-33 -45 -60 -25 -26 -45 -53 -45 -60 0 -7 -27 -39 -60 -71 -37 -36 -60 -67
-60 -80 0 -12 -4 -22 -9 -22 -5 0 -13 -10 -16 -22 -4 -13 -20 -36 -35 -53 -50
-55 -150 -222 -150 -251 0 -7 -14 -27 -30 -44 -17 -17 -30 -40 -30 -51 0 -11
-7 -22 -15 -25 -8 -4 -15 -14 -15 -24 0 -10 -7 -23 -15 -30 -8 -7 -15 -20 -15
-30 0 -10 -7 -23 -15 -30 -8 -7 -15 -21 -15 -31 0 -10 -4 -20 -9 -23 -12 -8
-51 -89 -51 -107 0 -8 -25 -64 -55 -124 -30 -61 -55 -118 -55 -128 0 -17 -13
-46 -41 -97 -39 -69 -49 -94 -49 -124 0 -19 -4 -38 -10 -41 -5 -3 -10 -21 -10
-39 0 -19 -7 -39 -15 -46 -9 -7 -15 -29 -15 -54 0 -23 -7 -51 -15 -62 -8 -10
-15 -30 -15 -44 0 -14 -7 -34 -15 -44 -9 -12 -15 -42 -15 -72 0 -29 -5 -56
-10 -59 -6 -3 -10 -35 -10 -71 0 -48 -4 -66 -15 -70 -11 -5 -15 -23 -15 -78 0
-46 -5 -79 -14 -91 -22 -30 -23 -1111 -1 -1139 11 -15 15 -47 15 -122 0 -81 3
-103 15 -108 11 -4 15 -22 15 -70 0 -36 5 -68 10 -71 6 -3 10 -23 10 -44 0
-20 7 -46 15 -57 8 -10 15 -30 15 -44 0 -14 7 -34 15 -44 8 -11 15 -39 15 -62
0 -25 6 -47 15 -54 8 -7 15 -27 15 -44 0 -18 4 -36 9 -41 5 -6 11 -28 14 -50
4 -39 15 -75 44 -142 7 -17 13 -45 13 -62 0 -18 7 -43 16 -56 9 -14 13 -25 9
-25 -5 0 -1 -8 7 -17 23 -28 108 -208 108 -230 0 -11 7 -26 15 -33 8 -7 15
-20 15 -30 0 -10 7 -23 15 -30 8 -7 15 -20 15 -30 0 -10 7 -23 15 -30 8 -7 15
-20 15 -30 0 -10 7 -20 15 -24 8 -3 15 -14 15 -25 0 -11 14 -34 30 -51 17 -17
30 -37 30 -44 0 -29 100 -196 150 -251 15 -16 31 -40 35 -52 3 -13 11 -23 16
-23 5 0 9 -10 9 -22 0 -12 19 -39 45 -65 25 -23 45 -49 45 -56 0 -8 27 -42 60
-75 33 -34 60 -68 60 -75 0 -7 36 -48 80 -92 44 -44 80 -86 80 -95 0 -20 240
-260 260 -260 9 0 51 -36 95 -80 44 -44 85 -80 92 -80 6 0 33 -20 60 -45 26
-25 53 -45 60 -45 7 0 39 -27 71 -60 33 -33 66 -60 75 -60 9 0 30 -14 47 -30
17 -17 37 -30 46 -30 18 0 60 -25 99 -61 34 -30 129 -83 169 -93 14 -3 26 -11
26 -16 0 -6 10 -10 23 -10 13 0 33 -13 47 -30 14 -16 32 -29 41 -30 9 0 22 -7
29 -15 7 -8 20 -15 30 -15 10 0 23 -7 30 -15 7 -8 21 -15 31 -15 10 0 20 -4
23 -9 8 -12 88 -51 106 -51 17 0 157 -68 165 -80 3 -5 12 -7 20 -4 8 3 42 -7
77 -24 104 -48 122 -53 265 -78 18 -4 38 -12 44 -20 6 -8 26 -14 44 -14 18 0
38 -7 45 -15 7 -9 29 -15 54 -15 23 0 47 -5 54 -12 13 -13 86 -27 179 -35 36
-3 67 -11 74 -19 9 -11 39 -14 123 -14 83 0 117 -4 132 -15 15 -11 54 -14 177
-15 131 0 159 -3 163 -15 9 -22 419 -22 428 0 4 12 32 15 163 15 123 1 162 4
177 15 15 11 49 15 132 15 84 0 114 3 123 14 7 8 38 16 74 19 93 8 166 22 179
35 7 7 31 12 54 12 25 0 47 6 54 15 7 8 27 15 45 15 18 0 38 6 44 14 6 8 26
16 44 20 143 25 161 30 265 78 35 17 69 27 77 24 8 -3 17 -1 20 4 8 12 148 80
165 80 18 0 98 39 106 51 3 5 13 9 23 9 10 0 24 7 31 15 7 8 20 15 30 15 10 0
23 7 30 15 7 8 20 15 29 15 9 1 27 14 41 30 14 17 34 30 47 30 13 0 23 4 23
10 0 5 12 13 26 16 40 10 135 63 169 93 38 34 80 61 97 61 8 0 28 14 46 30 18
17 40 30 49 30 9 0 42 27 75 60 32 33 64 60 71 60 7 0 34 20 60 45 27 25 54
45 60 45 7 0 48 36 92 80 44 44 86 80 95 80 20 0 260 240 260 260 0 9 36 51
80 95 44 44 80 85 80 92 0 7 27 41 60 75 33 33 60 67 60 75 0 7 20 33 45 56
26 26 45 53 45 65 0 12 4 22 9 22 5 0 13 10 16 23 4 12 20 36 35 52 50 55 150
222 150 251 0 7 14 27 30 44 17 17 30 40 30 51 0 11 7 22 15 25 8 4 15 14 15
24 0 10 7 23 15 30 8 7 15 20 15 30 0 10 7 23 15 30 8 7 15 20 15 30 0 10 7
23 15 30 8 7 15 22 15 34 0 11 32 84 70 161 38 77 70 149 70 161 0 11 7 29 15
40 8 10 15 33 15 51 0 18 6 47 14 65 8 18 20 52 27 76 7 23 18 47 26 53 7 7
13 32 13 59 0 30 6 52 15 60 8 7 15 27 15 45 0 18 7 38 15 45 9 7 15 29 15 54
0 23 5 47 11 53 7 7 11 45 10 97 -1 70 1 87 14 92 12 5 15 24 15 93 0 61 4 93
15 107 10 13 14 47 15 115 0 73 4 100 15 109 23 19 23 671 0 690 -12 10 -15
37 -15 124 -1 82 -5 116 -15 130 -10 13 -15 44 -15 92 0 53 -4 73 -14 77 -11
4 -16 31 -20 99 -9 158 -17 216 -32 229 -8 6 -14 26 -14 44 0 18 -7 38 -15 45
-9 8 -15 30 -15 60 0 27 -6 52 -13 59 -8 6 -19 30 -26 53 -7 24 -19 58 -27 76
-8 18 -14 47 -14 65 0 18 -7 41 -15 51 -8 11 -15 29 -15 40 0 12 -25 70 -55
131 -30 60 -55 116 -55 124 0 18 -39 99 -51 107 -5 3 -9 13 -9 23 0 10 -7 24
-15 31 -8 7 -15 20 -15 30 0 10 -7 23 -15 30 -8 7 -15 20 -15 30 0 10 -7 20
-15 24 -8 3 -15 14 -15 25 0 11 -13 34 -30 51 -16 17 -30 37 -30 44 0 29 -100
196 -150 251 -15 17 -31 40 -35 53 -3 12 -11 22 -16 22 -5 0 -9 10 -9 22 0 13
-23 44 -60 80 -33 32 -60 64 -60 71 0 7 -20 34 -45 60 -25 27 -45 54 -45 60 0
7 -36 48 -80 92 -44 44 -80 86 -80 95 0 20 -210 230 -230 230 -9 0 -58 43
-110 95 -52 52 -100 95 -107 95 -7 0 -33 20 -60 45 -26 25 -53 45 -60 45 -7 0
-39 27 -71 60 -33 33 -66 60 -75 60 -9 0 -30 14 -47 30 -17 17 -35 30 -40 30
-5 0 -38 20 -74 45 -78 53 -163 100 -200 109 -14 3 -26 11 -26 16 0 6 -11 10
-25 10 -14 0 -28 7 -31 15 -4 8 -14 15 -23 15 -10 0 -30 14 -46 30 -16 17 -36
30 -46 30 -9 0 -22 7 -29 15 -7 8 -21 15 -31 15 -10 0 -20 4 -23 9 -8 12 -88
51 -106 51 -17 0 -157 68 -165 80 -3 5 -13 6 -21 3 -9 -3 -43 8 -77 24 -98 48
-119 54 -264 79 -18 4 -38 12 -44 20 -6 8 -26 14 -44 14 -18 0 -38 7 -45 15
-7 9 -29 15 -54 15 -23 0 -47 5 -54 12 -13 13 -86 27 -179 35 -36 3 -67 11
-74 19 -8 10 -37 14 -108 14 -70 0 -103 4 -117 15 -15 11 -58 14 -207 15 -157
0 -189 2 -193 15 -5 12 -33 15 -169 15 -136 0 -164 -3 -169 -15z m244 -330
c10 -12 47 -15 209 -15 158 0 201 -3 217 -15 11 -8 42 -14 75 -15 38 0 61 -5
69 -15 9 -10 32 -15 77 -15 47 0 65 -4 69 -15 4 -10 21 -15 54 -15 30 0 52 -6
60 -15 7 -9 29 -15 52 -15 21 0 50 -7 64 -16 17 -12 39 -15 75 -12 42 4 51 2
60 -15 9 -15 18 -18 46 -14 26 5 47 -1 89 -24 30 -16 64 -29 75 -29 12 0 47
-14 79 -31 32 -17 64 -28 70 -24 6 4 17 1 25 -5 28 -23 90 -50 116 -50 15 0
32 -7 39 -15 7 -8 21 -15 31 -15 10 0 20 -4 23 -8 3 -5 52 -32 110 -61 58 -28
108 -56 111 -61 4 -6 17 -10 30 -10 12 0 25 -7 29 -15 3 -8 15 -15 26 -15 12
0 39 -19 62 -45 23 -25 50 -45 60 -45 11 0 31 -13 45 -30 13 -16 30 -30 37
-30 23 0 80 -33 111 -62 17 -16 44 -35 60 -42 17 -7 43 -27 57 -45 15 -17 35
-31 46 -31 10 0 50 -33 90 -75 39 -41 78 -75 85 -75 18 0 397 -379 397 -396 0
-8 27 -40 60 -72 33 -33 60 -66 60 -75 0 -8 18 -34 40 -57 22 -23 40 -47 40
-53 0 -7 18 -31 40 -55 22 -24 40 -49 40 -56 0 -7 11 -23 25 -36 14 -13 25
-31 25 -41 0 -9 14 -29 30 -42 17 -14 30 -34 30 -44 0 -10 14 -29 30 -43 23
-19 30 -33 30 -60 0 -24 8 -42 25 -58 14 -13 48 -71 77 -128 28 -58 55 -107
60 -110 4 -3 8 -13 8 -23 0 -10 7 -24 15 -31 8 -7 15 -27 15 -45 0 -18 7 -38
15 -45 8 -7 15 -20 15 -30 0 -10 7 -23 15 -30 8 -7 15 -18 15 -25 0 -7 11 -33
25 -56 14 -24 25 -54 25 -67 0 -12 7 -34 16 -47 11 -17 14 -36 10 -59 -5 -28
-3 -37 12 -45 16 -9 18 -18 14 -60 -4 -41 -1 -52 12 -57 10 -4 16 -18 16 -39
0 -18 7 -38 15 -45 8 -7 15 -25 15 -39 0 -15 7 -36 15 -47 8 -10 15 -38 15
-60 0 -24 6 -47 15 -54 10 -9 15 -32 15 -75 0 -47 4 -64 15 -69 12 -4 15 -26
15 -109 0 -81 3 -107 15 -117 22 -19 23 -946 0 -976 -10 -14 -14 -47 -15 -122
0 -82 -3 -104 -15 -108 -10 -4 -15 -21 -15 -54 0 -30 -6 -52 -15 -60 -10 -8
-15 -31 -15 -69 -1 -33 -7 -64 -15 -75 -8 -11 -15 -32 -15 -47 0 -14 -7 -32
-15 -39 -9 -8 -15 -30 -15 -60 0 -33 -5 -50 -15 -54 -10 -3 -15 -19 -15 -45 0
-25 -5 -41 -15 -44 -10 -4 -14 -20 -13 -52 0 -26 -5 -52 -11 -58 -6 -6 -11
-19 -11 -28 0 -10 -25 -69 -55 -132 -30 -62 -55 -120 -55 -128 0 -24 -148
-311 -175 -341 -15 -15 -25 -38 -25 -55 0 -19 -10 -39 -30 -58 -16 -16 -30
-36 -30 -45 0 -9 -16 -32 -36 -51 -19 -18 -47 -59 -62 -89 -14 -30 -38 -67
-53 -81 -15 -14 -35 -41 -44 -60 -10 -19 -33 -49 -52 -67 -18 -18 -31 -37 -28
-42 3 -4 -22 -36 -55 -70 -33 -34 -60 -67 -60 -74 0 -15 -351 -366 -366 -366
-7 0 -51 -38 -98 -85 -47 -47 -92 -85 -99 -85 -8 0 -35 -20 -61 -45 -27 -25
-54 -45 -62 -45 -8 0 -26 -13 -40 -30 -25 -28 -98 -70 -120 -70 -6 0 -23 -14
-39 -30 -16 -17 -36 -30 -45 -30 -9 0 -29 -13 -45 -30 -16 -16 -36 -30 -44
-30 -9 0 -29 -14 -45 -30 -16 -17 -37 -30 -46 -30 -9 0 -20 -4 -26 -10 -16
-16 -307 -160 -324 -160 -10 0 -38 -11 -64 -25 -26 -14 -57 -25 -69 -25 -12
-1 -47 -14 -77 -30 -30 -17 -65 -30 -77 -30 -12 0 -25 -4 -28 -10 -3 -5 -14
-10 -24 -10 -10 0 -24 -7 -31 -15 -9 -10 -32 -15 -77 -15 -47 0 -65 -4 -69
-15 -4 -9 -19 -15 -39 -15 -18 0 -38 -7 -45 -15 -8 -10 -31 -15 -70 -15 -39 0
-62 -5 -70 -15 -8 -9 -30 -15 -60 -15 -33 0 -50 -5 -54 -15 -4 -11 -20 -15
-54 -15 -32 0 -54 -5 -62 -15 -9 -11 -33 -15 -84 -15 -46 -1 -78 -6 -90 -15
-16 -12 -62 -15 -240 -15 -154 -1 -232 -5 -257 -14 -30 -10 -39 -10 -55 1 -13
10 -70 13 -239 13 -179 0 -225 3 -241 15 -12 9 -44 14 -90 15 -51 0 -75 4 -84
15 -8 10 -30 15 -62 15 -34 0 -50 4 -54 15 -4 10 -21 15 -54 15 -30 0 -52 6
-60 15 -8 10 -31 15 -70 15 -39 0 -62 5 -70 15 -7 8 -27 15 -45 15 -20 0 -35
6 -39 15 -4 11 -22 15 -69 15 -45 0 -68 5 -77 15 -7 8 -21 15 -31 15 -10 0
-21 4 -24 10 -3 5 -16 10 -28 10 -12 0 -47 13 -77 30 -30 16 -65 29 -77 30
-12 0 -43 11 -69 25 -26 14 -54 25 -64 25 -17 0 -308 144 -324 160 -6 6 -17
10 -26 10 -9 0 -30 13 -46 30 -16 16 -36 30 -45 30 -8 0 -28 13 -44 30 -16 16
-36 30 -45 30 -9 0 -29 14 -45 30 -16 17 -33 30 -39 30 -22 0 -95 42 -120 70
-14 17 -32 30 -40 30 -8 0 -35 20 -62 45 -26 25 -53 45 -61 45 -7 0 -52 38
-99 85 -47 47 -91 85 -98 85 -15 0 -366 351 -366 366 0 7 -27 40 -60 74 -33
34 -58 66 -55 70 2 4 -16 29 -40 55 -25 26 -45 53 -45 61 0 7 -15 28 -33 46
-18 18 -45 58 -59 88 -15 30 -43 71 -62 89 -20 19 -36 42 -36 51 0 9 -13 29
-30 45 -20 19 -30 39 -30 58 0 17 -10 40 -25 55 -31 34 -175 319 -175 347 0
12 -5 26 -11 32 -5 5 -12 25 -14 43 -3 19 -9 38 -15 44 -5 5 -10 20 -10 32 0
11 -13 48 -30 80 -16 32 -30 69 -30 81 0 12 -5 25 -10 28 -6 3 -10 15 -10 26
0 11 -7 22 -15 25 -11 5 -15 21 -15 60 0 39 -4 56 -15 60 -11 5 -15 22 -15 63
0 35 -6 65 -15 77 -8 10 -15 31 -15 45 0 15 -7 32 -15 39 -10 9 -15 32 -15 75
0 47 -4 64 -15 69 -11 4 -15 22 -15 69 0 45 -5 68 -15 77 -11 9 -15 34 -15 94
0 57 -5 88 -15 102 -22 29 -22 839 0 868 10 14 15 45 15 102 0 60 4 85 15 94
10 9 15 32 15 77 0 47 4 65 15 69 10 4 15 21 15 54 0 30 6 52 15 60 10 8 15
31 15 67 0 33 6 63 16 79 11 16 15 36 11 59 -5 28 -2 37 13 45 15 8 19 20 17
58 -1 35 3 53 16 66 9 10 17 26 17 37 0 10 5 19 10 19 6 0 10 15 10 34 0 19 4
37 8 40 11 6 72 129 72 144 0 5 7 15 15 22 8 7 15 20 15 30 0 10 7 23 15 30 8
7 15 27 15 45 0 18 7 38 15 45 8 7 15 21 15 31 0 10 4 20 8 23 5 3 32 52 61
110 29 59 64 116 77 129 16 15 24 33 24 57 0 27 7 41 30 60 17 14 30 33 30 43
0 10 14 30 30 44 17 13 30 33 30 42 0 10 11 28 25 41 14 13 25 29 25 36 0 7
18 32 40 56 22 24 40 48 40 55 0 6 18 30 40 53 22 23 40 49 40 57 0 9 27 42
60 75 33 32 60 64 60 72 0 17 379 396 397 396 7 0 46 34 85 75 40 42 80 75 90
75 11 0 31 14 46 31 14 18 40 38 57 45 16 7 44 26 60 42 31 29 88 62 111 62 7
0 24 14 37 30 14 17 34 30 45 30 10 0 37 20 60 45 23 26 50 45 62 45 11 0 23
7 26 15 4 8 17 15 29 15 13 0 26 4 30 10 3 5 53 33 111 61 58 29 107 56 110
61 3 4 13 8 23 8 10 0 24 7 31 15 7 8 24 15 39 15 26 0 88 27 116 50 8 6 19 9
25 5 6 -4 38 7 70 24 32 17 67 31 79 31 11 0 45 13 75 29 42 23 63 29 89 24
28 -4 37 -1 46 14 9 17 18 19 60 15 36 -3 58 0 75 12 14 9 43 16 64 16 23 0
45 6 52 15 8 9 30 15 60 15 33 0 50 5 54 15 4 11 22 15 69 15 45 0 68 5 77 15
8 10 31 15 69 15 33 1 64 7 75 15 16 12 59 15 217 15 162 0 199 3 209 15 9 10
32 15 75 15 43 0 66 -5 75 -15z"/>
<path d="M2630 5234 c-75 -41 -100 -61 -100 -84 0 -9 -18 -34 -40 -55 -31 -30
-40 -47 -40 -73 0 -19 -8 -47 -17 -63 -16 -27 -16 -31 0 -58 9 -16 17 -47 17
-68 0 -29 7 -46 25 -63 14 -13 25 -31 25 -39 0 -21 1760 -1781 1781 -1781 8 0
33 -18 54 -40 l39 -40 117 0 c91 0 119 3 129 15 7 8 20 15 29 15 9 0 428 413
932 918 848 849 919 922 948 983 44 94 43 164 -3 256 -43 84 -91 132 -179 177
-76 40 -162 50 -173 21 -4 -9 -20 -15 -43 -15 -27 0 -44 -8 -65 -30 -16 -17
-35 -30 -41 -30 -6 0 -352 -340 -767 -755 -416 -415 -762 -755 -768 -755 -7 0
-359 347 -783 770 -431 431 -778 770 -787 770 -10 0 -20 7 -24 15 -3 8 -16 15
-30 15 -13 0 -26 7 -30 15 -4 11 -22 15 -73 14 -58 0 -78 -6 -133 -35z"/>
</g>
</svg>
),

  bottomArrow2: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="74.000000pt" height="74.000000pt" viewBox="0 0 74.000000 74.000000"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,74.000000) scale(0.100000,-0.100000)">
<path d="M299 720 c-168 -29 -303 -210 -285 -383 13 -126 96 -242 209 -293 52
-23 76 -28 147 -28 71 -1 94 4 142 26 228 106 286 389 118 572 -50 54 -119 91
-194 105 -66 12 -70 12 -137 1z m217 -60 c101 -49 157 -127 177 -245 42 -247
-229 -451 -458 -344 -201 94 -254 346 -109 518 14 17 47 43 72 58 105 62 211
66 318 13z"/>
<path d="M340 611 c-6 -12 -10 -92 -10 -192 l0 -173 -43 42 c-47 46 -58 50
-77 27 -10 -12 0 -28 66 -95 42 -44 85 -80 94 -80 9 0 52 36 94 80 66 67 76
83 66 95 -19 23 -30 19 -77 -27 l-43 -42 0 173 c0 178 -6 211 -40 211 -11 0
-24 -9 -30 -19z"/>
</g>
</svg>
 ),


  pen0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="765.000000pt" height="765.000000pt" viewBox="0 0 765.000000 765.000000"
 preserveAspectRatio="xMidYMid meet"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait  
 >
<g transform="translate(0.000000,765.000000) scale(0.100000,-0.100000)">
<path d="M6200 7505 c-7 -8 -20 -15 -29 -15 -9 0 -951 -935 -2094 -2078 -1877
-1877 -2077 -2080 -2077 -2108 0 -17 -7 -37 -15 -44 -9 -8 -15 -30 -15 -60 0
-30 -6 -52 -15 -60 -9 -8 -15 -30 -15 -60 0 -30 -6 -52 -15 -60 -8 -7 -15 -27
-15 -45 0 -18 -7 -38 -15 -45 -9 -8 -15 -30 -15 -60 0 -30 -6 -52 -15 -60 -9
-8 -15 -30 -15 -60 0 -30 -6 -52 -15 -60 -8 -7 -15 -27 -15 -45 0 -18 -7 -38
-15 -45 -9 -8 -15 -30 -15 -60 0 -30 -6 -52 -15 -60 -9 -8 -15 -30 -15 -60 0
-30 -6 -52 -15 -60 -9 -8 -15 -30 -15 -60 0 -30 -6 -52 -15 -60 -8 -7 -15 -27
-15 -45 0 -18 -7 -38 -15 -45 -9 -8 -15 -30 -15 -60 0 -30 -6 -52 -15 -60 -21
-18 -22 -222 -1 -240 8 -6 16 -21 18 -33 2 -14 11 -23 25 -25 12 -2 27 -10 33
-18 7 -8 20 -14 30 -14 10 0 23 -7 30 -15 17 -20 103 -20 120 0 8 9 30 15 60
15 30 0 52 6 60 15 7 8 27 15 45 15 18 0 38 7 45 15 8 9 30 15 60 15 30 0 52
6 60 15 8 9 30 15 60 15 30 0 52 6 60 15 8 9 30 15 60 15 30 0 52 6 60 15 8 9
30 15 60 15 30 0 52 6 60 15 7 8 27 15 45 15 18 0 38 7 45 15 8 9 30 15 60 15
30 0 52 6 60 15 8 9 30 15 60 15 30 0 52 6 60 15 7 8 27 15 45 15 18 0 38 7
45 15 8 9 30 15 60 15 30 0 52 6 60 15 7 8 27 15 45 15 18 0 38 7 45 15 7 8
20 15 29 15 21 0 4171 4150 4171 4171 0 9 7 22 15 29 10 9 15 32 15 75 0 43
-5 66 -15 75 -8 7 -15 20 -15 29 0 9 -233 249 -518 534 -462 462 -520 517
-548 517 -17 0 -37 7 -44 15 -8 9 -30 15 -60 15 -30 0 -52 -6 -60 -15z m413
-832 c185 -186 337 -338 337 -338 0 0 -880 -880 -1955 -1955 l-1955 -1955 -49
-3 c-28 -2 -55 -9 -61 -17 -7 -8 -27 -15 -45 -15 -18 0 -38 -7 -45 -15 -8 -9
-30 -15 -60 -15 -30 0 -52 -6 -60 -15 -8 -9 -30 -15 -60 -15 -30 0 -52 -6 -60
-15 -7 -8 -27 -15 -45 -15 -18 0 -38 -7 -45 -15 -8 -9 -30 -15 -60 -15 -30 0
-52 -6 -60 -15 -7 -8 -27 -15 -45 -15 -18 0 -38 -7 -45 -15 -8 -9 -30 -15 -60
-15 -31 0 -52 -5 -60 -15 -18 -22 -54 -15 -58 11 -2 11 4 27 13 34 8 7 15 27
15 45 0 18 7 38 15 45 9 8 15 30 15 60 0 30 6 52 15 60 9 8 15 30 15 60 0 30
6 52 15 60 8 7 15 27 15 45 0 18 7 38 15 45 9 8 15 30 15 60 0 30 6 52 15 60
9 8 15 30 15 60 0 30 6 52 15 60 8 7 15 27 15 45 0 18 7 38 15 45 9 8 15 30
15 59 l0 46 1953 1956 c1073 1076 1954 1956 1957 1957 3 1 157 -150 343 -335z"/>
<path d="M162 6447 l-52 -53 0 -3075 0 -3075 38 -37 c21 -20 45 -37 54 -37 8
0 21 -7 28 -15 11 -13 362 -15 3045 -15 2683 0 3034 2 3045 15 7 8 20 15 29
15 30 0 91 72 91 107 0 17 7 36 15 43 13 11 15 213 15 1710 0 1497 -2 1699
-15 1710 -8 7 -15 27 -15 44 0 44 -63 106 -107 106 -17 0 -36 7 -43 15 -7 8
-20 15 -30 15 -10 0 -23 -7 -30 -15 -7 -8 -27 -15 -44 -15 -24 0 -41 -10 -69
-38 -20 -21 -37 -45 -37 -54 0 -8 -7 -21 -15 -28 -13 -11 -15 -205 -17 -1609
l-3 -1596 -2770 0 -2770 0 0 2770 0 2770 1760 3 1759 2 53 52 53 52 0 91 0 91
-38 37 c-21 20 -45 37 -54 37 -8 0 -21 7 -28 15 -11 13 -235 15 -1904 15
l-1892 0 -52 -53z"/>
</g>
</svg>  
  
  ),
  
  
    pen: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="43.000000pt" height="46.000000pt" viewBox="0 0 43.000000 46.000000"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait  
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,46.000000) scale(0.100000,-0.100000)">
<path d="M166 290 l-127 -129 3 -63 3 -63 149 -2 c148 -2 176 1 176 18 0 5
-67 9 -150 9 -93 0 -150 4 -150 10 0 6 17 10 38 10 34 0 46 9 160 125 67 69
122 132 122 142 0 24 -50 73 -75 73 -14 0 -64 -43 -149 -130z m181 73 c8 -12
10 -24 5 -27 -12 -7 -52 27 -52 43 0 19 31 9 47 -16z m-44 -41 c15 -16 10 -24
-77 -116 -85 -90 -95 -97 -115 -87 -11 7 -21 20 -21 31 0 20 165 190 185 190
6 0 19 -8 28 -18z"/>
</g>
</svg>
),
  
  
  fullscreen: (
  
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="876.000000pt" viewBox="0 0 900.000000 876.000000"
 preserveAspectRatio="xMidYMid meet"
       fill="currentColor" // Dynamique pour la couleur
      stroke="currentColor" // Dynamique pour le trait 
	  >
<g transform="translate(0.000000,876.000000) scale(0.100000,-0.100000)">
<path d="M410 7035 c0 -1269 3 -1595 13 -1595 94 -3 441 1 448 5 5 4 9 520 9
1349 0 1129 2 1345 14 1355 10 8 361 11 1351 10 778 0 1341 3 1346 8 5 5 8
110 7 234 l-3 224 -1592 3 -1593 2 0 -1595z"/>
<path d="M5565 8620 c-10 -15 -6 -443 4 -453 5 -5 610 -8 1346 -7 992 0 1341
-2 1351 -11 12 -10 14 -224 14 -1355 0 -829 4 -1345 9 -1349 7 -4 354 -8 449
-5 9 0 12 326 12 1595 l0 1595 -1589 0 c-1074 0 -1592 -3 -1596 -10z"/>
<path d="M417 3473 c-4 -3 -7 -721 -7 -1595 l0 -1588 1593 2 1592 3 3 210 c1
116 0 220 -3 232 l-5 23 -1343 0 c-1031 0 -1346 3 -1355 12 -9 9 -12 324 -12
1354 0 1214 -2 1342 -16 1348 -21 8 -439 8 -447 -1z"/>
<path d="M8287 3474 c-4 -4 -7 -611 -7 -1349 0 -1114 -2 -1344 -13 -1354 -10
-8 -385 -12 -1358 -13 l-1344 -3 -5 -223 c-3 -122 -3 -227 -2 -232 3 -7 557
-10 1598 -10 l1594 0 -2 1593 -3 1592 -226 3 c-124 1 -228 -1 -232 -4z"/>
</g>
</svg>
  ),
  
  triangle: (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt"
    height="300.000000pt"
    viewBox="0 0 300.000000 300.000000"
    preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
    <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)">
      <path d="M1500 2850 L2900 300 100 300 Z" />
    </g>
  </svg>
),

  left: (
<svg 
   version="1.0" xmlns="http://www.w3.org/2000/svg"
   width="66.000000pt" 
   height="111.000000pt" 
   viewBox="0 0 66.000000 111.000000"
   preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
<path d="M267 822 c-213 -213 -247 -251 -247 -277 0 -26 34 -64 248 -278 215
-215 251 -247 278 -247 39 0 74 36 74 76 0 25 -31 60 -210 239 -115 115 -210
209 -210 210 0 1 94 95 210 210 183 183 210 213 210 240 0 40 -36 75 -76 75
-25 0 -65 -36 -277 -248z"/>
</g>
</svg>
  ),
  
  right: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="66.000000pt" height="111.000000pt" viewBox="0 0 66.000000 111.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
<path d="M42 1047 c-48 -51 -40 -65 188 -292 116 -115 210 -209 210 -210 0 -1
-94 -95 -210 -210 -183 -183 -210 -213 -210 -240 0 -40 36 -75 76 -75 25 0 65
36 277 248 213 213 247 251 247 277 0 26 -34 64 -248 278 -215 215 -251 247
-278 247 -19 0 -39 -9 -52 -23z"/>
</g>
</svg>
  ),
  
  cross0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="14.000000pt" height="14.000000pt" viewBox="0 0 14.000000 14.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,14.000000) scale(0.050000,-0.050000)">
<path d="M20 224 c0 -20 11 -47 24 -60 19 -19 19 -29 0 -48 -37 -37 -29 -96
12 -96 20 0 47 11 60 24 19 19 29 19 48 0 13 -13 40 -24 60 -24 41 0 49 59 12
96 -19 19 -19 29 0 48 37 37 29 96 -12 96 -20 0 -47 -11 -60 -24 -19 -19 -29
-19 -48 0 -37 37 -96 29 -96 -12z m83 -17 c35 -31 40 -31 77 3 52 47 77 22 30
-30 -35 -39 -35 -41 0 -80 47 -52 22 -77 -30 -30 -39 35 -41 35 -80 0 -52 -47
-77 -22 -30 30 34 37 34 42 3 77 -58 64 -34 88 30 30z"/>
</g>
</svg>

),

  cross: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="14.000000pt" height="14.000000pt" viewBox="0 0 14.000000 14.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
 <g>
    <path d="M2 2 L12 12 M12 2 L2 12" stroke="currentColor" stroke-width="2"/>
  </g>
</svg>

),

  download: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="363.000000pt" height="363.000000pt" viewBox="0 0 363.000000 363.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
>
<g transform="translate(0.000000,363.000000) scale(0.100000,-0.100000)">
<path d="M1752 3566 c-61 -17 -134 -82 -151 -137 -12 -36 -15 -195 -18 -874
-2 -456 -6 -836 -8 -844 -4 -10 -15 -4 -39 20 -201 203 -496 489 -514 498 -13
7 -54 13 -90 13 -85 0 -148 -33 -194 -100 -29 -42 -32 -52 -30 -120 1 -51 6
-80 17 -92 8 -9 15 -20 15 -25 0 -17 936 -946 973 -965 69 -37 166 -26 236 27
53 38 906 895 931 935 41 62 51 100 41 151 -14 74 -41 117 -97 154 -46 30 -60
35 -116 35 -47 0 -76 -6 -109 -22 -28 -14 -135 -113 -296 -272 -143 -143 -256
-247 -262 -244 -8 5 -11 254 -11 859 0 822 -1 854 -19 891 -24 45 -59 80 -111
106 -43 22 -82 23 -148 6z"/>
<path d="M148 1337 c-44 -24 -63 -43 -82 -79 -25 -47 -25 -50 -31 -400 -4
-194 -2 -425 2 -513 9 -148 12 -163 36 -202 15 -24 46 -55 70 -70 l42 -28
1625 0 1625 0 40 26 c45 30 77 64 99 108 14 26 16 97 16 523 0 473 -1 495 -20
533 -89 174 -295 181 -399 12 -23 -37 -23 -43 -29 -397 -3 -252 -8 -360 -16
-360 -6 0 -598 0 -1315 0 -890 0 -1308 3 -1317 11 -9 7 -13 95 -16 362 -3 352
-3 352 -27 392 -30 49 -68 85 -91 85 -10 0 -23 7 -30 15 -8 10 -31 15 -69 15
-45 0 -68 -7 -113 -33z"/>
</g>
</svg>
),

  upload: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="363.000000pt" height="363.000000pt" viewBox="0 0 363.000000 363.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
>
<g transform="translate(0.000000,363.000000) scale(0.100000,-0.100000)">
<path d="M1752 3566 c-61 -17 -134 -82 -151 -137 -12 -36 -15 -195 -18 -874
-2 -456 -6 -836 -8 -844 -4 -10 -15 -4 -39 20 -201 203 -496 489 -514 498 -13
7 -54 13 -90 13 -85 0 -148 -33 -194 -100 -29 -42 -32 -52 -30 -120 1 -51 6
-80 17 -92 8 -9 15 -20 15 -25 0 -17 936 -946 973 -965 69 -37 166 -26 236 27
53 38 906 895 931 935 41 62 51 100 41 151 -14 74 -41 117 -97 154 -46 30 -60
35 -116 35 -47 0 -76 -6 -109 -22 -28 -14 -135 -113 -296 -272 -143 -143 -256
-247 -262 -244 -8 5 -11 254 -11 859 0 822 -1 854 -19 891 -24 45 -59 80 -111
106 -43 22 -82 23 -148 6z"/>
<path d="M148 1337 c-44 -24 -63 -43 -82 -79 -25 -47 -25 -50 -31 -400 -4
-194 -2 -425 2 -513 9 -148 12 -163 36 -202 15 -24 46 -55 70 -70 l42 -28
1625 0 1625 0 40 26 c45 30 77 64 99 108 14 26 16 97 16 523 0 473 -1 495 -20
533 -89 174 -295 181 -399 12 -23 -37 -23 -43 -29 -397 -3 -252 -8 -360 -16
-360 -6 0 -598 0 -1315 0 -890 0 -1308 3 -1317 11 -9 7 -13 95 -16 362 -3 352
-3 352 -27 392 -30 49 -68 85 -91 85 -10 0 -23 7 -30 15 -8 10 -31 15 -69 15
-45 0 -68 -7 -113 -33z"/>
</g>
</svg>
),

  bold: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="1158.000000pt" viewBox="0 0 900.000000 1158.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,1158.000000) scale(0.100000,-0.100000)">
<path d="M134 11428 c-11 -17 -12 -11199 -1 -11221 8 -18 102 -18 2485 -14
2222 3 2489 6 2597 20 66 9 147 17 179 17 33 0 102 7 153 15 51 8 135 22 186
30 51 8 106 15 122 15 16 0 58 7 94 15 69 16 152 34 274 61 90 20 155 37 282
76 222 68 270 85 380 133 17 7 66 28 110 45 85 34 104 43 230 110 155 82 191
104 325 194 114 76 313 234 411 326 131 123 361 423 447 581 54 100 129 254
147 299 9 25 22 56 27 70 6 14 14 36 18 50 5 14 18 50 30 80 12 30 25 71 30
90 4 19 19 78 32 130 74 286 105 521 115 885 4 170 2 253 -10 365 -20 178 -44
320 -63 380 -8 25 -14 52 -14 61 0 26 -87 285 -120 355 -16 36 -30 68 -30 70
0 3 -13 31 -28 62 -216 435 -512 752 -897 962 -102 56 -103 56 -270 130 -87
38 -209 79 -356 117 -58 15 -106 33 -106 38 -1 11 0 12 192 105 145 71 238
126 358 214 86 62 254 205 297 253 169 187 282 350 383 554 140 282 213 534
262 903 15 106 17 178 12 410 -2 155 -9 304 -15 331 -5 28 -17 104 -26 170
-16 111 -25 154 -61 275 -7 25 -20 74 -30 110 -17 63 -92 257 -121 312 -8 14
-14 31 -14 37 0 6 -20 45 -45 87 -25 41 -45 77 -45 79 0 2 -14 24 -30 48 -17
25 -30 47 -30 51 0 13 -47 76 -181 241 -96 119 -276 287 -436 408 -78 59 -144
107 -147 107 -3 0 -24 12 -48 28 -73 46 -82 52 -103 61 -11 5 -37 21 -58 35
-35 24 -187 100 -337 169 -163 74 -459 180 -610 217 -19 5 -69 18 -110 30 -88
25 -167 43 -305 70 -55 11 -131 26 -170 34 -240 51 -748 102 -1170 116 -439
15 -4182 13 -4191 -2z m4046 -2008 c223 -11 412 -31 530 -56 224 -47 452 -133
579 -218 29 -20 55 -36 58 -36 3 0 37 -28 76 -62 243 -216 366 -516 384 -940
12 -271 -58 -547 -189 -749 -118 -183 -355 -365 -578 -443 -278 -99 -477 -137
-805 -156 -104 -5 -479 -10 -832 -10 -625 0 -643 1 -653 19 -14 27 -14 2615 0
2642 10 18 28 19 618 19 334 0 699 -4 812 -10z m720 -4415 c243 -18 327 -34
515 -98 226 -76 418 -217 537 -393 50 -73 115 -192 128 -234 5 -14 18 -50 29
-80 64 -168 92 -367 92 -649 0 -272 -18 -393 -85 -578 -42 -115 -137 -265
-230 -361 -104 -109 -324 -241 -486 -291 -41 -13 -93 -30 -115 -36 -43 -14
-145 -35 -295 -61 -83 -15 -229 -17 -1158 -21 -828 -4 -1066 -2 -1077 7 -13
11 -15 189 -15 1392 0 932 3 1386 10 1399 10 19 32 19 983 19 744 -1 1018 -4
1167 -15z"/>
</g>
</svg>
),

  italic: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="531.000000pt" height="900.000000pt" viewBox="0 0 531.000000 900.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
<path d="M1825 8858 c-3 -7 -4 -215 -3 -463 l3 -450 529 -3 c378 -1 532 -5
537 -13 4 -7 1 -35 -6 -63 -7 -28 -21 -87 -30 -131 -17 -79 -31 -145 -59 -267
-8 -35 -22 -99 -31 -143 -9 -44 -23 -105 -30 -135 -7 -30 -21 -91 -30 -135 -9
-44 -23 -105 -30 -135 -7 -30 -20 -93 -30 -140 -9 -47 -23 -110 -30 -140 -7
-30 -21 -91 -30 -135 -10 -44 -23 -107 -31 -140 -7 -33 -20 -94 -29 -135 -9
-41 -23 -102 -30 -135 -15 -66 -36 -165 -61 -277 -8 -40 -21 -100 -29 -133 -7
-33 -21 -96 -30 -140 -9 -44 -23 -105 -30 -135 -7 -30 -21 -91 -30 -135 -9
-44 -22 -107 -30 -140 -8 -33 -21 -94 -30 -135 -9 -41 -22 -102 -29 -135 -8
-33 -21 -96 -31 -140 -9 -44 -23 -107 -30 -140 -8 -33 -21 -94 -30 -135 -9
-41 -22 -102 -30 -135 -7 -33 -21 -96 -30 -140 -10 -44 -23 -107 -31 -140 -7
-33 -20 -94 -30 -135 -9 -41 -22 -102 -30 -135 -22 -102 -43 -197 -59 -275 -9
-41 -22 -100 -29 -130 -8 -30 -21 -93 -31 -140 -9 -47 -22 -110 -30 -140 -7
-30 -21 -91 -30 -135 -9 -44 -23 -107 -30 -140 -8 -33 -21 -94 -30 -135 -9
-41 -23 -102 -30 -135 -8 -33 -21 -94 -30 -135 -16 -80 -38 -177 -59 -275 -41
-180 -49 -216 -61 -275 -8 -36 -22 -99 -30 -140 -9 -41 -22 -102 -30 -135 -7
-33 -21 -94 -30 -135 -33 -152 -45 -207 -63 -285 l-19 -80 -619 -5 c-341 -3
-620 -6 -622 -8 -1 -1 -1 -210 0 -464 l3 -463 1625 0 1625 0 3 454 c1 327 -1
458 -9 467 -9 12 -103 14 -525 14 l-514 0 0 22 c0 12 6 47 14 77 8 31 22 92
31 136 10 44 24 103 31 132 8 28 14 61 14 74 0 12 6 45 14 73 8 28 22 87 31
131 9 44 23 108 31 143 8 34 20 90 28 125 8 34 22 98 31 142 10 44 23 107 31
140 7 33 20 94 29 135 9 41 22 102 30 135 8 33 21 96 30 140 9 44 23 105 30
135 7 30 21 91 30 135 22 107 43 198 61 267 8 32 14 67 14 79 0 12 6 45 14 73
8 28 22 87 31 131 9 44 23 108 31 143 8 34 20 90 28 125 8 34 22 98 31 142 9
44 23 105 30 135 8 30 21 93 30 140 10 47 23 110 31 140 7 30 20 91 29 135 9
44 22 105 30 135 7 30 21 91 30 135 22 107 43 198 61 267 8 32 14 67 14 79 0
12 6 45 14 73 8 28 22 87 31 131 16 76 25 115 58 265 8 36 22 101 32 145 9 44
23 107 30 140 8 33 21 94 30 135 9 41 22 102 30 135 7 33 21 96 30 140 9 44
23 105 30 135 7 30 21 91 30 135 9 44 23 105 30 135 7 30 20 93 30 140 9 47
23 110 30 140 7 30 21 91 30 135 17 78 31 143 59 267 8 35 22 99 31 143 9 44
23 105 30 135 7 30 20 93 30 140 9 47 24 110 33 140 l17 55 628 3 627 2 0 465
0 465 -1645 0 c-1307 0 -1647 -3 -1650 -12z"/>
</g>
</svg>
),
  
  underline: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="1386.000000pt" viewBox="0 0 900.000000 1386.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,1386.000000) scale(0.100000,-0.100000)">
<path d="M730 13706 c-138 -25 -238 -77 -345 -181 -106 -103 -149 -176 -196
-335 -12 -37 -14 -564 -14 -3120 0 -3195 1 -3292 41 -3468 8 -35 14 -78 14
-95 0 -45 33 -204 84 -407 40 -160 67 -245 126 -400 11 -30 31 -84 44 -120 13
-36 56 -131 95 -212 39 -81 71 -150 71 -153 0 -3 47 -85 105 -181 58 -97 105
-177 105 -179 0 -4 130 -182 233 -318 180 -241 543 -591 827 -799 192 -141
464 -307 635 -388 72 -34 162 -77 200 -96 90 -43 400 -152 540 -189 225 -61
329 -83 494 -105 85 -12 158 -23 161 -25 8 -5 417 -28 500 -28 270 0 763 57
960 110 52 14 111 29 130 33 74 16 138 34 215 61 245 85 352 127 455 177 232
111 336 164 367 188 17 13 34 24 38 24 28 0 536 355 580 405 6 6 75 70 155
142 80 72 154 142 166 155 40 47 199 223 205 228 7 5 72 91 191 249 78 104
146 207 178 266 6 11 18 32 28 47 54 83 105 177 156 283 32 66 70 145 85 175
16 30 56 132 90 225 34 94 67 181 73 195 11 27 36 114 48 170 4 19 22 87 39
150 54 197 100 552 112 859 6 170 9 1321 7 3191 l-3 2925 -28 80 c-34 94 -65
151 -121 220 -271 337 -782 333 -1050 -8 -66 -85 -96 -143 -128 -252 -9 -30
-14 -786 -18 -3155 l-6 -3115 -26 -165 c-22 -139 -50 -261 -98 -435 -9 -34
-33 -102 -79 -224 -45 -118 -160 -348 -234 -466 -83 -133 -218 -313 -301 -401
-36 -40 -75 -83 -86 -96 -33 -43 -240 -223 -353 -308 -231 -174 -504 -320
-767 -410 -14 -5 -50 -18 -80 -30 -30 -11 -73 -25 -95 -30 -22 -4 -83 -20
-135 -33 -195 -51 -380 -71 -670 -71 -258 0 -316 4 -529 40 -80 13 -108 20
-203 45 -24 7 -59 15 -78 20 -19 4 -60 17 -90 29 -30 12 -86 32 -125 45 -104
35 -344 146 -417 193 -14 9 -61 38 -105 64 -105 62 -281 196 -412 312 -197
175 -412 436 -553 671 -66 110 -185 348 -213 428 -79 217 -132 417 -159 592
-9 55 -21 134 -28 175 -9 58 -13 791 -18 3185 -4 2462 -8 3115 -17 3132 -7 12
-13 29 -13 38 0 34 -72 169 -122 232 -153 188 -401 281 -638 239z"/>
<path d="M670 1526 c-186 -55 -339 -180 -419 -339 -60 -122 -75 -183 -74 -312
0 -124 15 -192 64 -288 81 -159 205 -275 364 -337 120 -47 -88 -45 3850 -45
3550 0 3693 1 3760 18 234 62 405 224 480 455 36 112 38 282 4 388 -75 236
-247 402 -481 464 -72 19 -138 20 -3773 19 l-3700 0 -75 -23z"/>
</g>
</svg>
),

  unorderedList: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="681.000000pt" viewBox="0 0 900.000000 681.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,681.000000) scale(0.100000,-0.100000)">
<path d="M575 6625 c-197 -49 -333 -174 -421 -385 -27 -64 -27 -295 0 -360 53
-128 107 -207 187 -273 167 -136 410 -166 614 -76 55 24 166 111 204 159 36
45 72 112 107 199 28 67 26 265 -4 348 -71 201 -223 342 -422 389 -68 16 -198
16 -265 -1z"/>
<path d="M2460 6512 c-178 -55 -299 -198 -314 -372 -13 -153 33 -275 141 -369
55 -49 84 -65 161 -92 54 -18 139 -19 3033 -19 l2978 0 66 24 c79 29 134 65
186 124 146 166 140 430 -14 584 -59 59 -113 91 -197 117 -65 21 -75 21 -3025
20 -2746 -1 -2964 -2 -3015 -17z"/>
<path d="M540 3926 c-36 -12 -78 -29 -95 -38 -16 -10 -41 -22 -54 -28 -66 -30
-190 -186 -229 -290 -31 -79 -40 -224 -22 -320 31 -163 153 -321 310 -401 79
-40 120 -50 235 -56 174 -9 320 49 445 178 51 52 94 124 136 228 28 67 26 265
-4 348 -68 194 -210 329 -402 384 -93 27 -234 25 -320 -5z"/>
<path d="M2433 3780 c-146 -52 -261 -186 -284 -333 -36 -222 82 -417 300 -495
42 -15 281 -17 2996 -20 2740 -2 2955 -1 3025 14 159 36 268 130 325 279 37
97 24 261 -26 345 -5 8 -13 24 -18 35 -11 23 -92 102 -136 133 -17 11 -57 30
-90 41 l-59 21 -2991 -1 c-2885 0 -2992 -1 -3042 -19z"/>
<path d="M587 1250 c-82 -14 -211 -84 -281 -153 -132 -129 -183 -267 -173
-463 5 -96 11 -118 55 -214 58 -125 193 -241 342 -295 76 -28 290 -27 365 1
139 53 265 160 322 275 65 132 68 143 67 283 -1 121 -4 136 -31 201 -114 275
-370 414 -666 365z"/>
<path d="M2490 1071 c-25 -4 -72 -20 -104 -36 -268 -128 -328 -482 -117 -694
63 -63 126 -98 216 -117 78 -17 5891 -21 5977 -3 152 30 267 126 333 278 15
35 19 66 19 150 -1 98 -3 111 -34 174 -62 131 -184 226 -318 248 -65 10 -5901
10 -5972 0z"/>
</g>
</svg>
),

  orderedList: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="768.000000pt" viewBox="0 0 900.000000 768.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,768.000000) scale(0.100000,-0.100000)">
<path d="M812 7370 c-22 -16 -55 -49 -72 -72 -118 -163 -172 -240 -194 -283
-60 -112 -9 -250 104 -284 23 -7 43 -17 45 -24 3 -7 6 -247 7 -534 l3 -521 30
-43 c56 -80 169 -113 257 -75 53 23 104 79 117 131 16 63 15 1519 -1 1583 -15
61 -33 88 -82 123 -34 25 -48 29 -106 29 -58 0 -72 -4 -108 -30z"/>
<path d="M2838 7381 c-115 -42 -204 -129 -248 -241 -18 -46 -21 -71 -18 -155
3 -85 8 -109 32 -158 51 -106 144 -182 266 -218 69 -21 5492 -21 5565 0 78 23
125 51 186 111 143 142 157 368 32 527 -45 57 -116 107 -188 132 l-59 21
-2761 -1 c-2591 -1 -2763 -2 -2807 -18z"/>
<path d="M704 4705 c-197 -30 -356 -162 -416 -343 -65 -198 -2 -347 156 -368
117 -16 218 70 233 199 5 41 13 59 39 85 29 29 38 32 91 32 80 0 130 -34 156
-106 17 -48 17 -53 0 -103 -24 -75 -101 -151 -303 -302 -171 -127 -344 -288
-374 -349 -52 -104 -56 -127 -56 -310 l0 -175 32 -46 c33 -49 70 -73 128 -85
57 -11 799 -11 855 1 65 13 98 36 130 90 45 78 29 191 -37 252 -53 50 -77 53
-388 53 -254 0 -291 2 -297 16 -3 9 6 27 23 46 34 36 149 130 218 179 26 19
68 48 92 65 297 209 430 445 394 702 -25 179 -141 344 -290 413 -74 34 -98 42
-180 55 -98 16 -99 16 -206 -1z"/>
<path d="M2910 4168 c-133 -19 -250 -107 -310 -235 -30 -64 -32 -71 -28 -172
3 -94 7 -113 33 -165 39 -78 111 -148 193 -188 l67 -33 2780 0 c2716 0 2781 0
2830 19 61 23 145 84 178 128 121 162 112 373 -22 520 -68 74 -144 113 -250
127 -107 14 -5373 13 -5471 -1z"/>
<path d="M735 2024 c-195 -39 -294 -93 -378 -206 -37 -49 -51 -79 -78 -163
-50 -159 3 -291 130 -324 90 -23 200 18 235 87 7 15 19 54 26 87 7 33 22 70
33 82 28 32 116 49 172 33 59 -17 75 -48 75 -148 0 -103 -16 -126 -92 -136
-122 -16 -177 -46 -213 -116 -40 -78 -20 -177 49 -236 33 -28 53 -35 137 -50
84 -15 103 -22 126 -46 27 -29 28 -32 27 -144 0 -128 -10 -154 -75 -186 -39
-21 -137 -23 -184 -5 -66 25 -88 57 -100 141 -6 36 -17 56 -50 91 -48 49 -97
63 -188 51 -63 -9 -88 -24 -127 -78 -28 -38 -30 -47 -30 -127 0 -83 19 -166
46 -203 5 -7 16 -25 24 -40 46 -93 184 -186 342 -233 71 -21 295 -16 374 8
182 54 312 185 364 367 7 25 15 115 17 201 4 138 2 163 -16 217 -22 64 -51
121 -82 161 -25 32 -24 54 8 120 52 110 68 287 40 421 -41 192 -162 311 -367
361 -68 17 -192 23 -245 13z"/>
<path d="M2905 943 c-125 -29 -216 -88 -274 -178 -43 -68 -54 -106 -58 -208
-6 -137 25 -215 118 -303 56 -52 83 -68 155 -94 58 -20 64 -20 2804 -20 2690
0 2747 0 2800 19 88 31 118 50 172 105 100 103 137 237 104 376 -25 106 -108
213 -202 261 -103 52 58 49 -2880 48 -1495 -1 -2728 -3 -2739 -6z"/>
</g>
</svg>
),

  insertLink: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="903.000000pt" viewBox="0 0 900.000000 903.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,903.000000) scale(0.100000,-0.100000)">
<path d="M6565 8818 c-216 -20 -483 -100 -638 -190 -26 -15 -50 -28 -52 -28
-11 0 -117 -69 -190 -123 -84 -63 -1114 -1081 -1211 -1197 -62 -75 -167 -228
-213 -313 -79 -146 -131 -296 -178 -512 -25 -116 -25 -508 0 -615 10 -41 22
-97 28 -125 52 -234 211 -540 373 -715 59 -64 67 -51 -177 -296 -123 -123
-230 -224 -238 -224 -8 0 -51 30 -95 68 -44 37 -106 84 -139 106 -33 21 -72
46 -86 56 -97 68 -355 171 -514 206 -89 19 -292 43 -370 44 -392 2 -825 -161
-1130 -423 -116 -100 -1107 -1102 -1170 -1181 -153 -197 -266 -421 -319 -631
-46 -184 -66 -327 -66 -470 0 -216 52 -475 136 -671 68 -158 117 -244 218
-379 69 -93 458 -490 563 -575 205 -168 386 -260 688 -351 81 -24 299 -49 429
-49 169 0 413 35 506 72 14 6 39 14 55 19 83 22 318 131 356 165 8 8 19 14 23
14 4 0 50 32 104 72 70 52 249 224 642 615 631 630 678 684 797 911 112 216
168 411 194 681 17 188 -8 424 -69 641 -57 201 -192 450 -333 613 -33 37 -59
76 -59 85 0 19 439 462 457 462 7 0 27 -14 45 -31 103 -96 260 -202 413 -277
387 -191 855 -225 1273 -91 65 21 257 102 273 116 8 7 20 13 25 13 6 0 41 20
78 45 38 25 71 45 74 45 2 0 43 30 91 67 88 69 1085 1058 1202 1193 119 138
204 279 281 465 66 160 93 262 120 455 42 301 -22 682 -162 964 -128 260 -189
338 -500 648 -299 299 -421 388 -675 498 -61 27 -207 75 -255 84 -19 4 -62 13
-95 21 -134 31 -336 40 -510 23z m409 -509 c211 -40 428 -153 638 -332 86 -73
284 -268 376 -371 203 -225 326 -566 309 -856 -16 -266 -92 -483 -241 -685
-60 -82 -947 -982 -1124 -1141 -161 -144 -331 -234 -557 -296 -70 -19 -107
-21 -285 -22 -161 0 -216 3 -255 16 -27 8 -79 24 -115 34 -127 35 -295 125
-410 220 -33 27 -60 56 -60 64 0 8 104 119 230 245 127 127 239 247 250 268
26 48 29 187 5 207 -8 7 -15 18 -15 24 0 20 -73 84 -120 105 -25 11 -65 21
-90 21 -88 0 -128 -29 -377 -278 -127 -128 -236 -232 -241 -232 -23 0 -137
146 -189 240 -48 89 -109 245 -123 315 -25 124 -30 172 -30 292 0 204 36 360
129 553 14 30 52 96 85 145 59 91 205 242 636 659 91 87 257 250 370 361 113
111 234 221 269 244 144 98 324 168 511 199 80 14 354 14 424 1z m-3885 -3868
c191 -34 345 -96 505 -204 72 -49 136 -105 136 -121 0 -6 -97 -108 -215 -226
-119 -118 -231 -238 -250 -267 -32 -48 -35 -57 -35 -129 0 -71 3 -83 31 -124
39 -57 91 -97 143 -111 51 -14 133 -6 177 16 19 10 141 123 271 253 l238 236
31 -29 c35 -34 144 -197 177 -266 121 -252 156 -594 87 -844 -8 -27 -16 -59
-19 -70 -16 -67 -84 -215 -132 -290 -62 -96 -115 -160 -247 -295 -955 -983
-930 -957 -1023 -1026 -70 -52 -107 -74 -209 -127 -16 -8 -64 -26 -105 -40
-380 -130 -782 -71 -1128 165 -48 33 -162 137 -303 278 -174 174 -240 246
-288 320 -35 52 -67 104 -72 115 -5 11 -13 27 -18 35 -23 38 -60 131 -78 195
-50 174 -55 214 -51 407 3 105 10 204 18 233 68 260 166 444 323 611 41 43
292 296 558 561 412 411 498 492 579 545 90 60 218 128 239 128 6 0 25 6 43
14 78 33 139 47 298 70 72 10 219 4 319 -13z"/>
</g>
</svg>
),

  insertImage: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="705.000000pt" viewBox="0 0 900.000000 705.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,705.000000) scale(0.100000,-0.100000)">
<path d="M509 6896 c-127 -43 -226 -121 -299 -236 -42 -66 -59 -108 -71 -177
-5 -31 -8 -1257 -7 -2975 3 -2849 3 -2924 22 -2963 10 -22 28 -60 40 -85 12
-25 55 -79 96 -120 84 -84 152 -122 270 -151 72 -18 213 -19 3895 -19 3682 0
3823 1 3895 19 202 49 339 175 414 379 14 38 16 336 16 2980 -1 2813 -1 2939
-19 2987 -68 187 -180 300 -360 362 l-66 22 -3880 0 -3880 -1 -66 -22z m7705
-526 l26 -10 0 -1985 c0 -1751 -2 -1985 -15 -1985 -14 0 -61 39 -180 150 -51
48 -233 214 -404 369 -77 70 -182 166 -247 226 -75 69 -199 181 -237 214 -141
121 -313 143 -477 62 -32 -16 -214 -192 -616 -593 -351 -351 -576 -568 -583
-563 -10 6 -504 593 -586 695 -35 44 -227 273 -235 280 -3 3 -25 30 -50 60
-53 65 -78 94 -105 125 -11 12 -45 53 -75 90 -30 37 -84 103 -120 145 -36 42
-83 98 -105 125 -22 26 -71 84 -108 129 -91 107 -96 114 -451 541 -170 204
-330 391 -356 416 -26 26 -74 59 -106 75 -51 25 -73 29 -163 32 -104 4 -119 1
-209 -41 -50 -24 -110 -85 -295 -302 -112 -132 -163 -191 -173 -200 -6 -5 -33
-37 -60 -70 -27 -33 -80 -96 -119 -141 -38 -44 -106 -123 -150 -174 -77 -90
-104 -121 -225 -260 -30 -35 -64 -75 -75 -90 -11 -14 -32 -39 -47 -55 -15 -16
-238 -275 -495 -576 -257 -301 -474 -548 -480 -548 -10 -1 -13 391 -13 1928 0
1534 3 1930 13 1934 24 10 7495 7 7521 -3z"/>
<path d="M6545 5674 c-147 -26 -260 -76 -364 -161 -256 -207 -346 -549 -229
-863 25 -67 87 -165 142 -227 184 -202 441 -289 707 -238 42 8 89 19 105 26
242 98 399 265 476 505 30 96 33 319 4 409 -77 242 -240 423 -457 506 -56 22
-235 59 -279 58 -14 -1 -61 -7 -105 -15z"/>
</g>
</svg>
),

  floppyDisk: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="900.000000pt" viewBox="0 0 900.000000 900.000000"
 preserveAspectRatio="xMidYMid meet"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
  >
<g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
<path d="M515 8991 c6 -11 -11 -17 -80 -26 -87 -12 -171 -61 -265 -155 -84
-84 -128 -154 -159 -251 -8 -26 -11 -1125 -11 -4068 0 -3630 2 -4038 16 -4087
8 -29 20 -56 25 -59 5 -4 9 -13 9 -21 0 -17 70 -115 115 -159 44 -45 142 -115
159 -115 8 0 17 -4 21 -9 3 -5 30 -17 59 -25 49 -14 457 -16 4087 -16 2943 0
4042 3 4068 11 20 6 65 25 101 42 91 44 223 177 268 269 17 37 32 73 32 80 0
30 22 88 31 83 5 -4 9 1339 9 3608 0 3037 -2 3616 -14 3620 -7 3 -16 24 -20
47 -11 71 -41 115 -180 263 -170 181 -817 822 -876 868 -54 42 -100 65 -158
79 -23 6 -40 15 -37 20 4 7 -1316 10 -3600 10 -2215 0 -3604 -4 -3600 -9z
m1834 -257 c3 -3 8 -589 11 -1302 5 -1055 8 -1303 19 -1330 10 -26 11 -36 2
-45 -9 -9 -134 -12 -479 -12 -431 1 -469 2 -497 19 -51 30 -66 60 -75 154 -15
134 -13 2448 1 2475 7 12 21 30 33 40 20 17 43 18 500 13 264 -3 482 -8 485
-12z m4336 -2 c53 -47 50 29 53 -1302 l3 -1235 -22 -40 c-12 -22 -36 -55 -52
-72 l-31 -33 -1965 0 c-1887 1 -1967 1 -1988 19 -12 10 -33 35 -47 56 l-26 38
0 1272 c0 1213 1 1273 18 1288 24 22 22 22 2202 24 1740 2 1836 1 1855 -15z
m920 -3902 c64 -40 60 80 60 -1820 0 -1412 -2 -1741 -13 -1766 -7 -17 -31 -43
-54 -58 l-40 -26 -3072 0 -3072 0 -32 23 c-17 13 -42 37 -54 53 l-23 29 0
1745 0 1745 23 30 c13 16 36 38 50 47 26 17 181 18 3111 18 3071 0 3084 0
3116 -20z m-6680 -3386 c36 -23 45 -89 45 -328 l0 -212 -33 -37 -33 -37 -234
1 c-322 1 -313 -2 -320 134 -3 53 -3 177 0 276 l5 179 30 20 c28 18 48 20 273
20 204 0 247 -3 267 -16z m7678 -12 l27 -28 0 -257 c0 -245 -1 -258 -20 -277
-12 -12 -32 -25 -46 -30 -14 -6 -130 -10 -258 -10 l-234 0 -37 41 -37 42 4
226 c5 245 14 292 60 311 13 5 134 9 269 9 l245 1 27 -28z"/>
<path d="M4822 8501 c-53 -9 -88 -35 -127 -92 l-30 -44 0 -975 0 -975 28 -37
c16 -20 45 -49 65 -65 l37 -28 425 0 426 0 42 34 c24 18 53 52 65 75 l22 41 3
918 c2 603 -1 938 -8 975 -12 70 -53 131 -105 157 -38 19 -62 20 -420 22 -209
0 -399 -2 -423 -6z"/>
</g>
</svg>
),

  mediaTypeImage: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="156.000000pt" height="180.000000pt" viewBox="0 0 156.000000 180.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
<path d="M280 1744 c-48 -21 -68 -41 -90 -92 -17 -38 -20 -67 -20 -193 l0
-149 25 -12 c20 -9 28 -8 43 5 16 15 18 31 15 152 -5 162 3 195 53 218 31 15
80 17 419 17 l383 0 33 -27 c18 -16 91 -86 161 -157 l128 -129 0 -604 0 -605
-29 -29 -29 -29 -526 0 c-374 0 -532 3 -550 11 -31 15 -49 65 -41 112 6 28 2
39 -16 56 -20 18 -25 19 -43 7 -30 -19 -33 -97 -7 -156 25 -56 64 -86 127 -97
27 -4 283 -6 569 -3 l520 5 32 24 c65 49 63 26 63 699 0 364 -4 621 -10 636
-5 14 -77 93 -160 176 -111 112 -161 155 -191 165 -62 22 -808 21 -859 -1z"/>
<path d="M1402 1688 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12
-12z"/>
<path d="M1051 1621 c-11 -7 -14 -36 -15 -123 0 -102 3 -118 22 -145 30 -42
82 -61 186 -67 97 -6 126 4 126 42 0 30 -13 34 -129 35 -75 2 -104 6 -116 17
-11 12 -15 42 -17 119 -3 119 -16 148 -57 122z"/>
<path d="M70 1212 c-21 -17 -21 -20 -20 -410 0 -215 3 -399 6 -407 4 -8 17
-18 29 -21 13 -3 255 -6 539 -7 410 -2 518 1 528 11 10 10 14 93 18 355 5 367
2 459 -18 479 -10 10 -127 13 -537 15 -484 2 -525 1 -545 -15z m1024 -60 c7
-12 10 -451 2 -459 -3 -4 -37 27 -74 68 -105 117 -129 139 -147 139 -10 0 -88
-70 -173 -155 -85 -85 -158 -155 -162 -155 -4 0 -33 27 -64 60 -46 50 -59 59
-74 51 -10 -5 -73 -66 -139 -135 -67 -69 -128 -126 -136 -126 -11 0 -14 60
-15 351 -1 194 1 356 4 360 7 11 971 12 978 1z m-105 -453 l111 -111 0 -73 0
-74 -417 -3 c-230 -2 -423 1 -430 5 -8 6 13 33 69 88 45 43 85 79 90 79 5 0
32 -25 60 -55 27 -30 59 -55 69 -55 11 0 83 64 175 155 86 85 157 155 159 155
2 0 53 -50 114 -111z"/>
<path d="M254 1079 c-122 -63 -80 -249 56 -249 109 0 174 116 115 206 -17 26
-84 64 -112 64 -10 0 -37 -10 -59 -21z m103 -71 c27 -26 29 -55 5 -84 -28 -33
-55 -37 -85 -13 -34 26 -36 70 -5 99 28 26 56 25 85 -2z"/>
</g>
</svg>
),

  mediaTypeSound: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="156.000000pt" height="180.000000pt" viewBox="0 0 156.000000 180.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
<path d="M284 1742 c-100 -56 -104 -69 -104 -383 0 -226 2 -249 18 -257 9 -6
27 -6 40 -1 l22 8 0 256 c0 157 4 264 10 276 26 47 44 49 450 49 310 0 386 -3
408 -14 15 -8 89 -77 165 -154 l139 -140 1 -64 c0 -34 0 -310 -1 -611 l-2
-548 -25 -24 -24 -25 -534 0 c-511 0 -536 1 -558 19 -23 18 -24 26 -29 187 -4
145 -7 168 -22 178 -13 8 -23 8 -35 0 -16 -10 -18 -31 -21 -167 -2 -141 0
-161 18 -197 21 -42 54 -68 105 -85 19 -6 223 -8 570 -5 l540 5 36 35 c20 19
42 50 48 69 8 24 11 214 11 626 0 489 -2 598 -14 626 -17 40 -290 315 -338
340 -30 17 -70 18 -438 18 -363 0 -408 -2 -436 -17z"/>
<path d="M1495 1691 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z"/>
<path d="M1047 1614 c-4 -4 -7 -59 -7 -121 0 -107 2 -116 26 -148 33 -43 96
-65 188 -65 99 0 116 6 116 41 0 15 -6 31 -12 35 -7 5 -56 8 -109 9 -134 0
-137 4 -141 144 -3 105 -3 106 -28 109 -14 2 -29 0 -33 -4z"/>
<path d="M463 1192 c-26 -22 -79 -67 -117 -102 l-69 -63 -78 6 c-60 4 -83 2
-101 -10 -47 -32 -48 -38 -48 -229 l0 -182 31 -26 c28 -24 39 -26 118 -26 70
0 90 -3 102 -17 9 -10 46 -43 83 -73 38 -30 79 -65 92 -77 39 -36 74 -40 96
-13 17 21 18 49 18 414 0 338 -2 395 -16 414 -22 32 -56 27 -111 -16z m51
-395 c1 -365 2 -360 -65 -291 -18 19 -55 51 -82 71 l-47 35 2 191 c3 188 3
192 26 203 13 6 51 37 84 68 34 31 66 55 72 53 6 -2 10 -118 10 -330z m-263
151 c2 -7 2 -80 -1 -163 l-5 -150 -39 -3 c-22 -2 -50 -1 -63 2 -23 6 -23 7
-23 160 0 84 3 156 7 159 12 13 121 8 124 -5z"/>
<path d="M842 1158 c-20 -20 -14 -41 31 -91 62 -68 100 -171 101 -267 0 -107
-32 -191 -104 -273 -42 -47 -48 -65 -28 -85 26 -26 57 -13 95 41 49 68 59 86
83 149 38 101 22 334 -27 386 -7 7 -13 19 -13 25 -1 22 -86 122 -106 125 -10
1 -25 -3 -32 -10z"/>
<path d="M707 1013 c-14 -14 -6 -43 28 -94 31 -47 35 -61 35 -117 0 -63 -13
-102 -51 -151 -11 -13 -19 -34 -19 -48 0 -48 63 -39 90 13 8 16 19 35 24 43
15 19 35 100 35 136 0 60 -38 164 -77 208 -15 17 -53 23 -65 10z"/>
</g>
</svg>
),

  mediaTypeVideo0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="156.000000pt" height="180.000000pt" viewBox="0 0 156.000000 180.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
<path d="M272 1744 c-36 -16 -58 -36 -85 -77 -15 -23 -17 -47 -15 -165 l3
-137 30 0 30 0 5 131 c5 143 11 157 67 181 45 18 758 19 800 1 15 -7 66 -51
111 -98 46 -47 111 -113 144 -147 l61 -61 -1 -601 c-1 -561 -2 -603 -19 -625
-10 -14 -27 -27 -38 -30 -11 -3 -257 -6 -546 -6 l-526 0 -24 26 c-19 20 -25
40 -29 92 -5 67 -5 67 -35 67 l-30 0 -3 -76 c-3 -75 -3 -75 37 -121 25 -28 52
-48 71 -51 16 -4 271 -7 565 -7 536 -1 536 -1 571 21 20 12 45 36 55 53 18 30
19 60 19 655 0 600 -1 625 -19 655 -11 17 -85 95 -164 173 -111 109 -152 144
-183 152 -25 7 -175 11 -429 10 -314 0 -396 -3 -423 -15z"/>
<path d="M1037 1612 c-12 -14 -13 -37 -8 -129 6 -100 10 -115 32 -139 37 -40
83 -55 181 -59 78 -3 92 -1 109 16 15 15 17 24 9 39 -12 22 -18 23 -143 24
-114 1 -117 4 -117 141 0 98 -1 102 -24 113 -19 9 -27 7 -39 -6z"/>
<path d="M44 1288 c-12 -19 -16 -144 -17 -453 0 -340 5 -454 20 -463 6 -4 244
-7 530 -7 l518 0 8 205 c5 113 6 318 2 457 -6 219 -9 253 -24 259 -9 5 -244
10 -522 12 -413 3 -508 1 -515 -10z m266 -57 c28 -53 3 -83 -73 -88 -59 -3
-87 15 -87 57 0 40 18 50 87 50 51 0 64 -3 73 -19z m215 -31 l0 -45 -58 -5
c-32 -3 -64 -2 -72 3 -15 8 -21 78 -8 91 4 4 37 6 73 4 l65 -3 0 -45z m225 31
c29 -55 -1 -89 -76 -86 -66 3 -74 8 -74 55 0 45 6 48 82 49 47 1 59 -3 68 -18z
m228 -28 c4 -51 -10 -61 -86 -58 -58 1 -72 12 -72 56 0 41 18 50 90 47 l65 -3
3 -42z m85 -373 l0 -264 -502 -1 -503 0 1 260 c0 143 0 263 0 266 1 3 227 5
502 5 l502 -1 0 -265z m-758 -327 c19 -18 14 -71 -8 -85 -6 -5 -39 -7 -72 -6
-55 3 -60 5 -69 30 -7 20 -6 35 4 53 12 22 20 25 71 25 40 0 63 -5 74 -17z
m220 -38 l0 -50 -70 0 -70 0 -3 39 c-5 63 -1 67 75 64 l68 -3 0 -50z m217 38
c20 -18 23 -45 8 -74 -9 -15 -22 -19 -65 -19 -29 0 -60 3 -69 6 -19 7 -22 74
-4 92 18 18 108 15 130 -5z m226 5 c7 -7 12 -29 12 -50 0 -44 -15 -51 -95 -46
-44 3 -51 6 -59 30 -7 18 -6 35 2 53 10 23 17 25 70 25 32 0 63 -5 70 -12z"/>
<path d="M492 823 c0 -79 5 -131 11 -135 6 -3 31 11 55 33 25 21 64 49 88 61
24 12 44 27 44 33 0 6 -36 35 -80 64 -44 28 -80 56 -80 61 0 6 -9 10 -19 10
-18 0 -19 -8 -19 -127z"/>
</g>
</svg>
),


  mediaTypeVideo1: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="156.000000pt" height="180.000000pt" viewBox="0 0 156.000000 180.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
<path d="M272 1744 c-36 -16 -58 -36 -85 -77 -15 -23 -17 -47 -15 -165 l3
-137 30 0 30 0 5 131 c5 143 11 157 67 181 45 18 758 19 800 1 15 -7 66 -51
111 -98 46 -47 111 -113 144 -147 l61 -61 -1 -601 c-1 -561 -2 -603 -19 -625
-10 -14 -27 -27 -38 -30 -11 -3 -257 -6 -546 -6 l-526 0 -24 26 c-19 20 -25
40 -29 92 -5 67 -5 67 -35 67 l-30 0 -3 -76 c-3 -75 -3 -75 37 -121 25 -28 52
-48 71 -51 16 -4 271 -7 565 -7 536 -1 536 -1 571 21 20 12 45 36 55 53 18 30
19 60 19 655 0 600 -1 625 -19 655 -11 17 -85 95 -164 173 -111 109 -152 144
-183 152 -25 7 -175 11 -429 10 -314 0 -396 -3 -423 -15z"/>
<path d="M1037 1612 c-12 -14 -13 -37 -8 -129 6 -100 10 -115 32 -139 37 -40
83 -55 181 -59 78 -3 92 -1 109 16 15 15 17 24 9 39 -12 22 -18 23 -143 24
-114 1 -117 4 -117 141 0 98 -1 102 -24 113 -19 9 -27 7 -39 -6z"/>
<path d="M44 1288 c-12 -19 -16 -144 -17 -453 0 -340 5 -454 20 -463 6 -4 244
-7 530 -7 l518 0 8 205 c5 113 6 318 2 457 -6 219 -9 253 -24 259 -9 5 -244
10 -522 12 -413 3 -508 1 -515 -10z m266 -57 c28 -53 3 -83 -73 -88 -59 -3
-87 15 -87 57 0 40 18 50 87 50 51 0 64 -3 73 -19z m215 -31 l0 -45 -58 -5
c-32 -3 -64 -2 -72 3 -15 8 -21 78 -8 91 4 4 37 6 73 4 l65 -3 0 -45z m225 31
c29 -55 -1 -89 -76 -86 -66 3 -74 8 -74 55 0 45 6 48 82 49 47 1 59 -3 68 -18z
m228 -28 c4 -51 -10 -61 -86 -58 -58 1 -72 12 -72 56 0 41 18 50 90 47 l65 -3
3 -42z m85 -373 l0 -264 -502 -1 -503 0 1 260 c0 143 0 263 0 266 1 3 227 5
502 5 l502 -1 0 -265z m-758 -327 c19 -18 14 -71 -8 -85 -6 -5 -39 -7 -72 -6
-55 3 -60 5 -69 30 -7 20 -6 35 4 53 12 22 20 25 71 25 40 0 63 -5 74 -17z
m220 -38 l0 -50 -70 0 -70 0 -3 39 c-5 63 -1 67 75 64 l68 -3 0 -50z m217 38
c20 -18 23 -45 8 -74 -9 -15 -22 -19 -65 -19 -29 0 -60 3 -69 6 -19 7 -22 74
-4 92 18 18 108 15 130 -5z m226 5 c7 -7 12 -29 12 -50 0 -44 -15 -51 -95 -46
-44 3 -51 6 -59 30 -7 18 -6 35 2 53 10 23 17 25 70 25 32 0 63 -5 70 -12z"/>
<path d="M492 823 c0 -79 5 -131 11 -135 6 -3 31 11 55 33 25 21 64 49 88 61
24 12 44 27 44 33 0 6 -36 35 -80 64 -44 28 -80 56 -80 61 0 6 -9 10 -19 10
-18 0 -19 -8 -19 -127z"/>
</g>
</svg>
),

  mediaTypeVideo2: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="594.000000pt" height="355.000000pt" viewBox="0 0 594.000000 355.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,355.000000) scale(0.100000,-0.100000)">
<path d="M30 1775 l0 -1745 2935 0 2935 0 -2 1742 -3 1743 -2932 3 -2933 2 0
-1745z m4903 1551 c35 -15 98 -66 82 -66 -5 0 -3 -5 5 -10 13 -8 15 -183 15
-1475 0 -1212 -2 -1467 -13 -1474 -8 -5 -12 -12 -11 -17 2 -5 -17 -22 -42 -39
l-44 -30 -1935 -3 c-1320 -2 -1946 0 -1971 8 -38 11 -108 70 -110 92 0 7 -3
22 -6 33 -3 11 -7 657 -10 1437 l-5 1416 22 45 c13 26 38 54 63 70 l41 27
1943 0 c1630 0 1949 -2 1976 -14z m-4212 -176 c17 -10 19 -23 19 -155 0 -132
-2 -145 -19 -155 -11 -6 -89 -10 -181 -10 -92 0 -170 4 -181 10 -17 10 -19 23
-19 150 0 113 3 142 16 154 13 13 44 16 180 16 95 0 174 -4 185 -10z m4863
-12 c12 -17 16 -50 16 -147 0 -170 12 -161 -206 -161 -144 0 -175 3 -188 16
-23 23 -23 275 0 298 13 13 45 16 189 16 168 0 174 -1 189 -22z m-4858 -812
c17 -13 19 -29 22 -141 5 -184 16 -175 -206 -175 -125 0 -182 4 -190 12 -8 8
-12 56 -12 149 0 112 3 141 16 153 22 22 340 24 370 2z m4854 -6 c18 -18 20
-33 20 -147 0 -173 13 -163 -210 -163 -123 0 -180 4 -188 12 -8 8 -12 56 -12
149 0 178 -12 169 207 169 150 0 165 -2 183 -20z m-4855 -825 c24 -23 25 -30
25 -143 0 -174 8 -167 -209 -166 -120 1 -175 5 -186 14 -12 10 -15 40 -15 151
0 178 -11 169 203 169 154 0 158 -1 182 -25z m4855 5 c18 -18 20 -33 20 -148
0 -172 11 -163 -208 -165 -130 -2 -173 1 -185 12 -14 11 -17 35 -17 152 0 179
-12 169 207 169 150 0 165 -2 183 -20z m-4852 -822 c8 -8 12 -56 12 -149 0
-178 10 -169 -200 -169 -210 0 -200 -9 -200 169 0 93 4 141 12 149 17 17 359
17 376 0z m4856 -10 c22 -31 23 -255 2 -284 -13 -17 -30 -19 -181 -22 -226 -5
-215 -13 -215 163 0 108 3 137 16 149 13 13 45 16 189 16 168 0 174 -1 189
-22z"/>
<path d="M2687 2229 c-45 -26 -47 -47 -47 -439 0 -408 1 -416 60 -440 16 -7
42 -10 58 -7 15 3 171 89 347 190 314 181 320 185 335 226 14 39 13 44 -5 78
-17 30 -67 62 -340 219 -328 189 -358 202 -408 173z"/>
</g>
</svg>

),

  mediaTypeVideo: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="600.000000pt" height="450.000000pt" viewBox="0 0 600.000000 450.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,450.000000) scale(0.100000,-0.100000)">
<path d="M481 4475 c-205 -37 -374 -192 -438 -400 -17 -57 -18 -140 -18 -1820
0 -1680 1 -1763 18 -1820 59 -192 210 -342 393 -389 56 -14 313 -16 2562 -16
l2500 0 68 21 c192 59 337 212 385 409 12 45 14 367 14 1800 0 1637 -1 1749
-18 1809 -51 187 -193 332 -387 398 -53 17 -153 18 -2530 20 -2041 1 -2488 -1
-2549 -12z m559 -385 c22 -11 52 -39 67 -62 l28 -41 3 -221 c4 -239 -1 -274
-45 -327 -53 -62 -83 -69 -328 -69 -250 0 -279 7 -331 76 l-29 37 -3 231 c-2
127 0 246 3 264 7 39 59 100 100 118 22 10 93 13 263 14 214 0 236 -2 272 -20z
m3440 -1835 l0 -1855 -1485 0 -1485 0 0 1855 0 1855 1485 0 1485 0 0 -1855z
m997 1844 c15 -5 41 -22 56 -37 55 -52 57 -62 57 -317 0 -212 -2 -240 -19
-273 -46 -91 -81 -101 -351 -101 -240 -1 -270 6 -323 68 -44 53 -49 88 -45
327 l3 221 27 41 c51 76 70 81 335 82 140 0 243 -4 260 -11z m-4474 -1480 c51
-14 102 -61 122 -113 14 -36 16 -78 13 -267 -3 -250 -7 -264 -75 -316 l-36
-28 -249 -3 c-249 -3 -250 -3 -291 22 -24 13 -52 41 -65 64 -21 38 -22 50 -22
277 0 235 0 239 25 280 25 44 60 72 104 85 39 12 430 11 474 -1z m4505 -22
c77 -50 82 -72 82 -343 0 -226 -1 -238 -22 -276 -13 -23 -41 -51 -65 -64 -41
-25 -42 -25 -291 -22 l-249 3 -37 29 c-69 52 -76 81 -76 331 0 240 7 272 63
323 50 47 85 52 328 49 l226 -2 41 -28z m-4470 -1478 c26 -13 54 -38 70 -62
l27 -41 0 -240 c0 -275 -5 -296 -78 -344 -40 -27 -41 -27 -266 -30 -124 -2
-241 0 -259 3 -40 7 -101 59 -118 102 -17 41 -20 476 -3 520 15 40 48 73 94
94 35 16 68 19 264 19 209 0 228 -2 269 -21z m4447 2 c46 -21 79 -54 94 -94
17 -44 14 -479 -3 -520 -17 -43 -78 -95 -118 -102 -18 -3 -135 -5 -259 -3
-225 3 -226 3 -266 30 -71 47 -78 72 -81 325 -3 208 -2 225 18 272 20 46 64
88 110 104 8 3 116 6 240 6 198 0 230 -2 265 -18z"/>
<path d="M2235 3185 c-5 -2 -22 -6 -37 -9 -37 -8 -98 -63 -114 -103 -11 -26
-14 -181 -14 -820 0 -882 -5 -825 73 -887 29 -23 50 -31 95 -34 l58 -4 774
387 c426 213 783 394 794 404 38 34 58 91 54 153 -8 109 29 86 -839 520 -707
354 -814 404 -844 393z"/>
</g>
</svg>
),


  mediaTypeAudioSlideshow: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="156.000000pt" height="180.000000pt" viewBox="0 0 156.000000 180.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
<path d="M280 1744 c-48 -21 -68 -41 -90 -92 -17 -38 -20 -67 -20 -193 l0
-149 25 -12 c20 -9 28 -8 43 5 16 15 18 31 15 152 -5 162 3 195 53 218 31 15
80 17 419 17 l383 0 33 -27 c18 -16 91 -86 161 -157 l128 -129 0 -604 0 -605
-29 -29 -29 -29 -526 0 c-371 0 -532 3 -550 11 -42 19 -47 56 -45 322 1 250
-3 277 -36 277 -6 0 -19 -8 -28 -18 -15 -16 -17 -50 -17 -275 0 -145 4 -258 9
-262 5 -3 12 -18 16 -34 9 -40 61 -78 121 -88 27 -4 283 -6 569 -3 l520 5 32
24 c65 49 63 26 63 699 0 364 -4 621 -10 636 -5 14 -77 93 -160 176 -111 112
-161 155 -191 165 -62 22 -808 21 -859 -1z"/>
<path d="M1402 1688 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12
-12z"/>
<path d="M1051 1621 c-11 -7 -14 -36 -15 -125 0 -102 3 -120 21 -144 38 -50
79 -67 178 -69 102 -3 135 8 135 44 0 31 -12 35 -129 36 -75 2 -104 6 -116 17
-11 12 -15 42 -17 119 -3 119 -16 148 -57 122z"/>
<path d="M46 1231 c-14 -15 -16 -51 -16 -238 0 -200 2 -221 18 -236 16 -15 53
-17 309 -17 268 0 291 1 306 18 15 16 17 48 17 239 0 201 -2 221 -18 237 -17
14 -51 16 -310 15 -263 0 -292 -2 -306 -18z m574 -154 c3 -63 1 -111 -4 -115
-5 -3 -29 16 -52 41 -23 26 -51 47 -62 47 -12 0 -52 -33 -98 -80 -42 -44 -84
-80 -91 -80 -7 0 -26 15 -42 32 l-29 32 -75 -76 c-41 -43 -77 -74 -81 -71 -8
9 -8 368 1 376 4 4 124 6 267 5 l261 -3 5 -108z m-53 -149 c45 -45 53 -58 53
-90 l0 -38 -133 0 c-74 0 -175 -3 -225 -6 -86 -7 -92 -6 -91 12 0 10 16 32 35
48 l35 29 28 -27 c15 -14 36 -26 47 -26 12 0 51 31 95 75 41 41 81 75 89 75 8
0 38 -23 67 -52z"/>
<path d="M132 1137 c-48 -51 -14 -127 56 -127 45 0 69 20 78 68 13 66 -86 110
-134 59z m78 -32 c10 -13 10 -19 -5 -35 -14 -15 -20 -17 -36 -7 -22 14 -24 28
-7 45 16 16 33 15 48 -3z"/>
<path d="M820 713 c-8 -3 -17 -9 -20 -12 -3 -3 -24 -23 -48 -43 -35 -32 -49
-38 -86 -38 -37 0 -48 -5 -66 -27 -19 -25 -21 -38 -18 -121 4 -108 13 -122 84
-122 37 0 49 -6 91 -45 48 -45 83 -62 102 -50 7 4 11 83 11 230 0 194 -2 224
-16 229 -9 3 -16 6 -17 5 -1 0 -9 -3 -17 -6z m5 -231 c0 -91 -3 -152 -9 -152
-5 0 -24 11 -43 26 l-33 25 0 100 0 99 33 30 c17 16 36 28 41 27 5 -2 10 -72
11 -155z m-137 7 c2 -50 -1 -69 -13 -79 -28 -23 -45 5 -45 75 0 68 4 77 35 73
17 -3 20 -11 23 -69z"/>
<path d="M1001 681 c-14 -9 -8 -42 12 -63 62 -66 60 -195 -4 -277 -23 -29 -24
-47 -2 -55 20 -8 53 24 79 80 26 54 26 174 0 229 -22 47 -55 95 -64 95 -4 0
-13 -4 -21 -9z"/>
<path d="M924 585 c-3 -8 1 -24 10 -37 21 -29 21 -111 1 -132 -28 -28 -14 -63
20 -50 20 8 55 85 55 119 0 27 -29 96 -45 107 -16 12 -35 9 -41 -7z"/>
</g>
</svg>
),

  mediaTypeUnknown: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="444.000000pt" height="573.000000pt" viewBox="0 0 444.000000 573.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,573.000000) scale(0.100000,-0.100000)">
<path d="M775 5640 c-38 -4 -119 -8 -179 -9 -69 -1 -121 -7 -143 -16 -20 -8
-43 -15 -51 -15 -37 0 -222 -142 -222 -171 0 -4 -16 -25 -35 -46 -19 -21 -35
-43 -35 -49 0 -6 -7 -26 -16 -44 -16 -30 -17 -224 -15 -2427 1 -1522 6 -2414
12 -2451 5 -31 13 -72 16 -89 3 -18 12 -38 19 -44 8 -6 14 -16 14 -22 0 -13
139 -147 152 -147 5 0 25 -12 45 -27 75 -57 96 -58 2233 -58 1336 0 1474 5
1543 58 19 15 40 27 45 27 12 0 152 133 152 145 0 5 6 16 13 24 25 30 40 126
47 311 4 102 6 1002 5 2000 -1 1674 -3 1818 -18 1852 -9 21 -17 50 -17 66 0
17 -9 37 -21 48 -12 10 -32 35 -45 55 -42 66 -760 779 -898 891 -54 45 -137
98 -151 98 -8 0 -16 4 -20 9 -7 13 -63 20 -200 26 -183 9 -2155 13 -2230 5z
m2065 -230 c58 -5 146 -13 195 -16 110 -9 100 -2 320 -201 72 -65 132 -122
134 -128 2 -5 154 -161 338 -345 l333 -335 -4 -1805 c-2 -993 -7 -1836 -10
-1875 -4 -38 -10 -118 -14 -176 -8 -95 -12 -110 -40 -152 -58 -84 -104 -101
-282 -108 -185 -7 -3060 -4 -3190 3 -69 4 -136 10 -150 14 -39 11 -88 52 -117
97 -30 48 -37 102 -50 417 -10 237 -10 4014 0 4140 14 181 25 262 36 273 6 6
11 18 11 27 0 20 58 82 95 102 84 45 107 48 385 64 52 3 97 8 99 10 9 8 1813
3 1911 -6z"/>
<path d="M2928 5193 c-56 -35 -60 -59 -55 -331 2 -136 6 -263 9 -282 3 -19 8
-64 13 -100 4 -36 14 -74 21 -85 8 -11 14 -27 14 -35 0 -20 96 -128 124 -141
12 -5 29 -13 39 -19 9 -5 25 -15 35 -20 9 -6 22 -12 27 -14 6 -1 26 -9 45 -15
83 -30 201 -43 420 -48 221 -4 226 -4 269 20 75 39 99 103 61 164 -35 59 -50
61 -402 73 -353 11 -374 18 -421 138 -14 36 -17 83 -17 310 -1 255 -2 269 -23
312 -34 69 -110 104 -159 73z"/>
<path d="M1795 3480 c-22 -10 -53 -33 -70 -50 l-30 -31 0 -277 0 -277 155 0
155 0 5 175 5 175 185 0 185 0 3 -201 2 -201 -46 -64 c-26 -35 -53 -68 -61
-72 -7 -4 -13 -13 -13 -19 0 -11 -45 -70 -92 -122 -16 -17 -28 -36 -28 -43 0
-6 -6 -16 -13 -20 -16 -10 -77 -88 -77 -99 0 -4 -6 -15 -13 -23 -28 -33 -38
-123 -35 -316 l3 -190 155 0 155 0 3 203 2 203 176 234 c153 204 177 241 189
292 19 80 21 571 2 625 -17 50 -42 75 -95 98 -42 19 -67 20 -406 19 -329 -1
-365 -2 -401 -19z"/>
<path d="M2004 1627 c-2 -7 -3 -80 -2 -162 l3 -150 163 -3 162 -2 0 165 0 165
-160 0 c-122 0 -162 -3 -166 -13z"/>
</g>
</svg>
),



  void: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="156.000000pt" height="180.000000pt" viewBox="0 0 156.000000 180.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)">
</g>
</svg>
),

  undo: (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="42.000000pt" height="23.000000pt" viewBox="0 0 42.000000 23.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,23.000000) scale(0.050000,-0.050000)">
<path d="M350 417 c-70 -39 -134 -105 -159 -164 l-25 -56 -25 61 c-28 66 -36
71 -78 44 -23 -15 -22 -33 5 -117 62 -185 77 -190 304 -104 72 27 42 101 -34
86 -75 -15 -75 14 0 97 116 130 298 67 345 -119 30 -119 131 -123 121 -5 -21
227 -269 379 -454 277z"/>
</g>
</svg>
),


  lockedPadlock2: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="393.000000pt" height="519.000000pt" viewBox="0 0 393.000000 519.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,519.000000) scale(0.050000,-0.050000)">
<path d="M3580 10298 c-1141 -127 -2123 -926 -2490 -2025 -124 -370 -150 -584
-150 -1226 l0 -567 -339 0 c-377 0 -423 -10 -481 -105 -46 -74 -64 -5361 -20
-5596 65 -340 340 -616 678 -679 148 -27 6137 -27 6283 0 340 65 616 340 679
678 44 238 26 5523 -20 5597 -58 95 -104 105 -481 105 l-339 0 0 567 c0 483
-6 599 -41 795 -281 1564 -1706 2632 -3279 2456z m806 -1327 c479 -140 848
-452 1063 -898 150 -310 156 -348 166 -1008 l8 -585 -1703 0 -1703 0 8 585
c10 660 16 698 166 1008 360 747 1209 1129 1995 898z m-226 -4235 c609 -183
813 -975 363 -1413 l-98 -96 69 -625 c97 -869 138 -812 -574 -812 -712 0 -671
-57 -574 812 l69 625 -98 96 c-615 599 18 1660 843 1413z"/>
</g>
</svg>
),

  lockedPadlock: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="243.000000pt" height="258.000000pt" viewBox="0 0 243.000000 258.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,258.000000) scale(0.100000,-0.100000)">
<path d="M1309 2493 c-120 -52 -167 -83 -238 -153 -44 -43 -86 -97 -100 -125
-13 -28 -30 -62 -38 -77 -7 -14 -13 -35 -13 -46 0 -11 -7 -33 -15 -48 -12 -24
-15 -78 -15 -290 l0 -262 -45 -6 c-24 -4 -47 -11 -50 -17 -4 -5 -13 -9 -21 -9
-25 0 -92 -60 -127 -114 l-32 -51 0 -530 0 -530 24 -43 c30 -55 68 -93 123
-123 l43 -24 685 0 c664 0 686 1 720 20 51 29 107 83 133 130 l22 40 0 531 0
532 -37 54 c-21 30 -52 65 -70 79 -32 24 -117 57 -149 58 -15 1 -17 29 -20
276 -3 202 -7 277 -16 287 -7 6 -13 24 -13 38 0 14 -7 35 -15 46 -8 10 -15 27
-15 36 0 9 -6 23 -14 30 -7 8 -17 25 -21 38 -9 28 -145 166 -178 180 -12 6
-40 21 -62 35 -22 13 -49 24 -60 25 -11 0 -29 7 -40 16 -28 21 -296 19 -346
-3z m301 -63 c50 -14 107 -36 130 -51 8 -5 22 -12 31 -15 27 -9 160 -153 171
-184 5 -17 14 -30 19 -30 5 0 9 -8 9 -17 0 -10 8 -31 17 -48 14 -26 17 -68 17
-310 l1 -280 -85 0 -85 0 -6 265 c-5 254 -6 267 -29 310 -75 143 -248 226
-387 185 -32 -9 -65 -21 -73 -26 -8 -5 -24 -13 -35 -18 -32 -14 -99 -92 -122
-141 -37 -80 -43 -133 -43 -361 l0 -220 -82 3 -83 3 0 280 c0 249 2 283 18
305 9 13 17 34 17 46 0 12 7 27 15 34 8 7 15 17 15 22 0 15 59 89 94 118 16
14 37 32 46 40 24 21 51 38 80 50 14 6 33 15 42 20 10 6 26 10 35 11 10 0 34
6 53 14 41 16 155 14 220 -5z m12 -276 c20 -13 52 -40 70 -59 58 -65 62 -85
65 -357 l4 -248 -271 0 -270 0 0 249 c0 138 4 252 9 255 5 3 12 18 15 32 4 15
13 33 21 41 8 8 20 22 27 32 22 31 102 79 138 84 67 9 153 -4 192 -29z m573
-768 c40 -26 61 -52 85 -105 19 -42 20 -66 20 -527 0 -271 -4 -485 -9 -488 -5
-3 -12 -17 -15 -31 -8 -33 -67 -92 -100 -101 -14 -3 -29 -10 -32 -15 -3 -5
-284 -9 -649 -9 -593 0 -647 1 -682 18 -42 19 -103 75 -103 95 0 7 -7 22 -15
33 -12 16 -14 93 -15 500 0 460 1 483 20 525 30 67 72 108 125 122 11 3 317 4
680 4 634 -2 661 -3 690 -21z"/>
<path d="M1388 1130 c-26 -16 -55 -42 -65 -57 -10 -16 -24 -34 -31 -42 -10
-10 -13 -37 -10 -95 3 -73 6 -86 36 -127 36 -50 37 -79 6 -162 -8 -20 -14 -49
-14 -63 0 -13 -7 -35 -16 -48 -10 -16 -14 -41 -12 -73 l3 -48 203 -3 c232 -3
223 -7 203 87 -6 31 -15 75 -20 98 -4 23 -12 48 -18 55 -6 7 -14 38 -17 68 -6
51 -5 58 19 85 37 42 45 67 45 145 0 48 -5 73 -15 84 -8 8 -15 19 -15 23 0 15
-52 58 -98 81 -62 32 -125 29 -184 -8z m192 -82 c63 -46 64 -141 3 -209 -34
-37 -35 -42 -30 -93 3 -29 10 -62 15 -72 15 -30 34 -106 36 -144 l1 -35 -115
0 -115 0 -3 28 c-2 16 1 34 6 40 6 7 13 30 17 52 4 22 13 57 21 78 23 60 18
110 -12 138 -27 25 -64 89 -64 111 0 43 61 119 105 131 37 10 105 -2 135 -25z"/>
</g>
</svg>
),

  openPadlock: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="243.000000pt" height="258.000000pt" viewBox="0 0 243.000000 258.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,258.000000) scale(0.100000,-0.100000)">
<path d="M470 2495 c-7 -8 -21 -15 -31 -15 -41 0 -146 -67 -219 -140 -71 -71
-140 -180 -140 -222 0 -8 -6 -20 -12 -26 -17 -17 -25 -379 -10 -394 13 -13
263 -11 298 2 24 9 24 10 24 160 l0 151 33 50 c18 29 55 65 86 86 52 35 58 36
140 37 76 0 91 -3 126 -26 133 -85 148 -132 143 -447 l-3 -215 -45 -11 c-25
-7 -62 -19 -83 -28 -45 -19 -115 -91 -124 -127 -3 -14 -11 -31 -17 -39 -8 -10
-11 -165 -11 -525 l0 -511 23 -49 c26 -54 87 -116 141 -143 34 -17 84 -18 721
-18 l685 0 36 22 c45 28 129 117 129 136 0 8 7 28 15 43 13 25 15 103 15 514
0 480 0 485 -22 540 -13 30 -26 57 -30 58 -5 2 -8 9 -8 15 0 17 -71 77 -100
84 -14 3 -31 11 -39 17 -10 8 -160 13 -480 16 l-466 5 -6 250 c-7 289 -17 353
-72 458 -40 76 -173 217 -205 217 -6 0 -12 4 -14 8 -5 12 -86 52 -106 52 -9 0
-26 7 -36 15 -29 22 -318 22 -336 0z m280 -64 c64 -17 111 -35 140 -52 8 -5
24 -13 36 -18 68 -30 191 -200 209 -288 4 -18 11 -35 16 -38 5 -4 9 -122 9
-276 l0 -269 -90 0 -90 0 0 256 c0 273 1 264 -54 362 -20 36 -77 91 -111 108
-49 25 -145 54 -179 54 -17 -1 -49 -7 -71 -15 -22 -8 -46 -15 -53 -15 -14 0
-63 -32 -106 -70 -75 -66 -116 -178 -116 -316 l0 -94 -78 0 c-47 0 -83 5 -90
12 -29 29 -5 263 34 340 8 14 14 31 14 37 0 14 59 99 93 133 37 37 133 108
147 108 6 0 21 5 33 12 38 21 140 46 192 46 28 1 79 -7 115 -17z m1472 -1054
c20 -16 46 -44 57 -63 20 -34 21 -49 21 -556 l0 -521 -35 -43 c-21 -25 -56
-52 -82 -64 -44 -19 -64 -20 -678 -20 -610 0 -634 1 -676 20 -53 24 -79 45
-105 85 -18 28 -19 55 -22 505 -2 261 0 498 3 527 5 45 13 58 56 102 34 34 61
51 82 54 18 2 327 4 687 3 l655 -1 37 -28z"/>
<path d="M1454 1145 c-10 -8 -27 -15 -36 -15 -28 0 -89 -61 -109 -108 -20 -47
-26 -137 -9 -147 6 -3 10 -15 10 -25 0 -11 14 -35 30 -53 34 -39 36 -53 15
-93 -8 -16 -15 -43 -15 -60 0 -16 -5 -35 -10 -40 -6 -6 -15 -35 -21 -65 -5
-30 -13 -67 -16 -83 -4 -18 -1 -31 8 -37 8 -5 100 -9 206 -9 156 0 194 3 206
15 15 15 12 50 -4 61 -5 3 -9 20 -9 37 0 18 -7 45 -15 61 -8 15 -15 39 -15 51
0 12 -7 45 -16 73 -16 50 -16 51 8 84 63 85 82 155 53 194 -8 10 -15 26 -15
35 0 20 -68 99 -84 99 -6 0 -28 9 -49 20 -44 24 -86 26 -113 5z m149 -112 c35
-34 37 -40 37 -97 0 -59 -2 -63 -45 -109 -26 -26 -44 -51 -43 -55 28 -58 60
-186 62 -248 l1 -39 -100 -3 c-119 -3 -143 7 -126 51 6 16 11 41 11 56 0 15 5
32 12 39 10 10 19 47 34 137 4 25 -1 36 -34 68 -63 60 -64 140 -3 202 31 33
38 35 96 35 58 0 64 -2 98 -37z"/>
</g>
</svg>
),

  arrowUp: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="84.000000pt" height="57.000000pt" viewBox="0 0 84.000000 57.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,57.000000) scale(0.050000,-0.050000)">
<path d="M680 1087 c0 -7 32 -70 70 -139 l70 -125 -115 -69 c-63 -38 -243
-143 -400 -233 -157 -90 -285 -169 -285 -175 0 -29 171 -306 189 -306 12 0
197 102 412 226 l391 226 75 -126 c41 -69 84 -126 95 -126 11 0 15 9 8 20 -7
11 -3 20 8 20 12 0 27 23 34 50 7 28 20 50 29 50 9 0 28 32 42 70 14 39 31 70
38 70 15 0 67 104 62 125 -1 8 5 15 14 15 15 0 55 70 60 106 1 8 15 29 32 46
17 17 31 44 31 59 0 16 9 29 20 29 10 0 25 23 32 50 7 28 20 50 28 50 9 0 13
16 10 35 -4 19 -8 42 -8 50 -2 18 -942 20 -942 2z"/>
</g>
</svg>

),

  arrowDown: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="84.000000pt" height="57.000000pt" viewBox="0 0 84.000000 57.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,57.000000) scale(0.050000,-0.050000)">
<path d="M104 952 c-46 -81 -84 -152 -84 -158 0 -6 128 -85 285 -175 157 -90
337 -195 400 -233 l115 -69 -70 -125 c-38 -69 -70 -132 -70 -139 0 -18 940
-16 942 2 0 8 4 31 8 50 3 19 -1 35 -10 35 -8 0 -21 23 -28 50 -7 28 -22 50
-32 50 -11 0 -20 13 -20 29 0 15 -14 42 -31 59 -17 17 -29 33 -28 36 7 15 -49
116 -64 116 -9 0 -15 7 -14 15 5 21 -47 125 -62 125 -7 0 -24 32 -38 70 -14
39 -33 70 -42 70 -9 0 -22 23 -29 50 -7 28 -22 50 -34 50 -11 0 -15 9 -8 20 7
11 3 20 -8 20 -11 0 -54 -57 -95 -126 l-75 -126 -391 226 c-464 268 -414 260
-517 78z"/>
</g>
</svg>
),

  disk: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="471.000000pt" height="471.000000pt" viewBox="0 0 471.000000 471.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,471.000000) scale(0.100000,-0.100000)">
<path d="M2095 4655 c-38 -7 -85 -14 -104 -14 -43 -1 -239 -46 -316 -72 -16
-6 -43 -14 -60 -19 -16 -4 -41 -12 -55 -18 -14 -5 -45 -18 -70 -27 -269 -105
-570 -304 -785 -520 -216 -215 -415 -516 -520 -785 -9 -25 -22 -56 -27 -70 -6
-14 -14 -38 -18 -55 -5 -16 -13 -43 -19 -60 -25 -74 -71 -273 -71 -311 0 -16
-7 -65 -15 -109 -19 -106 -19 -394 0 -500 8 -44 15 -93 15 -109 0 -38 46 -237
71 -311 6 -16 14 -43 19 -60 4 -16 12 -41 18 -55 5 -14 18 -45 27 -70 30 -76
144 -302 186 -369 80 -127 225 -308 334 -416 215 -216 512 -413 785 -520 25
-9 56 -22 70 -27 14 -6 39 -14 55 -18 17 -5 44 -13 60 -19 74 -25 273 -71 311
-71 16 0 65 -7 109 -15 106 -19 394 -19 500 0 44 8 93 15 109 15 38 0 237 46
311 71 17 6 44 14 60 19 17 4 41 12 55 18 14 5 45 18 70 27 180 71 374 183
553 317 322 243 605 614 752 988 9 25 22 56 27 70 6 14 14 39 18 55 5 17 13
44 19 60 25 74 71 273 71 311 0 16 7 65 15 109 19 106 19 394 0 500 -8 44 -15
93 -15 109 0 38 -46 237 -71 311 -6 17 -14 44 -19 60 -4 17 -12 41 -18 55 -5
14 -18 45 -27 70 -107 273 -304 570 -520 785 -108 109 -289 254 -416 334 -67
42 -293 156 -369 186 -25 9 -56 22 -70 27 -14 6 -38 14 -55 18 -16 5 -43 13
-60 19 -74 25 -273 71 -311 71 -16 0 -65 7 -109 15 -102 18 -403 18 -500 0z"/>
</g>
</svg>
),

  filmStrip: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="225.000000pt" viewBox="0 0 300.000000 225.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
	preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,225.000000) scale(0.050000,-0.050000)">
<path d="M2500 4468 c-1393 -169 -2665 -1691 -2438 -2917 46 -249 188 -480
386 -625 163 -120 422 -225 556 -226 45 0 64 -19 120 -125 370 -698 1478 -733
2394 -74 l167 121 154 -80 c612 -319 1223 -187 1702 368 204 237 460 697 413
743 -13 12 -181 164 -374 337 -192 173 -371 337 -396 364 -57 62 -51 70 -103
-132 -139 -542 -426 -970 -783 -1169 -223 -124 -267 -102 -119 60 662 724 828
1791 363 2329 -151 175 -506 357 -696 358 -58 0 -70 12 -129 125 -204 387
-695 606 -1217 543z m368 -169 c1001 -144 795 -1656 -356 -2614 -1226 -1022
-2504 -785 -2294 423 208 1193 1599 2343 2650 2191z m784 -624 c381 -1279
-1459 -3113 -2783 -2775 -150 39 -276 103 -139 71 1212 -283 2949 1259 2885
2559 -6 110 -17 216 -25 235 -8 19 -6 35 5 35 11 0 36 -56 57 -125z m403 -116
c546 -273 550 -1049 10 -1879 -143 -218 -145 -199 -33 232 136 521 147 580
147 778 1 283 -80 506 -240 667 -51 51 -80 102 -94 168 l-20 95 54 0 c30 0
109 -27 176 -61z m-146 -404 c63 -97 152 -461 120 -493 -39 -39 -223 206 -207
275 9 40 17 116 18 168 0 104 23 120 69 50z m701 -183 c129 -477 -81 -1156
-535 -1728 -108 -136 -124 -138 -143 -14 -12 75 -5 89 103 224 400 497 603
1115 520 1582 -24 130 15 85 55 -64z m-664 -752 c-29 -115 -54 -212 -56 -215
-5 -6 -350 175 -350 184 0 3 35 81 77 173 43 92 89 203 103 245 l25 78 126
-128 126 -127 -51 -210z m1555 -373 c153 -140 279 -261 279 -270 0 -23 -197
-362 -230 -395 -24 -24 -52 -7 -201 120 -95 81 -208 175 -250 208 -94 73 -94
76 -20 224 32 65 75 174 95 242 44 151 -2 169 327 -129z m-1835 73 c190 -98
187 -92 144 -270 -16 -66 -30 -150 -30 -187 0 -56 -6 -65 -35 -53 -19 8 -120
41 -223 72 -104 32 -194 63 -200 69 -14 14 140 472 156 465 8 -3 92 -46 188
-96z m-490 -315 c-26 -93 -36 -184 -32 -292 5 -154 3 -159 -55 -205 -80 -65
-81 -65 -222 75 l-124 123 94 74 c51 40 152 138 223 216 160 176 164 176 116
9z m2002 -390 l240 -205 -84 -87 c-86 -90 -248 -217 -331 -261 -42 -23 -57
-17 -160 64 -62 48 -164 127 -227 173 l-114 86 158 149 c87 82 177 180 201
217 57 92 45 97 317 -136z m-1446 25 c16 0 32 -11 36 -25 29 -113 63 -192 99
-231 58 -64 16 -88 -127 -72 -298 32 -395 108 -439 343 -24 129 -27 129 200
53 111 -38 215 -68 231 -68z m-1001 -161 c135 -137 140 -125 -81 -217 -237
-99 -241 -100 -342 0 -108 106 -109 99 14 157 57 27 140 78 185 114 105 82 85
87 224 -54z m545 -137 l43 -59 -163 -104 c-628 -403 -1292 -519 -1657 -288
-93 58 -219 167 -219 189 0 45 194 30 311 -24 396 -183 1064 -62 1509 273 111
84 122 85 176 13z m1300 -230 c220 -164 216 -176 -49 -177 -285 -2 -912 199
-687 219 115 11 345 69 420 107 53 27 76 29 100 12 16 -13 114 -85 216 -161z
m-2445 86 l79 -82 -210 8 c-281 10 -304 28 -118 97 81 31 153 56 159 57 6 1
46 -35 90 -80z m1347 -27 l67 -49 -183 -120 c-552 -362 -1116 -495 -1567 -369
-167 47 -190 88 -30 54 409 -86 1057 101 1495 432 155 117 137 112 218 52z"/>
<path d="M2795 4090 c-353 -130 -795 -700 -746 -963 49 -258 423 -151 758 216
397 435 390 894 -12 747z m181 -174 c38 -38 29 -80 -45 -228 -164 -328 -641
-707 -699 -556 -80 208 602 926 744 784z"/>
<path d="M1400 3674 c-274 -133 -625 -548 -703 -828 -120 -434 266 -463 703
-52 571 537 571 1160 0 880z m290 -146 c142 -143 -497 -908 -757 -908 -258 0
218 710 597 892 119 57 118 57 160 16z"/>
<path d="M2704 3002 c-496 -171 -1061 -967 -901 -1268 213 -399 1257 470 1265
1053 3 228 -119 300 -364 215z m232 -276 c26 -262 -610 -962 -854 -942 l-72 6
1 102 c2 359 893 1162 925 834z"/>
<path d="M1764 2886 c-182 -89 -239 -326 -80 -326 148 0 314 209 248 310 -38
58 -76 62 -168 16z"/>
<path d="M1276 2392 c-354 -126 -794 -697 -744 -964 68 -364 781 55 1000 589
123 297 5 468 -256 375z m190 -194 c84 -135 -409 -736 -647 -788 -307 -68 98
591 491 799 71 37 128 33 156 -11z"/>
</g>
</svg>
),

  star: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="286.000000pt" viewBox="0 0 300.000000 286.000000"
	preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,286.000000) scale(0.100000,-0.100000)"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
	>
<path d="M1496 2830 c-3 -8 -82 -249 -174 -535 l-169 -520 -566 -3 c-312 -1
-567 -6 -566 -10 0 -4 194 -148 432 -320 238 -172 443 -321 455 -331 l24 -18
-157 -484 c-87 -266 -166 -510 -176 -542 l-17 -57 46 34 c610 445 877 634 886
627 86 -66 899 -652 902 -649 2 3 -73 241 -167 531 -94 290 -169 532 -166 539
2 8 205 159 451 338 245 178 446 327 446 332 0 4 -253 8 -563 8 l-564 0 -142
441 c-190 586 -208 637 -215 619z m140 -792 l128 -398 420 -2 420 -3 -337
-245 c-185 -134 -337 -248 -337 -253 0 -5 56 -182 126 -394 69 -212 123 -387
120 -390 -3 -3 -154 104 -337 237 -182 132 -337 239 -343 237 -6 -3 -159 -113
-341 -245 -181 -132 -331 -240 -332 -239 -1 1 56 180 127 397 81 250 124 399
119 406 -5 6 -157 119 -338 250 l-329 239 420 5 421 5 23 70 c13 39 71 218
129 398 59 181 108 327 109 325 2 -2 61 -182 132 -400z"/>
</g>
</svg>

),

star2: (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt" height="286.000000pt" viewBox="0 0 300.000000 286.000000"
       fill="currentColor"
       stroke="none"
	   preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,286.000000) scale(0.100000,-0.100000)">
      <path d="M1496 2830 c-3 -8 -82 -249 -174 -535 l-169 -520 -566 -3 c-312 -1
-567 -6 -566 -10 0 -4 194 -148 432 -320 238 -172 443 -321 455 -331 l24 -18
-157 -484 c-87 -266 -166 -510 -176 -542 l-17 -57 46 34 c610 445 877 634 886
627 86 -66 899 -652 902 -649 2 3 -73 241 -167 531 -94 290 -169 532 -166 539
2 8 205 159 451 338 245 178 446 327 446 332 0 4 -253 8 -563 8 l-564 0 -142
441 c-190 586 -208 637 -215 619z"/>
    </g>
  </svg>
),

filledStar: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="397.000000pt" height="379.000000pt" viewBox="0 0 397.000000 379.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait  
	preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,379.000000) scale(0.100000,-0.100000)">
<path d="M1745 3065 l-230 -705 -620 -1 c-341 -1 -680 -4 -752 -8 l-133 -6 58
-44 c57 -45 527 -389 934 -685 120 -87 218 -161 218 -164 0 -4 -93 -290 -206
-637 -113 -346 -217 -665 -231 -708 -14 -43 -23 -80 -21 -82 2 -3 227 157 499
353 511 370 714 512 734 512 7 0 32 -15 56 -33 192 -147 1130 -817 1143 -817
7 0 -9 51 -126 415 -160 500 -308 974 -308 989 0 20 106 101 677 520 277 202
505 372 509 377 7 12 48 11 -775 18 l-724 6 -39 125 c-199 631 -417 1280 -430
1280 -2 0 -107 -317 -233 -705z"/>
</g>
</svg>
),

  factory: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="822.000000pt" viewBox="0 0 900.000000 822.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
	preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,822.000000) scale(0.100000,-0.100000)">
<path d="M6935 8180 c-95 -15 -209 -64 -290 -124 -58 -42 -135 -118 -146 -141
-5 -11 -13 -27 -17 -35 -5 -8 -13 -24 -19 -35 -6 -12 -24 -22 -44 -26 -89 -15
-193 -96 -298 -231 -52 -67 -53 -67 -79 -54 -39 20 -122 28 -161 17 -44 -14
-85 -53 -114 -110 -20 -41 -22 -61 -22 -191 0 -110 4 -155 16 -185 14 -34 15
-64 8 -210 -4 -93 -12 -330 -18 -525 -6 -195 -15 -458 -20 -585 -12 -259 -28
-722 -41 -1205 -5 -179 -14 -422 -19 -540 -6 -118 -13 -341 -16 -495 -6 -280
-9 -315 -25 -315 -5 0 -32 25 -62 56 l-53 56 -5 816 -5 817 -760 5 -760 5 -7
55 c-3 30 -11 141 -18 245 -7 105 -17 196 -22 203 -6 7 -33 12 -64 12 -35 0
-54 4 -54 12 0 15 129 138 145 138 7 0 23 -8 36 -17 29 -21 51 -35 102 -62 47
-26 199 -54 252 -46 81 12 150 29 164 39 7 5 63 11 125 12 94 1 121 6 181 29
39 15 80 29 92 32 12 3 28 11 34 19 6 8 16 14 21 14 19 0 166 120 244 199 84
85 135 168 136 221 1 42 -26 76 -81 104 -48 25 -48 25 -55 86 -28 247 -328
450 -573 388 -54 -13 -122 -49 -148 -78 -26 -28 -41 -25 -85 19 -50 49 -99 74
-177 91 -163 34 -342 -62 -431 -230 -16 -30 -32 -72 -36 -92 -8 -43 -31 -55
-70 -37 -66 30 -203 -34 -297 -140 -78 -87 -103 -147 -107 -260 -5 -129 23
-231 100 -359 21 -34 38 -67 38 -72 0 -5 -44 -11 -97 -12 l-98 -3 -6 -70 c-3
-38 -11 -162 -18 -275 -6 -113 -16 -266 -21 -340 -6 -74 -15 -240 -20 -370 -6
-130 -14 -270 -20 -311 -5 -41 -10 -117 -10 -169 0 -52 -5 -156 -10 -230 -6
-74 -15 -223 -20 -330 -5 -107 -13 -276 -19 -375 -6 -99 -18 -304 -26 -455 -9
-151 -22 -372 -30 -490 -8 -118 -17 -289 -20 -380 -3 -91 -10 -205 -15 -255
-5 -49 -10 -145 -10 -212 0 -137 -8 -170 -44 -179 -41 -10 -62 4 -90 59 -38
71 -84 156 -136 252 -24 44 -50 92 -58 107 -11 23 -13 145 -13 675 1 779 -2
815 -86 950 -46 74 -96 126 -161 169 -31 21 -59 39 -62 41 -3 3 -7 145 -10
316 -5 297 -6 315 -28 369 -69 172 -214 297 -387 334 -43 10 -164 13 -427 14
-425 0 -457 -4 -591 -76 -50 -27 -146 -125 -179 -182 -69 -119 -70 -129 -77
-442 l-6 -285 -45 -14 c-213 -67 -359 -224 -396 -426 -10 -53 -13 -258 -13
-845 0 -808 2 -846 44 -959 21 -57 15 -61 -106 -61 -79 0 -98 -3 -103 -16 -3
-9 -6 -229 -6 -489 0 -379 3 -476 13 -487 11 -11 708 -12 4023 -8 l4009 5 0
495 0 495 -112 5 c-61 3 -114 7 -116 10 -6 7 -27 186 -37 329 -5 63 -13 160
-19 215 -6 56 -17 182 -26 281 -8 99 -20 223 -25 275 -6 52 -15 157 -20 233
-16 218 -10 204 -152 337 -67 63 -163 154 -212 201 l-89 86 -8 164 c-5 90 -13
326 -19 524 -5 198 -14 486 -20 640 -13 393 -38 1108 -50 1440 -6 154 -15 442
-21 640 -6 198 -15 367 -20 377 -5 10 -19 18 -30 18 -11 0 -22 7 -25 15 -10
24 15 45 55 45 47 1 138 23 179 44 17 9 47 32 67 51 19 19 39 35 45 35 6 0 27
-11 48 -23 69 -44 132 -62 212 -61 89 0 131 19 203 88 27 25 52 46 56 46 5 0
28 -15 52 -33 164 -124 365 -134 625 -31 119 47 193 102 260 194 125 173 140
403 38 586 -115 206 -345 268 -579 155 -46 -23 -90 -41 -98 -41 -7 0 -24 11
-37 25 -26 27 -81 58 -122 68 -15 4 -37 22 -49 40 -35 50 -90 107 -132 134
-54 34 -150 63 -211 63 -77 0 -197 -37 -277 -86 -36 -23 -59 -19 -84 12 -5 7
-38 27 -72 44 -53 26 -77 31 -155 35 -51 2 -115 0 -143 -5z m187 -81 c68 -14
112 -41 167 -101 24 -26 52 -48 62 -48 10 0 30 16 44 34 45 59 165 106 270
106 80 0 151 -26 208 -75 33 -29 34 -43 5 -49 -153 -32 -210 -51 -284 -92
-118 -65 -212 -157 -251 -245 -15 -34 -21 -39 -62 -45 -25 -4 -68 -21 -96 -39
-46 -30 -172 -155 -221 -221 l-20 -27 -49 16 c-70 24 -121 22 -172 -8 -23 -14
-43 -30 -43 -36 0 -5 -11 -15 -25 -21 -21 -9 -30 -7 -64 15 -21 14 -47 43 -57
64 -17 33 -23 38 -54 38 l-35 0 -3 -60 c-4 -68 -21 -94 -86 -127 -34 -17 -54
-20 -140 -17 l-101 4 -6 -46 c-4 -25 -14 -60 -23 -77 l-17 -32 -93 0 c-90 0
-94 1 -111 26 -43 66 -57 258 -27 348 30 86 89 109 176 67 23 -12 51 -21 62
-21 21 0 69 46 124 120 54 71 71 89 134 136 71 54 104 57 153 14 39 -34 46
-36 67 -14 20 19 20 44 1 70 -20 26 -19 48 5 93 49 97 233 216 376 245 89 18
121 18 186 5z m907 -236 c43 -14 70 -31 114 -75 69 -68 107 -77 131 -30 19 36
110 81 199 98 168 32 313 -55 378 -228 27 -74 30 -239 4 -302 -66 -160 -143
-234 -310 -299 -107 -42 -152 -51 -260 -51 -95 -1 -118 2 -165 23 -75 32 -136
78 -150 111 -11 26 -46 50 -75 50 -7 0 -24 -21 -36 -47 -35 -72 -98 -128 -156
-139 -104 -21 -254 42 -290 121 -20 44 -46 55 -84 35 -18 -10 -21 -18 -16 -52
9 -67 -20 -106 -103 -135 -45 -16 -145 -17 -170 -1 -32 20 -54 -1 -61 -58 -11
-93 -17 -97 -149 -92 l-84 3 -17 45 c-32 83 -43 182 -29 252 18 94 19 95 51
128 37 37 57 37 137 3 74 -31 92 -26 141 41 16 22 40 53 53 67 13 14 37 41 53
60 52 58 113 101 153 106 31 4 44 0 70 -22 23 -19 39 -25 56 -21 34 8 38 28
15 73 -16 32 -18 42 -7 68 55 138 301 282 487 284 35 1 89 -7 120 -16z m-1445
-694 l31 -19 1 -122 c0 -90 6 -138 19 -181 18 -54 18 -72 6 -320 -7 -144 -16
-426 -21 -626 -5 -200 -12 -387 -15 -415 -3 -28 -10 -208 -15 -401 -11 -448
-27 -925 -41 -1230 -6 -132 -14 -381 -19 -554 -5 -173 -12 -316 -14 -318 -7
-8 -31 9 -87 62 l-54 50 -12 265 c-6 146 -12 326 -12 400 -1 74 -5 212 -11
305 -6 94 -15 332 -20 530 -10 368 -18 593 -45 1350 -8 237 -20 566 -25 733
-6 167 -13 309 -17 317 -3 8 -15 15 -28 15 -13 0 -25 6 -28 14 -11 28 17 44
83 49 96 7 145 26 203 79 56 50 65 51 121 17z m-435 -254 c6 -6 11 -84 13
-180 l3 -170 -154 -3 c-85 -1 -158 1 -163 6 -14 14 3 331 18 347 17 16 267 16
283 0z m881 -235 c6 -12 9 -81 8 -182 l-3 -163 -152 -3 -152 -3 -7 27 c-10 38
5 316 18 331 7 9 48 13 144 13 123 0 134 -2 144 -20z m-2789 -110 c70 -21 113
-54 153 -118 37 -59 62 -57 141 16 98 89 182 110 295 74 153 -49 268 -159 298
-284 17 -69 16 -75 -28 -103 -46 -29 -53 -64 -18 -89 28 -20 49 -20 92 0 38
19 80 13 90 -12 20 -53 -218 -295 -360 -367 -79 -40 -247 -83 -278 -71 -8 3
-20 19 -27 36 -26 62 -109 53 -109 -12 0 -42 -44 -62 -146 -68 -97 -5 -172 14
-257 65 -59 36 -77 57 -77 93 0 11 -10 34 -22 50 -17 23 -30 30 -57 30 -65 0
-89 -51 -54 -111 l18 -29 -71 -65 c-39 -35 -83 -82 -99 -105 -27 -38 -30 -40
-82 -40 -30 0 -64 5 -76 11 -36 19 -92 86 -124 152 -55 112 -66 153 -66 256
-1 118 16 156 112 251 70 68 148 108 187 94 46 -17 74 -46 85 -90 12 -47 56
-94 89 -94 25 0 60 38 60 65 0 12 -18 49 -41 83 l-41 61 17 57 c39 134 124
227 242 264 74 24 78 24 154 0z m1933 -237 c5 -72 6 -143 2 -157 l-6 -26 -158
0 c-106 0 -162 4 -169 11 -9 9 -10 52 -7 148 3 75 7 142 10 149 3 10 40 12
161 10 l158 -3 9 -132z m870 -110 c2 -10 6 -79 8 -153 l3 -135 -172 -3 -173
-2 0 139 c0 77 3 146 6 155 5 14 29 16 164 16 143 0 159 -2 164 -17z m-871
-171 c23 -26 38 -409 16 -423 -18 -11 -349 -12 -367 0 -21 13 -6 399 16 424
13 15 35 17 167 17 134 0 154 -2 168 -18z m886 -226 c8 -9 11 -77 9 -222 l-3
-209 -165 -3 c-91 -1 -176 0 -189 3 l-24 6 6 203 c4 112 9 210 13 220 5 14 27
16 174 16 130 0 170 -3 179 -14z m-864 -297 c4 -6 10 -76 13 -156 4 -118 2
-147 -9 -154 -8 -5 -96 -9 -195 -9 -146 0 -184 3 -194 14 -8 11 -10 53 -4 158
3 79 9 146 11 151 7 12 371 9 378 -4z m-2343 -163 c15 -15 45 -336 33 -356 -4
-6 -106 -10 -296 -10 -256 0 -290 2 -296 16 -10 26 15 334 28 350 17 20 511
21 531 0z m3215 -68 c6 -7 14 -77 17 -155 l7 -142 -23 -6 c-13 -3 -104 -4
-203 -3 l-180 3 -3 144 c-2 97 1 148 9 157 16 19 361 20 376 2z m-857 -183 c9
-11 13 -72 14 -217 l1 -203 -220 0 -220 0 3 205 c2 126 7 209 14 217 17 20
391 18 408 -2z m-2316 -268 c17 -183 18 -227 6 -242 -11 -13 -58 -15 -316 -15
-279 0 -304 1 -312 18 -12 23 10 291 25 300 6 4 141 6 301 4 l290 -3 6 -62z
m3196 43 c5 -8 10 -108 10 -222 l0 -208 -214 0 c-159 0 -216 3 -223 13 -13 16
3 391 18 418 10 19 19 20 205 17 160 -2 196 -6 204 -18z m-1672 -1957 l-3
-1918 -595 -2 c-354 -2 -601 1 -610 7 -11 7 -16 46 -21 177 -4 92 -10 187 -13
210 -7 54 4 61 89 65 l70 3 3 749 c2 593 0 751 -10 758 -7 4 -61 8 -119 8 -74
0 -110 4 -117 13 -12 14 -18 178 -8 196 5 7 49 11 126 11 65 0 125 3 134 6 14
6 16 81 16 754 0 673 -2 748 -16 754 -9 3 -91 6 -184 6 l-167 0 -7 50 c-4 28
-4 55 -1 60 4 6 271 10 721 10 l714 0 -2 -1917z m-1140 1574 l3 -127 -26 -10
c-35 -13 -161 -13 -186 0 -17 10 -19 22 -19 134 0 67 3 126 7 130 4 3 54 5
112 4 l106 -3 3 -128z m1956 51 c13 -107 14 -257 1 -268 -8 -7 -91 -9 -236 -8
l-224 3 1 142 c1 78 4 149 7 157 6 14 36 16 226 16 l220 0 5 -42z m-2320 -70
c9 -45 27 -409 21 -418 -10 -16 -680 -13 -692 3 -8 11 12 389 23 425 3 9 76
12 323 12 l321 0 4 -22z m3190 -127 c3 -5 9 -72 12 -151 6 -116 5 -143 -7
-151 -22 -14 -446 -12 -455 2 -8 13 -6 288 2 301 7 11 441 10 448 -1z m-2836
-93 c17 -17 17 -229 0 -246 -13 -13 -173 -17 -202 -6 -13 5 -16 26 -16 129 0
89 3 125 13 128 26 11 193 7 205 -5z m-2337 -70 c132 -46 240 -148 294 -278
17 -39 19 -80 23 -318 4 -289 1 -309 -41 -296 -11 3 -52 9 -91 13 l-71 6 -6
180 c-5 152 -10 188 -28 234 -43 107 -116 186 -211 227 -40 17 -69 19 -310 19
-241 0 -270 -2 -310 -19 -95 -41 -168 -120 -211 -227 -18 -46 -22 -83 -28
-244 l-6 -190 -25 1 c-14 1 -61 6 -105 10 l-80 9 -3 205 c-5 326 17 424 124
539 60 65 130 107 224 132 58 17 104 18 440 16 312 -3 383 -6 421 -19z m4317
-25 c3 -10 7 -108 7 -218 l0 -200 -250 0 -250 0 1 200 c0 111 3 209 7 218 6
15 29 17 242 17 215 0 236 -2 243 -17z m-2309 -212 c11 -17 25 -286 16 -300
-8 -13 -713 -15 -733 -2 -11 6 -11 26 -3 104 6 53 11 121 11 151 0 34 5 56 13
60 6 2 164 4 350 3 273 -2 339 -5 346 -16z m3185 -8 c2 -10 6 -108 8 -218 l3
-200 -253 -3 c-206 -2 -253 0 -258 11 -7 18 12 387 21 410 7 15 27 17 240 17
214 0 234 -1 239 -17z m-2852 -41 c5 -5 7 -65 6 -133 l-3 -124 -110 0 -110 0
-3 128 c-2 119 -1 128 17 135 27 10 192 5 203 -6z m-2511 -22 c47 -13 113 -70
146 -127 36 -62 52 -154 53 -304 0 -141 -5 -153 -71 -165 -108 -22 -276 -162
-333 -279 -55 -113 -56 -130 -56 -992 0 -869 1 -850 -57 -735 -16 31 -48 91
-71 134 l-42 76 0 641 c0 429 -4 666 -11 718 -22 144 -101 273 -222 359 -29
21 -58 44 -64 53 -9 10 -13 58 -13 157 0 144 17 271 42 316 42 74 110 137 164
151 37 9 499 7 535 -3z m4497 -237 c6 -10 11 -81 13 -158 l4 -140 -265 0 -265
0 -3 131 c-1 72 2 143 7 158 l11 26 244 0 c223 0 246 -2 254 -17z m-2284 -125
c3 -18 7 -114 10 -214 4 -132 3 -183 -6 -192 -9 -9 -111 -12 -389 -12 -337 0
-379 2 -394 16 -10 11 -14 25 -11 38 4 12 9 95 12 186 3 91 7 175 10 188 l4
22 380 0 379 0 5 -32z m304 -78 c4 -158 10 -150 -103 -150 -51 0 -96 4 -99 8
-2 4 -8 63 -12 130 l-7 123 109 -3 109 -3 3 -105z m2859 -22 c8 -14 21 -262
15 -290 -3 -12 -14 -18 -33 -18 -23 0 -49 19 -121 88 -145 136 -179 167 -186
165 -4 -2 -9 -58 -12 -125 l-5 -123 -84 -3 c-58 -2 -87 1 -92 9 -7 12 -1 271
6 297 3 9 63 12 254 12 189 0 252 -3 258 -12z m-1052 -177 c7 -12 -12 -493
-21 -515 -11 -30 -31 -16 -115 82 -46 53 -100 115 -121 137 -20 22 -53 58 -73
80 l-37 40 6 83 c3 45 8 87 11 92 8 13 342 13 350 1z m199 -13 c8 -13 7 -21
-2 -30 -9 -9 -17 -7 -37 12 -13 12 -22 27 -19 32 9 14 46 5 58 -14z m-5368
-27 c86 -28 118 -47 183 -107 106 -98 144 -206 139 -389 l-3 -110 -460 -3
c-253 -1 -470 0 -482 3 -22 5 -23 9 -23 120 0 182 38 284 141 380 99 91 188
124 340 125 79 0 122 -5 165 -19z m1322 0 c100 -32 171 -83 230 -165 72 -98
95 -187 90 -346 l-3 -105 -479 -3 c-377 -2 -481 0 -488 10 -4 7 -8 55 -8 107
0 98 19 200 48 261 47 97 151 193 246 229 28 10 58 21 66 24 8 3 65 6 126 6
84 1 126 -4 172 -18z m4927 -276 c83 -78 188 -177 235 -221 47 -43 111 -104
144 -135 l59 -56 7 -129 c5 -71 11 -140 14 -154 4 -14 11 -83 16 -155 12 -174
24 -304 76 -835 9 -91 14 -181 13 -200 l-4 -35 -1105 0 -1105 0 0 480 c1 491
22 1626 31 1635 6 5 23 -13 154 -159 41 -46 80 -89 85 -95 6 -6 44 -49 85 -96
41 -47 90 -102 110 -124 59 -64 74 -81 108 -120 18 -20 37 -34 42 -31 6 3 10
31 10 62 0 31 7 147 15 257 8 111 16 228 17 261 2 36 7 60 14 60 7 0 43 -29
81 -65 108 -100 397 -375 504 -477 52 -51 101 -93 107 -93 9 0 12 81 12 328 0
181 3 332 7 335 7 7 27 -11 268 -238z m-3175 85 c12 -7 15 -37 15 -157 l0
-148 -417 -3 c-331 -2 -418 0 -419 10 -5 63 5 286 13 296 13 15 784 18 808 2z
m2810 -140 c5 -155 4 -170 -13 -170 -7 0 -51 39 -99 87 l-88 88 0 60 c0 35 5
66 12 73 9 9 40 12 98 10 l85 -3 5 -145z m-2550 -109 c4 -88 2 -128 -7 -136
-15 -16 -124 -10 -135 7 -10 16 -11 242 -1 252 4 4 37 6 73 4 l65 -3 5 -124z
m-233 -172 c8 -17 15 -98 20 -219 5 -159 4 -193 -8 -201 -8 -5 -208 -9 -445
-9 -334 0 -434 3 -441 13 -8 10 -6 122 6 399 1 9 8 24 17 32 14 14 63 16 427
14 l412 -3 12 -26z m231 -196 l3 -133 -55 0 c-30 0 -57 4 -60 8 -2 4 -9 61
-16 127 -12 137 -13 136 70 133 l55 -3 3 -132z m-3014 106 c7 -7 9 -800 1
-807 -3 -3 -13 5 -23 19 -19 27 -19 27 -92 164 -29 55 -65 123 -80 150 -15 28
-41 76 -59 108 -17 31 -45 83 -62 115 -18 31 -45 82 -62 112 -16 30 -38 70
-49 88 -16 27 -18 35 -7 48 10 13 43 15 220 12 114 -2 210 -6 213 -9z m-544
-14 c14 -16 52 -84 96 -170 32 -63 139 -261 196 -363 25 -46 23 -59 -13 -66
-52 -10 -339 -7 -360 4 -16 9 -56 86 -265 515 -19 39 -34 76 -34 83 0 9 44 12
184 12 153 0 186 -3 196 -15z m1301 -16 c11 -11 27 -35 35 -52 14 -31 34 -68
118 -222 70 -127 93 -169 130 -238 21 -37 34 -72 31 -77 -7 -12 -384 -14 -401
-2 -6 4 -50 88 -99 187 -48 99 -112 230 -142 292 -30 62 -52 117 -48 123 4 6
71 10 181 10 163 0 175 -1 195 -21z m567 -409 c2 -417 2 -424 -17 -405 -10 11
-38 56 -61 100 -24 44 -52 96 -63 115 -11 19 -41 76 -67 125 -27 50 -60 110
-74 135 -13 25 -36 68 -50 95 -33 63 -93 173 -112 202 -8 12 -14 32 -14 43 0
20 4 20 228 18 l227 -3 3 -425z m-2238 207 c0 -4 46 -101 101 -215 56 -114
143 -292 194 -397 51 -104 141 -288 199 -409 59 -120 105 -224 102 -232 -4
-12 -54 -14 -279 -14 -303 0 -285 -4 -322 69 -43 84 -45 116 -45 683 0 299 0
552 0 563 0 17 3 16 25 -10 13 -16 24 -34 25 -38z m1307 -29 c12 -24 69 -142
128 -263 183 -376 304 -624 382 -782 41 -84 73 -160 71 -170 -3 -17 -23 -18
-262 -21 -290 -3 -279 -5 -315 72 -49 108 -51 129 -51 673 0 281 3 518 6 527
8 22 16 15 41 -36z m2625 -78 c2 -5 2 -66 0 -135 l-3 -125 -44 0 c-24 0 -46 4
-49 8 -8 13 -26 244 -20 253 7 12 112 11 116 -1z m-201 -114 c5 -16 9 -88 11
-160 l3 -131 -475 0 -475 0 2 141 c0 84 6 151 12 163 12 21 12 21 463 19 l452
-3 7 -29z m197 -368 l-3 -133 -26 -3 c-50 -6 -59 17 -59 149 l0 119 45 0 46 0
-3 -132z m-3169 93 c12 -16 21 -32 21 -35 0 -3 14 -28 30 -56 50 -85 59 -81
-182 -78 l-213 3 -43 85 c-23 47 -40 91 -37 97 3 10 53 13 204 13 l200 0 20
-29z m1314 -31 c39 -69 79 -151 75 -155 -7 -7 -394 -13 -411 -6 -20 7 -109
180 -100 194 2 4 97 6 210 5 l206 -3 20 -35z m1675 -82 c10 -14 16 -91 32
-422 7 -151 7 -213 -1 -223 -9 -10 -107 -13 -508 -13 -273 0 -502 4 -509 8
-10 7 -11 58 -2 268 12 288 18 363 33 382 7 9 115 12 477 12 362 0 470 -3 478
-12z m-2824 -190 c62 -110 76 -142 64 -155 -13 -16 -388 -19 -417 -3 -22 11
-105 176 -96 190 4 6 88 10 215 10 l209 0 25 -42z m1309 -26 c14 -27 35 -65
46 -85 39 -69 45 -67 -193 -67 l-215 0 -18 28 c-27 39 -73 138 -73 156 0 14
27 16 214 16 l214 0 25 -48z m-1177 -230 c21 -14 106 -184 97 -193 -5 -5 -103
-8 -229 -7 l-219 3 -47 90 c-33 65 -43 93 -36 102 8 10 64 13 217 13 113 0
211 -4 217 -8z m1300 -10 c6 -4 28 -38 49 -77 21 -38 42 -76 48 -82 5 -7 7
-20 3 -28 -4 -13 -38 -15 -219 -15 -155 0 -218 3 -229 13 -24 18 -92 163 -85
181 6 14 35 16 214 16 114 0 213 -4 219 -8z m5289 -702 l0 -415 -3930 0 -3930
0 -3 409 c-2 321 0 411 10 418 7 4 1777 7 3933 5 l3920 -2 0 -415z"/>
<path d="M4552 4718 c-17 -17 -17 -1479 0 -1496 9 -9 99 -12 344 -12 293 0
333 2 338 16 3 9 6 348 6 754 0 664 -2 738 -16 744 -9 3 -161 6 -338 6 -237 0
-325 -3 -334 -12z m296 -211 l3 -127 -26 -10 c-35 -13 -161 -13 -186 0 -17 10
-19 22 -19 135 0 89 3 125 13 129 6 2 57 4 112 3 l100 -2 3 -128z m300 -1 c2
-97 -1 -131 -10 -138 -19 -11 -166 -10 -189 2 -17 10 -19 22 -19 125 0 62 3
121 6 130 5 13 22 15 108 13 l101 -3 3 -129z m-310 -238 c17 -17 17 -229 0
-246 -8 -8 -46 -12 -103 -12 -57 0 -95 4 -103 12 -17 17 -17 229 0 246 16 16
190 16 206 0z m307 -123 l0 -130 -94 -3 c-60 -2 -98 1 -107 9 -19 15 -20 229
-2 247 9 9 42 12 108 10 l95 -3 0 -130z m-303 -233 c5 -5 7 -65 6 -133 l-3
-124 -110 0 -110 0 -3 128 c-2 119 -1 128 17 135 27 10 192 5 203 -6z m301 9
c4 -1 7 -62 7 -136 l0 -135 -104 0 c-85 0 -105 3 -110 16 -3 9 -6 67 -6 129 0
88 3 116 14 122 11 6 141 8 199 4z m-295 -471 c4 -159 11 -150 -112 -150 -85
0 -105 3 -110 16 -8 22 -8 229 1 238 4 3 54 5 112 4 l106 -3 3 -105z m302 -20
l0 -130 -104 0 c-85 0 -105 3 -110 16 -8 21 -8 229 1 237 3 4 53 7 110 7 l103
0 0 -130z"/>
<path d="M4532 2982 c-10 -7 -12 -165 -10 -758 l3 -749 339 -3 c265 -2 341 1
348 10 4 7 8 344 8 748 0 559 -3 739 -12 748 -14 14 -654 17 -676 4z m292 -98
c11 -29 7 -242 -5 -250 -9 -5 -136 -8 -201 -4 -10 0 -11 254 -1 263 3 4 50 7
104 7 79 0 98 -3 103 -16z m300 10 c13 -5 16 -26 16 -129 0 -82 -4 -126 -11
-131 -14 -8 -195 -8 -209 1 -11 7 -14 247 -3 258 8 9 186 9 207 1z m-305 -372
c10 -19 14 -178 5 -225 l-6 -28 -101 3 -102 3 -3 119 c-1 66 0 126 2 133 4 9
31 13 100 13 82 0 97 -3 105 -18z m309 6 c18 -18 16 -232 -2 -247 -9 -8 -48
-11 -112 -9 l-99 3 -3 119 c-1 66 0 126 2 133 7 17 197 18 214 1z m-304 -365
c7 -23 6 -190 0 -226 l-6 -28 -101 3 -102 3 -3 133 -3 132 105 0 c91 0 105 -2
110 -17z m314 -107 c2 -80 -1 -123 -9 -132 -9 -11 -35 -14 -113 -12 l-101 3
-3 119 c-1 66 0 126 2 133 4 11 30 13 113 11 l108 -3 3 -119z m-314 -252 c10
-25 7 -200 -4 -229 -10 -26 -10 -26 -107 -23 l-98 3 -3 133 -3 132 105 0 c85
0 105 -3 110 -16z m314 -105 c3 -148 3 -149 -117 -149 -54 0 -91 4 -99 12 -13
13 -18 239 -5 252 4 3 54 5 112 4 l106 -3 3 -116z"/>
<path d="M5727 2233 c-4 -3 -7 -146 -7 -318 0 -228 3 -314 12 -323 14 -14 384
-17 405 -4 9 6 13 85 13 317 0 171 0 316 0 323 0 9 -48 12 -208 12 -115 0
-212 -3 -215 -7z m331 -81 c9 -7 12 -62 10 -243 l-3 -234 -125 0 -125 0 -3
230 c-1 126 0 235 2 242 6 15 222 19 244 5z"/>
<path d="M6357 2234 c-4 -4 -7 -150 -7 -325 0 -280 2 -318 16 -323 9 -3 100
-6 204 -6 147 0 190 3 199 14 8 9 11 104 9 327 l-3 314 -206 3 c-113 1 -208
-1 -212 -4z m332 -88 c8 -9 11 -82 9 -242 l-3 -229 -125 0 -125 0 -3 230 c-1
126 0 235 2 242 8 19 229 18 245 -1z"/>
<path d="M6985 2228 c-3 -7 -4 -155 -3 -328 l3 -315 202 -3 c193 -2 203 -1
213 17 7 13 9 125 8 328 l-3 308 -208 3 c-161 2 -209 0 -212 -10z m333 -80 c9
-9 12 -74 12 -233 0 -159 -3 -224 -12 -233 -8 -8 -52 -12 -130 -12 l-118 0 0
238 c0 131 3 242 7 245 12 13 228 8 241 -5z"/>
</g>
</svg>
),

  addressBook: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="951.000000pt" viewBox="0 0 900.000000 951.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,951.000000) scale(0.100000,-0.100000)">
<path d="M1280 9452 c-121 -45 -215 -129 -270 -239 l-35 -68 -5 -330 -5 -330
-280 -6 c-246 -4 -287 -8 -336 -25 -144 -52 -255 -158 -307 -294 -22 -56 -32
-169 -23 -245 19 -157 130 -307 276 -373 87 -40 128 -45 400 -51 l270 -6 0
-310 0 -310 -280 -6 c-304 -7 -327 -10 -430 -69 -88 -50 -177 -155 -214 -250
-20 -52 -31 -156 -24 -235 16 -186 168 -361 363 -416 28 -8 145 -14 315 -18
l270 -6 0 -310 0 -310 -275 -6 c-294 -6 -308 -8 -424 -64 -63 -31 -168 -136
-197 -196 -48 -99 -52 -118 -52 -234 0 -111 9 -157 44 -215 5 -8 13 -25 18
-36 20 -46 130 -150 188 -179 115 -56 129 -58 423 -64 l275 -6 0 -310 0 -310
-270 -6 c-170 -4 -287 -10 -315 -18 -160 -45 -281 -157 -343 -316 -31 -79 -29
-250 4 -335 37 -96 130 -202 219 -252 104 -58 123 -61 425 -67 l280 -6 0 -310
0 -310 -270 -6 c-289 -6 -317 -10 -428 -64 -127 -62 -238 -227 -250 -370 -7
-79 4 -183 24 -235 38 -98 135 -209 222 -255 106 -55 123 -58 422 -64 l280 -6
5 -330 c3 -228 9 -336 17 -350 6 -11 22 -42 35 -68 42 -90 153 -183 264 -221
44 -15 348 -16 3684 -16 3439 0 3638 1 3685 18 121 42 218 129 276 247 l34 70
3 4325 c1 2525 -1 4357 -6 4401 -19 159 -125 295 -277 358 l-74 31 -3643 -1
c-3384 0 -3646 -2 -3688 -17z m1290 -222 c0 -11 0 -2029 0 -4485 0 -2456 0
-4474 0 -4485 0 -20 -7 -20 -585 -20 -434 0 -597 3 -631 12 -57 16 -115 69
-144 132 -19 43 -20 61 -18 333 l3 288 280 6 c186 3 292 9 315 18 175 62 291
182 342 351 20 67 14 213 -10 278 -62 161 -178 270 -337 319 -37 12 -119 17
-320 22 l-270 6 0 310 0 310 275 6 c294 6 308 8 423 64 103 51 200 174 239
305 20 67 14 213 -10 278 -62 161 -178 272 -334 319 -40 12 -119 17 -323 22
l-270 6 0 310 0 310 275 6 c281 6 299 8 400 53 84 37 190 143 226 226 41 94
49 127 48 215 -1 222 -131 396 -354 473 -34 12 -109 17 -320 21 l-275 6 0 310
0 310 270 6 c268 5 301 9 390 47 45 18 129 77 162 113 36 40 91 137 110 197
22 68 24 197 5 262 -52 174 -171 294 -350 351 -23 7 -143 14 -312 18 l-275 6
0 310 0 310 270 6 c204 5 283 10 323 22 213 65 357 255 357 472 0 136 -41 237
-140 344 -49 53 -90 79 -180 117 l-70 29 -280 5 -280 5 -3 288 c-2 273 -1 290
18 333 27 58 85 114 136 130 29 9 197 12 632 13 586 1 592 1 592 -19z m6011 8
c51 -15 114 -69 142 -122 l22 -41 0 -4330 0 -4330 -22 -41 c-28 -53 -91 -107
-142 -122 -29 -9 -758 -12 -2905 -12 l-2866 0 0 4505 0 4505 2866 0 c2147 0
2876 -3 2905 -12z"/>
<path d="M7250 8840 c-55 -13 -90 -70 -76 -124 3 -14 18 -38 32 -55 l26 -31
441 -2 442 -3 3 -420 2 -421 29 -31 c48 -53 104 -56 158 -9 l28 24 3 506 3
505 -30 33 -29 33 -499 2 c-274 1 -514 -2 -533 -7z"/>
<path d="M6599 8809 c-41 -44 -40 -96 2 -144 27 -31 37 -35 78 -35 54 1 84 22
106 74 17 39 13 56 -22 104 -22 29 -29 32 -79 32 -50 0 -59 -4 -85 -31z"/>
<path d="M3939 7135 c-97 -27 -171 -95 -208 -192 -21 -54 -21 -61 -20 -1186 0
-1041 1 -1135 17 -1172 24 -57 69 -117 112 -148 85 -61 -45 -57 1933 -57 1344
0 1820 3 1855 12 63 15 112 48 154 100 74 93 68 -12 68 1274 l0 1155 -24 47
c-45 89 -115 146 -203 167 -82 20 -3613 19 -3684 0z"/>
<path d="M3744 3464 c-40 -42 -44 -80 -13 -130 14 -23 32 -37 59 -44 25 -7
686 -9 2018 -8 l1981 3 30 29 c26 25 31 37 31 77 0 39 -5 52 -32 78 l-32 31
-2004 0 -2005 0 -33 -36z"/>
<path d="M3769 2553 c-58 -36 -74 -103 -38 -155 44 -61 -22 -58 1286 -58 1178
0 1199 0 1231 20 18 11 40 36 49 55 14 30 15 40 3 75 -9 26 -25 47 -45 60 -32
20 -54 20 -1246 20 -1105 -1 -1216 -2 -1240 -17z"/>
</g>
</svg>
),

  plus : (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="393.000000pt" height="393.000000pt" viewBox="0 0 393.000000 393.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,393.000000) scale(0.100000,-0.100000)">
<path d="M1705 3878 c-3 -7 -6 -384 -8 -838 l-2 -825 -835 -5 -835 -5 0 -250
0 -250 835 -5 835 -5 5 -835 5 -835 250 0 250 0 5 835 5 835 835 5 835 5 0
250 0 250 -835 5 -835 5 -5 835 -5 835 -248 3 c-193 2 -249 0 -252 -10z"/>
</g>
</svg>
),

  sun: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="588.000000pt" height="588.000000pt" viewBox="0 0 588.000000 588.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)">
<path d="M2895 5818 c-11 -6 -23 -16 -27 -22 -4 -6 -8 -230 -8 -498 l0 -487
30 -21 c27 -19 35 -21 61 -10 16 7 34 21 39 31 6 10 10 207 10 492 0 465 0
475 -21 501 -22 28 -51 33 -84 14z"/>
<path d="M1871 5394 c-12 -15 -21 -33 -21 -40 0 -14 22 -69 46 -116 8 -14 14
-31 14 -37 0 -6 13 -39 28 -73 16 -35 37 -83 47 -108 9 -25 26 -63 36 -86 10
-23 19 -44 19 -48 0 -4 11 -31 24 -59 13 -29 33 -77 45 -107 26 -64 52 -90 90
-90 35 0 71 34 71 66 0 24 -67 195 -126 322 -13 29 -24 57 -24 62 0 6 -13 38
-29 72 -15 35 -36 86 -46 113 -10 28 -24 57 -31 66 -8 8 -14 22 -14 30 0 28
-39 59 -75 59 -24 0 -39 -7 -54 -26z"/>
<path d="M3883 5403 c-11 -10 -27 -36 -35 -58 -31 -79 -81 -201 -103 -250 -13
-27 -26 -61 -30 -75 -4 -14 -20 -53 -36 -88 -16 -34 -29 -67 -29 -73 0 -6 -7
-25 -16 -42 -10 -18 -23 -44 -30 -59 -8 -14 -14 -42 -14 -62 0 -30 5 -40 32
-56 63 -38 92 -13 148 128 24 59 46 114 51 122 13 24 99 235 99 243 0 4 13 35
28 69 60 131 64 156 36 196 -19 27 -73 30 -101 5z"/>
<path d="M876 4975 c-38 -57 -39 -56 322 -417 336 -337 337 -338 379 -338 51
0 80 32 69 77 -5 19 -121 142 -344 366 -319 319 -339 337 -373 337 -28 0 -41
-6 -53 -25z"/>
<path d="M4560 4666 c-183 -184 -338 -344 -342 -357 -20 -53 25 -107 79 -95
20 5 131 110 366 345 291 292 337 342 337 368 0 38 -36 73 -76 73 -25 0 -76
-46 -364 -334z"/>
<path d="M2729 4456 c-2 -3 -49 -14 -104 -25 -126 -25 -232 -59 -341 -110 -99
-47 -254 -140 -254 -152 0 -5 -5 -9 -11 -9 -12 0 -109 -82 -184 -155 -73 -72
-186 -219 -231 -300 -32 -58 -84 -165 -99 -205 -9 -25 -21 -52 -25 -61 -11
-22 -38 -129 -61 -242 -25 -129 -27 -414 -3 -521 50 -222 65 -270 126 -396
105 -215 244 -392 434 -550 115 -95 343 -217 479 -255 33 -10 70 -21 83 -26
13 -5 79 -18 147 -29 164 -26 344 -26 490 0 116 21 302 73 319 90 6 6 16 10
24 10 13 0 118 50 172 81 239 141 455 361 581 594 40 74 69 136 69 149 0 6 6
20 13 31 7 11 21 49 31 85 10 36 24 85 31 110 59 202 59 506 -2 730 -41 152
-84 265 -135 353 -15 26 -28 50 -28 52 0 7 -63 99 -121 175 -66 88 -173 191
-286 278 -45 34 -84 62 -87 62 -3 0 -24 13 -48 28 -84 56 -253 129 -359 157
-173 44 -258 55 -438 55 -98 0 -180 -2 -182 -4z"/>
<path d="M462 3987 c-29 -31 -29 -77 1 -105 13 -12 29 -22 36 -22 7 0 25 -7
39 -14 15 -8 79 -36 142 -61 125 -50 171 -70 212 -91 14 -8 31 -14 37 -14 6 0
39 -13 73 -29 35 -16 87 -37 115 -47 52 -18 53 -18 79 2 37 27 45 55 28 90
-14 30 -46 46 -239 121 -22 9 -68 29 -103 45 -34 15 -66 28 -71 28 -5 0 -22 6
-38 14 -15 8 -39 19 -53 24 -14 6 -63 27 -109 46 -99 42 -120 44 -149 13z"/>
<path d="M5280 3984 c-30 -14 -71 -31 -90 -38 -59 -22 -240 -96 -258 -106 -9
-4 -75 -32 -146 -62 -101 -41 -133 -59 -147 -82 -29 -48 3 -106 60 -106 21 0
48 10 158 61 35 16 67 29 73 29 5 0 38 13 72 29 35 15 86 36 113 46 28 10 55
21 60 25 6 4 53 24 105 45 109 43 140 67 140 106 0 32 -41 79 -68 78 -9 0 -42
-11 -72 -25z"/>
<path d="M68 2994 c-51 -27 -46 -104 8 -124 32 -13 934 -13 966 -1 13 5 30 20
37 34 11 21 11 30 0 56 -7 16 -24 35 -37 40 -15 7 -179 11 -485 11 -389 -1
-466 -3 -489 -16z"/>
<path d="M4796 2984 c-38 -37 -27 -106 18 -118 29 -8 950 -8 971 0 8 4 22 19
31 35 13 26 13 32 0 58 -9 16 -23 31 -31 35 -9 3 -232 6 -495 6 -422 0 -480
-2 -494 -16z"/>
<path d="M1055 2241 c-33 -15 -80 -36 -105 -46 -25 -10 -68 -29 -97 -42 -28
-12 -55 -23 -59 -23 -4 0 -25 -9 -48 -19 -23 -10 -61 -27 -86 -36 -25 -10 -73
-31 -108 -47 -34 -15 -66 -28 -70 -28 -20 0 -42 -39 -42 -73 0 -39 27 -67 65
-67 22 0 104 27 120 39 5 4 26 14 45 21 38 14 256 103 305 124 17 8 50 22 75
31 86 34 148 65 164 81 20 20 20 63 0 92 -21 31 -83 28 -159 -7z"/>
<path d="M4640 2238 c-20 -33 -19 -59 3 -86 13 -16 78 -47 227 -108 63 -25
143 -59 178 -75 34 -16 67 -29 74 -29 6 0 34 -11 62 -24 76 -36 159 -63 176
-58 27 8 60 45 60 68 0 36 -31 63 -115 99 -44 20 -89 38 -100 41 -11 4 -42 16
-70 29 -27 12 -70 30 -95 40 -25 10 -73 31 -108 47 -34 15 -67 28 -73 28 -5 0
-37 14 -71 30 -82 41 -122 40 -148 -2z"/>
<path d="M1541 1643 c-7 -3 -164 -155 -348 -339 -329 -328 -334 -334 -331
-370 4 -46 43 -80 81 -70 29 7 684 659 698 694 22 56 -40 109 -100 85z"/>
<path d="M4243 1640 c-25 -10 -41 -68 -26 -95 6 -9 160 -167 344 -351 320
-321 335 -335 368 -332 45 4 77 44 67 85 -5 19 -115 136 -339 360 -345 345
-359 357 -414 333z"/>
<path d="M2158 1225 c-15 -8 -30 -25 -34 -37 -4 -13 -19 -50 -34 -83 -15 -33
-36 -82 -46 -110 -9 -27 -21 -54 -25 -60 -4 -5 -18 -40 -32 -76 -14 -36 -30
-75 -35 -85 -31 -58 -102 -243 -102 -265 0 -35 39 -69 77 -69 23 0 37 8 52 29
12 16 21 35 21 43 0 8 4 18 9 24 5 5 19 34 31 64 27 67 49 116 67 152 7 14 13
32 13 39 0 6 14 41 30 76 17 34 30 68 30 74 0 6 7 25 16 42 30 57 34 66 55
126 22 66 18 87 -23 115 -27 19 -35 19 -70 1z"/>
<path d="M3623 1220 c-28 -16 -33 -26 -33 -56 0 -21 14 -66 30 -101 17 -34 30
-68 30 -73 0 -6 13 -38 29 -73 16 -34 36 -82 46 -107 9 -25 21 -53 26 -62 4
-9 26 -61 48 -115 75 -188 79 -193 135 -193 26 0 66 41 66 69 0 17 -24 90 -39
119 -9 16 -30 67 -146 352 -79 193 -101 235 -129 248 -33 15 -25 16 -63 -8z"/>
<path d="M2879 1071 l-24 -19 -3 -473 c-2 -331 1 -482 9 -500 6 -15 24 -33 41
-40 25 -10 34 -10 56 4 15 8 30 29 35 46 4 17 6 241 5 497 l-3 466 -24 19
c-30 24 -62 24 -92 0z"/>
</g>
</svg>
),

  moon: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="492.000000pt" height="510.000000pt" viewBox="0 0 492.000000 510.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,510.000000) scale(0.100000,-0.100000)">
<path d="M1904 5028 c-26 -12 -42 -44 -50 -101 -9 -67 -34 -197 -49 -257 -8
-30 -16 -64 -17 -75 -2 -10 -14 -25 -28 -32 -57 -28 -161 -73 -169 -73 -5 0
-39 -13 -76 -30 -37 -16 -74 -30 -82 -30 -25 0 -73 -56 -73 -85 0 -29 41 -74
88 -98 51 -25 187 -100 222 -122 19 -12 45 -25 57 -29 11 -4 24 -13 26 -20 3
-8 14 -111 23 -230 l18 -217 32 -20 c52 -31 60 -26 283 188 76 73 102 93 125
93 28 0 80 -12 201 -44 116 -32 204 -48 227 -43 14 4 33 21 43 40 18 34 18 34
-12 93 -69 138 -123 254 -123 266 0 7 -7 22 -15 32 -21 28 -19 60 8 100 12 19
45 71 72 116 28 44 65 104 84 133 64 96 37 175 -54 162 -22 -3 -78 -10 -125
-15 -47 -5 -105 -14 -130 -19 -25 -6 -68 -10 -96 -11 -57 0 -47 -7 -149 115
-140 167 -197 225 -221 224 -10 0 -29 -5 -40 -11z"/>
<path d="M3435 4383 c-26 -28 -32 -62 -15 -79 11 -11 65 -156 91 -249 11 -38
25 -83 30 -100 5 -16 19 -82 31 -145 28 -156 31 -566 5 -705 -45 -238 -127
-484 -208 -628 -5 -10 -23 -42 -39 -72 -94 -174 -245 -366 -404 -514 -21 -20
-46 -43 -55 -52 -9 -8 -45 -38 -81 -65 -36 -27 -67 -52 -70 -56 -6 -8 -118
-81 -172 -112 -132 -78 -313 -157 -433 -191 -33 -10 -71 -22 -85 -28 -37 -15
-125 -31 -355 -63 -179 -25 -390 -14 -630 33 -44 8 -98 21 -120 28 -22 7 -69
21 -105 31 -36 9 -76 23 -90 30 -33 18 -145 54 -165 54 -9 0 -27 -11 -41 -25
-34 -34 -28 -59 46 -200 81 -154 116 -210 205 -330 64 -84 203 -237 268 -294
24 -20 53 -46 66 -58 62 -58 208 -162 316 -226 44 -26 87 -52 95 -57 8 -6 25
-14 37 -20 13 -5 42 -19 65 -30 133 -65 296 -121 468 -159 173 -39 220 -44
460 -48 199 -4 266 -2 360 12 107 16 235 44 305 66 17 5 61 18 99 29 38 11 74
24 80 28 6 4 36 16 66 26 30 11 62 24 70 31 8 6 35 20 60 30 25 11 67 32 93
47 26 15 50 28 53 28 11 0 153 96 244 165 221 168 420 390 572 641 32 53 118
226 118 237 0 7 5 18 12 25 12 12 34 67 47 117 4 17 13 39 18 50 17 31 61 193
87 320 19 91 36 294 36 420 0 184 -40 500 -70 556 -6 10 -10 29 -10 42 0 13
-12 55 -26 93 -14 38 -30 85 -36 104 -24 81 -140 312 -215 429 -105 162 -155
223 -323 391 -105 106 -314 280 -335 280 -4 0 -21 11 -38 24 -71 54 -295 166
-331 166 -15 0 -36 -11 -51 -27z"/>
<path d="M558 3423 c-140 -161 -115 -146 -226 -138 -54 3 -127 11 -165 17 -77
13 -107 3 -126 -40 -11 -22 -8 -33 17 -82 17 -31 47 -83 68 -116 79 -122 83
-134 60 -181 -8 -15 -25 -50 -39 -78 -84 -169 -92 -222 -36 -251 24 -12 37
-13 72 -3 23 6 67 17 97 24 30 7 82 20 115 28 33 9 66 12 73 8 7 -4 39 -32 70
-63 144 -139 171 -159 210 -156 59 5 73 40 81 215 9 172 -2 156 166 243 55 29
112 64 128 78 48 46 31 95 -50 136 -18 9 -37 16 -42 16 -6 0 -39 13 -73 29
-35 15 -78 34 -96 41 -39 15 -53 38 -64 105 -4 28 -14 88 -21 135 -18 110 -36
140 -88 140 -36 0 -43 -6 -131 -107z"/>
</g>
</svg>
),

  magicWand:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="621.000000pt" height="708.000000pt" viewBox="0 0 621.000000 708.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,708.000000) scale(0.100000,-0.100000)">
<path d="M1958 7014 c-16 -5 -56 -62 -91 -129 -74 -143 -143 -257 -166 -272
-14 -9 -46 -28 -71 -42 -25 -13 -72 -39 -105 -57 -33 -19 -67 -37 -75 -41 -57
-26 -110 -67 -118 -92 -11 -30 5 -83 29 -95 8 -3 28 -15 44 -26 17 -10 50 -29
75 -42 25 -13 70 -37 100 -54 30 -18 75 -43 99 -56 46 -26 59 -45 150 -218 28
-52 65 -117 83 -145 30 -45 37 -50 73 -53 22 -1 45 1 51 5 17 12 67 92 103
163 18 36 49 90 67 121 19 31 34 61 34 66 0 15 41 49 95 77 28 15 57 31 65 37
8 5 58 32 110 60 52 28 107 62 123 77 35 34 36 80 2 112 -27 25 -30 27 -146
89 -46 24 -97 52 -114 62 -16 10 -39 23 -51 28 -30 14 -84 61 -84 75 0 6 -11
27 -23 46 -13 19 -47 81 -76 136 -29 56 -64 115 -79 133 -27 31 -68 45 -104
35z m117 -409 c25 -49 54 -98 63 -107 10 -9 62 -40 117 -69 55 -28 104 -55
108 -59 17 -15 -8 -40 -80 -75 -140 -69 -155 -84 -228 -226 -61 -119 -64 -118
-131 12 -65 124 -86 145 -201 203 -78 40 -113 63 -113 76 0 4 47 31 105 60 57
30 116 66 130 80 26 28 62 88 111 189 l26 53 23 -23 c12 -13 44 -64 70 -114z"/>
<path d="M3635 5361 c-17 -7 -65 -82 -125 -196 -34 -66 -75 -97 -230 -178 -73
-37 -85 -52 -85 -102 0 -52 14 -67 95 -107 88 -43 172 -97 188 -119 18 -26 49
-81 93 -164 40 -75 62 -95 109 -95 46 0 64 19 121 128 24 45 49 91 55 102 16
30 47 61 69 71 11 5 36 19 55 30 19 12 58 33 85 47 78 39 95 59 95 107 0 52
-16 68 -128 125 -105 54 -156 91 -175 127 -61 118 -110 203 -121 213 -19 15
-76 22 -101 11z m56 -291 c10 -6 19 -17 19 -24 0 -27 60 -94 106 -118 72 -38
71 -40 -20 -101 -32 -20 -58 -48 -73 -77 -22 -41 -39 -59 -55 -60 -3 0 -16 20
-28 45 -20 41 -94 115 -115 115 -11 0 -45 31 -45 41 0 4 20 18 45 30 53 27 86
59 115 117 24 47 24 46 51 32z"/>
<path d="M638 5090 c-14 -11 -33 -34 -42 -52 -10 -18 -23 -42 -30 -53 -6 -11
-28 -51 -49 -90 -20 -38 -51 -96 -70 -128 -35 -63 -33 -62 -275 -188 -123 -65
-152 -92 -152 -140 0 -34 5 -42 42 -69 22 -16 45 -30 49 -30 5 0 37 -17 71
-38 35 -21 86 -49 113 -62 121 -59 130 -70 266 -329 54 -102 81 -131 123 -131
35 0 63 20 91 65 21 32 27 42 87 155 99 188 88 175 228 246 41 21 89 47 106
59 17 11 53 31 82 45 101 49 98 132 -7 189 -31 17 -76 42 -101 55 -25 14 -83
46 -130 71 -78 41 -87 49 -116 102 -17 32 -52 99 -78 148 -27 50 -54 97 -62
106 -8 8 -14 20 -14 26 0 18 -60 63 -84 63 -13 0 -35 -9 -48 -20z m105 -348
c42 -84 54 -106 77 -138 14 -19 106 -78 203 -129 38 -20 47 -38 25 -49 -7 -3
-26 -15 -43 -26 -16 -10 -58 -33 -92 -50 -79 -41 -90 -54 -158 -182 -68 -129
-74 -129 -131 -10 -58 119 -80 146 -139 177 -129 66 -180 100 -171 114 6 9 38
28 166 98 71 39 63 29 134 164 41 80 63 109 80 109 6 -1 28 -35 49 -78z"/>
<path d="M2255 4444 c-42 -21 -502 -482 -520 -520 -19 -41 -19 -97 0 -138 8
-17 849 -864 1867 -1883 1844 -1843 1853 -1852 1900 -1858 85 -13 99 -2 356
253 131 130 248 251 260 269 33 47 30 113 -7 166 -46 66 -3692 3705 -3724
3717 -40 15 -97 12 -132 -6z m344 -635 c144 -144 261 -268 261 -277 0 -20
-189 -212 -209 -212 -25 0 -536 512 -534 535 1 24 181 212 205 214 9 0 128
-111 277 -260z m1830 -1830 c727 -727 1321 -1326 1321 -1333 0 -17 -207 -219
-220 -214 -17 5 -2650 2642 -2650 2654 0 13 204 214 217 214 6 0 605 -594
1332 -1321z"/>
</g>
</svg>
),

  sleepingTV:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="1014.000000pt" viewBox="0 0 900.000000 1014.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,1014.000000) scale(0.100000,-0.100000)">
<path d="M1580 10084 c-162 -54 -244 -155 -226 -281 20 -145 154 -244 309
-230 41 4 67 2 78 -6 8 -7 125 -158 260 -337 135 -179 308 -408 384 -508 77
-101 151 -199 165 -218 14 -19 99 -131 190 -250 91 -119 183 -240 205 -269
239 -313 335 -444 335 -456 0 -8 -28 -44 -62 -80 -35 -36 -86 -98 -113 -139
-81 -118 -74 -115 -272 -102 -419 29 -668 36 -817 23 -80 -6 -170 -18 -201
-26 -31 -8 -67 -15 -81 -15 -13 0 -50 -6 -82 -14 -31 -8 -86 -21 -122 -30 -98
-22 -318 -75 -382 -91 -251 -64 -437 -115 -573 -156 -62 -18 -231 -78 -266
-92 -56 -24 -133 -100 -166 -164 -40 -76 -55 -142 -63 -288 -4 -66 -12 -194
-18 -285 -44 -630 -66 -2429 -42 -3378 18 -698 28 -762 151 -896 90 -98 211
-144 509 -191 54 -9 96 -29 109 -53 5 -10 11 -71 12 -136 4 -139 4 -138 -113
-179 -161 -56 -200 -78 -224 -123 -15 -28 -15 -32 0 -62 30 -58 92 -80 381
-136 72 -14 155 -31 185 -37 30 -6 80 -15 110 -19 88 -12 361 -59 415 -71 28
-7 77 -16 110 -20 84 -11 232 -35 296 -47 86 -17 215 -39 329 -57 114 -17 238
-38 340 -56 90 -15 243 -39 315 -49 33 -4 85 -12 115 -18 30 -6 120 -21 200
-32 80 -11 164 -25 188 -30 23 -6 60 -10 81 -10 21 0 51 -4 67 -10 26 -9 351
-60 509 -80 33 -4 168 -24 300 -45 132 -20 267 -41 300 -45 33 -5 121 -18 195
-30 74 -12 164 -25 200 -30 36 -5 112 -16 170 -24 58 -9 141 -21 185 -26 44
-6 105 -16 135 -22 30 -6 89 -14 130 -19 41 -4 109 -13 150 -18 114 -17 226
-31 317 -40 45 -5 88 -13 95 -17 7 -5 49 -11 93 -15 44 -4 143 -12 220 -19
160 -14 376 -7 450 14 120 33 303 115 450 201 33 19 67 38 75 42 8 4 48 26 88
50 41 24 76 43 79 43 2 0 23 12 46 27 66 43 81 53 97 60 8 4 33 18 55 32 22
14 56 34 75 44 19 11 54 32 78 48 24 16 45 29 46 29 4 0 350 203 376 220 8 6
22 13 30 17 41 17 209 126 238 153 25 25 32 39 32 70 0 33 -5 41 -32 58 -75
44 -210 72 -352 72 -123 0 -136 6 -136 68 0 107 6 119 84 169 170 110 214 141
271 187 116 95 164 179 201 354 20 99 43 345 54 579 5 106 11 197 14 202 29
47 51 2867 27 3376 -18 354 -46 452 -165 562 -61 56 -89 74 -171 106 -59 24
-271 62 -430 77 -44 4 -129 13 -190 20 -237 24 -295 30 -435 40 -80 5 -152 13
-160 17 -8 3 -82 10 -165 14 -343 18 -522 28 -745 43 -362 24 -574 36 -830 47
-129 5 -284 14 -345 19 -60 6 -161 10 -224 10 -98 0 -206 9 -328 26 -28 4 -61
40 -82 89 -13 31 -93 138 -143 193 -37 39 -56 67 -52 75 4 6 33 43 63 81 31
38 70 86 86 106 51 64 107 132 170 206 33 39 94 112 135 164 41 51 80 98 85
104 9 9 117 141 162 196 15 19 129 158 151 185 70 83 292 354 311 379 14 17
50 60 81 96 31 36 71 85 90 110 19 25 41 52 49 61 9 9 41 47 71 84 30 38 82
101 116 139 l60 71 65 6 c148 13 252 120 253 259 0 57 -25 127 -60 169 -29 34
-94 76 -140 89 -78 22 -120 17 -219 -29 -72 -33 -133 -131 -134 -214 -1 -38
27 -136 42 -152 17 -16 4 -54 -35 -104 -24 -30 -112 -137 -196 -239 -85 -102
-169 -203 -187 -225 -18 -22 -147 -177 -287 -344 -139 -167 -264 -318 -278
-335 -25 -31 -500 -601 -536 -643 -11 -12 -35 -42 -54 -67 -41 -54 -71 -65
-114 -43 -38 19 -107 40 -206 62 -98 22 -307 16 -435 -12 -73 -17 -94 -18
-110 -8 -20 12 -32 27 -154 185 -36 46 -71 91 -78 99 -22 25 -182 232 -313
405 -56 74 -238 311 -280 365 -25 31 -107 138 -182 237 -75 98 -166 217 -202
264 -234 303 -386 510 -386 527 0 10 7 46 16 78 14 56 14 65 -2 120 -43 149
-169 216 -314 169z m2347 -2645 c43 -7 100 -23 127 -37 103 -51 197 -169 235
-293 26 -86 1 -147 -70 -166 -100 -28 -211 -36 -423 -29 -336 10 -553 43 -605
90 -20 18 -20 19 -1 55 106 201 296 342 505 376 105 17 139 17 232 4z m-1472
-428 c132 -6 291 -17 353 -23 l113 -11 20 -37 c45 -79 180 -139 414 -183 194
-37 270 -42 620 -42 361 0 409 4 570 46 128 33 169 53 233 111 l43 39 137 -4
c236 -8 536 -25 552 -31 8 -3 101 -10 205 -16 276 -14 484 -28 700 -44 105 -9
285 -22 400 -31 390 -29 739 -63 1050 -102 110 -14 228 -28 262 -32 40 -4 69
-13 80 -24 17 -17 17 -19 0 -32 -11 -7 -67 -32 -125 -55 -59 -23 -120 -48
-137 -55 -29 -13 -78 -32 -157 -61 -82 -30 -124 -47 -156 -60 -18 -8 -41 -14
-50 -14 -10 0 -22 -4 -27 -9 -6 -5 -59 -26 -120 -47 -109 -37 -112 -37 -254
-35 -79 1 -148 4 -154 8 -10 6 -365 37 -612 53 -88 6 -182 15 -208 20 -26 6
-87 10 -135 10 -48 0 -125 5 -172 10 -47 6 -152 14 -235 20 -82 5 -204 14
-270 19 -66 6 -221 17 -345 26 -124 9 -281 20 -350 26 -69 5 -192 14 -275 18
-82 5 -157 11 -165 15 -8 3 -89 10 -180 16 -91 6 -289 20 -440 31 -151 12
-340 25 -420 29 -80 4 -152 10 -160 13 -8 4 -91 11 -185 17 -93 5 -294 19
-445 31 -151 12 -336 25 -410 29 -74 4 -187 12 -250 18 -63 6 -214 18 -335 27
-210 15 -382 30 -508 44 -105 11 -79 25 168 90 66 18 140 38 165 46 25 7 86
23 135 34 50 12 106 25 125 30 140 36 178 44 340 71 127 21 202 21 595 1z
m-1750 -428 c88 -8 216 -19 285 -23 69 -4 220 -14 335 -23 116 -9 282 -21 370
-27 88 -6 214 -16 280 -22 66 -6 183 -14 260 -18 77 -4 194 -12 260 -18 66 -6
226 -18 355 -27 129 -9 289 -21 355 -26 66 -6 185 -14 265 -19 80 -5 186 -14
235 -19 50 -6 126 -11 171 -11 44 0 105 -4 135 -10 30 -5 131 -14 224 -20 94
-6 285 -20 425 -31 140 -11 318 -24 395 -29 77 -4 183 -12 235 -18 52 -6 169
-16 260 -22 91 -6 253 -18 360 -27 107 -9 249 -19 315 -23 161 -10 577 -54
840 -90 134 -18 192 -69 232 -204 12 -42 16 -165 20 -711 6 -821 -8 -1514 -48
-2280 -6 -115 -14 -293 -17 -395 -4 -102 -11 -191 -15 -198 -5 -6 -12 -90 -17
-185 -13 -231 -23 -362 -60 -797 -12 -142 -41 -232 -89 -280 -50 -50 -191 -71
-402 -58 -160 9 -425 35 -559 54 -58 8 -190 23 -295 35 -104 11 -197 22 -205
26 -8 3 -53 9 -100 13 -121 11 -345 38 -411 50 -30 5 -75 10 -100 10 -24 0
-69 7 -99 15 -30 8 -79 15 -107 15 -29 0 -72 4 -95 10 -40 9 -264 39 -353 47
-22 2 -80 10 -130 18 -49 8 -151 21 -225 30 -74 9 -175 22 -225 30 -49 8 -142
21 -205 29 -63 9 -146 20 -185 26 -38 6 -104 15 -145 20 -41 5 -82 11 -90 14
-8 3 -51 10 -95 15 -44 5 -145 20 -225 31 -80 12 -176 26 -215 31 -38 4 -110
15 -160 23 -156 27 -348 58 -410 66 -33 5 -82 13 -110 18 -27 6 -99 17 -160
26 -136 20 -277 43 -375 61 -41 7 -118 21 -170 30 -151 25 -385 68 -495 90
-316 64 -368 81 -422 141 -58 65 -70 123 -83 379 -7 127 -14 255 -16 285 -2
30 -4 487 -4 1015 -1 1048 8 1395 60 2490 19 403 52 460 275 483 6 1 82 -6
170 -15z m7923 -178 c24 -20 31 -35 35 -77 3 -29 11 -87 16 -128 12 -91 12
-2345 0 -2620 -5 -102 -13 -315 -19 -475 -6 -159 -13 -317 -15 -350 -3 -33
-10 -125 -15 -205 -25 -368 -51 -542 -96 -636 -34 -73 -159 -173 -386 -309 -9
-5 -48 -29 -85 -51 -37 -23 -90 -54 -117 -69 -28 -15 -73 -41 -100 -57 -165
-98 -474 -258 -496 -258 -12 0 -13 14 0 98 5 37 14 132 19 212 6 80 15 199 20
265 24 288 61 884 71 1145 4 118 11 231 14 250 17 101 36 1154 36 1988 -1 604
3 908 9 916 13 16 166 80 371 156 112 42 152 57 198 74 90 35 262 97 317 114
155 50 181 52 223 17z m-7528 -4896 c19 -6 60 -15 90 -19 30 -4 96 -15 145
-24 112 -20 332 -55 405 -66 127 -18 219 -33 284 -46 38 -8 85 -14 105 -14 20
0 52 -4 71 -10 33 -9 185 -32 332 -50 38 -5 73 -12 78 -15 6 -4 45 -10 88 -15
42 -5 109 -14 147 -20 111 -16 214 -30 295 -40 41 -4 91 -13 110 -19 19 -6 53
-11 74 -11 22 0 65 -5 95 -10 61 -11 255 -38 366 -50 39 -4 97 -12 130 -18 33
-6 114 -18 180 -27 66 -9 161 -22 210 -30 50 -7 140 -21 200 -29 61 -9 142
-21 180 -27 39 -6 106 -14 150 -19 44 -5 109 -13 145 -19 36 -5 128 -17 205
-26 77 -9 169 -21 205 -27 36 -6 101 -14 145 -18 77 -8 267 -31 525 -66 69 -9
166 -20 215 -24 344 -31 380 -37 409 -69 16 -18 17 -27 5 -113 -11 -79 -17
-97 -40 -121 -25 -25 -33 -27 -106 -27 -43 1 -109 5 -148 11 -38 6 -113 14
-165 19 -52 4 -162 17 -245 29 -82 11 -188 25 -235 31 -47 6 -92 13 -100 17
-8 3 -49 9 -90 14 -41 4 -104 12 -140 18 -36 6 -114 17 -175 26 -60 8 -150 22
-200 30 -49 8 -142 22 -205 30 -63 9 -142 21 -175 27 -33 6 -89 14 -125 18
-36 5 -128 18 -205 30 -77 12 -169 26 -205 30 -36 4 -90 12 -120 18 -30 6
-122 20 -205 32 -82 11 -169 25 -193 30 -23 6 -59 10 -80 10 -20 0 -66 6 -102
14 -36 8 -137 24 -225 36 -88 12 -185 25 -215 30 -30 5 -101 16 -157 25 -226
33 -311 47 -383 60 -41 7 -127 21 -190 30 -63 9 -135 22 -160 27 -25 5 -72 13
-105 18 -33 4 -116 17 -185 29 -69 12 -153 26 -187 30 -34 5 -66 12 -72 15 -5
4 -40 11 -78 16 -37 5 -120 19 -183 30 -63 12 -132 23 -152 27 -49 7 -73 36
-87 101 -12 59 -15 155 -4 165 9 9 12 9 53 -4z"/>
<path d="M810 6245 c-19 -7 -44 -14 -55 -14 -37 -2 -128 -84 -157 -142 -34
-70 -63 -196 -77 -334 -24 -238 -44 -477 -51 -620 -5 -82 -13 -217 -19 -300
-18 -254 -33 -1023 -26 -1345 6 -284 27 -724 44 -955 21 -270 100 -353 396
-415 42 -9 226 -50 335 -75 36 -8 106 -22 155 -30 50 -9 116 -23 147 -30 32
-8 71 -15 86 -15 16 0 42 -4 58 -10 28 -10 173 -34 306 -50 38 -5 73 -12 80
-16 6 -4 44 -11 82 -15 39 -4 132 -16 206 -28 74 -12 180 -26 234 -31 54 -6
103 -13 108 -16 4 -3 43 -9 86 -14 42 -5 147 -18 232 -29 180 -24 195 -26 400
-46 85 -9 202 -23 260 -31 58 -8 131 -14 162 -14 31 0 79 -4 105 -10 26 -5
118 -14 203 -20 85 -6 206 -15 269 -20 62 -5 235 -15 385 -21 376 -17 454 -4
539 91 52 57 105 182 122 285 3 22 10 67 16 100 15 92 30 220 38 325 4 52 13
131 19 175 11 74 18 158 57 615 27 321 37 601 42 1135 5 506 2 632 -27 1040
-24 341 -94 441 -355 510 -56 15 -204 45 -250 51 -16 3 -64 11 -105 19 -41 7
-104 18 -140 24 -36 6 -108 18 -160 27 -52 8 -142 22 -200 30 -58 8 -154 21
-215 30 -60 8 -153 19 -205 24 -52 5 -102 11 -110 14 -8 3 -123 14 -255 26
-132 11 -283 26 -335 32 -52 6 -156 14 -230 18 -74 5 -189 13 -255 19 -578 50
-1866 88 -1945 56z m1936 -279 c143 -9 284 -20 313 -26 30 -5 89 -10 132 -10
43 0 100 -4 126 -9 26 -5 107 -14 178 -20 142 -12 255 -26 355 -42 36 -6 94
-15 130 -19 196 -24 539 -89 705 -135 358 -98 480 -172 551 -332 58 -130 97
-306 126 -573 16 -146 16 -961 0 -1180 -39 -523 -88 -849 -177 -1165 -69 -247
-169 -391 -315 -451 -167 -69 -261 -78 -755 -70 -220 3 -449 11 -510 16 -60 6
-173 15 -250 19 -77 5 -185 14 -240 20 -55 6 -167 18 -250 26 -82 9 -193 22
-245 30 -52 8 -149 22 -215 31 -66 9 -151 22 -190 30 -38 8 -81 14 -95 14 -14
0 -54 7 -90 15 -73 17 -282 62 -350 75 -25 4 -79 18 -120 30 -41 12 -88 25
-105 30 -32 9 -87 28 -120 41 -124 50 -159 66 -211 95 -147 81 -199 146 -242
304 -53 192 -68 269 -81 410 -4 42 -10 81 -15 88 -16 26 -31 387 -31 757 0
380 16 823 31 847 4 6 11 62 15 122 30 434 140 835 252 917 55 40 131 79 155
79 11 0 35 6 53 14 30 12 133 29 254 40 96 9 993 -4 1231 -18z"/>
<path d="M1388 4703 c-21 -5 -48 -62 -48 -100 0 -16 7 -53 16 -83 53 -179 187
-300 409 -371 117 -37 350 -20 446 32 145 79 238 167 296 281 38 75 39 87 12
122 -16 20 -29 26 -58 26 -40 0 -57 -14 -135 -113 -140 -176 -367 -223 -586
-120 -84 40 -149 107 -202 207 -60 116 -85 136 -150 119z"/>
<path d="M3247 4540 c-34 -27 -43 -76 -26 -153 55 -263 272 -453 571 -501 120
-20 188 -20 298 -1 102 16 154 34 236 80 89 50 155 105 207 172 60 78 77 115
77 162 0 47 -18 68 -66 77 -28 5 -42 1 -74 -21 -22 -15 -42 -35 -45 -45 -11
-34 -130 -135 -197 -168 -72 -35 -141 -50 -253 -53 -296 -10 -482 105 -590
365 -39 92 -90 124 -138 86z"/>
<path d="M2268 3230 c-27 -27 -30 -36 -26 -74 15 -127 135 -251 311 -318 77
-29 213 -57 283 -58 178 -1 394 82 508 196 95 93 109 165 42 210 -36 23 -69
12 -130 -44 -178 -165 -386 -207 -609 -125 -92 34 -164 85 -226 160 -77 93
-103 102 -153 53z"/>
<path d="M6371 5784 c-174 -38 -346 -177 -429 -347 -65 -133 -76 -180 -76
-332 -1 -121 3 -149 22 -204 69 -193 185 -329 347 -406 30 -14 99 -34 154 -45
95 -19 104 -19 192 -4 94 16 168 40 217 71 304 191 409 625 228 947 -43 75
-122 165 -192 217 -48 35 -71 48 -159 84 -35 15 -162 36 -208 34 -17 -1 -61
-8 -96 -15z m214 -208 c112 -41 207 -119 262 -217 115 -204 93 -428 -57 -593
-51 -55 -66 -66 -147 -104 -78 -38 -253 -46 -284 -15 -18 18 -2 43 38 59 208
82 302 177 335 338 21 99 -21 230 -92 286 -60 47 -95 60 -162 60 -125 0 -215
-70 -282 -217 -30 -66 -106 -163 -128 -163 -13 0 -38 58 -44 102 -6 47 20 165
55 243 25 56 129 166 185 196 104 55 214 64 321 25z m-85 -351 c59 -31 40 -79
-94 -235 -11 -14 -43 -54 -71 -89 -79 -100 -102 -121 -131 -121 -15 0 -36 7
-46 17 -37 34 -32 43 174 300 83 103 119 141 136 143 2 0 16 -7 32 -15z"/>
<path d="M6290 4286 c-204 -57 -367 -235 -425 -466 -19 -72 -19 -254 -1 -322
42 -158 129 -281 266 -375 171 -117 406 -136 600 -48 149 67 267 213 317 394
20 68 22 247 4 311 -73 269 -254 456 -491 506 -79 17 -209 17 -270 0z m197
-176 c86 -23 140 -54 216 -129 176 -170 208 -425 79 -613 -68 -99 -191 -169
-301 -172 -63 -1 -66 0 -66 23 0 18 18 36 81 80 121 84 170 149 197 261 29
119 -20 259 -115 332 -39 30 -116 58 -158 58 -40 0 -107 -27 -153 -63 -48 -37
-79 -91 -111 -195 -32 -102 -50 -138 -77 -153 -36 -19 -59 15 -65 97 -18 222
94 402 294 470 82 28 89 28 179 4z m24 -340 c13 -7 19 -21 19 -43 0 -38 -7
-50 -102 -166 -7 -8 -50 -64 -96 -125 -46 -61 -94 -118 -107 -126 -22 -13 -27
-12 -52 6 -45 34 -40 54 33 150 37 49 70 91 73 94 4 3 40 49 81 103 90 120
106 131 151 107z"/>
<path d="M5802 2804 c-53 -37 -43 -119 17 -144 26 -11 264 -42 451 -60 47 -4
162 -17 255 -29 394 -49 411 -49 439 -6 35 53 11 109 -58 135 -16 6 -138 22
-270 35 -133 14 -254 27 -271 31 -16 3 -73 10 -125 15 -52 4 -162 15 -245 23
-82 9 -155 16 -160 16 -6 0 -21 -7 -33 -16z"/>
<path d="M5765 2466 c-23 -23 -26 -33 -22 -64 4 -20 14 -44 24 -54 19 -18 98
-34 243 -48 47 -4 117 -12 155 -18 80 -12 202 -26 360 -42 61 -6 126 -16 146
-21 20 -5 61 -9 90 -9 30 0 71 -5 91 -10 30 -9 44 -8 67 5 57 29 66 78 24 125
-31 34 -77 45 -333 74 -74 9 -193 23 -265 31 -71 8 -186 22 -255 30 -69 8
-164 18 -212 21 -84 7 -87 6 -113 -20z"/>
<path d="M5752 2140 c-34 -36 -36 -68 -8 -105 28 -37 75 -50 236 -65 47 -5
159 -18 250 -29 91 -12 213 -25 272 -31 59 -5 118 -14 133 -20 14 -5 50 -10
80 -10 29 0 76 -5 103 -11 41 -10 52 -9 74 5 41 27 54 69 34 111 -14 29 -26
37 -69 50 -29 8 -95 19 -147 25 -52 5 -171 19 -265 30 -93 12 -210 25 -260 30
-49 4 -115 13 -146 18 -31 6 -103 14 -161 17 -100 7 -106 7 -126 -15z"/>
<path d="M5732 1825 c-49 -23 -60 -55 -32 -100 28 -46 78 -71 160 -80 36 -3
155 -18 265 -32 110 -14 236 -29 280 -33 44 -4 155 -17 248 -30 155 -21 169
-21 192 -6 65 42 69 113 9 148 -30 18 -60 23 -314 53 -74 9 -166 21 -205 26
-38 5 -113 14 -165 19 -52 5 -102 11 -110 14 -8 3 -60 10 -115 16 -55 6 -118
12 -140 15 -24 3 -53 -2 -73 -10z"/>
<path d="M7441 9422 c-25 -25 -31 -39 -31 -74 1 -93 47 -115 320 -148 123 -15
213 -34 217 -46 2 -7 -65 -58 -149 -114 -289 -194 -496 -344 -530 -384 -11
-13 -17 -38 -18 -67 0 -37 5 -50 30 -74 31 -30 36 -31 255 -65 72 -11 168 -27
215 -36 47 -8 108 -19 135 -23 28 -5 100 -19 161 -31 61 -13 123 -20 137 -16
44 11 85 53 92 94 9 53 -8 88 -52 110 -57 28 -250 72 -411 94 -52 7 -101 17
-109 23 -16 12 -13 13 397 290 187 125 255 181 275 224 20 46 14 89 -18 118
-46 42 -228 88 -447 113 -36 4 -92 12 -124 18 -32 6 -116 14 -187 18 l-128 7
-30 -31z"/>
<path d="M6402 8364 c-16 -8 -42 -58 -42 -83 0 -33 20 -67 48 -83 15 -8 72
-23 127 -32 192 -34 215 -39 224 -50 7 -8 -27 -40 -112 -106 -138 -109 -212
-166 -291 -229 -96 -76 -124 -148 -75 -196 25 -25 81 -38 314 -71 61 -9 137
-20 170 -25 141 -21 180 -22 211 -6 41 21 62 83 44 127 -13 31 -54 60 -87 60
-10 0 -47 7 -83 15 -36 8 -100 17 -142 20 -64 6 -78 10 -78 24 0 10 44 50 107
96 200 149 350 273 372 308 28 45 27 69 -5 106 -27 33 -68 49 -154 61 -30 5
-120 20 -200 35 -142 25 -322 41 -348 29z"/>
</g>
</svg>
),

  TV:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="1014.000000pt" viewBox="0 0 900.000000 1014.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,1014.000000) scale(0.100000,-0.100000)">
<path d="M1580 10084 c-162 -54 -244 -155 -226 -281 20 -145 154 -244 309
-230 41 4 67 2 78 -6 8 -7 125 -158 260 -337 135 -179 308 -408 384 -508 77
-101 151 -199 165 -218 14 -19 99 -131 190 -250 91 -119 183 -240 205 -269
239 -313 335 -444 335 -456 0 -8 -28 -44 -62 -80 -35 -36 -86 -98 -113 -139
-81 -118 -74 -115 -272 -102 -419 29 -668 36 -817 23 -80 -6 -170 -18 -201
-26 -31 -8 -67 -15 -81 -15 -13 0 -50 -6 -82 -14 -31 -8 -86 -21 -122 -30 -98
-22 -318 -75 -382 -91 -251 -64 -437 -115 -573 -156 -62 -18 -231 -78 -266
-92 -56 -24 -133 -100 -166 -164 -40 -76 -55 -142 -63 -288 -4 -66 -12 -194
-18 -285 -44 -630 -66 -2429 -42 -3378 18 -698 28 -762 151 -896 90 -98 211
-144 509 -191 54 -9 96 -29 109 -53 5 -10 11 -71 12 -136 4 -139 4 -138 -113
-179 -161 -56 -200 -78 -224 -123 -15 -28 -15 -32 0 -62 30 -58 92 -80 381
-136 72 -14 155 -31 185 -37 30 -6 80 -15 110 -19 88 -12 361 -59 415 -71 28
-7 77 -16 110 -20 84 -11 232 -35 296 -47 86 -17 215 -39 329 -57 114 -17 238
-38 340 -56 90 -15 243 -39 315 -49 33 -4 85 -12 115 -18 30 -6 120 -21 200
-32 80 -11 164 -25 188 -30 23 -6 60 -10 81 -10 21 0 51 -4 67 -10 26 -9 351
-60 509 -80 33 -4 168 -24 300 -45 132 -20 267 -41 300 -45 33 -5 121 -18 195
-30 74 -12 164 -25 200 -30 36 -5 112 -16 170 -24 58 -9 141 -21 185 -26 44
-6 105 -16 135 -22 30 -6 89 -14 130 -19 41 -4 109 -13 150 -18 114 -17 226
-31 317 -40 45 -5 88 -13 95 -17 7 -5 49 -11 93 -15 44 -4 143 -12 220 -19
160 -14 376 -7 450 14 120 33 303 115 450 201 33 19 67 38 75 42 8 4 48 26 88
50 41 24 76 43 79 43 2 0 23 12 46 27 66 43 81 53 97 60 8 4 33 18 55 32 22
14 56 34 75 44 19 11 54 32 78 48 24 16 45 29 46 29 4 0 350 203 376 220 8 6
22 13 30 17 41 17 209 126 238 153 25 25 32 39 32 70 0 33 -5 41 -32 58 -75
44 -210 72 -352 72 -123 0 -136 6 -136 68 0 107 6 119 84 169 170 110 214 141
271 187 116 95 164 179 201 354 20 99 43 345 54 579 5 106 11 197 14 202 29
47 51 2867 27 3376 -18 354 -46 452 -165 562 -61 56 -89 74 -171 106 -59 24
-271 62 -430 77 -44 4 -129 13 -190 20 -237 24 -295 30 -435 40 -80 5 -152 13
-160 17 -8 3 -82 10 -165 14 -343 18 -522 28 -745 43 -362 24 -574 36 -830 47
-129 5 -284 14 -345 19 -60 6 -161 10 -224 10 -98 0 -206 9 -328 26 -28 4 -61
40 -82 89 -13 31 -93 138 -143 193 -37 39 -56 67 -52 75 4 6 33 43 63 81 31
38 70 86 86 106 51 64 107 132 170 206 33 39 94 112 135 164 41 51 80 98 85
104 9 9 117 141 162 196 15 19 129 158 151 185 70 83 292 354 311 379 14 17
50 60 81 96 31 36 71 85 90 110 19 25 41 52 49 61 9 9 41 47 71 84 30 38 82
101 116 139 l60 71 65 6 c148 13 252 120 253 259 0 57 -25 127 -60 169 -29 34
-94 76 -140 89 -78 22 -120 17 -219 -29 -72 -33 -133 -131 -134 -214 -1 -38
27 -136 42 -152 17 -16 4 -54 -35 -104 -24 -30 -112 -137 -196 -239 -85 -102
-169 -203 -187 -225 -18 -22 -147 -177 -287 -344 -139 -167 -264 -318 -278
-335 -25 -31 -500 -601 -536 -643 -11 -12 -35 -42 -54 -67 -41 -54 -71 -65
-114 -43 -38 19 -107 40 -206 62 -98 22 -307 16 -435 -12 -73 -17 -94 -18
-110 -8 -20 12 -32 27 -154 185 -36 46 -71 91 -78 99 -22 25 -182 232 -313
405 -56 74 -238 311 -280 365 -25 31 -107 138 -182 237 -75 98 -166 217 -202
264 -234 303 -386 510 -386 527 0 10 7 46 16 78 14 56 14 65 -2 120 -43 149
-169 216 -314 169z m2347 -2645 c43 -7 100 -23 127 -37 103 -51 197 -169 235
-293 26 -86 1 -147 -70 -166 -100 -28 -211 -36 -423 -29 -336 10 -553 43 -605
90 -20 18 -20 19 -1 55 106 201 296 342 505 376 105 17 139 17 232 4z m-1472
-428 c132 -6 291 -17 353 -23 l113 -11 20 -37 c45 -79 180 -139 414 -183 194
-37 270 -42 620 -42 361 0 409 4 570 46 128 33 169 53 233 111 l43 39 137 -4
c236 -8 536 -25 552 -31 8 -3 101 -10 205 -16 276 -14 484 -28 700 -44 105 -9
285 -22 400 -31 390 -29 739 -63 1050 -102 110 -14 228 -28 262 -32 40 -4 69
-13 80 -24 17 -17 17 -19 0 -32 -11 -7 -67 -32 -125 -55 -59 -23 -120 -48
-137 -55 -29 -13 -78 -32 -157 -61 -82 -30 -124 -47 -156 -60 -18 -8 -41 -14
-50 -14 -10 0 -22 -4 -27 -9 -6 -5 -59 -26 -120 -47 -109 -37 -112 -37 -254
-35 -79 1 -148 4 -154 8 -10 6 -365 37 -612 53 -88 6 -182 15 -208 20 -26 6
-87 10 -135 10 -48 0 -125 5 -172 10 -47 6 -152 14 -235 20 -82 5 -204 14
-270 19 -66 6 -221 17 -345 26 -124 9 -281 20 -350 26 -69 5 -192 14 -275 18
-82 5 -157 11 -165 15 -8 3 -89 10 -180 16 -91 6 -289 20 -440 31 -151 12
-340 25 -420 29 -80 4 -152 10 -160 13 -8 4 -91 11 -185 17 -93 5 -294 19
-445 31 -151 12 -336 25 -410 29 -74 4 -187 12 -250 18 -63 6 -214 18 -335 27
-210 15 -382 30 -508 44 -105 11 -79 25 168 90 66 18 140 38 165 46 25 7 86
23 135 34 50 12 106 25 125 30 140 36 178 44 340 71 127 21 202 21 595 1z
m-1750 -428 c88 -8 216 -19 285 -23 69 -4 220 -14 335 -23 116 -9 282 -21 370
-27 88 -6 214 -16 280 -22 66 -6 183 -14 260 -18 77 -4 194 -12 260 -18 66 -6
226 -18 355 -27 129 -9 289 -21 355 -26 66 -6 185 -14 265 -19 80 -5 186 -14
235 -19 50 -6 126 -11 171 -11 44 0 105 -4 135 -10 30 -5 131 -14 224 -20 94
-6 285 -20 425 -31 140 -11 318 -24 395 -29 77 -4 183 -12 235 -18 52 -6 169
-16 260 -22 91 -6 253 -18 360 -27 107 -9 249 -19 315 -23 161 -10 577 -54
840 -90 134 -18 192 -69 232 -204 12 -42 16 -165 20 -711 6 -821 -8 -1514 -48
-2280 -6 -115 -14 -293 -17 -395 -4 -102 -11 -191 -15 -198 -5 -6 -12 -90 -17
-185 -13 -231 -23 -362 -60 -797 -12 -142 -41 -232 -89 -280 -50 -50 -191 -71
-402 -58 -160 9 -425 35 -559 54 -58 8 -190 23 -295 35 -104 11 -197 22 -205
26 -8 3 -53 9 -100 13 -121 11 -345 38 -411 50 -30 5 -75 10 -100 10 -24 0
-69 7 -99 15 -30 8 -79 15 -107 15 -29 0 -72 4 -95 10 -40 9 -264 39 -353 47
-22 2 -80 10 -130 18 -49 8 -151 21 -225 30 -74 9 -175 22 -225 30 -49 8 -142
21 -205 29 -63 9 -146 20 -185 26 -38 6 -104 15 -145 20 -41 5 -82 11 -90 14
-8 3 -51 10 -95 15 -44 5 -145 20 -225 31 -80 12 -176 26 -215 31 -38 4 -110
15 -160 23 -156 27 -348 58 -410 66 -33 5 -82 13 -110 18 -27 6 -99 17 -160
26 -136 20 -277 43 -375 61 -41 7 -118 21 -170 30 -151 25 -385 68 -495 90
-316 64 -368 81 -422 141 -58 65 -70 123 -83 379 -7 127 -14 255 -16 285 -2
30 -4 487 -4 1015 -1 1048 8 1395 60 2490 19 403 52 460 275 483 6 1 82 -6
170 -15z m7923 -178 c24 -20 31 -35 35 -77 3 -29 11 -87 16 -128 12 -91 12
-2345 0 -2620 -5 -102 -13 -315 -19 -475 -6 -159 -13 -317 -15 -350 -3 -33
-10 -125 -15 -205 -25 -368 -51 -542 -96 -636 -34 -73 -159 -173 -386 -309 -9
-5 -48 -29 -85 -51 -37 -23 -90 -54 -117 -69 -28 -15 -73 -41 -100 -57 -165
-98 -474 -258 -496 -258 -12 0 -13 14 0 98 5 37 14 132 19 212 6 80 15 199 20
265 24 288 61 884 71 1145 4 118 11 231 14 250 17 101 36 1154 36 1988 -1 604
3 908 9 916 13 16 166 80 371 156 112 42 152 57 198 74 90 35 262 97 317 114
155 50 181 52 223 17z m-7528 -4896 c19 -6 60 -15 90 -19 30 -4 96 -15 145
-24 112 -20 332 -55 405 -66 127 -18 219 -33 284 -46 38 -8 85 -14 105 -14 20
0 52 -4 71 -10 33 -9 185 -32 332 -50 38 -5 73 -12 78 -15 6 -4 45 -10 88 -15
42 -5 109 -14 147 -20 111 -16 214 -30 295 -40 41 -4 91 -13 110 -19 19 -6 53
-11 74 -11 22 0 65 -5 95 -10 61 -11 255 -38 366 -50 39 -4 97 -12 130 -18 33
-6 114 -18 180 -27 66 -9 161 -22 210 -30 50 -7 140 -21 200 -29 61 -9 142
-21 180 -27 39 -6 106 -14 150 -19 44 -5 109 -13 145 -19 36 -5 128 -17 205
-26 77 -9 169 -21 205 -27 36 -6 101 -14 145 -18 77 -8 267 -31 525 -66 69 -9
166 -20 215 -24 344 -31 380 -37 409 -69 16 -18 17 -27 5 -113 -11 -79 -17
-97 -40 -121 -25 -25 -33 -27 -106 -27 -43 1 -109 5 -148 11 -38 6 -113 14
-165 19 -52 4 -162 17 -245 29 -82 11 -188 25 -235 31 -47 6 -92 13 -100 17
-8 3 -49 9 -90 14 -41 4 -104 12 -140 18 -36 6 -114 17 -175 26 -60 8 -150 22
-200 30 -49 8 -142 22 -205 30 -63 9 -142 21 -175 27 -33 6 -89 14 -125 18
-36 5 -128 18 -205 30 -77 12 -169 26 -205 30 -36 4 -90 12 -120 18 -30 6
-122 20 -205 32 -82 11 -169 25 -193 30 -23 6 -59 10 -80 10 -20 0 -66 6 -102
14 -36 8 -137 24 -225 36 -88 12 -185 25 -215 30 -30 5 -101 16 -157 25 -226
33 -311 47 -383 60 -41 7 -127 21 -190 30 -63 9 -135 22 -160 27 -25 5 -72 13
-105 18 -33 4 -116 17 -185 29 -69 12 -153 26 -187 30 -34 5 -66 12 -72 15 -5
4 -40 11 -78 16 -37 5 -120 19 -183 30 -63 12 -132 23 -152 27 -49 7 -73 36
-87 101 -12 59 -15 155 -4 165 9 9 12 9 53 -4z"/>
<path d="M810 6245 c-19 -7 -44 -14 -55 -14 -37 -2 -128 -84 -157 -142 -34
-70 -63 -196 -77 -334 -24 -238 -44 -477 -51 -620 -5 -82 -13 -217 -19 -300
-18 -254 -33 -1023 -26 -1345 6 -284 27 -724 44 -955 21 -270 100 -353 396
-415 42 -9 226 -50 335 -75 36 -8 106 -22 155 -30 50 -9 116 -23 147 -30 32
-8 71 -15 86 -15 16 0 42 -4 58 -10 28 -10 173 -34 306 -50 38 -5 73 -12 80
-16 6 -4 44 -11 82 -15 39 -4 132 -16 206 -28 74 -12 180 -26 234 -31 54 -6
103 -13 108 -16 4 -3 43 -9 86 -14 42 -5 147 -18 232 -29 180 -24 195 -26 400
-46 85 -9 202 -23 260 -31 58 -8 131 -14 162 -14 31 0 79 -4 105 -10 26 -5
118 -14 203 -20 85 -6 206 -15 269 -20 62 -5 235 -15 385 -21 376 -17 454 -4
539 91 52 57 105 182 122 285 3 22 10 67 16 100 15 92 30 220 38 325 4 52 13
131 19 175 11 74 18 158 57 615 27 321 37 601 42 1135 5 506 2 632 -27 1040
-24 341 -94 441 -355 510 -56 15 -204 45 -250 51 -16 3 -64 11 -105 19 -41 7
-104 18 -140 24 -36 6 -108 18 -160 27 -52 8 -142 22 -200 30 -58 8 -154 21
-215 30 -60 8 -153 19 -205 24 -52 5 -102 11 -110 14 -8 3 -123 14 -255 26
-132 11 -283 26 -335 32 -52 6 -156 14 -230 18 -74 5 -189 13 -255 19 -578 50
-1866 88 -1945 56z m1936 -279 c143 -9 284 -20 313 -26 30 -5 89 -10 132 -10
43 0 100 -4 126 -9 26 -5 107 -14 178 -20 142 -12 255 -26 355 -42 36 -6 94
-15 130 -19 196 -24 539 -89 705 -135 358 -98 480 -172 551 -332 58 -130 97
-306 126 -573 16 -146 16 -961 0 -1180 -39 -523 -88 -849 -177 -1165 -69 -247
-169 -391 -315 -451 -167 -69 -261 -78 -755 -70 -220 3 -449 11 -510 16 -60 6
-173 15 -250 19 -77 5 -185 14 -240 20 -55 6 -167 18 -250 26 -82 9 -193 22
-245 30 -52 8 -149 22 -215 31 -66 9 -151 22 -190 30 -38 8 -81 14 -95 14 -14
0 -54 7 -90 15 -73 17 -282 62 -350 75 -25 4 -79 18 -120 30 -41 12 -88 25
-105 30 -32 9 -87 28 -120 41 -124 50 -159 66 -211 95 -147 81 -199 146 -242
304 -53 192 -68 269 -81 410 -4 42 -10 81 -15 88 -16 26 -31 387 -31 757 0
380 16 823 31 847 4 6 11 62 15 122 30 434 140 835 252 917 55 40 131 79 155
79 11 0 35 6 53 14 30 12 133 29 254 40 96 9 993 -4 1231 -18z"/>
<path d="M6371 5784 c-174 -38 -346 -177 -429 -347 -65 -133 -76 -180 -76
-332 -1 -121 3 -149 22 -204 69 -193 185 -329 347 -406 30 -14 99 -34 154 -45
95 -19 104 -19 192 -4 94 16 168 40 217 71 304 191 409 625 228 947 -43 75
-122 165 -192 217 -48 35 -71 48 -159 84 -35 15 -162 36 -208 34 -17 -1 -61
-8 -96 -15z m214 -208 c112 -41 207 -119 262 -217 115 -204 93 -428 -57 -593
-51 -55 -66 -66 -147 -104 -78 -38 -253 -46 -284 -15 -18 18 -2 43 38 59 208
82 302 177 335 338 21 99 -21 230 -92 286 -60 47 -95 60 -162 60 -125 0 -215
-70 -282 -217 -30 -66 -106 -163 -128 -163 -13 0 -38 58 -44 102 -6 47 20 165
55 243 25 56 129 166 185 196 104 55 214 64 321 25z m-85 -351 c59 -31 40 -79
-94 -235 -11 -14 -43 -54 -71 -89 -79 -100 -102 -121 -131 -121 -15 0 -36 7
-46 17 -37 34 -32 43 174 300 83 103 119 141 136 143 2 0 16 -7 32 -15z"/>
<path d="M6290 4286 c-204 -57 -367 -235 -425 -466 -19 -72 -19 -254 -1 -322
42 -158 129 -281 266 -375 171 -117 406 -136 600 -48 149 67 267 213 317 394
20 68 22 247 4 311 -73 269 -254 456 -491 506 -79 17 -209 17 -270 0z m197
-176 c86 -23 140 -54 216 -129 176 -170 208 -425 79 -613 -68 -99 -191 -169
-301 -172 -63 -1 -66 0 -66 23 0 18 18 36 81 80 121 84 170 149 197 261 29
119 -20 259 -115 332 -39 30 -116 58 -158 58 -40 0 -107 -27 -153 -63 -48 -37
-79 -91 -111 -195 -32 -102 -50 -138 -77 -153 -36 -19 -59 15 -65 97 -18 222
94 402 294 470 82 28 89 28 179 4z m24 -340 c13 -7 19 -21 19 -43 0 -38 -7
-50 -102 -166 -7 -8 -50 -64 -96 -125 -46 -61 -94 -118 -107 -126 -22 -13 -27
-12 -52 6 -45 34 -40 54 33 150 37 49 70 91 73 94 4 3 40 49 81 103 90 120
106 131 151 107z"/>
<path d="M5802 2804 c-53 -37 -43 -119 17 -144 26 -11 264 -42 451 -60 47 -4
162 -17 255 -29 394 -49 411 -49 439 -6 35 53 11 109 -58 135 -16 6 -138 22
-270 35 -133 14 -254 27 -271 31 -16 3 -73 10 -125 15 -52 4 -162 15 -245 23
-82 9 -155 16 -160 16 -6 0 -21 -7 -33 -16z"/>
<path d="M5765 2466 c-23 -23 -26 -33 -22 -64 4 -20 14 -44 24 -54 19 -18 98
-34 243 -48 47 -4 117 -12 155 -18 80 -12 202 -26 360 -42 61 -6 126 -16 146
-21 20 -5 61 -9 90 -9 30 0 71 -5 91 -10 30 -9 44 -8 67 5 57 29 66 78 24 125
-31 34 -77 45 -333 74 -74 9 -193 23 -265 31 -71 8 -186 22 -255 30 -69 8
-164 18 -212 21 -84 7 -87 6 -113 -20z"/>
<path d="M5752 2140 c-34 -36 -36 -68 -8 -105 28 -37 75 -50 236 -65 47 -5
159 -18 250 -29 91 -12 213 -25 272 -31 59 -5 118 -14 133 -20 14 -5 50 -10
80 -10 29 0 76 -5 103 -11 41 -10 52 -9 74 5 41 27 54 69 34 111 -14 29 -26
37 -69 50 -29 8 -95 19 -147 25 -52 5 -171 19 -265 30 -93 12 -210 25 -260 30
-49 4 -115 13 -146 18 -31 6 -103 14 -161 17 -100 7 -106 7 -126 -15z"/>
<path d="M5732 1825 c-49 -23 -60 -55 -32 -100 28 -46 78 -71 160 -80 36 -3
155 -18 265 -32 110 -14 236 -29 280 -33 44 -4 155 -17 248 -30 155 -21 169
-21 192 -6 65 42 69 113 9 148 -30 18 -60 23 -314 53 -74 9 -166 21 -205 26
-38 5 -113 14 -165 19 -52 5 -102 11 -110 14 -8 3 -60 10 -115 16 -55 6 -118
12 -140 15 -24 3 -53 -2 -73 -10z"/>
</g>
</svg>
),

  library:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="296.000000pt" viewBox="0 0 300.000000 296.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,296.000000) scale(0.100000,-0.100000)">
<path d="M414 2938 c-3 -5 -10 -6 -15 -3 -5 4 -9 2 -9 -4 0 -5 -13 -12 -29
-16 -15 -3 -38 -15 -50 -26 -12 -11 -26 -17 -31 -14 -6 3 -10 1 -10 -5 0 -13
-61 -69 -75 -70 -13 0 -103 -90 -91 -90 5 0 1 -9 -9 -20 -10 -11 -14 -20 -9
-20 5 0 2 -5 -6 -10 -8 -5 -10 -10 -5 -10 6 0 10 -13 10 -30 0 -16 -4 -30 -10
-30 -5 0 -3 -5 5 -10 8 -5 11 -10 5 -10 -5 0 -10 -13 -10 -30 0 -16 4 -30 8
-30 5 0 5 -5 2 -10 -3 -6 -8 -70 -10 -143 -13 -394 -16 -470 -20 -476 -2 -4
-6 -90 -9 -192 -3 -101 -8 -218 -11 -259 -4 -64 -17 -413 -19 -532 -1 -21 4
-38 9 -38 6 0 3 -5 -5 -10 -11 -7 -11 -10 -2 -10 8 0 10 -5 5 -12 -8 -14 -15
-488 -8 -525 3 -12 15 -25 27 -29 12 -4 31 -18 41 -31 11 -13 22 -22 25 -19 2
3 31 -17 63 -45 32 -27 67 -52 78 -54 12 -3 29 -7 39 -9 121 -30 162 -36 208
-34 34 2 56 8 59 17 3 7 12 11 19 8 8 -3 27 3 41 15 21 16 34 19 63 14 20 -4
53 -10 72 -13 53 -10 302 -8 325 2 30 13 39 12 56 -2 8 -7 24 -14 35 -16 10
-1 25 -6 32 -11 16 -10 80 -11 142 -2 25 3 61 7 80 9 49 5 90 24 90 42 0 25 1
29 10 41 5 5 10 91 10 190 1 98 3 195 5 214 3 19 7 73 10 120 4 47 10 103 14
125 8 39 8 40 20 15 6 -14 20 -38 31 -55 20 -30 37 -64 39 -77 0 -5 10 -17 21
-28 11 -11 20 -27 20 -35 0 -8 5 -15 10 -15 6 0 9 -3 8 -8 -4 -12 35 -86 52
-99 13 -11 13 -12 0 -13 -12 0 -12 -3 2 -11 10 -5 15 -16 12 -24 -4 -8 -1 -15
5 -15 6 0 20 -20 31 -45 11 -25 25 -45 30 -45 5 0 7 -6 4 -14 -6 -15 13 -32
23 -22 6 5 -103 235 -116 246 -3 3 -26 45 -51 95 -25 49 -55 104 -67 123 -13
18 -23 36 -23 41 0 4 -12 18 -26 32 -25 23 -26 26 -20 119 4 52 11 254 16 448
5 193 11 356 14 361 3 4 6 47 7 94 1 49 5 84 10 81 17 -10 154 -297 193 -402
12 -33 92 -216 116 -267 5 -11 40 -87 79 -170 68 -148 272 -554 346 -690 71
-130 124 -230 136 -255 13 -30 20 -41 58 -100 17 -24 29 -46 27 -47 -1 -2 -43
10 -92 26 -91 29 -297 83 -414 108 -64 14 -130 46 -130 64 0 5 -8 17 -18 27
-9 10 -22 27 -28 38 -7 10 -16 15 -20 11 -5 -5 -1 -14 8 -21 10 -7 15 -15 13
-18 -3 -3 4 -13 15 -23 11 -10 20 -23 20 -30 0 -21 34 -43 95 -61 33 -9 66
-17 73 -17 6 0 12 -3 12 -6 0 -3 12 -7 28 -8 42 -4 61 -8 68 -16 4 -4 17 -7
29 -7 12 0 48 -9 79 -20 32 -11 68 -21 79 -23 12 -2 29 -7 37 -10 8 -3 29 -8
45 -11 40 -6 95 -26 95 -35 0 -8 77 -6 100 2 8 3 38 11 65 17 66 17 135 48
135 61 0 6 4 7 10 4 5 -3 35 17 65 46 52 49 55 55 55 100 0 27 -4 49 -10 49
-5 0 -10 6 -10 14 0 7 -11 33 -23 57 -48 89 -101 185 -122 219 -12 19 -29 52
-39 73 -9 20 -21 37 -26 37 -6 0 -10 5 -10 12 0 6 -6 19 -14 27 -8 9 -35 59
-61 111 -47 97 -53 107 -86 167 -11 19 -21 42 -22 53 -2 10 -8 24 -14 32 -6 7
-14 24 -18 38 -4 14 -16 37 -26 52 -11 14 -19 31 -19 38 0 6 -18 49 -40 95
-22 47 -39 87 -38 89 2 2 -6 13 -16 25 -11 12 -15 21 -10 21 5 0 1 5 -9 11 -9
6 -14 15 -11 21 4 6 2 13 -3 17 -9 6 -43 74 -44 88 -1 5 -9 19 -18 33 -16 23
-54 98 -56 110 -2 11 -40 87 -55 110 -10 14 -21 36 -25 50 -4 14 -18 40 -32
58 -13 17 -21 32 -17 32 4 0 0 8 -8 18 -9 9 -19 28 -23 42 -4 14 -16 37 -26
52 -11 14 -19 33 -19 42 0 9 -4 16 -10 16 -5 0 -10 4 -10 9 0 5 -5 22 -12 38
-6 15 -12 30 -12 33 -1 3 -9 16 -18 30 -9 14 -19 36 -23 49 -4 14 -15 39 -25
55 -14 26 -23 31 -51 30 -62 -2 -88 -8 -94 -22 -3 -7 -9 -11 -14 -8 -4 3 -16
-3 -26 -14 -10 -11 -22 -20 -27 -20 -12 0 -78 -53 -78 -63 0 -10 38 10 62 33
28 26 99 58 144 66 37 5 43 3 62 -21 31 -40 28 -49 -25 -64 -46 -14 -137 -81
-182 -134 -14 -16 -30 -35 -37 -42 -7 -7 -22 -27 -33 -46 l-21 -34 0 60 c0 33
5 78 10 100 6 22 12 128 15 235 3 107 6 217 7 244 3 46 1 52 -30 72 -18 13
-41 20 -52 17 -11 -3 -20 -1 -20 4 0 6 -24 9 -57 6 -32 -2 -69 -3 -82 -3 -27
0 -157 -35 -183 -50 -10 -6 -27 -10 -38 -10 -11 0 -20 -5 -20 -11 0 -5 -8 -9
-17 -8 -10 1 -31 -4 -48 -11 -16 -7 -37 -14 -46 -16 -8 -2 -28 -10 -44 -18
-16 -8 -32 -13 -37 -10 -4 3 -8 1 -8 -4 0 -11 -64 -29 -130 -37 -25 -2 -54 -6
-65 -7 -12 -2 -19 2 -18 9 2 7 6 75 9 151 l7 138 -29 19 c-16 11 -32 20 -36
21 -5 1 -9 2 -10 4 -16 12 -267 20 -274 8z m281 -43 c42 -21 40 -16 36 -106
l-1 -26 -102 5 c-97 4 -251 -8 -291 -24 -16 -6 -18 0 -15 61 l3 68 60 24 c52
20 74 23 165 20 80 -2 114 -7 145 -22z m-409 -495 c-9 -179 -18 -365 -21 -415
-7 -121 -13 -244 -20 -400 -3 -71 -7 -166 -10 -210 -2 -44 -8 -213 -11 -375
-4 -162 -8 -298 -10 -301 -2 -4 -7 -119 -10 -255 -4 -137 -7 -250 -8 -251 -1
-1 -39 26 -84 59 l-83 62 6 245 c3 135 8 354 10 486 2 132 11 389 20 570 9
182 20 420 25 530 4 110 11 277 15 370 5 100 12 176 19 184 6 8 47 46 91 85
l80 70 3 -64 c2 -36 -4 -211 -12 -390z m414 341 c16 -4 26 -15 28 -30 4 -22 2
-23 -30 -16 -80 19 -286 13 -360 -11 -13 -4 -18 0 -18 15 0 19 21 27 130 44
42 7 223 5 250 -2z m845 -6 c64 -17 75 -26 75 -65 l0 -25 -163 -1 c-95 0 -180
-6 -206 -13 -49 -14 -46 -15 -55 21 -5 24 -1 28 38 48 51 24 153 48 211 49 23
1 67 -6 100 -14z m-822 -66 c1 -2 1 -38 -1 -80 l-3 -75 -138 4 c-125 4 -201
-3 -255 -24 -18 -7 -19 -3 -13 76 4 46 11 88 17 94 15 15 165 22 288 15 57 -4
104 -9 105 -10z m451 -36 c3 -25 5 -48 3 -49 -2 -2 -19 1 -38 6 -18 6 -50 10
-69 10 -19 0 -46 3 -59 7 -20 5 -11 11 55 39 44 18 84 33 90 33 6 1 14 -20 18
-46z m398 -9 c42 -7 50 -21 42 -73 l-6 -37 -76 9 c-80 9 -284 4 -314 -8 -16
-6 -18 -1 -18 38 l0 44 48 8 c26 3 65 9 87 12 22 3 42 7 44 9 7 6 152 4 193
-2z m-437 -57 c38 -13 40 -16 40 -58 l0 -44 -190 -7 c-104 -3 -202 -9 -218
-12 l-28 -6 3 57 c3 63 8 67 108 80 25 3 47 8 50 10 10 10 195 -6 235 -20z
m435 -70 l35 -12 -3 -130 c-3 -117 -13 -318 -27 -517 -10 -140 -16 -178 -27
-172 -6 4 -94 7 -195 8 l-185 2 1 144 c1 140 3 182 17 465 4 72 7 146 8 165 1
34 2 35 56 47 73 15 276 15 320 0z m-867 -12 c9 -4 17 -15 17 -25 0 -17 -13
-18 -164 -19 -91 -1 -171 -3 -178 -5 -7 -3 -26 -7 -41 -11 -26 -5 -28 -4 -25
22 3 26 7 29 73 40 73 12 287 11 318 -2z m436 -51 c31 -6 31 -7 31 -71 l0 -65
-27 6 c-91 21 -302 16 -396 -11 -16 -4 -18 2 -15 63 l3 67 69 4 c39 2 72 6 75
8 7 7 223 6 260 -1z m-434 -209 c0 -181 -13 -465 -36 -805 -6 -85 -11 -284
-11 -442 1 -210 -2 -289 -11 -296 -15 -11 -387 -10 -406 2 -11 7 -12 36 -7
150 3 77 8 209 11 291 3 83 7 186 10 230 3 44 10 220 15 390 6 171 13 330 15
355 2 25 7 99 11 165 3 66 10 124 14 129 17 18 81 24 235 23 l160 -2 0 -190z
m404 58 l54 -6 -7 -331 c-3 -182 -8 -457 -11 -611 -6 -342 -24 -837 -30 -843
-12 -13 -115 -21 -268 -21 l-167 -1 1 447 c1 247 7 547 14 668 7 121 16 297
20 390 3 94 9 199 13 235 l7 65 55 6 c80 8 257 10 319 2z m849 -27 c10 -24 8
-26 -53 -54 -72 -34 -137 -90 -202 -174 -24 -32 -49 -58 -54 -58 -5 0 -14 11
-20 24 -14 30 3 64 68 131 62 65 99 95 153 128 57 34 93 35 108 3z m32 -67 c0
-17 66 -148 111 -219 22 -36 55 -97 74 -136 18 -39 57 -117 86 -175 124 -248
127 -254 271 -564 38 -82 80 -170 93 -195 12 -25 29 -58 36 -75 8 -16 27 -50
43 -75 76 -117 96 -149 117 -193 l23 -47 -30 -31 c-16 -17 -51 -46 -79 -64
-72 -48 -271 -144 -278 -134 -1 2 -10 20 -19 39 -10 19 -32 62 -51 95 -35 64
-140 262 -229 435 -49 96 -179 372 -264 560 -18 41 -54 127 -79 190 -25 63
-63 149 -83 190 -20 41 -44 93 -53 115 l-17 40 32 40 c47 61 107 124 149 157
56 45 147 74 147 47z m-427 -550 c1 -2 1 -40 -1 -84 l-3 -80 -200 -1 -199 0
-2 45 c-2 56 1 101 7 120 5 11 40 13 200 9 108 -3 196 -7 198 -9z m-7 -274 c1
-144 -13 -483 -27 -627 -7 -73 -13 -154 -14 -179 l0 -46 -80 -6 c-80 -5 -279
4 -288 13 -8 8 12 913 20 921 13 12 69 16 233 15 l155 -1 1 -90z m-1086 -710
l185 0 -1 -129 c-1 -112 -4 -130 -19 -139 -19 -10 -339 -3 -387 9 l-28 6 0
134 0 134 33 -8 c17 -4 115 -7 217 -7z m876 -173 l170 -4 -4 -62 c-2 -33 -5
-65 -6 -71 -5 -18 -213 -32 -294 -20 -40 5 -73 13 -72 18 0 4 0 41 0 83 0 69
2 75 18 69 9 -4 94 -10 188 -13z m1527 -19 c8 -16 12 -34 10 -40 -15 -43 -311
-233 -362 -233 -10 0 -24 15 -35 36 -9 20 -16 37 -14 38 2 2 26 11 53 21 105
39 198 90 263 146 37 31 68 58 69 58 1 1 9 -11 16 -26z m-1753 -22 c0 -10 -3
-46 -6 -79 -7 -60 -8 -62 -43 -72 -49 -15 -318 -24 -361 -13 -33 9 -35 11 -38
59 -2 27 -1 63 3 81 l6 32 87 -5 c48 -3 125 -1 172 4 148 16 180 15 180 -7z
m1819 -108 c17 -34 31 -74 31 -89 0 -40 -78 -107 -180 -156 -97 -46 -150 -57
-186 -37 -25 13 -74 85 -74 108 0 7 35 28 78 48 98 46 193 108 255 169 18 17
35 28 39 25 4 -3 21 -34 37 -68z m-2471 32 l182 0 0 -76 c0 -108 -11 -134 -68
-156 -65 -25 -207 -24 -282 1 -30 10 -58 21 -62 25 -4 3 -10 55 -13 113 l-5
107 33 -7 c17 -4 114 -7 215 -7z m1032 -98 c0 -21 -5 -58 -11 -82 -10 -38 -16
-46 -47 -56 -20 -7 -83 -12 -141 -13 -84 -1 -113 3 -138 17 -33 17 -33 18 -33
95 l0 77 185 0 185 0 0 -38z m-610 -13 c80 4 162 9 183 12 l37 6 0 -55 c0 -55
0 -56 -37 -68 -50 -16 -304 -14 -363 4 -42 12 -45 15 -44 48 3 72 0 68 42 57
23 -7 91 -8 182 -4z"/>
</g>
</svg>
),

  library2:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="417.000000pt" height="459.000000pt" viewBox="0 0 417.000000 459.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,459.000000) scale(0.100000,-0.100000)">
<path d="M25 4518 c-3 -13 -4 -1029 -3 -2258 l3 -2235 2050 0 2050 0 0 2255 0
2255 -2047 3 -2048 2 -5 -22z m3830 -330 c3 -13 4 -266 3 -563 l-3 -540 -70 0
-70 0 -5 60 -5 60 -365 5 c-237 3 -368 2 -373 -5 -4 -5 -6 -35 -5 -65 l3 -55
-182 -3 c-176 -2 -183 -2 -183 17 0 11 4 22 9 25 5 3 20 41 34 83 14 43 36
103 47 133 12 30 25 69 30 85 5 17 18 55 30 85 12 30 25 69 30 85 5 17 18 55
30 85 46 118 49 150 11 150 -11 0 -36 7 -55 17 -43 20 -61 9 -71 -45 -3 -20
-12 -46 -19 -57 -7 -11 -15 -31 -19 -45 -6 -30 -53 -163 -71 -205 -16 -35 -34
-87 -46 -130 -5 -16 -15 -48 -24 -70 -26 -70 -53 -139 -61 -158 -6 -13 0 -20
24 -28 44 -16 29 -29 -34 -29 l-55 0 -2 328 -3 327 -70 0 -70 0 -3 -328 -2
-328 -28 3 -27 3 0 415 0 415 -60 0 -60 0 -3 -418 -2 -418 -23 3 -22 3 -2 445
-2 445 -53 0 -53 0 -1 -435 c-1 -239 -2 -441 -3 -448 -1 -9 -13 -12 -38 -10
l-38 3 -3 388 -2 388 -91 -3 -91 -3 -2 -385 -1 -385 -32 -3 -33 -3 -2 328 -3
328 -95 0 -95 0 -3 -326 c-2 -278 -4 -328 -17 -333 -45 -17 -45 -18 -47 423
l-3 416 -80 0 -80 0 -5 -415 -5 -415 -25 0 -25 0 -2 445 -2 445 -68 0 -68 0
-5 -445 -5 -445 -37 -3 -38 -3 -2 448 -3 448 -70 0 -70 0 -2 -435 c-2 -239 -3
-441 -3 -447 0 -14 -70 -19 -70 -5 0 4 -2 205 -3 447 l-2 440 -70 0 -70 0 -5
-445 -5 -445 -32 -3 -33 -3 -2 448 -3 448 -30 0 -30 0 -3 -448 -2 -448 -28 3
-27 3 -2 549 c-2 385 1 554 9 563 8 11 332 13 1779 13 l1769 0 5 -22z m3
-1893 c1 -297 0 -550 -3 -562 -4 -19 -12 -23 -43 -23 -21 0 -43 5 -50 12 -9 9
-12 109 -12 389 0 286 -3 380 -12 385 -17 11 -138 8 -149 -3 -5 -5 -10 -182
-11 -393 l-3 -385 -60 0 -60 0 -3 349 c-1 241 -6 353 -14 363 -12 15 -125 16
-145 0 -10 -7 -13 -90 -13 -352 0 -381 2 -369 -67 -363 l-38 3 -3 323 -2 322
-85 0 -85 0 0 -312 c0 -172 -4 -319 -9 -326 -5 -8 -23 -12 -47 -10 l-39 3 -5
255 -5 255 -40 0 -40 0 -5 -255 -5 -255 -70 0 -70 0 -3 135 c-1 74 -6 138 -11
143 -9 9 -730 11 -739 2 -3 -3 -5 -63 -3 -133 3 -147 -1 -155 -71 -150 l-43 3
-5 365 -5 365 -45 0 -45 0 -5 -365 -5 -365 -33 -3 c-61 -6 -60 -16 -58 374 3
412 19 367 -132 362 l-94 -3 1 -355 c1 -195 -3 -361 -7 -368 -6 -8 -23 -12
-43 -10 l-34 3 -5 365 -5 365 -115 0 -115 0 -2 -354 c-1 -195 -5 -361 -7 -368
-7 -17 -60 -17 -75 1 -9 10 -11 124 -9 425 3 477 20 424 -127 419 l-90 -3 -5
-425 c-3 -234 -7 -426 -8 -428 -1 -2 -21 -2 -44 0 l-43 3 -5 365 -5 365 -110
0 -110 0 -2 -354 c-1 -195 -5 -361 -7 -368 -7 -17 -80 -17 -95 0 -8 10 -11
171 -10 558 0 299 3 547 5 551 3 5 805 7 1782 6 l1777 -3 3 -540z m-3 -837 c3
-13 4 -266 3 -563 l-3 -540 -30 0 -30 0 -3 448 c-2 347 -5 447 -15 448 -55 4
-155 6 -169 2 -17 -4 -18 -34 -18 -454 l0 -450 -42 3 -43 3 -5 450 -5 450 -83
0 c-46 0 -88 -3 -93 -6 -6 -3 -11 -181 -12 -450 l-2 -444 -45 0 -45 0 -2 358
c0 196 -4 364 -7 373 -5 12 -22 14 -93 12 l-88 -3 -3 -372 -2 -373 -45 0 -45
0 -2 423 -3 422 -75 3 c-41 2 -85 0 -97 -3 l-23 -5 -2 -418 -3 -417 -40 0 -40
0 -5 405 -5 405 -90 0 -90 0 -5 -405 -5 -405 -43 0 -43 0 -2 400 -2 400 -97 3
c-75 2 -98 0 -98 -10 0 -7 -1 -188 -3 -403 l-2 -390 -45 0 -45 0 -2 442 c-1
244 -4 446 -6 450 -6 9 -164 9 -173 1 -3 -4 -6 -206 -7 -450 l-2 -443 -35 0
-35 0 -2 325 c-1 179 -2 331 -2 338 -1 10 -24 12 -93 10 l-93 -3 -3 -337 -2
-338 -30 0 c-17 0 -30 5 -30 13 0 6 0 179 0 383 0 204 -2 379 -6 388 -5 13
-21 16 -88 16 -44 0 -87 -4 -93 -8 -10 -6 -13 -101 -15 -398 l-3 -389 -32 -3
-33 -3 0 445 c0 244 -3 451 -6 460 -9 23 -99 22 -108 0 -4 -9 -6 -211 -6 -448
0 -237 0 -437 0 -443 0 -7 -9 -13 -20 -13 -20 0 -20 7 -20 418 0 312 -3 421
-12 430 -17 17 -107 16 -114 -2 -3 -8 -6 -200 -7 -428 l-2 -413 -22 -3 -23 -3
-2 338 -3 338 -70 0 -70 0 -3 -337 -2 -338 -81 0 c-86 0 -102 14 -40 35 58 19
58 25 -9 205 -17 47 -35 99 -40 116 -4 18 -10 36 -14 42 -8 14 -65 169 -76
207 -5 17 -18 55 -30 85 -12 30 -25 66 -29 80 -4 14 -12 25 -17 25 -25 -2 -92
-27 -114 -44 -23 -18 -23 -21 -8 -38 8 -10 18 -31 21 -48 2 -16 15 -55 27 -85
12 -30 27 -73 35 -95 24 -74 66 -190 75 -210 4 -11 11 -29 13 -40 3 -11 15
-45 27 -75 12 -30 26 -71 32 -90 5 -19 15 -41 20 -47 17 -21 -8 -24 -153 -21
l-134 3 -2 540 c-2 297 0 550 2 563 l5 22 1775 0 1775 0 5 -22z"/>
<path d="M3028 3979 c-5 -3 -8 -21 -6 -40 l3 -34 305 0 305 0 3 33 c2 21 -2
34 -12 38 -20 8 -585 11 -598 3z"/>
<path d="M3020 3810 l0 -40 308 2 307 3 0 35 0 35 -307 3 -308 2 0 -40z"/>
<path d="M2967 3703 c-12 -11 -7 -60 7 -72 9 -8 112 -11 357 -9 l344 3 3 43 3
42 -354 0 c-194 0 -357 -3 -360 -7z"/>
<path d="M2969 3553 c-6 -6 -9 -33 -7 -60 l3 -48 373 -3 c204 -1 372 1 373 5
4 70 4 105 -2 109 -4 2 -170 5 -369 7 -267 1 -364 -1 -371 -10z"/>
<path d="M3019 3373 c-6 -6 -9 -33 -7 -60 l3 -48 373 -3 c204 -1 372 1 373 5
5 43 3 106 -4 110 -5 3 -171 6 -369 7 -264 1 -362 -2 -369 -11z"/>
<path d="M1888 2459 c-5 -3 -8 -24 -6 -45 l3 -39 330 -3 c182 -2 340 0 351 2
26 7 40 52 23 72 -9 11 -77 14 -351 16 -187 2 -344 0 -350 -3z"/>
<path d="M1949 2286 c-10 -11 -13 -135 -3 -160 5 -14 48 -16 374 -16 326 0
369 2 374 16 10 26 7 152 -4 159 -17 11 -730 11 -741 1z"/>
</g>
</svg>
),

  library3:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 width="900.000000pt" height="708.000000pt" viewBox="0 0 900.000000 708.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,708.000000) scale(0.100000,-0.100000)">
<path d="M144 7041 c-42 -11 -77 -39 -103 -83 l-21 -37 0 -3386 c0 -3368 0
-3386 20 -3425 11 -22 37 -51 57 -65 l38 -25 3022 0 3023 0 33 22 c19 12 43
36 55 55 l22 33 0 2142 c0 1305 4 2149 10 2158 7 12 10 11 15 -5 4 -11 13 -35
21 -53 8 -18 14 -39 14 -46 0 -8 7 -38 16 -67 16 -56 31 -110 60 -214 9 -33
23 -82 30 -110 14 -50 29 -102 57 -205 19 -69 42 -153 63 -227 26 -90 41 -143
57 -203 14 -51 21 -78 60 -215 8 -27 22 -79 32 -115 9 -36 23 -85 31 -110 7
-25 21 -72 30 -105 9 -33 22 -80 29 -105 7 -25 20 -74 30 -110 10 -36 23 -85
30 -110 7 -25 20 -74 30 -110 9 -36 23 -85 31 -110 7 -25 21 -72 30 -105 9
-33 22 -80 29 -105 7 -25 20 -74 30 -110 10 -36 24 -87 31 -115 8 -27 21 -75
30 -105 8 -30 22 -80 30 -110 19 -68 38 -139 59 -210 16 -57 36 -127 60 -215
8 -27 21 -72 28 -100 8 -27 22 -79 32 -115 9 -36 23 -85 30 -110 7 -25 20 -70
28 -100 14 -51 21 -78 60 -215 8 -27 22 -79 32 -115 57 -213 60 -221 87 -256
28 -34 90 -64 135 -64 21 0 70 10 108 21 39 11 86 24 105 28 19 4 51 12 70 18
19 6 61 18 93 27 31 9 81 23 110 31 28 8 79 22 112 31 33 9 80 22 105 29 25 7
74 20 110 30 36 10 85 23 110 30 25 7 74 20 110 30 160 43 189 55 225 98 33
38 35 45 35 111 0 39 -6 88 -14 111 -8 22 -22 69 -31 105 -10 36 -23 85 -30
110 -7 25 -20 70 -29 100 -8 30 -22 78 -29 105 -8 28 -22 79 -32 115 -25 92
-42 152 -71 255 -14 50 -30 104 -34 120 -4 17 -18 66 -30 110 -12 44 -26 94
-30 110 -9 36 -47 171 -66 240 -8 28 -21 75 -30 105 -8 30 -19 69 -23 85 -19
66 -54 193 -68 245 -8 30 -21 78 -29 105 -8 28 -19 68 -24 91 -5 22 -13 51
-18 65 -6 13 -18 53 -27 89 -10 36 -24 88 -31 115 -14 50 -29 103 -60 213 -8
31 -21 77 -29 102 -7 25 -21 74 -30 110 -10 36 -24 88 -31 115 -8 28 -21 74
-29 103 -17 62 -39 138 -58 207 -8 28 -22 79 -32 115 -10 36 -24 88 -31 115
-8 28 -21 74 -29 103 -17 62 -39 138 -58 207 -8 28 -22 79 -32 115 -18 68 -36
131 -60 215 -8 28 -21 77 -31 110 -9 33 -22 80 -29 105 -7 25 -20 74 -30 110
-9 36 -23 85 -30 110 -7 25 -20 70 -29 100 -8 30 -22 78 -29 105 -8 28 -22 79
-32 115 -10 36 -23 85 -30 110 -7 25 -20 74 -30 110 -9 36 -23 85 -31 110 -7
25 -21 72 -30 105 -9 33 -22 80 -29 105 -7 25 -20 74 -30 110 -9 36 -23 85
-30 110 -7 25 -21 72 -30 105 -37 128 -54 155 -120 185 -52 24 -79 25 -137 6
-24 -7 -72 -21 -108 -31 -36 -9 -85 -23 -110 -30 -25 -7 -74 -20 -110 -30 -36
-10 -85 -23 -110 -30 -25 -7 -74 -20 -110 -30 -36 -10 -85 -23 -110 -30 -25
-7 -74 -20 -110 -30 -36 -9 -85 -23 -110 -30 -25 -7 -72 -21 -105 -30 -165
-45 -196 -61 -227 -118 -21 -39 -23 -132 -4 -184 7 -21 18 -58 25 -83 6 -25
19 -70 27 -100 40 -139 42 -150 29 -160 -8 -7 -283 -9 -801 -8 l-789 3 -5 335
c-4 287 -7 339 -22 365 -23 43 -59 74 -99 85 -46 13 -1233 13 -1278 0 -19 -5
-48 -22 -64 -37 -53 -51 -57 -75 -57 -314 0 -131 -4 -220 -10 -224 -19 -12
-782 -6 -796 6 -12 9 -14 113 -14 597 0 561 -1 586 -19 616 -11 17 -35 42 -53
56 l-33 25 -890 2 c-490 0 -904 -2 -921 -6z m1614 -293 c15 -15 17 -234 3
-243 -11 -6 -1432 -7 -1439 0 -11 10 0 240 11 247 7 4 327 8 712 8 532 0 704
-3 713 -12z m10 -3193 c1 -1452 0 -2650 -3 -2663 l-5 -22 -718 2 -717 3 -3
2650 c-1 1458 0 2656 3 2663 3 10 153 12 722 10 l718 -3 3 -2640z m5353 2555
c14 -51 41 -146 54 -190 7 -25 21 -74 30 -110 10 -36 24 -87 31 -115 8 -27 21
-74 29 -103 17 -62 39 -138 58 -207 8 -27 22 -77 32 -110 9 -33 17 -75 18 -94
2 -41 -12 -50 -113 -77 -119 -31 -175 -46 -215 -59 -22 -7 -69 -20 -105 -30
-36 -10 -85 -23 -110 -30 -25 -7 -74 -20 -110 -30 -36 -10 -85 -23 -110 -31
-86 -25 -102 -23 -122 16 -9 19 -24 64 -33 100 -10 36 -24 88 -31 115 -8 28
-21 73 -28 100 -8 28 -21 75 -29 105 -9 30 -23 82 -33 115 -9 33 -22 80 -29
105 -7 25 -20 74 -30 110 -10 36 -23 85 -31 110 -25 87 -24 92 26 111 25 10
74 25 110 34 36 10 88 24 115 31 28 8 75 21 105 30 30 8 80 22 110 30 30 9 75
21 100 29 25 7 74 20 110 30 36 9 81 23 100 30 54 21 93 15 101 -15z m-3023
-428 l2 -352 -462 2 -463 3 -3 333 c-1 219 1 340 8 353 11 19 22 19 463 17
l452 -3 3 -353z m-1229 -246 c8 -10 10 -687 9 -2567 l-3 -2554 -394 -3 c-282
-1 -398 1 -407 9 -12 10 -14 416 -14 2553 0 1397 4 2546 8 2552 4 6 14 14 22
17 8 3 184 6 391 6 305 1 379 -2 388 -13z m3126 -228 c3 -13 4 -1119 3 -2458
l-3 -2435 -795 0 -795 0 -3 2445 c-1 1345 0 2451 3 2458 3 9 172 12 794 12
l791 0 5 -22z m-1900 -258 l0 -75 -443 -3 c-294 -1 -449 1 -462 8 -16 9 -20
21 -20 68 0 32 5 63 12 70 9 9 121 12 463 10 l450 -3 0 -75z m3371 -108 c7 -4
19 -36 29 -72 52 -201 50 -182 29 -197 -11 -8 -30 -16 -44 -19 -23 -5 -72 -18
-180 -49 -25 -7 -74 -20 -110 -30 -36 -10 -87 -24 -115 -31 -27 -8 -75 -21
-105 -30 -30 -8 -80 -22 -110 -30 -30 -9 -75 -22 -100 -30 -25 -8 -59 -14 -75
-14 -34 0 -27 -13 -81 163 -9 29 -14 66 -12 82 3 31 6 32 148 70 36 10 85 23
110 30 25 7 74 20 110 30 36 9 85 23 110 30 58 17 139 40 215 61 33 9 78 22
100 29 47 16 66 17 81 7z m-3368 -344 c2 -59 0 -78 -10 -78 -7 0 -213 0 -457
0 -347 0 -446 3 -453 12 -4 7 -8 36 -8 65 0 89 -31 84 478 81 l447 -3 3 -77z
m3536 -230 c2 -7 11 -42 21 -78 9 -36 23 -85 30 -110 17 -57 39 -138 61 -215
9 -33 22 -80 29 -105 7 -25 20 -74 30 -110 9 -36 23 -85 30 -110 7 -25 20 -70
29 -100 8 -30 22 -77 29 -105 8 -27 22 -79 32 -115 18 -68 36 -131 60 -215 8
-27 21 -77 31 -110 9 -33 22 -80 29 -105 7 -25 20 -74 30 -110 9 -36 23 -85
30 -110 7 -25 20 -70 28 -100 20 -73 66 -239 90 -325 8 -27 22 -79 32 -115 9
-36 23 -85 30 -110 7 -25 20 -70 29 -100 8 -30 22 -80 31 -110 18 -65 39 -138
60 -215 15 -57 33 -122 58 -210 8 -27 22 -79 32 -115 10 -36 23 -85 30 -110 7
-25 20 -74 30 -110 10 -36 23 -83 30 -105 26 -80 46 -161 48 -189 2 -34 7 -32
-278 -111 -27 -8 -72 -21 -100 -28 -27 -8 -79 -22 -115 -32 -115 -31 -239 -66
-319 -91 -25 -8 -48 -14 -53 -14 -11 0 -33 52 -53 130 -18 66 -34 125 -60 215
-8 28 -21 77 -31 110 -9 33 -22 80 -29 105 -7 25 -20 74 -30 110 -18 68 -36
131 -60 215 -8 28 -21 75 -29 105 -17 62 -42 153 -61 220 -7 25 -20 74 -30
110 -9 36 -23 85 -30 110 -7 25 -20 70 -29 100 -8 30 -22 78 -29 105 -8 28
-22 79 -32 115 -9 36 -23 85 -30 110 -7 25 -21 72 -30 105 -9 33 -22 80 -30
105 -7 25 -20 74 -30 110 -10 36 -23 85 -30 110 -7 25 -20 70 -29 100 -8 30
-22 78 -29 105 -8 28 -22 79 -32 115 -10 36 -23 85 -30 110 -7 25 -21 74 -30
110 -10 36 -30 108 -45 160 -15 52 -35 124 -45 160 -9 36 -23 85 -30 110 -7
25 -20 72 -29 105 -9 33 -28 101 -42 150 -43 145 -43 140 8 158 23 8 72 23
108 32 36 10 85 23 110 31 42 12 79 23 220 61 30 8 75 21 100 27 25 7 74 21
110 31 36 9 81 23 100 30 46 17 100 18 104 3z m-3536 -1795 l2 -1643 -459 0
c-409 0 -460 2 -465 16 -3 9 -6 742 -6 1629 0 1458 2 1615 16 1629 14 14 66
16 462 14 l447 -3 3 -1642z m-2340 -1905 c14 -14 17 -225 4 -246 -7 -10 -158
-12 -723 -10 l-714 3 -3 119 c-1 66 0 126 2 133 7 18 1416 19 1434 1z m2340
-145 l-3 -108 -449 -3 c-323 -1 -453 1 -462 9 -10 8 -14 38 -14 104 0 50 3 95
7 98 3 4 213 7 465 7 l459 0 -3 -107z"/>
<path d="M2412 5103 c-18 -9 -44 -31 -58 -48 -23 -31 -24 -38 -24 -197 l0
-166 40 -41 c38 -39 43 -41 97 -41 42 0 65 6 89 22 55 38 64 71 64 232 0 132
-2 146 -23 177 -49 72 -118 95 -185 62z"/>
<path d="M2420 4342 c-28 -13 -56 -37 -73 -62 -16 -22 -17 -74 -17 -588 l0
-563 26 -34 c36 -48 96 -70 149 -55 49 14 77 36 99 78 14 27 16 93 16 577 0
588 1 573 -53 623 -26 24 -116 39 -147 24z"/>
<path d="M2420 2752 c-28 -13 -56 -37 -73 -62 -14 -20 -17 -50 -17 -176 0
-150 0 -153 26 -184 55 -65 132 -79 197 -35 56 39 67 76 67 227 0 138 -6 163
-53 206 -26 24 -116 39 -147 24z"/>
<path d="M2392 1970 c-23 -16 -46 -38 -51 -49 -15 -27 -15 -925 0 -952 19 -36
89 -79 128 -79 51 0 102 30 128 76 23 39 23 42 23 479 0 437 0 440 -23 479
-44 78 -134 98 -205 46z"/>
<path d="M4753 4906 c-44 -20 -83 -81 -83 -132 0 -50 46 -120 87 -131 16 -5
221 -8 456 -8 l428 0 40 42 c35 38 39 48 39 94 0 56 -17 93 -58 124 -26 19
-44 20 -452 22 -345 2 -431 0 -457 -11z"/>
<path d="M4760 4401 c-13 -4 -39 -26 -57 -50 -25 -33 -33 -52 -33 -85 0 -59
45 -121 97 -135 50 -14 805 -15 855 -1 20 6 50 26 67 46 53 60 40 158 -27 209
-26 19 -44 20 -452 22 -234 1 -436 -2 -450 -6z"/>
<path d="M4780 3896 c-57 -15 -110 -79 -110 -133 0 -47 24 -95 63 -124 l32
-24 385 -3 c467 -4 482 -3 532 48 34 34 38 43 38 90 0 65 -26 111 -78 136 -34
17 -69 19 -427 21 -280 1 -403 -2 -435 -11z"/>
<path d="M4730 924 c-82 -70 -79 -175 7 -234 l37 -25 400 -3 c289 -2 413 0
444 9 119 33 141 191 36 260 -27 18 -55 19 -461 19 l-431 0 -32 -26z"/>
</g>
</svg>
),

  musicalNotes:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="984.000000pt" viewBox="0 0 900.000000 984.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,984.000000) scale(0.100000,-0.100000)">
<path d="M2726 9758 c-8 -26 -80 -330 -106 -448 -11 -52 -27 -122 -35 -155 -7
-33 -20 -91 -29 -130 -17 -81 -71 -322 -92 -412 -42 -182 -45 -197 -89 -403
-8 -38 -22 -100 -30 -137 -21 -100 -104 -469 -120 -538 -8 -33 -28 -125 -45
-205 -42 -199 -58 -275 -75 -345 -38 -161 -112 -492 -136 -610 -4 -22 -24
-110 -45 -195 -20 -85 -40 -176 -45 -202 -4 -27 -10 -52 -13 -56 -3 -5 -17
-64 -31 -132 -23 -115 -34 -140 -60 -140 -5 0 -48 25 -95 55 -205 134 -444
226 -669 261 -159 24 -283 13 -429 -37 -294 -100 -473 -325 -542 -683 -39
-197 -20 -362 59 -531 56 -119 128 -207 241 -297 76 -62 216 -139 310 -173
218 -78 531 -73 760 10 164 60 303 140 460 264 143 112 153 124 172 211 22 94
73 327 88 400 7 30 32 152 57 270 25 118 48 233 53 255 4 22 26 123 49 225 46
207 62 279 86 395 10 44 23 107 31 140 77 344 97 436 104 470 13 67 131 611
150 695 32 138 53 236 66 303 21 109 30 130 54 124 10 -3 139 -90 285 -193
317 -225 608 -432 725 -515 47 -33 131 -92 187 -132 230 -164 270 -192 313
-221 84 -56 201 -148 206 -161 3 -7 -11 -86 -31 -176 -52 -239 -65 -296 -81
-374 -8 -38 -21 -97 -29 -130 -19 -79 -102 -451 -121 -540 -8 -38 -21 -97 -29
-130 -8 -33 -26 -112 -40 -175 -14 -63 -39 -173 -56 -245 -17 -71 -35 -150
-40 -175 -4 -25 -17 -85 -28 -135 -12 -49 -32 -142 -46 -205 -22 -100 -35
-129 -55 -130 -3 0 -48 27 -100 61 -411 266 -852 342 -1165 200 -250 -113
-420 -343 -471 -635 -19 -110 -19 -307 -1 -402 33 -169 166 -361 336 -482 63
-46 206 -117 293 -146 109 -37 310 -69 377 -61 363 43 640 170 922 424 61 54
62 58 104 251 17 77 50 219 86 370 11 47 27 114 35 150 8 36 21 92 29 125 8
33 31 132 50 220 20 88 47 207 61 265 54 227 85 364 134 580 28 124 62 272 76
330 44 183 52 220 99 430 25 113 59 261 76 330 16 69 37 153 45 188 7 34 21
90 29 125 8 34 28 127 46 207 17 80 37 166 45 192 8 26 14 53 14 61 0 8 6 37
14 63 14 46 28 106 106 459 17 77 40 174 50 215 23 96 23 93 21 107 0 6 -34
35 -73 64 -40 29 -134 98 -209 154 -153 113 -263 193 -494 360 -88 63 -182
132 -210 152 -94 69 -370 267 -452 325 -46 32 -121 85 -168 118 -47 33 -123
87 -170 120 -47 33 -124 88 -172 122 -133 93 -442 301 -494 331 -50 29 -77 34
-83 15z m265 -961 c19 -13 108 -77 199 -143 91 -66 264 -191 385 -279 300
-216 325 -234 446 -323 59 -42 182 -131 274 -197 92 -66 213 -154 269 -196
l101 -76 0 -44 c-1 -44 -38 -230 -56 -277 -6 -16 -15 -23 -27 -20 -14 4 -512
356 -837 591 -38 28 -99 71 -135 96 -36 26 -135 96 -219 156 -84 61 -201 144
-260 185 -211 147 -260 185 -265 205 -3 11 2 52 10 90 8 39 22 104 31 145 16
79 28 110 42 110 4 0 23 -10 42 -23z"/>
<path d="M6280 7260 c-14 -4 -37 -11 -51 -14 -51 -11 -61 45 126 -711 46 -187
105 -428 130 -535 26 -107 53 -215 60 -240 7 -25 28 -106 45 -180 18 -74 74
-306 126 -515 51 -209 105 -429 119 -490 14 -60 37 -155 51 -210 51 -199 101
-403 165 -675 19 -82 37 -152 65 -255 8 -27 25 -97 38 -155 79 -335 112 -474
136 -555 5 -16 29 -118 55 -225 25 -107 64 -267 87 -355 22 -88 43 -170 45
-182 7 -30 -21 -36 -82 -17 -117 35 -289 28 -497 -22 -338 -80 -686 -355 -915
-724 -116 -187 -173 -370 -173 -556 0 -183 46 -314 151 -427 119 -130 297
-197 523 -197 325 0 751 241 1021 580 134 168 226 359 266 555 19 91 15 255
-9 355 -11 47 -64 261 -117 475 -212 859 -236 958 -284 1160 -47 197 -62 255
-96 380 -7 28 -23 93 -35 145 -12 52 -73 304 -136 560 -63 256 -122 497 -131
535 -9 39 -28 117 -43 175 -80 308 -113 461 -103 471 23 23 164 32 288 20 148
-15 221 -31 400 -88 485 -156 873 -501 1099 -978 74 -157 120 -313 161 -557
34 -199 18 -650 -34 -948 -20 -109 -43 -237 -61 -325 -17 -84 -24 -133 -21
-162 1 -14 58 -18 78 -5 23 15 63 146 123 407 53 232 89 511 105 825 6 111
-18 448 -41 570 -41 219 -91 374 -167 521 -45 86 -143 244 -176 283 -15 17
-45 56 -69 86 -55 72 -200 222 -282 291 -36 29 -67 56 -70 60 -3 3 -36 28 -75
57 -38 28 -81 59 -95 70 -40 30 -214 146 -505 337 -148 98 -329 222 -401 276
-311 233 -496 501 -664 964 -61 166 -62 168 -130 145z"/>
</g>
</svg>
),

  palette:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="648.000000pt" viewBox="0 0 900.000000 648.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,648.000000) scale(0.100000,-0.100000)">
<path d="M2481 6447 c-29 -35 50 -301 150 -506 89 -180 156 -275 309 -435 130
-135 247 -218 362 -257 35 -11 67 -25 73 -30 5 -5 15 -9 22 -9 36 0 91 -51
123 -112 18 -35 47 -83 64 -108 17 -25 47 -74 65 -110 19 -36 45 -81 57 -101
22 -36 72 -79 91 -79 20 0 53 -49 104 -155 98 -203 188 -341 388 -589 53 -66
120 -149 149 -185 70 -88 66 -83 156 -191 148 -177 181 -215 306 -355 201
-226 548 -576 780 -785 57 -52 127 -115 155 -141 27 -25 69 -61 91 -80 23 -18
91 -77 151 -129 60 -52 132 -114 159 -136 27 -23 99 -84 160 -135 61 -52 200
-166 309 -254 109 -88 239 -194 289 -235 176 -146 321 -248 442 -309 69 -35
74 -36 74 -18 0 24 -129 269 -228 432 -127 210 -422 651 -513 766 -16 20 -29
40 -29 45 0 4 -9 18 -21 30 -12 13 -35 43 -53 67 -236 338 -822 1031 -1265
1496 -86 90 -159 169 -163 176 -9 15 -429 410 -538 506 -116 101 -355 296
-467 379 -77 57 -105 84 -118 115 -10 22 -28 54 -42 72 -24 33 -120 106 -183
139 -60 32 -179 116 -209 146 -16 16 -38 58 -49 93 -12 34 -33 85 -48 111 -94
170 -314 383 -499 485 -16 9 -52 30 -80 46 -27 16 -86 44 -130 62 -254 104
-292 129 -335 218 -33 68 -43 79 -59 60z m189 -229 c53 -32 207 -108 220 -108
27 0 150 -83 150 -101 0 -5 -7 -6 -17 0 -82 41 -121 49 -141 29 -22 -22 -12
-44 48 -101 56 -52 75 -87 49 -87 -6 0 -33 16 -59 35 -54 40 -80 45 -80 15 0
-25 33 -92 66 -137 24 -31 32 -63 16 -63 -12 0 -72 66 -124 135 -64 86 -121
187 -163 289 -48 116 -39 140 35 94z m1089 -1025 c91 -80 161 -154 161 -171 0
-7 -13 -30 -30 -50 -16 -20 -44 -57 -63 -82 -48 -65 -65 -63 -107 12 -62 110
-75 132 -102 180 -16 26 -28 55 -28 66 0 28 65 94 99 101 2 1 33 -25 70 -56z
m396 -376 c46 -34 131 -107 191 -162 159 -147 214 -197 264 -241 198 -174 386
-361 660 -654 80 -85 179 -190 221 -235 42 -44 93 -100 115 -125 21 -25 41
-47 44 -50 14 -14 129 -148 146 -171 10 -14 42 -51 69 -84 90 -105 129 -151
195 -231 35 -43 67 -81 70 -84 6 -6 75 -89 115 -140 17 -21 73 -91 126 -156
177 -221 467 -600 564 -739 233 -332 287 -428 224 -395 -11 7 -37 26 -57 44
-21 18 -75 61 -122 97 -47 35 -87 66 -90 69 -3 3 -27 23 -55 45 -122 97 -451
379 -645 555 -58 52 -123 110 -145 130 -22 19 -78 71 -125 115 -47 44 -110
103 -141 130 -121 107 -468 437 -549 521 -85 89 -146 157 -296 330 -44 51
-133 154 -199 230 -288 331 -433 523 -601 792 -21 34 -70 111 -109 171 -83
128 -105 168 -105 187 0 28 30 13 62 -31 18 -25 77 -103 131 -173 54 -70 120
-160 148 -201 28 -41 103 -137 168 -215 64 -78 160 -197 212 -266 262 -349
405 -508 893 -995 417 -416 613 -601 830 -784 74 -63 139 -123 294 -272 135
-131 257 -229 283 -229 15 0 10 37 -6 50 -8 7 -15 16 -15 21 0 19 -120 177
-280 369 -52 63 -136 165 -185 225 -49 61 -128 156 -175 211 -85 102 -196 235
-311 374 -34 41 -76 91 -93 110 -17 20 -51 60 -76 90 -87 104 -324 381 -355
414 -5 6 -53 58 -104 116 -148 163 -545 562 -766 768 -110 103 -222 208 -250
234 -67 62 -84 78 -208 187 -59 52 -107 98 -107 101 0 15 16 21 39 15 13 -3
61 -34 106 -68z"/>
<path d="M3720 5015 c0 -25 23 -65 37 -65 18 0 17 45 -3 64 -19 20 -34 20 -34
1z"/>
<path d="M4685 6289 c-77 -5 -153 -14 -169 -19 -16 -6 -50 -10 -75 -10 -25 0
-66 -5 -91 -11 -25 -6 -81 -14 -125 -19 -44 -4 -111 -13 -150 -19 -291 -48
-380 -66 -438 -87 -20 -8 -44 -14 -53 -14 -30 0 -165 -73 -184 -100 -28 -40
-25 -74 8 -100 23 -18 35 -21 77 -16 48 6 110 24 185 52 33 12 82 23 265 59
44 8 118 24 165 35 103 23 310 63 440 85 240 40 694 39 880 -1 313 -68 522
-191 579 -340 27 -70 27 -164 2 -259 -27 -98 -43 -132 -118 -254 -101 -161
-133 -240 -133 -329 0 -86 18 -129 83 -194 84 -86 151 -111 296 -110 82 0 129
6 211 27 58 15 137 33 175 40 169 30 328 85 593 206 34 16 66 29 71 29 5 0 34
11 65 25 61 27 234 84 331 109 33 9 114 21 180 27 100 9 134 8 205 -4 136 -24
244 -72 363 -159 155 -115 224 -236 285 -498 22 -97 25 -562 3 -680 -43 -243
-121 -453 -292 -793 -159 -314 -211 -390 -408 -592 -59 -60 -142 -152 -185
-203 -83 -99 -165 -171 -371 -326 -71 -54 -134 -106 -139 -116 -8 -18 27 -83
153 -279 57 -90 72 -102 106 -81 270 165 575 449 902 837 59 71 283 385 283
398 0 2 12 21 26 42 30 44 105 198 129 263 26 72 46 133 55 165 4 17 18 66 30
110 45 165 54 241 57 490 4 253 1 276 -49 430 -28 86 -98 230 -145 300 -54 79
-69 112 -77 161 -27 162 -184 393 -355 523 -178 136 -379 193 -566 161 -182
-31 -576 -156 -845 -268 -126 -53 -302 -115 -412 -146 -61 -17 -223 -22 -232
-7 -7 11 17 109 33 137 5 11 36 64 69 119 78 133 92 174 92 267 0 98 -25 155
-99 228 -52 51 -204 140 -239 140 -13 0 -23 20 -62 125 -82 216 -276 360 -560
416 -30 6 -75 15 -100 20 -66 13 -562 19 -725 8z"/>
<path d="M4965 5960 c-17 -5 -57 -32 -90 -61 -73 -62 -90 -69 -163 -69 -76 0
-120 -13 -165 -51 -59 -49 -87 -114 -87 -202 0 -90 22 -130 90 -164 35 -18 61
-23 126 -23 l82 0 29 -37 c16 -21 39 -58 52 -83 63 -120 116 -155 220 -148
164 11 335 130 404 281 30 65 24 83 -53 160 -38 39 -72 78 -75 86 -2 9 -13 55
-24 104 -23 104 -51 147 -122 182 -55 28 -172 41 -224 25z m172 -77 c87 -40
133 -96 133 -162 0 -44 28 -121 60 -161 53 -68 54 -76 26 -135 -53 -107 -164
-175 -301 -182 -59 -3 -76 0 -110 19 -46 27 -82 76 -96 133 -6 22 -19 51 -29
65 -18 24 -23 25 -137 25 -77 0 -126 4 -140 13 -59 33 -43 155 27 215 40 34
87 47 178 47 43 0 87 23 137 70 22 21 54 45 70 53 40 22 135 21 182 0z"/>
<path d="M4681 5604 c-17 -7 -31 -17 -31 -22 0 -31 77 -45 100 -17 29 35 -16
61 -69 39z"/>
<path d="M4967 5403 c-15 -14 -5 -46 22 -74 27 -26 36 -29 95 -29 53 0 70 4
86 20 24 24 24 30 7 54 -12 17 -16 17 -66 2 -61 -18 -98 -13 -106 15 -6 19
-26 25 -38 12z"/>
<path d="M2510 5646 c-80 -39 -213 -112 -260 -141 -19 -12 -42 -25 -50 -29
-28 -13 -34 -17 -335 -215 -243 -160 -368 -251 -525 -385 -130 -110 -421 -402
-516 -516 -299 -359 -395 -510 -563 -883 -17 -37 -31 -73 -31 -80 0 -7 -6 -21
-13 -32 -8 -11 -16 -29 -20 -40 -3 -11 -15 -45 -27 -75 -101 -261 -141 -452
-147 -705 -5 -206 11 -315 80 -549 23 -80 143 -323 203 -411 147 -218 188
-270 304 -386 178 -179 327 -286 625 -452 140 -77 351 -177 426 -200 64 -20
97 -37 137 -71 102 -88 373 -254 492 -303 41 -17 102 -39 135 -48 33 -10 71
-21 85 -26 206 -67 476 -93 950 -93 324 0 417 5 615 34 461 68 477 70 546 85
37 8 77 15 90 15 12 0 48 6 78 14 31 8 92 22 136 31 194 42 223 48 270 61 28
7 79 20 115 30 142 36 348 99 398 120 18 8 38 14 44 14 26 0 307 106 466 177
29 12 78 34 110 47 31 14 121 56 199 95 78 39 144 71 148 71 10 0 230 -134
370 -225 125 -81 178 -105 235 -105 34 0 42 4 50 25 17 46 -22 119 -156 290
-68 88 -131 173 -139 188 -16 31 -13 36 58 94 15 13 27 29 27 37 0 8 -21 32
-47 53 -26 21 -86 70 -133 109 -47 39 -113 91 -148 117 l-62 45 -132 -74
c-177 -101 -573 -296 -715 -353 -29 -11 -76 -30 -104 -42 -65 -26 -255 -89
-389 -128 -58 -17 -125 -37 -150 -45 -25 -8 -74 -21 -110 -31 -36 -9 -78 -22
-95 -27 -51 -16 -128 -39 -165 -47 -19 -5 -71 -18 -115 -30 -106 -29 -224 -52
-405 -80 -41 -7 -102 -17 -134 -22 -70 -12 -271 -36 -411 -49 -55 -5 -152 -13
-215 -19 -147 -14 -733 -14 -870 -1 -223 22 -375 45 -453 69 -18 5 -63 17
-102 27 -122 28 -317 89 -435 134 -30 12 -66 25 -80 30 -138 45 -351 161 -582
316 -199 134 -547 490 -654 669 -189 316 -285 766 -224 1050 31 148 111 395
148 462 7 12 12 27 12 33 0 11 108 232 149 305 215 380 600 835 1041 1230 36
32 81 72 100 89 99 89 346 278 487 374 26 18 86 59 132 92 46 33 92 60 102 60
10 0 48 16 86 36 37 20 80 43 95 51 40 21 87 70 94 99 8 29 -19 74 -44 73 -9
0 -46 -15 -82 -33z"/>
<path d="M2385 4844 c-11 -2 -45 -9 -75 -16 -160 -34 -255 -117 -236 -209 3
-16 3 -36 -1 -45 -3 -8 -53 -38 -112 -65 -58 -28 -117 -56 -130 -62 -71 -34
-131 -128 -131 -206 0 -45 3 -52 38 -79 52 -42 104 -61 181 -68 59 -6 95 -2
257 25 58 10 116 -8 132 -42 10 -21 10 -38 1 -86 -11 -53 -11 -64 5 -100 34
-75 94 -111 187 -111 183 0 445 145 462 256 6 42 -3 99 -24 151 -15 37 -8 49
48 78 64 34 130 84 159 122 24 32 28 46 28 103 0 179 -105 279 -263 250 l-62
-11 -40 36 c-72 65 -116 78 -269 81 -74 2 -144 1 -155 -2z m246 -78 c76 -16
99 -26 156 -72 40 -33 45 -34 126 -34 120 0 185 -33 202 -102 17 -66 -20 -108
-145 -169 -73 -35 -120 -81 -120 -116 0 -13 5 -44 11 -68 6 -25 8 -57 4 -72
-7 -29 -127 -153 -148 -153 -7 0 -18 -5 -24 -11 -38 -38 -229 -72 -283 -51
-24 9 -25 13 -26 103 0 107 -16 149 -66 175 -36 19 -150 15 -313 -9 -117 -18
-176 -10 -218 29 -31 29 -32 35 -11 79 19 41 82 86 181 131 96 43 153 72 176
92 19 17 22 63 6 94 -21 40 34 88 149 128 31 11 70 20 87 21 16 0 39 4 50 9
31 13 133 11 206 -4z"/>
<path d="M2435 4710 c-112 -24 -156 -40 -187 -69 -37 -33 -41 -51 -22 -97 l16
-39 -41 -35 c-23 -20 -67 -45 -99 -55 -31 -11 -75 -27 -97 -36 -46 -20 -100
-72 -91 -87 3 -6 26 -18 51 -27 41 -16 50 -16 135 -1 50 10 137 19 193 22 129
7 145 -1 172 -78 16 -48 18 -65 9 -118 -9 -55 -8 -65 9 -86 25 -32 43 -30 133
12 148 69 193 137 159 238 -16 47 -16 49 4 69 11 11 57 43 102 71 53 32 94 66
112 92 32 45 31 65 -5 103 -20 22 -26 23 -141 20 l-119 -4 -17 44 c-28 77
-116 96 -276 61z m89 -110 c39 -14 33 -38 -11 -46 -80 -14 -153 -72 -153 -121
0 -33 -23 -55 -55 -51 -37 4 -44 32 -17 61 11 12 26 43 33 70 13 55 14 56 94
78 73 21 77 22 109 9z"/>
<path d="M7370 4401 c-161 -23 -375 -128 -491 -241 -51 -50 -139 -205 -139
-245 0 -8 -5 -35 -12 -59 -13 -50 1 -132 34 -198 60 -117 250 -218 410 -218
63 0 207 26 278 50 175 59 346 193 424 330 50 89 66 146 67 242 1 102 -15 145
-84 216 -76 79 -184 121 -332 127 -55 2 -125 0 -155 -4z m510 -287 c43 -129
-73 -347 -246 -464 -117 -78 -320 -150 -426 -150 -34 0 -46 6 -74 36 -33 34
-34 38 -34 120 0 93 9 121 67 191 100 124 365 258 556 283 38 4 71 11 75 14 3
3 20 6 38 6 28 0 34 -4 44 -36z"/>
<path d="M1290 3488 c-19 -5 -46 -12 -60 -15 -33 -8 -117 -62 -154 -99 -34
-35 -46 -63 -46 -112 0 -53 18 -81 79 -123 74 -51 78 -61 38 -91 -17 -14 -42
-30 -55 -37 -42 -22 -82 -90 -82 -138 0 -101 68 -163 217 -197 157 -35 474
-16 621 38 158 59 276 156 310 257 28 83 8 216 -47 312 -95 166 -238 218 -594
216 -106 -1 -208 -5 -227 -11z m430 -76 c84 -12 172 -38 235 -69 107 -54 139
-107 139 -238 0 -66 -4 -98 -16 -121 -35 -64 -125 -123 -238 -156 -30 -9 -82
-24 -115 -34 -47 -14 -97 -17 -235 -17 -151 0 -186 3 -255 23 -124 34 -171 82
-132 133 6 9 41 30 77 46 81 36 102 59 104 110 1 49 -22 76 -90 107 -28 12
-61 35 -73 49 -20 26 -20 28 -3 57 27 46 100 81 247 116 46 12 260 8 355 -6z"/>
<path d="M1331 3246 c-10 -12 -8 -19 8 -35 40 -40 79 -16 40 25 -26 28 -32 29
-48 10z"/>
<path d="M1525 2900 c-16 -4 -60 -8 -96 -9 -73 -1 -132 -17 -126 -34 16 -50
314 -19 305 32 -4 18 -38 23 -83 11z"/>
<path d="M1560 2314 c-160 -41 -274 -89 -380 -159 -132 -88 -200 -192 -200
-307 0 -105 36 -132 195 -149 89 -9 150 -23 171 -40 6 -5 14 -39 17 -75 7 -75
29 -117 89 -168 46 -39 99 -60 208 -81 94 -19 153 -19 255 0 157 29 259 73
331 143 97 96 110 180 44 290 -47 77 -47 76 47 126 93 50 126 123 88 196 -27
52 -102 80 -218 80 l-78 0 -52 48 c-97 91 -162 112 -336 111 -73 0 -149 -7
-181 -15z m354 -94 c54 -17 79 -33 133 -83 l66 -62 104 3 c112 2 143 -6 143
-40 0 -26 -56 -80 -115 -109 -98 -49 -120 -105 -71 -180 33 -49 33 -81 -1
-128 -46 -65 -107 -101 -228 -137 -147 -43 -343 -45 -409 -5 -57 35 -74 64
-81 139 -8 75 -16 95 -54 135 -43 47 -85 60 -216 66 l-120 6 3 50 c7 113 141
226 327 276 17 4 57 16 90 25 111 30 270 62 316 63 26 1 77 -8 113 -19z"/>
<path d="M1650 2158 c-153 -21 -249 -48 -357 -100 -64 -30 -123 -88 -123 -120
0 -24 62 -54 126 -61 135 -15 214 -60 214 -121 0 -97 34 -151 120 -190 37 -16
65 -20 155 -19 96 0 117 3 165 25 103 48 131 101 112 208 -13 70 -1 96 54 124
56 28 74 45 74 67 0 28 -57 59 -108 59 -48 0 -81 18 -133 72 -65 67 -132 80
-299 56z m118 -64 c58 -16 -9 -68 -116 -88 -40 -8 -85 -24 -108 -40 -34 -23
-48 -26 -122 -26 -68 0 -84 3 -89 17 -23 60 319 168 435 137z"/>
<path d="M5085 1915 c-305 -40 -490 -148 -502 -294 -7 -81 20 -107 195 -182
90 -39 102 -56 102 -141 0 -61 4 -79 24 -109 52 -77 184 -108 377 -90 63 6
129 15 145 20 16 5 58 17 94 26 85 23 240 98 271 131 18 19 24 37 24 69 0 49
-25 83 -82 110 -45 21 -40 46 12 63 61 20 70 34 69 107 0 56 -5 71 -33 112
-106 154 -368 221 -696 178z m425 -84 c122 -34 220 -102 220 -151 0 -24 -33
-55 -88 -83 -89 -44 -96 -95 -22 -158 28 -23 50 -47 50 -54 0 -29 -84 -87
-167 -114 -119 -39 -196 -51 -329 -51 -131 0 -131 0 -174 31 -41 30 -42 32
-36 75 7 52 -14 115 -52 156 -24 27 -159 98 -184 98 -8 0 -23 6 -33 14 -16 12
-17 17 -6 45 34 81 146 144 341 191 112 26 385 27 480 1z"/>
<path d="M4862 1608 c-9 -9 -8 -16 5 -30 20 -22 66 -23 84 -2 11 14 10 18 -6
30 -23 17 -67 18 -83 2z"/>
<path d="M5330 1353 c-21 -9 -69 -16 -120 -18 -47 -1 -84 -6 -84 -11 1 -5 14
-18 28 -29 35 -26 146 -27 194 -1 36 19 57 56 38 68 -14 10 -15 10 -56 -9z"/>
<path d="M3308 1676 c-99 -30 -184 -80 -225 -135 -39 -50 -41 -75 -12 -156 30
-87 23 -106 -77 -205 -96 -95 -114 -123 -114 -175 0 -170 235 -215 521 -99 60
24 120 44 133 44 13 0 54 -14 91 -31 64 -30 71 -31 158 -26 170 10 304 85 366
202 24 46 21 115 -9 175 -32 63 -48 71 -162 79 -79 6 -115 13 -152 31 -49 25
-86 62 -86 87 0 32 -53 115 -100 155 -92 79 -192 95 -332 54z m257 -116 c40
-25 77 -67 101 -115 10 -22 34 -65 51 -96 42 -73 78 -89 201 -89 98 0 132 -13
146 -53 8 -23 5 -34 -20 -69 -47 -67 -143 -112 -297 -139 -90 -15 -145 -6
-233 37 l-73 36 -52 -17 c-29 -10 -88 -35 -131 -56 -91 -45 -164 -64 -215 -54
-44 8 -83 32 -83 52 0 35 45 96 109 147 79 63 100 105 82 158 -6 17 -11 54
-11 82 0 76 31 115 130 162 95 46 232 53 295 14z"/>
<path d="M3327 1498 c-48 -17 -60 -25 -72 -55 -8 -20 -15 -61 -15 -93 0 -91
-9 -114 -66 -176 -54 -60 -67 -97 -42 -122 19 -19 36 -15 148 33 128 54 179
58 266 19 70 -31 184 -47 273 -38 80 8 128 44 117 87 -8 35 -43 57 -108 67
-65 11 -127 25 -150 35 -26 10 -54 64 -62 113 -11 74 -31 109 -75 131 -52 27
-136 26 -214 -1z m89 -71 c12 -32 -64 -137 -100 -137 -37 0 -9 79 44 124 35
29 48 32 56 13z"/>
</g>
</svg>
),

  file:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="984.000000pt" viewBox="0 0 900.000000 984.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,984.000000) scale(0.100000,-0.100000)">
</g>
</svg>
),

  gripVertical: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="504.000000pt" height="900.000000pt" viewBox="0 0 504.000000 900.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
<path d="M815 8944 c-381 -91 -652 -343 -761 -709 -36 -120 -45 -324 -19 -442
18 -86 51 -181 87 -258 82 -173 279 -371 448 -447 211 -96 409 -127 585 -93
281 54 484 178 650 395 117 153 195 387 195 585 0 259 -126 545 -318 720 -143
130 -290 205 -489 249 -90 20 -294 20 -378 0z"/>
<path d="M3795 8944 c-157 -38 -281 -93 -390 -174 -96 -71 -137 -112 -206
-204 -193 -254 -253 -588 -159 -876 59 -179 123 -283 250 -410 100 -100 175
-154 285 -202 73 -32 110 -44 230 -78 22 -6 85 -14 140 -17 231 -13 500 83
692 246 80 69 194 216 237 305 233 488 51 1054 -424 1314 -53 29 -179 74 -262
92 -106 24 -301 26 -393 4z"/>
<path d="M841 5479 c-72 -13 -214 -61 -281 -96 -268 -140 -440 -362 -516 -665
-24 -92 -26 -115 -21 -242 3 -120 9 -156 34 -241 48 -156 103 -260 197 -370
60 -71 69 -79 161 -149 168 -129 390 -206 595 -206 74 0 230 24 259 39 11 6
28 11 37 11 10 0 72 27 139 60 330 163 537 483 553 852 6 154 -20 276 -95 448
-83 189 -274 383 -463 469 -111 50 -110 50 -185 72 -81 24 -324 34 -414 18z"/>
<path d="M3821 5479 c-72 -12 -213 -61 -281 -96 -201 -103 -376 -289 -457
-485 -57 -139 -63 -161 -84 -320 -11 -75 -10 -103 6 -200 45 -282 174 -500
396 -669 81 -62 253 -149 294 -149 9 0 25 -5 36 -11 29 -15 185 -39 259 -39
74 0 230 24 259 39 11 6 27 11 36 11 14 0 185 80 244 114 45 27 160 128 204
180 113 133 172 248 217 421 32 124 33 331 2 451 -49 185 -121 318 -245 450
-130 140 -265 221 -477 285 -76 24 -320 34 -409 18z"/>
<path d="M835 2007 c-101 -19 -267 -84 -350 -136 -41 -26 -177 -137 -206 -169
-44 -47 -130 -175 -157 -233 -74 -159 -102 -276 -102 -436 0 -241 79 -456 234
-638 147 -171 311 -270 546 -331 102 -26 320 -24 434 5 196 50 333 128 471
266 146 146 214 270 271 495 50 195 24 406 -76 626 -87 192 -270 373 -474 469
-53 25 -102 45 -108 45 -7 0 -30 6 -53 14 -102 35 -311 47 -430 23z"/>
<path d="M3810 2005 c-72 -14 -98 -23 -220 -73 -207 -85 -398 -267 -490 -467
-61 -131 -77 -187 -101 -345 -21 -143 8 -305 90 -498 64 -149 171 -279 322
-393 166 -126 428 -200 644 -183 79 6 232 37 263 54 10 4 41 18 71 30 178 72
371 248 469 430 33 62 74 169 93 248 31 122 31 333 1 448 -52 196 -131 335
-271 475 -147 146 -314 234 -521 274 -89 18 -259 17 -350 0z"/>
</g>
</svg>
  ),
  
  
  deliveryBox: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="297.000000pt" viewBox="0 0 300.000000 297.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,297.000000) scale(0.100000,-0.100000)">
<path d="M1261 2795 c-223 -89 -413 -167 -423 -174 -16 -10 -18 -31 -20 -203
l-3 -191 -394 -158 c-217 -87 -398 -164 -403 -171 -4 -7 -8 -225 -8 -484 0
-361 3 -474 12 -487 14 -18 824 -347 855 -347 11 0 97 32 193 70 96 39 175 70
177 70 2 0 3 -78 3 -172 0 -95 4 -178 8 -185 9 -14 828 -343 854 -343 32 0
842 329 856 347 18 25 18 956 -1 975 -8 7 -138 63 -290 123 -152 61 -277 113
-277 117 0 3 23 14 50 23 86 29 80 -13 80 524 0 371 -3 481 -12 488 -13 10
-842 344 -849 342 -2 0 -186 -74 -408 -164z m512 38 c53 -21 97 -41 97 -44 0
-3 -42 -22 -93 -43 l-94 -37 -94 37 c-52 20 -98 39 -102 43 -6 6 156 77 183
81 3 0 49 -16 103 -37z m-295 -130 l93 -37 -47 -18 -47 -19 -81 32 c-130 52
-127 49 -81 70 45 20 37 21 163 -28z m567 21 c20 -8 36 -17 34 -18 -2 -2 -161
-65 -354 -141 -192 -75 -360 -143 -372 -151 -21 -13 -23 -22 -24 -117 0 -80
-3 -97 -11 -80 -15 30 -44 38 -73 19 -13 -9 -27 -16 -30 -16 -3 0 -5 49 -5
108 l0 108 288 114 c158 62 330 130 382 151 109 44 115 44 165 23z m-790 -94
c54 -22 100 -42 102 -44 2 -2 -39 -20 -92 -41 l-95 -37 -95 38 c-52 20 -95 40
-95 44 0 4 39 23 88 42 48 20 87 37 88 37 0 1 45 -17 99 -39z m1032 -2 c46
-18 83 -35 83 -38 0 -9 -170 -74 -190 -73 -10 1 -54 17 -99 35 l-82 34 88 36
c48 20 95 37 103 37 8 1 52 -14 97 -31z m-262 -141 l130 -52 3 -107 c2 -88 0
-108 -11 -108 -8 0 -20 7 -27 15 -20 24 -49 17 -69 -15 l-18 -30 -6 107 c-4
67 -11 111 -19 118 -7 7 -58 30 -112 51 l-99 39 39 17 c21 10 44 18 49 18 6 0
69 -24 140 -53z m-972 -19 l77 -31 0 -162 c0 -163 5 -185 39 -185 8 0 29 11
47 25 18 14 36 25 41 25 4 0 26 -37 48 -83 37 -76 42 -82 70 -82 l30 0 3 173
c2 160 4 173 20 168 9 -4 59 -23 110 -43 l92 -36 0 -419 c0 -230 -1 -418 -3
-418 -1 0 -164 65 -362 144 l-360 144 -3 421 -2 421 37 -16 c21 -9 73 -30 116
-46z m1394 -775 c-5 -4 -687 -278 -717 -288 -20 -6 -20 -3 -18 412 l3 418 108
44 c90 37 110 42 118 30 5 -8 9 -78 9 -157 0 -79 5 -152 10 -163 6 -11 21 -19
36 -19 22 0 31 11 65 85 22 47 43 85 48 85 4 0 22 -11 41 -25 39 -29 53 -31
74 -9 13 13 16 44 16 178 l0 163 103 40 102 41 3 -416 c1 -228 1 -417 -1 -419z
m-669 731 c51 -20 92 -37 90 -39 -7 -7 -183 -75 -192 -75 -15 0 -169 60 -179
69 -6 6 159 78 183 81 3 0 47 -16 98 -36z m-958 -339 c0 -30 -4 -55 -9 -55
-11 0 -114 41 -124 50 -6 5 101 56 126 59 4 1 7 -24 7 -54z m-127 -96 l127
-51 0 -34 c0 -19 -4 -34 -10 -34 -10 0 -307 117 -324 128 -8 4 52 38 74 41 3
1 62 -22 133 -50z m-95 -124 l222 -88 0 -68 0 -69 36 -18 c21 -11 33 -21 28
-24 -5 -3 -169 59 -364 138 -317 127 -352 143 -330 153 14 5 57 24 95 40 39
16 75 28 80 26 6 -1 110 -42 233 -90z m240 -764 c1 -232 -1 -421 -5 -421 -10
0 -714 283 -730 293 -10 6 -13 102 -13 421 0 227 2 415 5 418 3 3 171 -61 373
-142 l367 -148 3 -421z m376 376 l179 -71 -54 -23 c-30 -13 -61 -27 -69 -32
-13 -7 -16 -52 -20 -276 l-5 -268 -145 -59 c-80 -32 -153 -60 -162 -64 -17 -5
-18 19 -18 416 l0 421 43 19 c23 10 49 16 57 14 8 -3 96 -37 194 -77z m1586
-148 c23 -10 19 -14 -72 -50 l-98 -39 -256 101 c-300 117 -296 115 -269 125
11 4 55 22 99 39 l79 32 246 -98 c135 -55 257 -104 271 -110z m-619 0 c112
-44 252 -99 312 -121 l107 -41 0 -115 0 -114 -25 16 c-38 25 -63 20 -85 -16
l-20 -33 0 103 c0 57 -4 112 -10 122 -6 11 -91 50 -232 105 -123 48 -252 99
-287 113 l-65 26 40 17 c21 10 44 18 50 18 6 1 103 -35 215 -80z m-599 1 c80
-34 95 -36 146 -14 l37 15 273 -107 c150 -59 269 -111 265 -114 -5 -4 -49 -23
-100 -42 l-91 -35 -334 133 c-183 74 -342 138 -353 143 -18 8 -15 11 25 30 25
11 49 21 53 21 4 0 40 -13 79 -30z m178 -243 l305 -122 3 -424 c2 -400 1 -423
-15 -417 -10 4 -177 70 -370 148 l-353 142 0 422 0 422 63 -24 c34 -13 199
-80 367 -147z m1140 -251 c0 -319 -3 -416 -12 -423 -14 -11 -718 -293 -731
-293 -4 0 -6 189 -5 421 l3 421 110 44 c60 24 112 44 116 44 4 0 8 -77 11
-171 3 -136 6 -172 18 -179 36 -23 50 -11 93 78 23 48 43 89 44 91 1 2 18 -8
37 -23 38 -29 68 -33 85 -13 6 8 12 77 13 177 l3 163 90 38 c50 21 98 38 108
39 16 0 17 -26 17 -414z"/>
<path d="M2290 1835 c-63 -26 -80 -46 -64 -72 15 -23 55 -21 117 6 38 16 47
25 47 45 0 21 -27 49 -42 45 -2 0 -28 -11 -58 -24z"/>
<path d="M2285 1729 c-115 -47 -127 -55 -123 -82 6 -41 30 -42 129 -4 104 40
139 61 139 82 0 14 -27 45 -38 44 -4 0 -52 -18 -107 -40z"/>
<path d="M2731 556 c-57 -25 -75 -44 -65 -70 10 -26 39 -28 95 -6 49 19 79 42
79 61 0 12 -30 39 -43 39 -7 -1 -36 -11 -66 -24z"/>
<path d="M2722 447 c-57 -23 -108 -49 -113 -59 -11 -20 -3 -44 19 -53 22 -8
231 74 242 95 10 19 -13 60 -33 60 -7 -1 -58 -20 -115 -43z"/>
</g>
</svg>
  ),
  
subscription: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="660.000000pt" height="708.000000pt" viewBox="0 0 660.000000 708.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,708.000000) scale(0.100000,-0.100000)">
<path d="M470 7015 c-169 -31 -323 -151 -403 -313 -43 -87 -42 17 -42 -3157 0
-3188 -2 -3034 44 -3152 9 -24 19 -43 23 -43 4 0 15 -14 23 -31 32 -61 144
-159 220 -191 117 -50 12 -48 2221 -48 2001 0 2061 1 2126 19 94 27 161 66
233 136 61 60 128 165 148 234 7 23 13 313 17 823 l5 787 675 675 c446 446
682 690 697 718 12 24 27 71 34 106 12 56 11 71 -5 135 -22 84 -47 128 -105
180 -67 61 -121 80 -226 81 -146 1 -135 10 -621 -476 -306 -305 -426 -419
-438 -415 -15 6 -16 119 -16 1246 l0 1239 -222 219 c-123 121 -254 249 -293
283 -178 162 -615 573 -842 793 l-172 167 -1508 -1 c-1124 -1 -1525 -5 -1573
-14z m2962 -167 c2 -2 5 -311 8 -687 l5 -684 35 -18 c33 -18 70 -19 720 -19
520 0 689 -3 698 -12 9 -9 12 -308 12 -1282 l0 -1270 -733 -736 c-607 -609
-735 -742 -745 -775 -7 -22 -24 -75 -37 -119 -14 -43 -29 -84 -33 -90 -5 -6
-12 -20 -15 -31 -3 -11 -28 -87 -56 -168 -47 -139 -50 -151 -37 -181 20 -48
60 -62 126 -42 29 9 58 19 64 24 6 5 58 23 116 41 92 29 126 42 190 71 8 3 54
19 102 34 l87 27 474 476 c273 273 480 472 486 469 8 -5 11 -196 11 -649 0
-616 -1 -645 -20 -707 -32 -101 -102 -182 -202 -233 l-63 -32 -2075 0 c-1960
0 -2077 1 -2103 18 -14 9 -31 17 -37 17 -5 0 -33 16 -60 36 -55 40 -95 92
-129 168 l-21 49 0 3008 0 3009 32 67 c35 76 110 156 167 181 97 40 73 39
1579 41 798 0 1453 0 1454 -1z m538 -469 c85 -80 182 -169 215 -199 33 -29
103 -94 155 -144 53 -50 125 -118 160 -150 144 -133 259 -249 254 -257 -3 -5
-258 -9 -569 -9 -504 0 -563 2 -569 16 -12 30 -7 1062 5 1066 6 2 52 -37 103
-87 51 -49 161 -156 246 -236z m2265 -2599 c58 -36 85 -82 85 -142 0 -34 -7
-63 -18 -80 -22 -34 -248 -258 -260 -258 -15 0 -226 215 -224 228 4 16 221
228 260 254 37 25 115 24 157 -2z m-433 -497 c56 -56 98 -106 98 -117 0 -22
-1949 -1976 -1971 -1976 -23 0 -221 205 -217 224 5 28 1950 1966 1973 1966 12
0 59 -40 117 -97z m-2112 -2117 c46 -45 80 -86 78 -95 -5 -27 -278 -111 -278
-85 0 17 54 175 61 180 5 3 9 13 9 22 0 22 29 64 41 60 5 -2 45 -39 89 -82z"/>
<path d="M1615 6446 c-72 -15 -107 -31 -160 -70 -80 -60 -118 -114 -155 -221
-44 -128 -12 -300 76 -404 14 -17 24 -37 21 -44 -2 -6 -33 -27 -68 -45 -76
-38 -199 -153 -250 -232 -38 -60 -87 -172 -113 -261 -16 -55 -22 -173 -10
-204 10 -26 62 -48 100 -41 51 10 74 47 74 119 0 62 24 170 44 197 6 8 22 37
36 63 29 55 60 91 133 154 49 42 181 113 211 113 8 0 42 7 77 16 138 35 354
-35 487 -160 39 -36 110 -142 135 -201 26 -61 47 -154 47 -206 0 -40 4 -51 31
-73 40 -34 74 -33 110 3 24 25 29 38 29 79 0 101 -51 285 -103 367 -69 111
-163 205 -269 266 -38 22 -68 47 -68 56 0 8 13 32 29 52 57 73 81 148 81 256
0 134 -32 209 -129 306 -73 73 -125 101 -223 118 -77 13 -95 13 -173 -3z m177
-177 c76 -30 110 -59 146 -127 44 -83 44 -151 1 -233 -24 -45 -45 -68 -88 -96
-54 -37 -59 -38 -141 -38 -75 0 -90 3 -125 26 -90 60 -130 128 -130 224 0 63
4 76 34 123 32 50 98 112 119 112 5 0 23 7 38 15 40 20 84 19 146 -6z"/>
<path d="M973 4526 c-35 -37 -31 -90 9 -127 l32 -29 1537 0 1537 0 31 31 c39
38 40 76 5 118 l-26 31 -1551 0 -1552 0 -22 -24z"/>
<path d="M990 3963 c-34 -23 -40 -33 -40 -71 0 -25 8 -41 32 -63 l32 -29 1534
0 c1427 0 1535 1 1559 17 39 26 55 71 37 105 -32 63 92 58 -1594 58 -1426 0
-1537 -1 -1560 -17z"/>
<path d="M993 3390 c-57 -34 -57 -104 1 -139 l33 -21 1524 0 c1191 0 1529 3
1548 13 14 6 33 26 44 44 17 29 17 34 2 62 -33 65 79 61 -1597 61 -1496 0
-1524 0 -1555 -20z"/>
<path d="M982 2811 c-41 -39 -44 -86 -6 -122 l26 -24 1533 -3 c988 -1 1542 1
1559 8 14 5 35 24 45 41 24 39 13 79 -29 109 -28 20 -45 20 -1562 20 l-1534 0
-32 -29z"/>
</g>
</svg>

  ),
  

   yes:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="900.000000pt" height="693.000000pt" viewBox="0 0 900.000000 693.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,693.000000) scale(0.100000,-0.100000)">
<path d="M8728 6866 c-10 -23 -15 -25 -49 -20 -25 4 -44 2 -54 -6 -11 -10 -39
-11 -104 -7 -88 7 -88 6 -100 -19 -11 -24 -16 -26 -56 -22 -30 4 -48 1 -58 -9
-18 -19 -85 -34 -152 -36 -38 -2 -56 -8 -74 -26 -19 -19 -30 -22 -62 -18 -32
4 -45 0 -67 -18 -16 -14 -48 -26 -77 -30 -28 -4 -60 -13 -72 -21 -12 -8 -44
-14 -71 -14 -32 0 -54 -5 -62 -15 -7 -8 -39 -31 -72 -51 -47 -29 -66 -35 -91
-30 -25 4 -42 -1 -76 -24 -24 -17 -51 -30 -59 -30 -9 0 -23 -6 -31 -13 -9 -7
-36 -22 -61 -32 -25 -10 -52 -25 -61 -32 -8 -7 -27 -13 -41 -13 -14 0 -31 -6
-37 -14 -6 -7 -25 -16 -42 -20 -17 -3 -40 -17 -51 -31 -11 -14 -28 -25 -38
-25 -9 0 -23 -7 -30 -15 -7 -8 -24 -15 -39 -15 -14 0 -57 -20 -94 -45 -38 -25
-74 -45 -81 -45 -7 0 -30 -13 -52 -30 -21 -16 -49 -30 -60 -30 -12 0 -27 -7
-34 -15 -7 -8 -19 -15 -27 -15 -9 0 -31 -13 -50 -30 -18 -16 -40 -30 -47 -30
-7 0 -21 -9 -31 -20 -10 -11 -23 -20 -28 -20 -6 0 -25 -11 -43 -25 -18 -14
-37 -25 -42 -25 -5 0 -17 -9 -27 -20 -10 -11 -22 -20 -28 -20 -5 0 -22 -11
-39 -25 -16 -14 -37 -25 -47 -25 -10 0 -40 -20 -67 -45 -27 -25 -54 -45 -61
-45 -13 0 -84 -46 -93 -59 -3 -5 -22 -16 -42 -24 -21 -9 -38 -20 -38 -26 0 -5
-23 -23 -50 -40 -28 -17 -53 -38 -57 -46 -3 -9 -31 -32 -62 -52 -31 -21 -58
-40 -61 -44 -3 -3 -15 -9 -28 -13 -12 -4 -26 -16 -32 -26 -5 -10 -35 -35 -67
-56 -32 -20 -71 -52 -86 -71 -16 -18 -35 -33 -44 -33 -8 0 -57 -38 -108 -85
-51 -47 -97 -85 -103 -85 -6 0 -32 -24 -59 -54 -53 -59 -128 -120 -162 -131
-11 -3 -21 -12 -21 -18 -1 -18 -44 -64 -68 -71 -12 -4 -24 -16 -27 -27 -4 -10
-15 -19 -25 -19 -11 0 -22 -11 -29 -30 -5 -16 -14 -30 -18 -30 -5 0 -61 -50
-124 -111 -62 -61 -133 -127 -156 -146 -22 -18 -44 -45 -47 -58 -4 -14 -11
-25 -17 -25 -6 0 -43 -35 -82 -77 -40 -43 -91 -95 -115 -117 -23 -21 -42 -44
-42 -49 0 -11 -110 -117 -122 -117 -4 0 -20 -19 -37 -43 -16 -24 -53 -68 -83
-98 -29 -30 -65 -73 -81 -97 -15 -23 -31 -42 -36 -42 -4 0 -20 -17 -35 -39
-15 -21 -38 -43 -51 -49 -14 -7 -25 -18 -25 -25 0 -18 -48 -81 -180 -237 -59
-69 -114 -136 -123 -149 -9 -14 -34 -43 -55 -65 -22 -23 -48 -59 -60 -81 -11
-22 -32 -50 -46 -62 -14 -13 -26 -28 -26 -35 0 -6 -10 -22 -22 -35 -12 -13
-34 -45 -48 -71 -25 -46 -26 -47 -80 -50 l-55 -2 -20 42 c-11 23 -47 69 -79
103 -32 33 -70 78 -84 100 -14 22 -52 66 -84 98 -32 32 -63 68 -68 81 -5 15
-20 25 -39 29 -17 4 -35 16 -42 29 -15 29 -80 98 -92 98 -5 0 -32 24 -61 53
-28 28 -75 72 -105 97 -29 25 -66 57 -82 73 -16 15 -34 27 -40 27 -5 0 -28 17
-52 38 -23 21 -59 49 -80 61 -20 12 -43 30 -50 40 -18 24 -162 126 -212 150
-11 5 -30 21 -42 35 -13 14 -27 26 -32 26 -5 0 -40 20 -77 45 -36 25 -73 45
-80 45 -8 0 -14 4 -14 9 0 5 -17 20 -37 32 -21 13 -44 29 -51 36 -7 7 -24 13
-37 13 -13 0 -28 6 -32 14 -4 8 -31 27 -58 43 -48 28 -58 30 -202 36 -110 4
-161 11 -183 22 -21 11 -53 16 -93 14 -62 -1 -159 13 -207 31 -14 6 -70 12
-125 14 -55 3 -110 8 -121 11 -17 5 -26 -1 -42 -27 -12 -18 -42 -53 -68 -78
-26 -25 -57 -61 -70 -81 -12 -20 -29 -42 -36 -50 -8 -8 -19 -22 -25 -32 -13
-25 -76 -98 -141 -162 -59 -60 -64 -81 -25 -96 15 -6 46 -26 69 -45 23 -19 49
-34 58 -34 19 0 106 -58 106 -71 0 -5 21 -19 48 -30 26 -11 61 -36 79 -54 20
-22 41 -35 57 -35 15 0 31 -9 38 -21 7 -11 33 -33 58 -48 25 -16 63 -45 85
-66 22 -20 57 -47 77 -61 21 -13 45 -35 54 -49 9 -14 24 -25 34 -25 10 0 41
-21 69 -47 28 -27 91 -84 141 -128 103 -90 430 -413 430 -424 0 -4 33 -41 73
-82 86 -91 159 -175 178 -209 8 -13 53 -68 102 -122 48 -54 87 -104 87 -113 0
-8 14 -27 30 -42 17 -14 30 -32 30 -39 0 -7 8 -15 18 -18 10 -4 28 -26 40 -51
12 -25 29 -48 37 -51 9 -4 25 -29 37 -56 13 -30 30 -53 44 -58 14 -6 26 -22
32 -44 6 -19 19 -44 29 -56 11 -11 35 -47 54 -80 19 -34 44 -72 56 -86 13 -14
23 -36 23 -48 0 -14 10 -30 25 -40 14 -9 25 -22 25 -28 0 -7 21 -43 46 -80 47
-71 108 -179 145 -258 53 -113 64 -132 76 -137 7 -3 13 -14 13 -24 0 -10 27
-70 60 -134 33 -64 60 -121 60 -127 0 -6 11 -26 25 -44 13 -17 27 -51 31 -74
4 -23 17 -57 30 -76 13 -19 24 -46 24 -61 0 -14 11 -38 24 -53 13 -16 29 -53
36 -82 6 -29 24 -78 38 -108 20 -42 26 -69 24 -112 -1 -50 1 -58 19 -63 12 -4
25 -3 29 2 8 8 49 79 95 165 13 26 29 49 35 53 5 3 10 15 10 25 0 10 8 21 18
25 11 3 31 30 45 60 15 29 36 56 47 60 11 3 20 12 20 20 0 7 15 34 34 58 19
25 42 60 52 79 9 18 36 54 60 80 24 26 44 54 44 62 0 9 20 38 45 66 25 28 45
56 45 63 0 8 14 26 30 42 17 16 30 33 30 38 0 6 26 44 58 86 32 42 70 96 86
121 16 25 41 55 57 68 15 12 30 35 34 51 3 16 12 32 20 35 7 2 22 25 33 49 12
26 29 48 41 52 12 3 28 21 37 38 33 69 47 90 75 106 16 9 34 30 39 47 6 17 33
55 60 84 28 30 50 57 50 61 0 4 22 34 50 66 27 32 50 62 50 66 0 8 81 109 131
164 37 41 119 145 119 152 0 4 14 15 31 25 17 10 35 30 42 44 17 41 58 92 72
92 18 0 55 48 55 71 0 9 13 28 28 41 16 13 44 43 63 68 40 53 173 206 204 235
11 11 26 32 33 48 6 15 16 27 22 27 14 0 70 61 70 76 0 7 16 21 35 33 20 11
44 35 53 53 9 18 45 61 79 95 34 34 69 75 78 92 8 17 28 37 44 45 15 8 39 30
53 48 14 18 75 84 136 146 62 63 130 136 152 162 23 27 49 52 59 55 10 3 22
14 27 24 5 10 48 53 97 96 48 43 87 84 87 90 0 7 17 25 38 41 20 15 60 51 88
79 28 27 119 111 203 185 83 74 191 174 240 221 48 48 96 89 107 93 17 5 94
70 134 113 8 9 22 22 30 29 8 7 40 35 70 62 30 27 66 53 80 57 14 4 41 22 60
39 19 18 51 43 70 55 19 13 42 37 50 54 10 22 25 34 49 40 19 5 56 29 82 54
27 25 60 54 74 63 14 9 31 23 38 32 6 8 31 20 55 27 23 6 42 16 42 20 0 14 53
62 85 76 16 7 47 28 67 47 57 51 95 78 108 78 12 0 38 19 118 86 20 18 53 39
72 48 19 9 60 32 90 51 30 19 70 42 88 50 17 7 32 19 32 24 0 6 8 11 18 11 10
0 29 8 42 17 14 10 37 25 51 33 15 8 47 28 70 44 24 16 66 38 93 47 61 23 91
50 117 109 12 25 28 61 37 80 17 36 58 98 77 115 10 9 95 172 95 182 0 2 -12
-3 -27 -11 -16 -8 -36 -17 -46 -20 -9 -3 -22 -18 -28 -32 -5 -15 -16 -32 -23
-38 -23 -18 -136 -199 -136 -217 0 -24 -90 -104 -147 -130 -26 -13 -67 -37
-90 -55 -23 -17 -60 -34 -82 -38 -26 -4 -44 -14 -55 -31 -10 -14 -29 -31 -44
-37 -15 -7 -36 -19 -47 -29 -11 -9 -36 -22 -56 -28 -20 -7 -58 -27 -85 -46
-27 -19 -64 -38 -82 -41 -25 -5 -31 -10 -27 -23 6 -20 -74 -91 -104 -91 -11 0
-33 -11 -49 -25 -17 -14 -35 -25 -41 -25 -6 0 -17 -13 -25 -28 -10 -19 -31
-35 -59 -46 -25 -9 -53 -26 -63 -38 -11 -11 -41 -35 -69 -53 -27 -18 -68 -50
-90 -71 -22 -22 -51 -45 -65 -52 -36 -18 -80 -51 -131 -99 -62 -58 -136 -115
-191 -147 -31 -17 -48 -34 -48 -46 0 -16 -5 -19 -30 -13 -27 5 -30 3 -30 -21
0 -20 -5 -26 -22 -27 -15 0 -40 -21 -73 -59 -27 -33 -75 -76 -105 -97 -59 -39
-99 -80 -100 -100 0 -19 -65 -63 -93 -63 -17 0 -28 -7 -32 -20 -13 -40 -287
-299 -352 -332 -27 -13 -44 -30 -48 -46 -7 -29 -139 -162 -160 -162 -8 0 -15
-5 -15 -11 0 -16 -122 -135 -157 -153 -18 -9 -34 -24 -35 -34 0 -9 -1 -24 -2
-32 -1 -8 -13 -21 -28 -28 -16 -7 -30 -23 -33 -35 -7 -25 -56 -57 -89 -57 -26
0 -56 -29 -56 -54 0 -32 -40 -96 -59 -96 -22 0 -81 -63 -81 -86 0 -8 -25 -37
-55 -65 -30 -28 -57 -59 -60 -69 -3 -9 -17 -22 -30 -28 -14 -6 -25 -17 -25
-23 0 -6 -25 -35 -55 -64 -30 -29 -55 -58 -55 -64 0 -5 -6 -14 -13 -18 -8 -4
-24 -23 -37 -40 -13 -18 -31 -33 -41 -33 -23 0 -36 -18 -44 -63 -7 -36 -44
-77 -70 -77 -15 0 -49 -37 -69 -77 -9 -18 -26 -43 -39 -57 -12 -13 -31 -36
-42 -51 -39 -52 -104 -130 -134 -161 -17 -16 -31 -35 -31 -40 0 -6 -16 -25
-35 -43 -19 -17 -46 -49 -60 -71 -14 -22 -31 -40 -39 -40 -7 0 -18 -12 -25
-26 -6 -15 -38 -56 -70 -93 -33 -36 -61 -75 -63 -86 -2 -11 -16 -26 -31 -33
-15 -7 -27 -21 -27 -31 0 -9 -18 -35 -41 -56 -22 -22 -56 -70 -76 -107 -19
-37 -46 -74 -59 -83 -22 -14 -55 -58 -115 -152 -12 -18 -29 -33 -39 -33 -28 0
-50 -28 -50 -63 0 -25 -8 -37 -35 -56 -19 -13 -35 -32 -35 -42 0 -25 -84 -155
-110 -171 -12 -7 -37 -42 -57 -78 -20 -36 -49 -81 -64 -100 -15 -19 -32 -52
-39 -72 -6 -21 -16 -38 -20 -38 -5 0 -21 -20 -35 -44 -14 -23 -34 -51 -45 -61
-12 -11 -29 -39 -40 -63 -22 -50 -43 -52 -48 -4 -2 22 3 36 17 49 13 11 21 30
21 48 0 21 9 40 25 55 14 13 25 29 25 36 0 20 -21 28 -35 13 -22 -24 -105
-187 -105 -208 0 -11 -4 -23 -10 -26 -5 -3 -10 -15 -10 -26 0 -10 -8 -27 -18
-37 -9 -9 -29 -38 -44 -62 -14 -25 -49 -69 -76 -98 -44 -47 -53 -52 -71 -42
-12 6 -21 20 -21 31 0 36 -24 98 -41 102 -9 2 -21 25 -29 53 -7 27 -18 58 -24
69 -7 11 -18 40 -25 65 -7 25 -17 52 -22 60 -5 8 -12 23 -15 33 -4 9 -9 17
-13 17 -4 0 -17 14 -30 31 -17 22 -20 34 -12 43 8 10 7 17 -5 27 -19 15 -47
69 -75 143 -11 31 -36 78 -54 105 -19 27 -55 93 -80 146 -26 53 -61 116 -78
140 -55 76 -97 144 -97 157 0 19 -89 148 -106 155 -8 3 -24 24 -36 47 -11 22
-29 51 -38 64 -10 12 -16 31 -13 42 4 13 0 20 -10 20 -25 0 -41 30 -42 78 -1
37 -5 47 -21 52 -33 9 -59 33 -87 83 -16 26 -45 64 -66 85 -21 21 -41 47 -45
59 -4 12 -16 25 -27 28 -12 4 -19 15 -19 30 0 28 -25 56 -45 49 -7 -3 -20 5
-30 19 -9 14 -25 27 -35 30 -16 4 -20 14 -20 45 0 34 -5 44 -30 62 -17 12 -38
36 -47 53 -20 40 -73 97 -136 145 -27 20 -58 53 -69 72 -12 19 -35 49 -52 67
-17 17 -62 67 -101 110 -38 44 -85 89 -102 101 -18 12 -33 27 -33 33 0 18 -57
69 -78 69 -27 0 -55 33 -40 48 9 9 9 18 0 37 -12 25 -36 33 -47 15 -10 -17
-24 -11 -68 28 -23 21 -55 46 -72 56 -16 11 -48 34 -70 53 -56 48 -122 98
-177 134 -25 17 -49 41 -52 54 -4 16 -18 27 -43 36 -21 6 -49 20 -62 30 -13
11 -30 19 -38 19 -7 0 -23 15 -34 34 -11 19 -31 37 -45 40 -13 4 -42 22 -63
41 -21 19 -44 35 -50 35 -7 0 -29 9 -51 20 -36 19 -38 22 -30 50 5 17 7 37 4
45 -10 25 81 147 128 171 22 11 28 21 28 48 0 25 6 35 25 44 14 7 33 25 42 40
14 25 22 29 55 26 20 -1 42 -5 48 -9 6 -4 22 1 37 10 21 14 30 15 52 5 41 -19
132 -41 142 -34 6 3 5 11 -2 20 -9 11 -9 18 -1 26 9 9 26 9 70 1 31 -7 93 -17
137 -24 44 -6 104 -20 132 -31 36 -14 75 -20 124 -19 87 1 155 -15 192 -46 16
-12 34 -23 41 -23 7 0 25 -13 39 -30 15 -16 33 -30 41 -30 8 0 37 -16 65 -35
28 -19 59 -35 70 -35 11 0 51 -29 90 -65 39 -36 77 -65 85 -65 7 0 19 -7 26
-15 7 -8 20 -15 30 -15 9 0 38 -20 64 -45 27 -25 52 -45 57 -45 4 0 31 -20 59
-45 28 -25 55 -45 59 -45 5 0 14 -13 19 -30 7 -18 22 -35 39 -41 68 -28 96
-46 109 -70 7 -15 31 -34 54 -43 26 -10 48 -29 61 -50 11 -19 35 -44 54 -55
19 -11 40 -32 48 -48 8 -15 39 -48 69 -73 98 -83 189 -174 210 -212 12 -21 30
-40 39 -43 10 -3 21 -15 25 -27 21 -68 133 -166 174 -153 15 5 22 0 30 -20 15
-40 13 -51 -19 -87 -32 -37 -71 -110 -71 -133 0 -31 22 -13 62 50 22 36 54 73
69 81 16 8 37 27 46 42 9 15 33 43 53 62 53 52 91 101 106 137 8 18 30 45 49
60 19 15 35 34 35 41 0 17 48 92 60 92 5 0 23 20 40 45 17 25 49 57 71 70 23
15 45 40 53 60 9 19 23 38 33 42 28 10 53 34 53 52 0 23 92 154 115 165 11 5
30 25 43 45 13 20 36 44 52 53 16 9 32 28 36 42 3 14 16 28 30 33 15 5 34 28
51 63 20 39 35 56 51 58 14 2 28 15 35 30 22 50 118 152 143 152 19 0 24 5 24
25 0 17 12 36 35 57 20 17 42 46 50 65 10 23 27 39 52 51 36 16 97 75 119 113
24 42 72 92 102 104 17 8 32 19 32 24 0 6 7 11 15 11 9 0 15 7 13 17 -2 10 11
26 32 40 46 32 190 168 190 180 0 16 45 53 64 53 30 0 83 38 90 64 3 13 23 35
44 48 48 32 132 116 132 131 0 7 13 18 29 25 16 7 39 29 50 48 17 28 26 34 53
34 27 0 36 5 46 30 8 17 26 37 40 45 15 8 63 48 107 89 77 73 131 104 159 93
14 -6 56 31 56 49 0 11 73 83 110 108 13 9 36 16 51 16 35 0 77 34 87 71 6 25
18 34 67 54 32 13 69 36 82 50 13 14 29 25 34 25 6 0 23 8 37 18 15 10 43 25
62 32 19 7 49 25 65 40 39 35 139 100 154 100 6 0 29 16 50 36 22 19 56 40 75
45 20 5 49 21 65 34 16 14 36 25 44 25 8 0 20 7 27 15 7 8 17 15 23 15 6 0 18
6 26 13 9 7 36 21 61 31 72 29 115 50 118 58 2 5 15 5 29 2 20 -5 33 1 66 34
41 38 117 77 272 137 39 15 79 32 90 39 11 7 47 18 80 26 63 14 84 24 124 59
16 14 38 21 66 21 22 0 45 4 50 9 21 19 117 43 149 37 25 -5 37 -2 50 13 10
11 41 25 69 32 29 7 59 15 67 19 8 4 42 14 75 23 111 28 180 50 196 63 10 9
31 12 65 8 30 -4 76 1 119 11 39 9 86 17 105 18 30 2 35 -2 38 -22 3 -15 14
-27 33 -35 32 -12 45 -41 35 -80 -3 -13 1 -41 10 -61 8 -21 13 -43 11 -49 -5
-13 12 -83 31 -129 7 -16 12 -36 12 -46 0 -26 -39 -57 -88 -72 -49 -14 -53
-38 -9 -53 21 -8 34 -6 57 8 18 10 39 15 51 11 37 -12 49 11 49 94 0 42 -5 82
-10 87 -6 6 -13 43 -15 82 -2 40 -9 81 -15 91 -5 11 -10 37 -10 58 0 22 -5 44
-10 49 -6 6 -12 46 -13 90 l-2 79 -68 3 c-63 3 -68 2 -79 -22z m-3143 -3476
c-5 -8 -11 -8 -17 -2 -6 6 -7 16 -3 22 5 8 11 8 17 2 6 -6 7 -16 3 -22z"/>
<path d="M8643 6216 c-17 -6 -41 -20 -52 -30 -25 -23 -28 -51 -5 -42 9 3 23 6
32 6 16 0 92 62 92 74 0 9 -31 5 -67 -8z"/>
<path d="M8408 6099 c-10 -5 -18 -19 -18 -30 0 -16 4 -19 23 -14 25 8 49 34
41 46 -7 12 -25 11 -46 -2z"/>
<path d="M8282 6020 c-23 -17 -48 -30 -54 -30 -5 0 -26 -13 -45 -30 -18 -16
-40 -30 -48 -30 -8 0 -15 -4 -15 -9 0 -5 -14 -14 -32 -20 -25 -9 -29 -14 -20
-23 10 -10 22 -7 57 12 25 14 45 28 45 31 0 4 13 10 29 14 16 3 35 13 42 21 6
8 18 14 26 14 14 0 113 67 113 76 0 15 -62 -2 -98 -26z"/>
<path d="M7985 5846 c-30 -13 -65 -46 -49 -46 30 0 85 24 94 40 13 24 0 26
-45 6z"/>
<path d="M7835 5757 c-22 -11 -46 -29 -53 -39 -7 -10 -19 -18 -27 -18 -8 0
-19 -9 -25 -20 -7 -13 -21 -20 -40 -20 -21 0 -36 -10 -60 -40 -23 -29 -27 -40
-16 -40 8 0 17 4 20 9 3 5 22 12 41 15 23 5 40 15 46 29 5 12 33 33 62 45 29
13 72 41 97 63 41 36 43 39 20 38 -14 -1 -43 -11 -65 -22z"/>
<path d="M7537 5562 c-10 -10 -17 -24 -17 -30 0 -7 -10 -12 -23 -12 -25 0 -75
-45 -63 -57 4 -4 10 -2 14 4 4 7 27 15 50 19 32 5 42 11 42 25 0 11 11 25 25
31 14 6 25 17 25 25 0 19 -34 16 -53 -5z"/>
<path d="M7237 5341 c-32 -26 -77 -54 -99 -62 -25 -8 -47 -24 -57 -40 -8 -15
-34 -35 -58 -44 -29 -12 -43 -24 -43 -37 0 -26 16 -23 69 15 25 18 58 39 73
46 15 8 46 31 70 52 24 21 48 39 54 39 11 0 74 62 74 73 0 18 -30 3 -83 -42z"/>
<path d="M6878 5066 c-48 -36 -92 -66 -99 -66 -11 0 -75 -57 -148 -131 -20
-20 -51 -40 -69 -44 -25 -5 -37 -15 -47 -39 -8 -19 -32 -44 -57 -60 -24 -15
-52 -40 -63 -56 -11 -17 -30 -30 -45 -32 -19 -2 -26 -10 -28 -30 -2 -21 -14
-32 -48 -48 -24 -12 -44 -26 -44 -30 0 -5 -12 -21 -27 -34 -22 -21 -25 -28
-15 -38 11 -11 17 -8 34 15 11 15 26 27 33 27 7 0 20 10 28 23 28 42 127 137
143 137 9 0 36 21 60 48 86 92 120 122 144 122 10 0 27 12 37 26 32 46 77 84
100 84 16 0 27 8 33 25 5 13 24 31 42 39 42 19 131 101 126 116 -2 6 -43 -18
-90 -54z"/>
<path d="M6107 4423 c-4 -3 -7 -17 -7 -30 0 -35 34 -26 38 10 3 26 -14 37 -31
20z"/>
<path d="M6018 4335 c-16 -18 -28 -37 -28 -43 0 -6 -4 -12 -9 -14 -22 -8 -115
-92 -210 -190 -57 -60 -109 -108 -115 -108 -17 0 -83 -71 -91 -97 -3 -12 -17
-31 -31 -42 -28 -22 -32 -51 -6 -51 24 0 42 19 42 45 1 12 21 36 50 60 28 22
50 45 50 52 0 6 16 21 35 33 19 12 35 28 35 36 0 8 5 14 11 14 6 0 41 30 78
68 36 37 94 94 128 127 148 144 149 146 111 144 -13 0 -35 -15 -50 -34z"/>
<path d="M850 4170 c0 -14 12 -25 38 -36 20 -9 63 -28 94 -42 32 -14 60 -23
64 -20 8 8 -18 48 -32 48 -6 0 -21 9 -34 20 -13 11 -35 20 -50 20 -15 0 -33 7
-40 15 -18 21 -40 19 -40 -5z"/>
<path d="M1110 4030 c37 -33 74 -40 68 -14 -2 9 -21 22 -43 30 -58 20 -62 17
-25 -16z"/>
<path d="M1215 3970 c-10 -16 3 -28 34 -35 16 -3 36 -17 45 -30 8 -13 39 -37
69 -54 29 -17 62 -40 72 -51 19 -21 45 -27 45 -10 0 20 -72 89 -105 100 -18 6
-36 17 -39 25 -3 8 -12 15 -19 15 -8 0 -26 11 -41 25 -28 26 -51 32 -61 15z"/>
<path d="M1517 3764 c-11 -11 3 -24 25 -24 17 0 18 2 8 15 -13 16 -23 19 -33
9z"/>
<path d="M5428 3712 c-40 -55 -33 -67 15 -28 22 17 28 30 25 52 -3 28 -3 28
-40 -24z"/>
<path d="M1570 3727 c0 -20 51 -64 83 -71 16 -4 31 -16 37 -30 5 -14 18 -27
28 -30 11 -4 40 -26 66 -51 26 -24 59 -46 75 -50 15 -3 34 -17 41 -30 7 -14
17 -25 22 -25 5 0 36 -27 68 -60 52 -53 90 -75 90 -52 0 12 -70 82 -83 82 -6
0 -28 17 -48 38 -20 20 -43 42 -50 48 -8 7 -25 26 -39 44 -14 18 -45 41 -69
51 -25 11 -51 29 -58 39 -8 11 -20 20 -28 20 -7 0 -15 4 -17 9 -4 12 -96 81
-108 81 -6 0 -10 -6 -10 -13z"/>
<path d="M5303 3581 c-29 -27 -53 -53 -53 -59 0 -5 -12 -13 -26 -16 -16 -4
-30 -19 -39 -39 -7 -18 -29 -46 -49 -64 -38 -33 -51 -72 -18 -54 27 15 119
116 127 140 3 11 13 21 21 21 8 0 18 8 21 17 8 20 33 46 67 68 14 10 23 21 20
26 -9 15 -17 10 -71 -40z"/>
<path d="M5048 3319 c-10 -5 -18 -16 -18 -24 0 -24 -58 -101 -85 -113 -14 -7
-29 -20 -33 -30 -11 -29 -93 -140 -144 -197 -27 -28 -48 -56 -48 -61 0 -4 -20
-29 -43 -54 -24 -25 -50 -61 -58 -80 -7 -19 -21 -42 -30 -50 -29 -26 -51 -68
-40 -75 16 -9 86 72 135 157 15 25 38 54 51 62 14 9 25 22 25 29 0 8 11 24 25
37 14 13 25 27 25 32 0 5 23 32 50 60 28 28 50 58 50 67 0 9 28 46 63 83 82
89 127 144 127 157 0 14 -29 14 -52 0z"/>
<path d="M2090 3308 c0 -23 30 -58 49 -58 10 0 35 -20 56 -45 46 -57 82 -82
97 -67 7 7 2 15 -16 27 -15 10 -39 38 -53 62 -19 33 -31 43 -44 40 -10 -3 -26
4 -36 15 -26 29 -53 42 -53 26z"/>
<path d="M2320 3102 c0 -12 34 -42 48 -42 18 0 14 37 -4 44 -22 9 -44 7 -44
-2z"/>
<path d="M2420 3029 c0 -14 59 -73 66 -66 7 6 -47 77 -58 77 -5 0 -8 -5 -8
-11z"/>
<path d="M2559 2873 c21 -42 113 -133 133 -133 7 0 19 -9 26 -20 13 -22 32
-27 32 -9 0 14 -187 199 -201 199 -5 0 -1 -17 10 -37z"/>
<path d="M2840 2614 c0 -11 9 -29 20 -39 27 -24 27 1 0 35 -19 24 -20 24 -20
4z"/>
<path d="M4461 2555 c-30 -34 -41 -75 -22 -75 15 0 71 73 71 92 0 27 -15 22
-49 -17z"/>
<path d="M4346 2406 c-7 -27 -73 -129 -87 -134 -12 -5 -12 -52 1 -52 6 0 10 4
10 8 0 4 17 26 38 49 57 62 93 125 80 140 -16 20 -35 15 -42 -11z"/>
<path d="M4227 2194 c-4 -4 -7 -14 -7 -23 0 -11 3 -12 11 -4 6 6 10 16 7 23
-2 6 -7 8 -11 4z"/>
<path d="M4151 2120 c-5 -16 -15 -30 -21 -30 -15 0 -8 -62 8 -68 7 -2 12 5 12
17 0 11 14 34 30 51 37 37 39 60 6 60 -18 0 -27 -8 -35 -30z"/>
<path d="M4070 1980 c0 -18 3 -19 20 -10 22 12 18 30 -6 30 -8 0 -14 -9 -14
-20z"/>
<path d="M4040 1925 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M3988 1834 c-29 -47 -36 -70 -18 -59 14 9 60 82 60 95 0 21 -16 8
-42 -36z"/>
<path d="M3903 1708 c-28 -31 -93 -133 -93 -145 0 -5 -9 -18 -20 -28 -25 -22
-26 -48 -2 -43 9 2 29 25 43 51 14 26 37 59 51 74 21 23 58 92 58 109 0 11
-19 1 -37 -18z"/>
<path d="M3740 1439 c0 -24 23 -21 28 4 2 10 -3 17 -12 17 -10 0 -16 -9 -16
-21z"/>
<path d="M3691 1341 c-13 -4 -28 -13 -32 -21 -4 -8 -21 -39 -38 -68 -17 -29
-31 -60 -31 -70 0 -9 -18 -43 -40 -75 -31 -45 -130 -230 -130 -244 0 -2 9 -3
19 -3 13 0 26 14 39 43 11 23 32 67 46 96 14 30 26 64 26 74 0 11 16 35 35 54
19 19 35 41 35 49 0 24 28 72 76 132 30 37 29 41 -5 33z"/>
</g>
</svg>

),

 no:(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="300.000000pt" height="302.000000pt" viewBox="0 0 300.000000 302.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait 
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,302.000000) scale(0.050000,-0.050000)">
<path d="M5290 5961 c-22 -9 -134 -50 -250 -92 -328 -117 -794 -360 -1020
-533 -56 -43 -319 -240 -421 -316 -90 -67 -362 -304 -505 -440 -133 -126 -152
-136 -182 -98 -102 130 -774 656 -1056 827 -387 236 -683 381 -938 461 -92 29
-194 61 -226 71 -117 38 -139 26 -246 -126 -207 -298 -364 -640 -366 -796 0
-106 73 -422 104 -443 14 -10 71 -45 126 -78 55 -32 168 -108 250 -168 83 -60
176 -124 208 -142 49 -27 481 -333 542 -383 90 -74 507 -378 535 -390 62 -25
62 -72 2 -140 -64 -73 -447 -645 -447 -667 0 -8 -12 -29 -28 -46 -39 -45 -271
-503 -346 -682 -229 -552 -308 -998 -236 -1342 29 -135 96 -318 117 -318 14 0
173 241 173 262 0 10 7 18 15 18 8 0 38 33 65 74 28 40 59 83 70 95 12 11 65
79 118 150 208 276 648 763 1012 1121 484 476 579 563 605 548 32 -19 296
-254 504 -448 458 -427 994 -987 1331 -1388 116 -139 272 -350 320 -432 31
-54 74 17 121 200 98 377 1 922 -262 1476 -55 115 -99 211 -99 215 0 64 -555
919 -778 1197 -80 99 -80 96 43 179 58 39 191 134 295 211 214 158 1011 696
1122 758 40 22 94 52 120 67 64 36 77 57 78 121 0 29 9 59 20 66 11 7 20 32
20 56 0 25 22 113 48 196 81 254 -3 490 -343 963 -110 153 -135 169 -215 136z
m64 -253 c26 -32 55 -85 65 -118 l17 -60 2 56 c3 75 34 52 51 -37 7 -39 26
-76 42 -82 16 -6 24 -19 18 -29 -6 -10 -1 -18 11 -18 12 0 17 -8 11 -18 -10
-17 63 -125 94 -139 8 -3 15 -15 15 -26 0 -11 -7 -15 -15 -10 -8 5 -16 -22
-17 -60 0 -42 5 -58 15 -43 10 15 15 -16 14 -74 -3 -73 -14 -107 -42 -127 -53
-38 -15 -75 45 -43 24 13 46 20 50 17 9 -9 -97 -225 -114 -233 -8 -4 -9 -19
-4 -33 13 -33 -89 -131 -134 -131 -19 0 -38 -19 -44 -42 -7 -27 -24 -39 -47
-35 -20 4 -59 -16 -86 -45 -28 -29 -62 -48 -76 -43 -14 4 -25 -1 -25 -13 0
-11 -11 -16 -25 -11 -14 5 -34 -11 -45 -36 -11 -25 -29 -45 -40 -45 -11 0 -30
-7 -43 -15 -13 -9 -28 -4 -34 10 -6 16 -10 12 -11 -9 -1 -18 -31 -54 -67 -79
-36 -25 -72 -55 -80 -66 -8 -12 -15 -13 -15 -4 0 9 -25 -11 -54 -45 -30 -34
-68 -62 -84 -62 -23 0 -25 5 -6 24 13 13 24 33 24 44 0 11 -12 3 -27 -17 -15
-21 -37 -31 -50 -23 -13 8 -22 8 -19 -2 10 -30 -53 -97 -174 -187 -66 -49
-125 -96 -132 -105 -35 -48 -172 -93 -146 -49 8 14 8 19 0 12 -9 -8 -15 -21
-16 -30 0 -38 -39 -87 -68 -87 -17 0 -25 -9 -18 -20 7 -11 0 -25 -15 -31 -14
-5 -28 -29 -30 -52 -4 -59 -18 -67 -55 -29 -45 44 -60 41 -88 -21 -26 -57 -11
-94 19 -46 12 20 17 7 15 -47 -1 -41 8 -86 21 -99 13 -13 23 -35 23 -50 0 -40
120 -208 139 -195 21 13 63 -101 44 -122 -7 -8 -2 -8 12 0 17 9 25 1 25 -26 0
-28 9 -37 30 -29 27 10 40 -13 32 -59 -2 -10 6 -12 17 -5 10 7 43 -38 72 -98
28 -61 59 -111 68 -111 9 0 21 -18 27 -41 6 -22 22 -38 36 -35 14 4 31 -22 39
-58 7 -36 28 -87 46 -115 18 -27 33 -63 33 -79 0 -16 18 -35 40 -42 22 -7 36
-21 30 -30 -6 -9 4 -31 21 -48 18 -18 23 -32 12 -32 -11 0 -10 -20 4 -50 13
-27 29 -50 37 -50 24 0 113 -204 102 -233 -6 -15 0 -27 13 -27 13 0 18 9 11
20 -7 11 -4 20 6 20 11 0 24 -18 30 -40 6 -22 2 -40 -8 -40 -15 0 56 -174 82
-200 12 -12 17 -31 54 -200 43 -191 44 -195 67 -159 18 28 31 -14 21 -68 -2
-10 -11 -86 -20 -170 -9 -84 -23 -170 -32 -191 -13 -29 -10 -35 10 -22 19 12
21 9 8 -12 -17 -28 -21 -38 -25 -79 -5 -36 -43 1 -43 41 0 21 -16 49 -36 64
-48 34 -204 243 -204 272 0 13 -13 18 -30 11 -18 -6 -30 0 -30 16 -1 15 -24
49 -52 75 -30 29 -47 63 -41 85 5 20 3 34 -5 31 -7 -2 -49 32 -92 75 -44 44
-66 72 -50 63 17 -10 8 5 -20 33 -27 27 -57 46 -65 41 -8 -5 -25 17 -36 48
-26 67 -79 129 -100 116 -8 -5 -20 13 -27 41 -7 28 -21 46 -31 40 -10 -7 -24
7 -31 29 -7 22 -20 36 -28 31 -13 -8 -77 81 -88 124 -2 8 -10 13 -17 11 -7 -3
-18 16 -24 40 -6 25 -47 67 -90 95 -43 27 -74 57 -69 66 14 22 -114 153 -149
153 -15 0 -23 8 -17 17 6 10 -48 78 -119 151 -72 73 -125 142 -119 152 7 11 0
20 -15 20 -16 0 -49 22 -74 49 -26 28 -55 45 -64 39 -9 -6 -17 -1 -17 11 0 37
-227 249 -237 221 -5 -15 15 -44 44 -65 29 -21 53 -50 53 -65 0 -15 16 -32 35
-38 19 -7 121 -103 225 -215 105 -112 233 -246 285 -298 52 -52 95 -103 95
-115 0 -12 29 -52 65 -90 36 -38 101 -112 145 -163 44 -52 100 -117 125 -145
25 -29 45 -61 45 -73 0 -12 33 -55 72 -95 41 -42 66 -84 58 -97 -13 -22 -110
69 -110 104 0 8 -36 52 -80 97 -44 46 -80 95 -80 110 0 16 -10 28 -22 28 -12
0 -65 43 -118 95 -53 52 -155 149 -227 215 -72 66 -128 131 -123 145 5 13 2
22 -6 20 -8 -3 -54 33 -103 79 -48 47 -93 81 -100 77 -7 -5 -33 19 -59 51 -34
42 -59 56 -90 49 -23 -6 -31 -6 -18 0 13 7 19 24 13 40 -6 16 -19 24 -29 18
-10 -6 -18 -1 -18 11 0 12 -9 17 -20 10 -23 -14 -84 39 -66 58 7 6 3 12 -9 12
-12 0 -25 -8 -28 -17 -15 -39 -97 -47 -99 -9 -2 31 -4 31 -11 3 -5 -19 -32
-49 -59 -66 -27 -18 -44 -42 -37 -52 7 -11 5 -19 -5 -17 -42 7 -66 -5 -66 -32
0 -16 -10 -30 -22 -30 -31 0 -169 -124 -162 -146 3 -9 -13 -22 -35 -28 -22 -6
-45 -28 -52 -50 -7 -22 -39 -48 -70 -59 -32 -11 -62 -35 -68 -54 -13 -38 -331
-377 -331 -352 0 23 100 167 156 223 25 25 40 57 32 69 -10 17 -20 15 -36 -6
-12 -16 -50 -48 -84 -72 -35 -24 -74 -71 -88 -105 -14 -35 -45 -65 -72 -72
-39 -10 -44 -21 -34 -73 9 -44 6 -57 -11 -47 -13 8 -23 5 -23 -7 0 -11 -14
-21 -31 -21 -16 0 -36 -16 -43 -35 -7 -19 -30 -50 -51 -68 -21 -19 -36 -41
-35 -50 2 -8 -13 -21 -32 -28 -19 -6 -53 -52 -76 -100 -23 -49 -62 -98 -87
-109 -25 -11 -45 -27 -45 -36 0 -21 -124 -201 -145 -211 -8 -3 -15 -19 -15
-35 0 -16 -22 -37 -50 -48 -30 -11 -45 -29 -38 -47 5 -15 -4 -42 -21 -59 -17
-17 -31 -45 -31 -63 0 -29 -25 -41 -68 -32 -10 2 -25 -7 -33 -20 -10 -17 -24
-18 -52 -2 -23 14 -27 22 -10 22 22 1 23 7 4 30 -20 23 -18 42 5 89 25 50 25
61 2 70 -37 14 -36 105 1 119 20 8 26 35 21 92 -4 44 1 85 10 91 10 6 13 24 7
41 -7 18 1 29 21 29 18 0 32 10 32 22 0 12 -13 17 -28 12 -18 -7 -26 1 -23 22
3 20 20 31 39 28 28 -5 33 9 29 77 -4 62 4 91 31 110 26 19 34 45 28 88 -5 34
-2 61 7 61 10 0 17 20 17 45 0 25 18 57 41 71 22 14 35 34 28 46 -7 11 -2 33
12 49 13 16 18 29 10 29 -8 0 1 15 19 32 17 18 37 59 44 91 9 46 17 53 39 35
36 -30 38 23 2 59 -20 20 -15 33 25 66 28 22 37 33 20 25 -25 -13 -26 -10 -5
15 13 17 19 37 11 44 -7 7 -2 13 11 13 13 0 23 14 23 31 0 18 26 53 58 80 32
27 64 74 71 104 8 30 23 66 35 79 33 41 156 250 156 266 0 9 15 21 33 28 18 7
28 18 21 24 -16 17 69 108 101 108 15 0 21 10 14 22 -8 12 5 48 29 79 23 32
42 67 42 80 0 12 11 41 24 65 13 24 21 69 18 99 -3 30 5 55 16 55 12 0 22 12
22 26 0 15 16 44 35 65 26 29 32 57 23 109 -7 39 -14 51 -15 27 -2 -23 -16
-53 -33 -67 -16 -14 -30 -38 -30 -53 0 -16 -16 -34 -35 -41 -19 -7 -42 -23
-50 -35 -9 -13 -15 -8 -15 13 0 19 -22 58 -50 87 -27 30 -45 61 -39 70 5 9
-17 22 -49 29 -40 8 -62 28 -71 62 -7 27 -21 44 -32 38 -10 -7 -19 -4 -19 6 0
10 -25 14 -55 10 -31 -5 -46 -2 -35 7 59 50 34 93 -48 82 -45 -6 -87 -3 -93 7
-6 10 0 18 15 19 14 0 2 22 -28 48 -29 26 -47 54 -40 63 8 9 -1 5 -20 -9 -28
-22 -40 -19 -74 15 -23 23 -73 54 -112 71 -39 16 -76 43 -82 60 -7 17 -24 31
-39 31 -15 0 -34 12 -43 26 -9 15 -58 56 -110 91 -52 35 -103 78 -113 96 -10
18 -45 33 -78 35 -34 1 -57 9 -52 17 5 8 0 15 -10 15 -11 0 -26 18 -33 40 -7
22 -20 36 -30 30 -9 -6 -20 -2 -23 8 -8 20 -121 91 -202 127 -42 18 -52 33
-42 64 6 23 5 35 -3 27 -24 -22 -73 39 -83 104 -11 73 105 42 223 -59 22 -19
90 -55 150 -80 61 -25 117 -58 126 -74 9 -15 49 -41 90 -58 41 -17 83 -41 94
-55 12 -13 36 -33 54 -44 116 -72 229 -149 299 -205 44 -36 93 -65 108 -65 15
0 38 -16 53 -35 14 -19 51 -48 81 -63 30 -16 55 -36 55 -45 0 -10 14 -17 31
-17 16 0 35 -13 41 -29 12 -30 268 -201 292 -195 8 2 10 -8 5 -22 -6 -16 20
-40 64 -61 62 -30 70 -31 48 -4 -14 17 -39 31 -55 31 -15 0 -24 7 -18 16 17
28 -303 291 -358 294 -11 1 -18 13 -15 26 3 14 -22 30 -56 37 -37 8 -53 18
-39 27 23 14 -20 43 -70 48 -11 1 -23 11 -27 22 -4 11 -51 46 -105 77 -54 31
-112 76 -128 100 -17 24 -37 41 -45 38 -23 -7 -89 17 -78 29 17 16 -191 149
-241 155 -25 2 -67 28 -94 57 -31 34 -62 49 -82 41 -20 -8 -30 -2 -26 16 4 17
-11 26 -38 26 -24 -1 -39 5 -34 15 6 9 -4 16 -21 16 -17 0 -76 31 -131 70 -55
39 -109 70 -121 70 -11 0 -19 11 -16 25 3 14 -2 46 -11 72 -9 28 -8 55 4 67
12 12 16 33 10 48 -5 15 4 33 22 40 18 7 32 29 32 48 0 20 27 93 60 163 33 70
60 114 60 99 0 -18 14 -12 40 18 22 25 40 61 40 80 0 49 153 198 195 190 19
-4 47 -8 61 -8 47 -3 3 -42 -47 -42 -30 0 -49 -12 -49 -30 0 -39 48 -39 80 0
13 16 35 23 47 15 13 -8 39 -11 58 -8 20 3 59 -13 88 -36 29 -22 73 -41 99
-41 25 0 51 -9 58 -20 18 -29 151 -82 172 -69 10 6 18 3 18 -6 0 -10 43 -40
95 -67 52 -27 95 -58 95 -68 0 -11 20 -23 45 -26 25 -4 45 -16 45 -27 0 -10 9
-14 20 -7 11 7 20 5 20 -5 0 -9 17 -18 37 -19 21 -2 68 -31 105 -65 65 -59
113 -82 88 -41 -7 11 -3 20 9 20 19 0 29 -31 16 -45 -17 -19 88 -95 159 -116
47 -14 81 -31 76 -39 -5 -7 27 -34 71 -58 43 -25 79 -55 79 -68 0 -13 47 -55
104 -94 58 -38 139 -104 182 -145 43 -41 85 -70 94 -65 8 5 27 -4 40 -20 14
-17 38 -30 54 -30 15 0 23 -9 16 -20 -7 -11 -3 -21 9 -22 11 -2 28 -5 36 -8 8
-3 35 -12 60 -20 25 -8 45 -24 45 -36 0 -11 6 -15 12 -8 15 14 57 -24 72 -66
8 -20 16 -12 26 25 12 45 29 58 92 68 72 11 111 47 53 47 -17 1 -16 6 4 19 16
10 35 15 42 10 7 -4 25 14 39 41 14 27 33 45 41 39 8 -5 30 14 48 42 18 28 41
45 52 38 10 -6 19 3 19 20 0 18 20 40 45 49 25 10 68 44 95 77 48 56 140 119
140 95 0 -6 18 -2 41 10 22 12 35 31 28 41 -6 10 -2 19 10 19 11 0 21 14 21
30 0 17 7 30 16 30 9 0 61 29 115 64 54 35 108 65 119 67 11 2 31 4 45 6 14 2
24 10 23 18 -8 49 6 85 33 85 17 0 26 9 19 20 -7 11 6 21 29 23 85 5 91 9 86
58 -3 27 2 40 10 28 25 -35 74 -21 95 26 17 39 60 56 116 47 8 -1 20 11 27 28
6 16 32 30 58 30 26 0 52 8 58 18 6 10 31 13 56 7 39 -10 41 -8 19 19 -20 26
-20 33 5 43 19 7 31 1 31 -17 0 -17 12 -24 30 -17 16 6 24 21 17 32 -8 12 -4
15 10 7 13 -8 37 0 55 17 17 17 44 31 61 31 16 0 24 8 18 18 -13 21 35 42 98
42 26 0 52 14 59 32 7 18 25 27 41 21 15 -6 32 1 38 15 18 48 136 23 187 -40z
m399 -616 c-20 -53 -46 -36 -46 29 0 54 3 57 29 32 16 -17 24 -44 17 -61z"/>
<path d="M5548 4885 c-7 -24 -20 -40 -29 -34 -9 5 -30 -10 -48 -35 -17 -25
-31 -33 -31 -19 0 14 -9 20 -20 13 -35 -22 -21 -50 25 -49 71 1 162 91 136
134 -19 32 -21 31 -33 -10z"/>
<path d="M5222 4682 c-21 -21 -57 -44 -80 -51 -24 -8 -37 -22 -31 -32 6 -11
-7 -19 -28 -19 -23 0 -46 -18 -53 -40 -7 -22 -21 -36 -31 -30 -21 13 -158 -72
-159 -98 0 -10 6 -13 13 -6 7 8 24 5 37 -6 16 -13 44 2 90 50 38 39 75 70 83
70 46 0 195 113 203 154 10 56 5 57 -44 8z"/>
<path d="M4738 4323 c-26 -20 -59 -33 -73 -28 -14 4 -25 -1 -25 -13 0 -12 -13
-22 -30 -22 -16 0 -30 -10 -30 -21 0 -12 -10 -15 -23 -7 -13 8 -18 5 -10 -7 7
-11 -3 -33 -21 -48 -29 -23 -31 -23 -17 1 13 21 10 24 -11 11 -68 -41 -183
-129 -168 -129 9 0 0 -17 -19 -39 -20 -22 -48 -33 -66 -26 -18 7 -26 3 -19 -8
6 -11 -6 -35 -27 -53 -21 -19 -39 -27 -40 -19 0 8 -13 -2 -30 -24 -16 -21 -29
-32 -29 -24 0 32 -82 -32 -110 -87 -20 -38 -41 -55 -60 -47 -19 7 -36 -7 -49
-41 -11 -29 -29 -52 -41 -52 -11 0 -20 -10 -20 -23 0 -14 15 -10 37 10 20 18
43 33 51 33 8 0 27 11 41 25 14 14 45 38 69 54 23 17 42 45 42 64 0 19 9 40
20 47 11 7 14 -1 8 -19 -7 -17 -2 -31 10 -31 12 0 22 9 22 20 0 12 22 31 50
43 27 13 55 40 61 60 7 21 19 33 28 28 9 -6 32 8 51 29 20 22 48 40 62 40 14
0 31 19 38 41 8 24 25 37 40 32 15 -6 32 2 38 18 6 16 19 29 30 29 11 0 49 27
85 60 36 33 75 60 86 61 28 1 119 78 107 90 -5 5 -32 -7 -58 -28z"/>
<path d="M2855 2750 c-30 -26 -55 -60 -55 -74 -1 -19 -6 -17 -20 4 -15 23 -19
24 -20 3 0 -29 -99 -157 -101 -130 0 10 -14 -8 -30 -38 -17 -30 -40 -55 -52
-55 -12 0 -16 -13 -10 -29 7 -19 1 -25 -18 -18 -17 7 -37 -10 -53 -44 -14 -30
-52 -67 -86 -81 -33 -15 -49 -27 -35 -27 14 -1 25 -14 25 -31 0 -28 -25 -39
-67 -32 -9 2 -21 -16 -27 -39 -9 -31 -16 -35 -27 -17 -11 18 -20 10 -29 -27
-8 -30 -24 -48 -38 -43 -29 11 -79 -85 -60 -115 16 -26 165 116 190 181 11 26
24 42 31 36 13 -13 107 92 107 119 0 9 27 35 60 57 33 22 60 46 60 53 0 7 63
78 139 158 77 79 138 151 135 160 -2 9 14 30 36 47 22 17 31 31 20 31 -11 0
-45 -22 -75 -49z"/>
</g>
</svg>
),

  noImage: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="351.000000pt" height="393.000000pt" viewBox="0 0 351.000000 393.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,393.000000) scale(0.100000,-0.100000)">
<path d="M2596 3788 c-25 -23 -42 -55 -216 -410 -50 -103 -97 -192 -104 -197
-8 -7 -325 -11 -957 -13 l-944 -3 -50 -26 c-73 -39 -142 -104 -173 -163 l-27
-51 0 -995 0 -995 28 -53 c32 -62 90 -121 150 -153 41 -23 49 -23 362 -26 176
-2 330 -5 343 -8 43 -10 35 -28 -196 -493 -34 -69 -36 -74 -22 -100 9 -14 28
-33 43 -42 24 -13 30 -13 54 0 30 16 62 80 593 1155 263 532 318 644 330 665
5 8 62 125 128 260 113 231 568 1154 708 1434 76 153 80 184 30 215 -42 26
-49 26 -80 -1z m-442 -774 c28 -7 34 -30 16 -62 -5 -9 -122 -246 -261 -527
-138 -280 -263 -534 -277 -563 -38 -75 -58 -84 -96 -40 -17 18 -109 123 -205
232 -96 108 -185 204 -197 213 -44 28 -85 10 -150 -65 -73 -83 -88 -100 -210
-237 -177 -198 -446 -504 -459 -522 -11 -15 -15 -15 -29 -4 -15 13 -16 78 -14
735 3 665 4 724 20 748 29 45 87 82 137 88 63 9 1693 12 1725 4z m-1020 -967
c47 -50 265 -294 319 -358 26 -31 47 -65 47 -75 0 -11 -58 -136 -129 -279 -70
-143 -145 -296 -166 -340 -21 -44 -49 -95 -62 -113 l-24 -32 -355 0 c-387 0
-394 1 -447 58 -16 16 -33 47 -38 68 -12 53 -11 157 1 190 6 15 81 106 167
203 87 97 173 194 192 216 19 22 71 81 116 130 45 50 114 128 155 175 109 128
168 190 181 190 6 0 25 -15 43 -33z"/>
<path d="M2550 3163 c-44 -16 -63 -80 -35 -120 14 -21 22 -21 299 -25 l284 -3
44 -30 c23 -17 52 -48 63 -70 19 -39 20 -63 23 -757 l2 -718 -21 0 c-11 0 -35
17 -54 38 -18 20 -126 143 -240 272 -115 129 -213 238 -219 242 -6 4 -27 8
-47 8 -39 0 -66 -25 -230 -211 -31 -35 -134 -152 -229 -259 -94 -107 -181
-196 -191 -198 -20 -4 -35 10 -147 130 -29 31 -61 59 -71 63 -48 15 -100 -39
-87 -91 7 -26 217 -271 255 -296 14 -10 36 -18 47 -18 23 0 77 46 145 125 148
171 249 286 273 311 6 6 38 41 71 79 119 137 148 165 165 165 10 0 33 -17 51
-37 18 -21 63 -72 99 -113 37 -41 111 -124 165 -185 54 -60 127 -143 164 -184
98 -109 101 -115 101 -203 0 -119 -42 -196 -121 -218 -21 -6 -353 -10 -860
-10 l-826 0 -34 -23 c-46 -31 -52 -76 -13 -106 l27 -21 876 2 876 3 40 23 c60
33 122 99 153 161 l27 56 0 985 0 985 -28 55 c-45 91 -101 141 -200 178 -55
21 -74 22 -320 21 -144 0 -269 -3 -277 -6z"/>
<path d="M2471 2689 c-67 -13 -124 -57 -171 -134 -21 -34 -25 -52 -24 -125 0
-76 3 -90 28 -129 39 -60 72 -90 135 -119 118 -54 270 1 335 123 21 41 26 63
26 124 0 94 -23 144 -92 205 -42 37 -62 46 -113 55 -68 12 -63 12 -124 0z
m136 -164 c40 -27 56 -101 32 -148 -22 -40 -52 -56 -105 -57 -43 0 -54 4 -79
30 -24 25 -29 39 -29 79 0 98 98 150 181 96z"/>
</g>
</svg>
),

  noPhoto: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="336.000000pt" height="390.000000pt" viewBox="0 0 336.000000 390.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,390.000000) scale(0.100000,-0.100000)">
<path d="M2513 3783 c-25 -24 -109 -186 -330 -640 -33 -68 -44 -77 -77 -62
-14 7 -26 15 -26 19 0 4 -24 20 -52 36 l-53 29 -291 3 c-276 3 -293 2 -345
-18 -79 -31 -132 -88 -185 -198 -24 -52 -44 -97 -44 -101 0 -5 -12 -20 -26
-35 -26 -25 -31 -26 -133 -25 -156 1 -189 16 -128 54 40 26 49 73 18 104 -19
19 -33 21 -123 21 -112 0 -123 -3 -136 -39 -13 -37 -2 -72 29 -90 60 -34 20
-49 -136 -50 -187 -2 -271 -42 -346 -166 l-24 -40 0 -770 0 -770 24 -45 c32
-62 102 -125 164 -147 45 -16 95 -19 387 -23 303 -5 335 -7 338 -22 2 -9 -67
-158 -152 -331 -171 -343 -178 -368 -129 -407 32 -25 69 -20 95 13 10 12 49
87 89 167 39 80 82 168 97 195 14 28 29 57 33 65 4 8 110 222 234 475 125 253
307 622 405 820 98 198 273 554 389 790 117 237 216 437 221 445 6 8 15 26 21
40 5 14 70 147 144 295 188 380 184 367 134 409 -39 33 -50 33 -86 -1z m-538
-793 c31 -29 65 -91 65 -119 0 -33 -89 -199 -110 -206 -11 -4 -37 0 -58 7 -25
9 -92 13 -207 13 -164 0 -173 -1 -250 -30 -44 -16 -109 -44 -145 -63 -128 -66
-271 -217 -336 -351 -20 -42 -40 -84 -45 -93 -17 -33 -49 -217 -49 -280 0 -74
29 -222 58 -293 54 -134 133 -246 235 -331 31 -27 60 -56 63 -66 7 -24 -59
-162 -88 -182 -20 -14 -68 -16 -376 -16 -388 0 -390 0 -448 61 l-29 30 0 733
c0 817 -4 768 71 812 l41 24 384 0 c285 0 390 3 407 13 27 14 40 36 116 197
57 122 76 145 122 160 16 5 147 8 291 7 l261 -2 27 -25z m-147 -468 c26 -15
29 -48 7 -80 -15 -21 -21 -21 -118 -16 -87 6 -113 3 -182 -16 -110 -30 -184
-72 -258 -144 -68 -67 -99 -116 -137 -216 -21 -55 -25 -82 -25 -180 0 -98 4
-125 24 -180 34 -88 55 -123 124 -204 49 -58 57 -73 52 -95 -18 -70 -53 -68
-126 8 -93 96 -135 171 -175 311 -31 112 -31 208 0 320 13 47 31 99 40 115 9
17 16 33 16 37 0 19 72 111 135 173 86 84 219 156 324 175 66 12 271 6 299 -8z
m-114 -248 c9 -3 16 -16 16 -27 0 -12 -65 -152 -144 -312 -80 -160 -149 -303
-155 -318 -23 -61 -86 -21 -136 88 -25 54 -28 71 -28 165 0 96 2 110 31 171
28 60 91 133 150 174 62 44 216 78 266 59z"/>
<path d="M2238 2775 c-50 -28 -45 -105 8 -125 14 -6 177 -10 372 -10 341 0
348 -1 387 -23 26 -14 48 -37 63 -67 l22 -45 -2 -705 -3 -705 -23 -37 c-14
-21 -41 -45 -66 -57 -42 -21 -55 -21 -840 -21 -508 0 -804 -4 -816 -10 -21
-11 -35 -60 -25 -89 3 -10 21 -26 39 -35 30 -14 121 -16 819 -16 744 0 788 1
846 19 72 22 141 75 175 134 45 76 47 127 44 867 -3 768 -1 734 -68 822 -41
53 -85 83 -152 103 -74 22 -739 22 -780 0z"/>
<path d="M2104 2512 c-21 -13 -36 -54 -29 -79 3 -14 36 -58 73 -98 82 -90 82
-90 111 -144 63 -122 73 -167 73 -321 0 -132 -2 -151 -26 -212 -60 -158 -136
-258 -260 -342 -86 -59 -159 -89 -279 -111 -87 -17 -105 -18 -165 -6 -128 26
-172 11 -172 -55 0 -66 12 -73 165 -94 68 -9 97 -8 195 9 138 24 195 42 279
93 34 21 66 38 70 38 11 0 143 130 183 180 47 59 113 186 133 258 42 145 42
339 0 484 -36 128 -156 310 -248 378 -39 29 -80 38 -103 22z"/>
<path d="M1965 2244 c-23 -36 -13 -78 34 -142 49 -64 75 -147 75 -232 0 -164
-89 -296 -256 -381 -30 -15 -68 -23 -140 -27 -110 -6 -128 -16 -128 -78 0
-102 213 -100 394 2 139 78 240 223 272 391 17 89 17 97 0 185 -19 102 -74
218 -129 276 -41 42 -96 45 -122 6z"/>
</g>
</svg>
),

  noMovie: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="759.000000pt" height="468.000000pt" viewBox="0 0 759.000000 468.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,468.000000) scale(0.100000,-0.100000)">
<path d="M1420 4557 c-48 -39 -45 65 -50 -1721 l-5 -1671 -22 -3 c-12 -2 -27
-10 -33 -18 -7 -8 -20 -14 -30 -14 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30
-15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30 -14 -46 -30 -16
-17 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7
-30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15
-10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30 -14 -46 -30 -16 -16
-36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30
-15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0
-23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30 -13 -46 -30 -16 -16 -36 -30
-46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7
-8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30 -13
-46 -30 -16 -16 -36 -30 -45 -30 -9 0 -26 -10 -38 -23 -18 -19 -22 -35 -22
-83 0 -83 22 -104 107 -104 42 0 64 5 73 15 7 8 20 15 30 15 10 0 23 7 30 15
7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15
30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17 36 30 46 30 9
0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30
15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17
36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15
10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 13 46 30 16 16 36 30 46 30 9 0 22 7
29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 23 15 36 15 l24 0 0 -371 0 -371
34 -34 34 -34 2386 2 2386 3 25 25 25 26 0 1716 0 1717 24 25 c13 14 30 26 38
26 9 0 21 7 28 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30
13 46 30 16 16 36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7
8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 29
15 10 0 30 14 46 30 16 17 36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15 10 0
23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15
7 8 20 15 29 15 10 0 30 14 46 30 16 17 36 30 46 30 9 0 22 7 29 15 7 8 20 15
30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 29 15 9 0
34 17 54 38 34 35 37 42 37 98 0 83 -22 104 -107 104 -42 0 -64 -5 -73 -15 -7
-8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7
-30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15
-10 0 -30 -14 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20
-15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15
-7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30
-14 -46 -30 -16 -17 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20 -15 -30
-15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8
-20 -15 -29 -15 -10 0 -30 -13 -46 -30 -16 -17 -36 -30 -46 -30 -9 0 -22 -7
-29 -15 -7 -8 -23 -15 -36 -15 -12 0 -26 -4 -29 -10 -12 -19 -25 -10 -23 18 1
15 1 161 0 325 l-2 298 -26 24 -27 25 -2386 0 c-1860 -1 -2389 -3 -2401 -13z
m603 -201 c67 -28 72 -41 75 -219 4 -203 1 -220 -46 -252 -35 -24 -42 -25
-195 -25 -162 0 -181 4 -224 43 -22 20 -23 26 -23 212 0 210 -2 203 65 238 40
22 299 24 348 3z m983 -1 c71 -29 73 -38 74 -247 l0 -187 -37 -30 -38 -31
-164 0 c-149 0 -167 2 -197 21 -19 11 -39 29 -44 39 -6 10 -10 97 -10 192 0
191 3 202 64 239 27 16 51 19 174 19 103 0 152 -4 178 -15z m988 1 c18 -7 42
-26 54 -41 21 -26 22 -38 22 -204 -1 -190 -2 -193 -60 -234 -21 -14 -50 -17
-189 -17 -243 0 -251 8 -251 259 0 167 9 200 67 230 33 17 57 20 181 21 99 0
153 -4 176 -14z m995 -6 c59 -29 71 -71 71 -238 0 -113 -4 -144 -19 -179 -30
-66 -54 -73 -238 -73 -139 0 -162 2 -190 20 -56 34 -63 61 -63 232 1 241 17
257 253 258 127 0 153 -3 186 -20z m982 0 c22 -12 44 -32 49 -46 6 -14 10
-103 10 -197 0 -245 -2 -247 -247 -247 -136 0 -162 3 -186 18 -55 37 -56 43
-57 230 0 253 7 261 248 261 125 1 148 -2 183 -19z m-177 -689 l25 -24 -42
-38 c-23 -21 -49 -38 -58 -39 -9 0 -22 -7 -29 -15 -7 -8 -20 -15 -30 -15 -10
0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15
-29 -15 -10 0 -30 -13 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -22 -7 -29 -15
-7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23
-7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15
-10 0 -30 -13 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20
-15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15
-7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30
-13 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20 -15 -30
-15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8
-20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -21 -15 -31 -15 -10 0 -21 -5 -24
-11 -4 -6 -16 -14 -27 -18 -16 -6 -32 4 -77 48 -31 31 -87 77 -126 102 -61 41
-93 57 -203 100 -55 22 -184 41 -272 42 -201 0 -383 -64 -542 -192 -72 -58
-166 -164 -201 -228 -41 -75 -87 -180 -87 -201 0 -9 -7 -35 -15 -57 -20 -56
-20 -314 0 -370 8 -22 15 -46 15 -54 0 -21 -40 -61 -61 -61 -9 0 -22 -7 -29
-15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0
-23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29
-15 -10 0 -30 -14 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8
-20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30
-15 -7 -8 -20 -15 -29 -15 -10 0 -30 -13 -46 -30 -16 -16 -36 -30 -46 -30 -9
0 -22 -7 -29 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15
-30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7
-8 -20 -15 -29 -15 -10 0 -30 -14 -46 -30 -16 -16 -36 -30 -46 -30 -9 0 -22
-7 -29 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -19 -15 -28 -15
-8 0 -24 -8 -34 -17 -12 -11 -22 -13 -28 -7 -7 7 -9 391 -8 1101 l3 1091 24
26 c13 14 35 27 50 29 14 2 893 4 1953 3 l1926 -1 26 -24z m38 -1467 c-3
-1249 0 -1192 -58 -1214 -27 -11 -3862 -14 -3899 -4 -32 8 -65 65 -65 111 0
46 38 103 70 103 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15
30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17 36 30 46 30 9
0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30
15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17
36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15
10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14
46 30 16 17 36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8
20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 22 15 33 15
11 0 25 7 32 17 11 14 16 11 43 -28 68 -98 190 -197 317 -259 39 -18 78 -37
89 -42 10 -5 39 -13 65 -18 25 -5 64 -13 86 -19 52 -14 218 -14 270 0 22 6 62
14 89 19 27 5 54 14 60 20 5 5 17 10 26 10 20 0 115 49 184 95 30 20 93 77
140 126 68 72 94 109 135 193 28 57 51 110 51 119 0 8 8 32 17 53 14 32 17 72
17 219 1 184 -7 231 -50 319 -14 27 -13 31 7 52 13 13 30 24 40 24 9 0 22 7
29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8
20 15 30 15 10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17 36 30 46
30 9 0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7
30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17 36 30 46 30 9 0 22 7 29 15 7 8
20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15
10 0 23 7 30 15 7 8 20 15 29 15 10 0 30 14 46 30 16 17 36 30 46 30 9 0 22 7
29 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8
23 15 36 15 12 0 26 5 29 10 3 6 9 10 13 10 4 0 6 -516 4 -1146z m-2101 590
c51 -31 103 -60 114 -65 34 -16 114 -64 126 -76 16 -16 4 -43 -19 -43 -10 0
-31 -13 -47 -30 -16 -16 -36 -30 -46 -30 -9 0 -22 -7 -29 -15 -7 -8 -20 -15
-30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7
-8 -20 -15 -30 -15 -10 0 -23 -7 -30 -15 -7 -8 -20 -15 -29 -15 -10 0 -30 -14
-46 -30 -18 -19 -38 -30 -50 -28 -19 3 -20 11 -23 191 -3 201 2 227 52 269 36
30 75 22 177 -38z m589 -341 c39 -24 72 -51 84 -72 18 -31 18 -37 5 -74 -15
-44 -10 -41 -338 -231 -125 -73 -167 -97 -263 -150 -20 -12 -64 -38 -98 -58
-47 -29 -72 -38 -106 -38 -40 0 -46 4 -74 42 -30 40 -31 45 -28 132 3 85 4 91
25 94 12 2 27 10 33 18 7 8 20 14 30 14 10 0 23 7 30 15 7 8 20 15 29 15 10 0
30 14 46 30 16 17 36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15 10 0 23 7 30
15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 7 8 20
15 29 15 10 0 30 14 46 30 16 17 36 30 46 30 9 0 22 7 29 15 7 8 20 15 30 15
10 0 23 7 30 15 7 8 20 15 30 15 10 0 23 7 30 15 18 22 28 19 100 -22z m-2297
-1657 c67 -28 72 -41 75 -221 4 -191 -2 -222 -48 -253 -31 -20 -44 -22 -192
-22 -163 0 -182 4 -225 43 -22 20 -23 26 -23 209 0 210 1 212 70 242 47 20
296 22 343 2z m983 -1 c71 -29 73 -38 74 -246 0 -180 -1 -186 -22 -206 -44
-39 -63 -43 -223 -43 -243 0 -245 2 -245 251 0 196 4 209 72 242 45 23 292 24
344 2z m990 -4 c71 -32 74 -42 74 -241 -1 -189 -2 -192 -60 -233 -21 -14 -50
-17 -189 -17 -245 0 -251 6 -251 258 0 168 9 201 67 231 33 17 57 20 178 20
116 1 147 -3 181 -18z m987 0 c65 -28 77 -65 77 -239 0 -113 -4 -144 -19 -179
-30 -66 -54 -73 -235 -73 -245 0 -256 11 -256 250 0 240 18 258 252 259 113 1
144 -2 181 -18z m988 -1 c22 -12 44 -32 49 -46 11 -27 14 -345 4 -381 -3 -12
-22 -31 -41 -43 -31 -18 -51 -20 -196 -20 -140 0 -166 3 -190 18 -55 37 -56
43 -57 230 0 252 7 259 248 261 125 1 148 -2 183 -19z"/>
</g>
</svg>
),

  live0: (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="600.000000pt" height="184.000000pt" viewBox="0 0 600.000000 184.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,184.000000) scale(0.100000,-0.100000)">
<path d="M351 1764 c-191 -209 -292 -450 -321 -769 -29 -306 83 -643 299 -902
35 -43 59 -63 74 -63 29 0 107 78 107 107 0 12 -20 45 -44 75 -61 76 -133 188
-167 263 -101 223 -123 500 -58 736 32 118 118 282 203 388 42 52 76 100 76
107 0 22 -80 114 -99 114 -11 0 -42 -25 -70 -56z"/>
<path d="M4589 1674 c-9 -3 -21 -15 -27 -27 -20 -39 -202 -698 -259 -935 -15
-62 -30 -109 -34 -105 -3 5 -34 118 -67 253 -83 334 -210 771 -229 792 -14 16
-36 18 -170 18 l-153 0 0 -25 c0 -13 6 -42 14 -62 8 -21 32 -94 54 -163 22
-69 109 -334 192 -590 83 -256 156 -480 161 -498 19 -60 26 -62 189 -62 144 0
150 1 164 23 8 12 57 148 109 302 80 236 242 706 333 969 38 111 42 106 -90
106 -62 0 -126 2 -142 4 -16 2 -36 2 -45 0z"/>
<path d="M2090 1651 c-16 -31 -14 -1355 3 -1369 8 -7 163 -11 439 -13 516 -3
472 -17 465 140 -3 57 -10 108 -15 113 -6 6 -121 11 -286 12 -211 1 -278 4
-288 14 -10 10 -14 131 -18 565 l-5 552 -142 3 c-132 2 -143 1 -153 -17z"/>
<path d="M3175 1658 c-3 -7 -4 -321 -3 -698 l3 -685 130 -3 c72 -1 140 0 153
3 l22 5 0 679 c0 374 -3 686 -6 695 -5 14 -28 16 -150 16 -107 0 -146 -3 -149
-12z"/>
<path d="M5035 1658 c-3 -7 -4 -321 -3 -698 l3 -685 454 -3 c327 -1 458 1 467
9 18 15 20 219 2 237 -9 9 -90 12 -303 12 -213 0 -294 3 -303 12 -13 13 -18
271 -6 302 5 14 37 16 254 16 300 0 280 -10 280 138 0 90 -2 102 -19 112 -12
6 -113 10 -259 10 -180 0 -242 3 -249 13 -12 14 -11 246 0 265 6 9 71 12 266
12 318 0 304 -5 310 124 1 48 0 98 -3 111 l-6 25 -441 0 c-342 0 -441 -3 -444
-12z"/>
<path d="M599 1543 c-98 -106 -156 -207 -205 -353 -26 -79 -28 -96 -28 -255
-1 -196 15 -279 84 -421 59 -122 161 -254 196 -254 13 0 104 95 104 109 0 9
-25 50 -57 91 -167 222 -206 488 -107 736 34 86 78 155 138 216 25 26 46 55
46 65 0 18 -100 113 -118 113 -5 0 -29 -21 -53 -47z"/>
<path d="M830 1313 c-112 -127 -161 -293 -139 -469 13 -98 40 -168 100 -259
52 -78 75 -93 110 -75 32 18 99 81 99 94 0 7 -15 30 -34 52 -48 56 -83 131
-97 207 -21 111 14 229 95 326 20 24 36 47 36 53 0 14 -101 118 -116 118 -7 0
-31 -21 -54 -47z"/>
<path d="M1145 1135 c-50 -18 -111 -85 -126 -139 -27 -102 14 -213 97 -262
203 -119 431 112 308 313 -54 88 -172 125 -279 88z"/>
</g>
</svg>
),

live: (

<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="391.000000pt" height="514.000000pt" viewBox="0 0 391.000000 514.000000"
    fill="currentColor" // Dynamique pour la couleur
    stroke="currentColor" // Dynamique pour le trait
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,514.000000) scale(0.050000,-0.050000)">
<path d="M2267 10218 c-166 -63 -619 -556 -964 -1046 -1907 -2710 -1633 -6477
641 -8843 342 -356 610 -408 878 -172 291 257 259 544 -106 949 -2159 2394
-2123 5824 85 8164 454 482 63 1178 -534 948z"/>
<path d="M3836 8733 c-133 -37 -231 -108 -382 -276 -1731 -1927 -1731 -4707 1
-6635 311 -346 621 -392 902 -133 255 234 219 529 -110 901 -1336 1510 -1322
3635 33 5140 201 223 229 283 229 480 0 366 -326 620 -673 523z"/>
<path d="M5353 7256 c-121 -22 -219 -83 -348 -219 -1003 -1051 -993 -2772 22
-3823 501 -518 1302 111 856 672 -241 304 -294 380 -364 524 -217 448 -217
1012 0 1460 70 144 124 221 363 523 312 391 -33 954 -529 863z"/>
<path d="M6822 5838 c-509 -155 -672 -828 -292 -1208 390 -390 1062 -216 1209
314 149 540 -381 1057 -917 894z"/>
</g>
</svg>

),

videoFadeTransition: (
    <svg xmlns               = "http://www.w3.org/2000/svg"
         width               = "680"
         height              = "680"
         preserveAspectRatio = "xMidYMid meet"
         fill                = "currentColor"
         stroke              = "currentColor"
         viewBox             = "135 185 410 320" >
  <defs>
    <linearGradient id="maskGrad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%"   stop-color="black"/>
      <stop offset="100%" stop-color="white"/>
    </linearGradient>
    <mask id="fadeMask">
      <rect x="240" y="200" width="300" height="300" fill="url(#maskGrad)"/>
    </mask>
  </defs>

  <rect x="140" y="190" width="300" height="300" fill="black" stroke="black" stroke-width="3"/>

  <g mask="url(#fadeMask)">
    <rect x="240" y="200" width="300" height="300" fill="white" stroke="black" stroke-width="3"/>
  </g>

</svg>
  ),

// Logo officiel de WhatsApp.
//
// Deux écarts avec le fichier fourni par la marque, et un seul motif pour les
// deux : Icon clone la balise <svg> racine et lui impose `fill` et `stroke`.
//
//  - la couleur de marque (#25d366) portée par une classe CSS est remplacée par
//    `currentColor`. Une classe l'emporterait sur le fill hérité, et le logo
//    resterait vert même posé sur la pastille verte d'une puce de destinataire,
//    où il disparaîtrait. Les appelants qui le montrent seul lui repassent le
//    vert officiel (RECIPIENT_ICON_COLORS) ;
//  - `stroke="none"` sur le groupe, sinon le contour imposé par Icon épaissirait
//    le combiné jusqu'à le boucher.
//
// Le <defs><style> d'origine a disparu avec la classe : une règle `.cls-1` dans
// une page entière n'appartient à personne et finit par toucher autre chose.
whatsapp: (
    <svg xmlns               = "http://www.w3.org/2000/svg"
         width               = "720"
         height              = "720"
         preserveAspectRatio = "xMidYMid meet"
         fill                = "currentColor"
         stroke              = "currentColor"
         viewBox             = "0 0 720 720" >
  <g stroke="none">
    <path d="M360,0C161.18,0,0,161.18,0,360c0,65.41,17.45,126.75,47.94,179.61L0,720l187.02-44.21c51.34,28.18,110.28,44.21,172.98,44.21,198.82,0,360-161.18,360-360S558.82,0,360,0ZM360,655.52c-60.17,0-116.13-17.98-162.82-48.87l-110.49,28.14,30.99-105.61c-33.53-47.93-53.2-106.26-53.2-169.19,0-163.21,132.31-295.52,295.52-295.52s295.52,132.31,295.52,295.52-132.31,295.52-295.52,295.52Z"/>
    <path d="M444.35,407.52l87.1,41.06c4,1.88,6.56,5.94,6.2,10.34-.94,11.46-5.54,34.43-26.13,55.02-58.12,58.12-162.49-7.64-166.74-10.18-25.67-13.79-50.06-32.24-73.19-55.36-23.12-23.12-41.58-47.52-55.37-73.19-2.55-4.24-68.31-108.61-10.18-166.74,20.59-20.59,43.56-25.19,55.02-26.13,4.41-.36,8.46,2.2,10.34,6.2l41.07,87.1c1.94,4.12,1.09,9.02-2.13,12.24l-30.61,30.61c-6.62,6.62-8.56,16.93-4,25.11,11.17,20.03,26.19,39.32,43.59,57.07,17.75,17.4,37.04,32.43,57.07,43.59,8.18,4.56,18.48,2.62,25.11-4l30.61-30.61c3.22-3.22,8.12-4.08,12.24-2.13Z"/>
  </g>
</svg>
  ),

};




interface IconProps {
  name                            : string;
  id?                             : number;
  className?                      : string;
  onClick?                        : (event: React.MouseEvent<HTMLOrSVGElement, MouseEvent>, id?: number, state?: boolean) => void;
  onMouseEnter?                   : (event: React.MouseEvent) => void;
  onMouseLeave?                   : (event: React.MouseEvent) => void;
  width?                          : number;
  height?                         : number;
  backgroundColor?                : string;
  color?                          : string;
  hoverColor?                     : string;
  pressedState?                   : boolean;
  pressedName?                    : string;
  pressedTransform?               : string;
  unpressedTransform?             : string;
  originalSvgIconTransform?       : string;
  originalSvgPressedIconTransform?: string;
  role?                           : string;
  ariaExpanded?                   : boolean;
  hoverable?                      : boolean;
  clickable?                      : boolean;
}

// ---------------------------------------------------------------------------
// Résolution d'une icône : SVG custom → Lucide → none
// ---------------------------------------------------------------------------
type ResolvedIcon =
  | { kind: "svg";    element: React.ReactElement }
  | { kind: "lucide"; Component: LucideIcon }
  | { kind: "none" };

function resolveIcon(name: string): ResolvedIcon {
  // 1. Recherche dans le registre SVG custom
  const svgElement = svgIcons[name];
  if (svgElement) return { kind: "svg", element: svgElement };

  // 2. Recherche dans le registre Lucide
  const LucideComponent = lucideIcons[name];
  if (LucideComponent) return { kind: "lucide", Component: LucideComponent };

  // 3. Introuvable → warning, fallback PNG géré par l'appelant
  console.warn(
    `[Icon] "${name}" introuvable dans svgIcons ni dans lucideIcons. ` +
    `Ajoutez-le dans lucideRegistry.ts si c'est une icône Lucide.`
  );
  return { kind: "none" };
}

// ---------------------------------------------------------------------------
// Composant Icon
// ---------------------------------------------------------------------------
export const Icon = ({
  name,
  id,
  className,
  onClick,
  width                           = 24,
  height                          = 24,
  backgroundColor                 = "",
  color                           = "var(--color-0)",
  hoverColor                      = "var(--color-R)",
  pressedState,
  pressedName,
  pressedTransform                = "none",
  unpressedTransform              = "none",
  originalSvgIconTransform        = "none",
  originalSvgPressedIconTransform = "none",
  role                            = "button",
  ariaExpanded                    = false,
  hoverable                       = true,
  clickable                       = true,
  onMouseEnter,
  onMouseLeave,
}: IconProps) => {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    if (pressedState !== undefined) setPressed(pressedState);
  }, [pressedState]);

  // --- Résolution de l'icône active (normale ou pressed) -----------------
  const activeName     = pressed && pressedName ? pressedName : name;
  const resolvedActive = resolveIcon(activeName);

  // --- Handlers ----------------------------------------------------------
  const handleMouseEnter = (e: React.MouseEvent) => {
    setHovered(true);
    if (onMouseEnter) onMouseEnter(e);
  };

  const handleMouseLeave = (e: React.MouseEvent) => {
    setHovered(false);
    if (onMouseLeave) onMouseLeave(e);
  };

  const handleClick = (e: React.MouseEvent<SVGElement>) => {
    if (!clickable) return;
    if (onClick) onClick(e, id, !pressed);
    if (pressedState) setPressed((prev) => !prev);
  };

  const appliedColor     = hovered && hoverable ? hoverColor : color;
  const appliedTransform = pressed ? pressedTransform : unpressedTransform;

  // --- Rendu : SVG custom ------------------------------------------------
  if (resolvedActive.kind === "svg") {
    const iconTransform = pressed
      ? originalSvgPressedIconTransform
      : originalSvgIconTransform;

    const svgWithTransform =
      iconTransform && iconTransform !== "none"
        ? React.cloneElement(resolvedActive.element, {
            style: { transform: iconTransform },
          })
        : resolvedActive.element;

    return React.cloneElement(svgWithTransform, {
      width,
      height,
      stroke      : appliedColor,
      fill        : appliedColor,
      onClick     : clickable ? handleClick : undefined,
      role        : clickable ? role        : undefined,
      ariaExpanded: clickable ? ariaExpanded : undefined,
      className   : classNames(styles.icon, className, clickable && styles.clickable),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      style: {
        display      : "inline-block",
        transform    : appliedTransform,
        transition   : "transform 0.2s ease",
        pointerEvents: clickable ? "auto" : "none",
        ...(height !== 24 && { height }),
        ...(width  !== 24 && { width  }),
      },
    });
  }

  // --- Rendu : icône Lucide ----------------------------------------------
  if (resolvedActive.kind === "lucide") {
    const Component = resolvedActive.Component;
    return (
      <span
        role          ={clickable ? role        : undefined}
        aria-expanded ={clickable ? ariaExpanded : undefined}
        className     ={classNames(styles.icon, className, clickable && styles.clickable)}
        onMouseEnter  ={handleMouseEnter}
        onMouseLeave  ={handleMouseLeave}
        onClick       ={clickable ? (handleClick as unknown as React.MouseEventHandler<HTMLSpanElement>) : undefined}
        style={{
          display      : "inline-block",
          transform    : appliedTransform,
          transition   : "transform 0.2s ease",
          pointerEvents: clickable ? "auto" : "none",
          backgroundColor,
        }}
      >
        <Component
          width ={width}
          height={height}
          stroke={appliedColor}
        />
      </span>
    );
  }

  // --- Rendu : fallback PNG ----------------------------------------------
  const WWW_URLS = "/images/icons/";

  return (
    <img
      src          ={pressed ? `${WWW_URLS}${pressedName}.png` : `${WWW_URLS}${name}.png`}
      alt          ={pressed ? pressedName : name}
      onClick      ={clickable && onClick ? (e) => onClick(e, id) : undefined}
      role         ={clickable ? role        : undefined}
      aria-expanded={clickable ? ariaExpanded : undefined}
      width        ={width}
      height       ={height}
      className    ={classNames(styles.icon, className, clickable && styles.clickable)}
      onMouseEnter ={handleMouseEnter}
      onMouseLeave ={handleMouseLeave}
      style={{
        transform    : pressed ? pressedTransform : unpressedTransform,
        transition   : "transform 0.2s ease",
        pointerEvents: clickable ? "auto" : "none",
      }}
    />
  );
};

export default Icon;